function _typeof(e) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e
    }
    : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    }
    )(e)
}
!function(e, t) {
    "use strict";
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document)
            throw new Error("jQuery requires a window with a document");
        return t(e)
    }
    : t(e)
}("undefined" != typeof window ? window : this, function(C, e) {
    "use strict";
    function g(e) {
        return null != e && e === e.window
    }
    var t = []
      , n = Object.getPrototypeOf
      , a = t.slice
      , m = t.flat ? function(e) {
        return t.flat.call(e)
    }
    : function(e) {
        return t.concat.apply([], e)
    }
      , l = t.push
      , o = t.indexOf
      , i = {}
      , s = i.toString
      , v = i.hasOwnProperty
      , r = v.toString
      , c = r.call(Object)
      , y = {}
      , w = function(e) {
        return "function" == typeof e && "number" != typeof e.nodeType
    }
      , T = C.document
      , d = {
        type: !0,
        src: !0,
        nonce: !0,
        noModule: !0
    };
    function b(e, t, i) {
        var n, o, s = (i = i || T).createElement("script");
        if (s.text = e,
        t)
            for (n in d)
                (o = t[n] || t.getAttribute && t.getAttribute(n)) && s.setAttribute(n, o);
        i.head.appendChild(s).parentNode.removeChild(s)
    }
    function x(e) {
        return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? i[s.call(e)] || "object" : _typeof(e)
    }
    var u = "3.5.1"
      , S = function e(t, i) {
        return new e.fn.init(t,i)
    };
    function p(e) {
        var t = !!e && "length"in e && e.length
          , i = x(e);
        return !w(e) && !g(e) && ("array" === i || 0 === t || "number" == typeof t && 0 < t && t - 1 in e)
    }
    S.fn = S.prototype = {
        jquery: u,
        constructor: S,
        length: 0,
        toArray: function() {
            return a.call(this)
        },
        get: function(e) {
            return null == e ? a.call(this) : e < 0 ? this[e + this.length] : this[e]
        },
        pushStack: function(e) {
            var t = S.merge(this.constructor(), e);
            return t.prevObject = this,
            t
        },
        each: function(e) {
            return S.each(this, e)
        },
        map: function(i) {
            return this.pushStack(S.map(this, function(e, t) {
                return i.call(e, t, e)
            }))
        },
        slice: function() {
            return this.pushStack(a.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        even: function() {
            return this.pushStack(S.grep(this, function(e, t) {
                return (t + 1) % 2
            }))
        },
        odd: function() {
            return this.pushStack(S.grep(this, function(e, t) {
                return t % 2
            }))
        },
        eq: function(e) {
            var t = this.length
              , i = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= i && i < t ? [this[i]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: l,
        sort: t.sort,
        splice: t.splice
    },
    S.extend = S.fn.extend = function() {
        var e, t, i, n, o, s, r = arguments[0] || {}, a = 1, l = arguments.length, c = !1;
        for ("boolean" == typeof r && (c = r,
        r = arguments[a] || {},
        a++),
        "object" == _typeof(r) || w(r) || (r = {}),
        a === l && (r = this,
        a--); a < l; a++)
            if (null != (e = arguments[a]))
                for (t in e)
                    n = e[t],
                    "__proto__" !== t && r !== n && (c && n && (S.isPlainObject(n) || (o = Array.isArray(n))) ? (i = r[t],
                    s = o && !Array.isArray(i) ? [] : o || S.isPlainObject(i) ? i : {},
                    o = !1,
                    r[t] = S.extend(c, s, n)) : void 0 !== n && (r[t] = n));
        return r
    }
    ,
    S.extend({
        expando: "jQuery" + (u + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isPlainObject: function(e) {
            var t, i;
            return !(!e || "[object Object]" !== s.call(e) || (t = n(e)) && ("function" != typeof (i = v.call(t, "constructor") && t.constructor) || r.call(i) !== c))
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e)
                return !1;
            return !0
        },
        globalEval: function(e, t, i) {
            b(e, {
                nonce: t && t.nonce
            }, i)
        },
        each: function(e, t) {
            var i, n = 0;
            if (p(e))
                for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++)
                    ;
            else
                for (n in e)
                    if (!1 === t.call(e[n], n, e[n]))
                        break;
            return e
        },
        makeArray: function(e, t) {
            var i = t || [];
            return null != e && (p(Object(e)) ? S.merge(i, "string" == typeof e ? [e] : e) : l.call(i, e)),
            i
        },
        inArray: function(e, t, i) {
            return null == t ? -1 : o.call(t, e, i)
        },
        merge: function(e, t) {
            for (var i = +t.length, n = 0, o = e.length; n < i; n++)
                e[o++] = t[n];
            return e.length = o,
            e
        },
        grep: function(e, t, i) {
            for (var n = [], o = 0, s = e.length, r = !i; o < s; o++)
                !t(e[o], o) != r && n.push(e[o]);
            return n
        },
        map: function(e, t, i) {
            var n, o, s = 0, r = [];
            if (p(e))
                for (n = e.length; s < n; s++)
                    null != (o = t(e[s], s, i)) && r.push(o);
            else
                for (s in e)
                    null != (o = t(e[s], s, i)) && r.push(o);
            return m(r)
        },
        guid: 1,
        support: y
    }),
    "function" == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]),
    S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        i["[object " + t + "]"] = t.toLowerCase()
    });
    var h = function(i) {
        function u(e, t) {
            var i = "0x" + e.slice(1) - 65536;
            return t || (i < 0 ? String.fromCharCode(65536 + i) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320))
        }
        function o() {
            _()
        }
        var e, h, b, s, r, f, p, g, x, l, c, _, C, a, T, m, d, v, y, S = "sizzle" + +new Date, w = i.document, $ = 0, n = 0, k = le(), A = le(), E = le(), z = le(), D = function(e, t) {
            return e === t && (c = !0),
            0
        }, O = {}.hasOwnProperty, t = [], j = t.pop, L = t.push, P = t.push, N = t.slice, M = function(e, t) {
            for (var i = 0, n = e.length; i < n; i++)
                if (e[i] === t)
                    return i;
            return -1
        }, I = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", q = "[\\x20\\t\\r\\n\\f]", H = "(?:\\\\[\\da-fA-F]{1,6}" + q + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", R = "\\[" + q + "*(" + H + ")(?:" + q + "*([*^$|!~]?=)" + q + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + H + "))|)" + q + "*\\]", W = ":(" + H + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + R + ")*)|.*)\\)|)", F = new RegExp(q + "+","g"), B = new RegExp("^" + q + "+|((?:^|[^\\\\])(?:\\\\.)*)" + q + "+$","g"), U = new RegExp("^" + q + "*," + q + "*"), X = new RegExp("^" + q + "*([>+~]|" + q + ")" + q + "*"), G = new RegExp(q + "|>"), Y = new RegExp(W), V = new RegExp("^" + H + "$"), Q = {
            ID: new RegExp("^#(" + H + ")"),
            CLASS: new RegExp("^\\.(" + H + ")"),
            TAG: new RegExp("^(" + H + "|[*])"),
            ATTR: new RegExp("^" + R),
            PSEUDO: new RegExp("^" + W),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + q + "*(even|odd|(([+-]|)(\\d*)n|)" + q + "*(?:([+-]|)" + q + "*(\\d+)|))" + q + "*\\)|)","i"),
            bool: new RegExp("^(?:" + I + ")$","i"),
            needsContext: new RegExp("^" + q + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + q + "*((?:-\\d)?\\d*)" + q + "*\\)|)(?=[^-]|$)","i")
        }, K = /HTML$/i, Z = /^(?:input|select|textarea|button)$/i, J = /^h\d$/i, ee = /^[^{]+\{\s*\[native \w/, te = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, ie = /[+~]/, ne = new RegExp("\\\\[\\da-fA-F]{1,6}" + q + "?|\\\\([^\\r\\n\\f])","g"), oe = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, se = function(e, t) {
            return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
        }, re = be(function(e) {
            return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
        }, {
            dir: "parentNode",
            next: "legend"
        });
        try {
            P.apply(t = N.call(w.childNodes), w.childNodes),
            t[w.childNodes.length].nodeType
        } catch (e) {
            P = {
                apply: t.length ? function(e, t) {
                    L.apply(e, N.call(t))
                }
                : function(e, t) {
                    for (var i = e.length, n = 0; e[i++] = t[n++]; )
                        ;
                    e.length = i - 1
                }
            }
        }
        function ae(e, t, i, n) {
            var o, s, r, a, l, c, d, u = t && t.ownerDocument, p = t ? t.nodeType : 9;
            if (i = i || [],
            "string" != typeof e || !e || 1 !== p && 9 !== p && 11 !== p)
                return i;
            if (!n && (_(t),
            t = t || C,
            T)) {
                if (11 !== p && (l = te.exec(e)))
                    if (o = l[1]) {
                        if (9 === p) {
                            if (!(r = t.getElementById(o)))
                                return i;
                            if (r.id === o)
                                return i.push(r),
                                i
                        } else if (u && (r = u.getElementById(o)) && y(t, r) && r.id === o)
                            return i.push(r),
                            i
                    } else {
                        if (l[2])
                            return P.apply(i, t.getElementsByTagName(e)),
                            i;
                        if ((o = l[3]) && h.getElementsByClassName && t.getElementsByClassName)
                            return P.apply(i, t.getElementsByClassName(o)),
                            i
                    }
                if (h.qsa && !z[e + " "] && (!m || !m.test(e)) && (1 !== p || "object" !== t.nodeName.toLowerCase())) {
                    if (d = e,
                    u = t,
                    1 === p && (G.test(e) || X.test(e))) {
                        for ((u = ie.test(e) && ve(t.parentNode) || t) === t && h.scope || ((a = t.getAttribute("id")) ? a = a.replace(oe, se) : t.setAttribute("id", a = S)),
                        s = (c = f(e)).length; s--; )
                            c[s] = (a ? "#" + a : ":scope") + " " + we(c[s]);
                        d = c.join(",")
                    }
                    try {
                        return P.apply(i, u.querySelectorAll(d)),
                        i
                    } catch (t) {
                        z(e, !0)
                    } finally {
                        a === S && t.removeAttribute("id")
                    }
                }
            }
            return g(e.replace(B, "$1"), t, i, n)
        }
        function le() {
            var n = [];
            return function e(t, i) {
                return n.push(t + " ") > b.cacheLength && delete e[n.shift()],
                e[t + " "] = i
            }
        }
        function ce(e) {
            return e[S] = !0,
            e
        }
        function de(e) {
            var t = C.createElement("fieldset");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t),
                t = null
            }
        }
        function ue(e, t) {
            for (var i = e.split("|"), n = i.length; n--; )
                b.attrHandle[i[n]] = t
        }
        function pe(e, t) {
            var i = t && e
              , n = i && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (n)
                return n;
            if (i)
                for (; i = i.nextSibling; )
                    if (i === t)
                        return -1;
            return e ? 1 : -1
        }
        function he(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }
        function fe(i) {
            return function(e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t || "button" === t) && e.type === i
            }
        }
        function ge(t) {
            return function(e) {
                return "form"in e ? e.parentNode && !1 === e.disabled ? "label"in e ? "label"in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && re(e) === t : e.disabled === t : "label"in e && e.disabled === t
            }
        }
        function me(r) {
            return ce(function(s) {
                return s = +s,
                ce(function(e, t) {
                    for (var i, n = r([], e.length, s), o = n.length; o--; )
                        e[i = n[o]] && (e[i] = !(t[i] = e[i]))
                })
            })
        }
        function ve(e) {
            return e && void 0 !== e.getElementsByTagName && e
        }
        for (e in h = ae.support = {},
        r = ae.isXML = function(e) {
            var t = e.namespaceURI
              , i = (e.ownerDocument || e).documentElement;
            return !K.test(t || i && i.nodeName || "HTML")
        }
        ,
        _ = ae.setDocument = function(e) {
            var t, i, n = e ? e.ownerDocument || e : w;
            return n != C && 9 === n.nodeType && n.documentElement && (a = (C = n).documentElement,
            T = !r(C),
            w != C && (i = C.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", o, !1) : i.attachEvent && i.attachEvent("onunload", o)),
            h.scope = de(function(e) {
                return a.appendChild(e).appendChild(C.createElement("div")),
                void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
            }),
            h.attributes = de(function(e) {
                return e.className = "i",
                !e.getAttribute("className")
            }),
            h.getElementsByTagName = de(function(e) {
                return e.appendChild(C.createComment("")),
                !e.getElementsByTagName("*").length
            }),
            h.getElementsByClassName = ee.test(C.getElementsByClassName),
            h.getById = de(function(e) {
                return a.appendChild(e).id = S,
                !C.getElementsByName || !C.getElementsByName(S).length
            }),
            h.getById ? (b.filter.ID = function(e) {
                var t = e.replace(ne, u);
                return function(e) {
                    return e.getAttribute("id") === t
                }
            }
            ,
            b.find.ID = function(e, t) {
                if (void 0 !== t.getElementById && T) {
                    var i = t.getElementById(e);
                    return i ? [i] : []
                }
            }
            ) : (b.filter.ID = function(e) {
                var i = e.replace(ne, u);
                return function(e) {
                    var t = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                    return t && t.value === i
                }
            }
            ,
            b.find.ID = function(e, t) {
                if (void 0 !== t.getElementById && T) {
                    var i, n, o, s = t.getElementById(e);
                    if (s) {
                        if ((i = s.getAttributeNode("id")) && i.value === e)
                            return [s];
                        for (o = t.getElementsByName(e),
                        n = 0; s = o[n++]; )
                            if ((i = s.getAttributeNode("id")) && i.value === e)
                                return [s]
                    }
                    return []
                }
            }
            ),
            b.find.TAG = h.getElementsByTagName ? function(e, t) {
                return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : h.qsa ? t.querySelectorAll(e) : void 0
            }
            : function(e, t) {
                var i, n = [], o = 0, s = t.getElementsByTagName(e);
                if ("*" !== e)
                    return s;
                for (; i = s[o++]; )
                    1 === i.nodeType && n.push(i);
                return n
            }
            ,
            b.find.CLASS = h.getElementsByClassName && function(e, t) {
                if (void 0 !== t.getElementsByClassName && T)
                    return t.getElementsByClassName(e)
            }
            ,
            d = [],
            m = [],
            (h.qsa = ee.test(C.querySelectorAll)) && (de(function(e) {
                var t;
                a.appendChild(e).innerHTML = "<a id='" + S + "'></a><select id='" + S + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                e.querySelectorAll("[msallowcapture^='']").length && m.push("[*^$]=" + q + "*(?:''|\"\")"),
                e.querySelectorAll("[selected]").length || m.push("\\[" + q + "*(?:value|" + I + ")"),
                e.querySelectorAll("[id~=" + S + "-]").length || m.push("~="),
                (t = C.createElement("input")).setAttribute("name", ""),
                e.appendChild(t),
                e.querySelectorAll("[name='']").length || m.push("\\[" + q + "*name" + q + "*=" + q + "*(?:''|\"\")"),
                e.querySelectorAll(":checked").length || m.push(":checked"),
                e.querySelectorAll("a#" + S + "+*").length || m.push(".#.+[+~]"),
                e.querySelectorAll("\\\f"),
                m.push("[\\r\\n\\f]")
            }),
            de(function(e) {
                e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = C.createElement("input");
                t.setAttribute("type", "hidden"),
                e.appendChild(t).setAttribute("name", "D"),
                e.querySelectorAll("[name=d]").length && m.push("name" + q + "*[*^$|!~]?="),
                2 !== e.querySelectorAll(":enabled").length && m.push(":enabled", ":disabled"),
                a.appendChild(e).disabled = !0,
                2 !== e.querySelectorAll(":disabled").length && m.push(":enabled", ":disabled"),
                e.querySelectorAll("*,:x"),
                m.push(",.*:")
            })),
            (h.matchesSelector = ee.test(v = a.matches || a.webkitMatchesSelector || a.mozMatchesSelector || a.oMatchesSelector || a.msMatchesSelector)) && de(function(e) {
                h.disconnectedMatch = v.call(e, "*"),
                v.call(e, "[s!='']:x"),
                d.push("!=", W)
            }),
            m = m.length && new RegExp(m.join("|")),
            d = d.length && new RegExp(d.join("|")),
            t = ee.test(a.compareDocumentPosition),
            y = t || ee.test(a.contains) ? function(e, t) {
                var i = 9 === e.nodeType ? e.documentElement : e
                  , n = t && t.parentNode;
                return e === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)))
            }
            : function(e, t) {
                if (t)
                    for (; t = t.parentNode; )
                        if (t === e)
                            return !0;
                return !1
            }
            ,
            D = t ? function(e, t) {
                if (e === t)
                    return c = !0,
                    0;
                var i = !e.compareDocumentPosition - !t.compareDocumentPosition;
                return i || (1 & (i = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !h.sortDetached && t.compareDocumentPosition(e) === i ? e == C || e.ownerDocument == w && y(w, e) ? -1 : t == C || t.ownerDocument == w && y(w, t) ? 1 : l ? M(l, e) - M(l, t) : 0 : 4 & i ? -1 : 1)
            }
            : function(e, t) {
                if (e === t)
                    return c = !0,
                    0;
                var i, n = 0, o = e.parentNode, s = t.parentNode, r = [e], a = [t];
                if (!o || !s)
                    return e == C ? -1 : t == C ? 1 : o ? -1 : s ? 1 : l ? M(l, e) - M(l, t) : 0;
                if (o === s)
                    return pe(e, t);
                for (i = e; i = i.parentNode; )
                    r.unshift(i);
                for (i = t; i = i.parentNode; )
                    a.unshift(i);
                for (; r[n] === a[n]; )
                    n++;
                return n ? pe(r[n], a[n]) : r[n] == w ? -1 : a[n] == w ? 1 : 0
            }
            ),
            C
        }
        ,
        ae.matches = function(e, t) {
            return ae(e, null, null, t)
        }
        ,
        ae.matchesSelector = function(e, t) {
            if (_(e),
            h.matchesSelector && T && !z[t + " "] && (!d || !d.test(t)) && (!m || !m.test(t)))
                try {
                    var i = v.call(e, t);
                    if (i || h.disconnectedMatch || e.document && 11 !== e.document.nodeType)
                        return i
                } catch (e) {
                    z(t, !0)
                }
            return 0 < ae(t, C, null, [e]).length
        }
        ,
        ae.contains = function(e, t) {
            return (e.ownerDocument || e) != C && _(e),
            y(e, t)
        }
        ,
        ae.attr = function(e, t) {
            (e.ownerDocument || e) != C && _(e);
            var i = b.attrHandle[t.toLowerCase()]
              , n = i && O.call(b.attrHandle, t.toLowerCase()) ? i(e, t, !T) : void 0;
            return void 0 !== n ? n : h.attributes || !T ? e.getAttribute(t) : (n = e.getAttributeNode(t)) && n.specified ? n.value : null
        }
        ,
        ae.escape = function(e) {
            return (e + "").replace(oe, se)
        }
        ,
        ae.error = function(e) {
            throw new Error("Syntax error, unrecognized expression: " + e)
        }
        ,
        ae.uniqueSort = function(e) {
            var t, i = [], n = 0, o = 0;
            if (c = !h.detectDuplicates,
            l = !h.sortStable && e.slice(0),
            e.sort(D),
            c) {
                for (; t = e[o++]; )
                    t === e[o] && (n = i.push(o));
                for (; n--; )
                    e.splice(i[n], 1)
            }
            return l = null,
            e
        }
        ,
        s = ae.getText = function(e) {
            var t, i = "", n = 0, o = e.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof e.textContent)
                        return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling)
                        i += s(e)
                } else if (3 === o || 4 === o)
                    return e.nodeValue
            } else
                for (; t = e[n++]; )
                    i += s(t);
            return i
        }
        ,
        (b = ae.selectors = {
            cacheLength: 50,
            createPseudo: ce,
            match: Q,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(e) {
                    return e[1] = e[1].replace(ne, u),
                    e[3] = (e[3] || e[4] || e[5] || "").replace(ne, u),
                    "~=" === e[2] && (e[3] = " " + e[3] + " "),
                    e.slice(0, 4)
                },
                CHILD: function(e) {
                    return e[1] = e[1].toLowerCase(),
                    "nth" === e[1].slice(0, 3) ? (e[3] || ae.error(e[0]),
                    e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])),
                    e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && ae.error(e[0]),
                    e
                },
                PSEUDO: function(e) {
                    var t, i = !e[6] && e[2];
                    return Q.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : i && Y.test(i) && (t = f(i, !0)) && (t = i.indexOf(")", i.length - t) - i.length) && (e[0] = e[0].slice(0, t),
                    e[2] = i.slice(0, t)),
                    e.slice(0, 3))
                }
            },
            filter: {
                TAG: function(e) {
                    var t = e.replace(ne, u).toLowerCase();
                    return "*" === e ? function() {
                        return !0
                    }
                    : function(e) {
                        return e.nodeName && e.nodeName.toLowerCase() === t
                    }
                },
                CLASS: function(e) {
                    var t = k[e + " "];
                    return t || (t = new RegExp("(^|" + q + ")" + e + "(" + q + "|$)")) && k(e, function(e) {
                        return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                    })
                },
                ATTR: function(i, n, o) {
                    return function(e) {
                        var t = ae.attr(e, i);
                        return null == t ? "!=" === n : !n || (t += "",
                        "=" === n ? t === o : "!=" === n ? t !== o : "^=" === n ? o && 0 === t.indexOf(o) : "*=" === n ? o && -1 < t.indexOf(o) : "$=" === n ? o && t.slice(-o.length) === o : "~=" === n ? -1 < (" " + t.replace(F, " ") + " ").indexOf(o) : "|=" === n && (t === o || t.slice(0, o.length + 1) === o + "-"))
                    }
                },
                CHILD: function(f, e, t, g, m) {
                    var v = "nth" !== f.slice(0, 3)
                      , y = "last" !== f.slice(-4)
                      , w = "of-type" === e;
                    return 1 === g && 0 === m ? function(e) {
                        return !!e.parentNode
                    }
                    : function(e, t, i) {
                        var n, o, s, r, a, l, c = v != y ? "nextSibling" : "previousSibling", d = e.parentNode, u = w && e.nodeName.toLowerCase(), p = !i && !w, h = !1;
                        if (d) {
                            if (v) {
                                for (; c; ) {
                                    for (r = e; r = r[c]; )
                                        if (w ? r.nodeName.toLowerCase() === u : 1 === r.nodeType)
                                            return !1;
                                    l = c = "only" === f && !l && "nextSibling"
                                }
                                return !0
                            }
                            if (l = [y ? d.firstChild : d.lastChild],
                            y && p) {
                                for (h = (a = (n = (o = (s = (r = d)[S] || (r[S] = {}))[r.uniqueID] || (s[r.uniqueID] = {}))[f] || [])[0] === $ && n[1]) && n[2],
                                r = a && d.childNodes[a]; r = ++a && r && r[c] || (h = a = 0) || l.pop(); )
                                    if (1 === r.nodeType && ++h && r === e) {
                                        o[f] = [$, a, h];
                                        break
                                    }
                            } else if (p && (h = a = (n = (o = (s = (r = e)[S] || (r[S] = {}))[r.uniqueID] || (s[r.uniqueID] = {}))[f] || [])[0] === $ && n[1]),
                            !1 === h)
                                for (; (r = ++a && r && r[c] || (h = a = 0) || l.pop()) && ((w ? r.nodeName.toLowerCase() !== u : 1 !== r.nodeType) || !++h || (p && ((o = (s = r[S] || (r[S] = {}))[r.uniqueID] || (s[r.uniqueID] = {}))[f] = [$, h]),
                                r !== e)); )
                                    ;
                            return (h -= m) === g || h % g == 0 && 0 <= h / g
                        }
                    }
                },
                PSEUDO: function(e, s) {
                    var t, r = b.pseudos[e] || b.setFilters[e.toLowerCase()] || ae.error("unsupported pseudo: " + e);
                    return r[S] ? r(s) : 1 < r.length ? (t = [e, e, "", s],
                    b.setFilters.hasOwnProperty(e.toLowerCase()) ? ce(function(e, t) {
                        for (var i, n = r(e, s), o = n.length; o--; )
                            e[i = M(e, n[o])] = !(t[i] = n[o])
                    }) : function(e) {
                        return r(e, 0, t)
                    }
                    ) : r
                }
            },
            pseudos: {
                not: ce(function(e) {
                    var n = []
                      , o = []
                      , a = p(e.replace(B, "$1"));
                    return a[S] ? ce(function(e, t, i, n) {
                        for (var o, s = a(e, null, n, []), r = e.length; r--; )
                            (o = s[r]) && (e[r] = !(t[r] = o))
                    }) : function(e, t, i) {
                        return n[0] = e,
                        a(n, null, i, o),
                        n[0] = null,
                        !o.pop()
                    }
                }),
                has: ce(function(t) {
                    return function(e) {
                        return 0 < ae(t, e).length
                    }
                }),
                contains: ce(function(t) {
                    return t = t.replace(ne, u),
                    function(e) {
                        return -1 < (e.textContent || s(e)).indexOf(t)
                    }
                }),
                lang: ce(function(i) {
                    return V.test(i || "") || ae.error("unsupported lang: " + i),
                    i = i.replace(ne, u).toLowerCase(),
                    function(e) {
                        var t;
                        do {
                            if (t = T ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                                return (t = t.toLowerCase()) === i || 0 === t.indexOf(i + "-")
                        } while ((e = e.parentNode) && 1 === e.nodeType);return !1
                    }
                }),
                target: function(e) {
                    var t = i.location && i.location.hash;
                    return t && t.slice(1) === e.id
                },
                root: function(e) {
                    return e === a
                },
                focus: function(e) {
                    return e === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                },
                enabled: ge(!1),
                disabled: ge(!0),
                checked: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && !!e.checked || "option" === t && !!e.selected
                },
                selected: function(e) {
                    return e.parentNode && e.parentNode.selectedIndex,
                    !0 === e.selected
                },
                empty: function(e) {
                    for (e = e.firstChild; e; e = e.nextSibling)
                        if (e.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(e) {
                    return !b.pseudos.empty(e)
                },
                header: function(e) {
                    return J.test(e.nodeName)
                },
                input: function(e) {
                    return Z.test(e.nodeName)
                },
                button: function(e) {
                    var t = e.nodeName.toLowerCase();
                    return "input" === t && "button" === e.type || "button" === t
                },
                text: function(e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                },
                first: me(function() {
                    return [0]
                }),
                last: me(function(e, t) {
                    return [t - 1]
                }),
                eq: me(function(e, t, i) {
                    return [i < 0 ? i + t : i]
                }),
                even: me(function(e, t) {
                    for (var i = 0; i < t; i += 2)
                        e.push(i);
                    return e
                }),
                odd: me(function(e, t) {
                    for (var i = 1; i < t; i += 2)
                        e.push(i);
                    return e
                }),
                lt: me(function(e, t, i) {
                    for (var n = i < 0 ? i + t : t < i ? t : i; 0 <= --n; )
                        e.push(n);
                    return e
                }),
                gt: me(function(e, t, i) {
                    for (var n = i < 0 ? i + t : i; ++n < t; )
                        e.push(n);
                    return e
                })
            }
        }).pseudos.nth = b.pseudos.eq,
        {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            b.pseudos[e] = he(e);
        for (e in {
            submit: !0,
            reset: !0
        })
            b.pseudos[e] = fe(e);
        function ye() {}
        function we(e) {
            for (var t = 0, i = e.length, n = ""; t < i; t++)
                n += e[t].value;
            return n
        }
        function be(a, e, t) {
            var l = e.dir
              , c = e.next
              , d = c || l
              , u = t && "parentNode" === d
              , p = n++;
            return e.first ? function(e, t, i) {
                for (; e = e[l]; )
                    if (1 === e.nodeType || u)
                        return a(e, t, i);
                return !1
            }
            : function(e, t, i) {
                var n, o, s, r = [$, p];
                if (i) {
                    for (; e = e[l]; )
                        if ((1 === e.nodeType || u) && a(e, t, i))
                            return !0
                } else
                    for (; e = e[l]; )
                        if (1 === e.nodeType || u)
                            if (o = (s = e[S] || (e[S] = {}))[e.uniqueID] || (s[e.uniqueID] = {}),
                            c && c === e.nodeName.toLowerCase())
                                e = e[l] || e;
                            else {
                                if ((n = o[d]) && n[0] === $ && n[1] === p)
                                    return r[2] = n[2];
                                if ((o[d] = r)[2] = a(e, t, i))
                                    return !0
                            }
                return !1
            }
        }
        function xe(o) {
            return 1 < o.length ? function(e, t, i) {
                for (var n = o.length; n--; )
                    if (!o[n](e, t, i))
                        return !1;
                return !0
            }
            : o[0]
        }
        function _e(e, t, i, n, o) {
            for (var s, r = [], a = 0, l = e.length, c = null != t; a < l; a++)
                (s = e[a]) && (i && !i(s, n, o) || (r.push(s),
                c && t.push(a)));
            return r
        }
        function Ce(h, f, g, m, v, e) {
            return m && !m[S] && (m = Ce(m)),
            v && !v[S] && (v = Ce(v, e)),
            ce(function(e, t, i, n) {
                var o, s, r, a = [], l = [], c = t.length, d = e || function(e, t, i) {
                    for (var n = 0, o = t.length; n < o; n++)
                        ae(e, t[n], i);
                    return i
                }(f || "*", i.nodeType ? [i] : i, []), u = !h || !e && f ? d : _e(d, a, h, i, n), p = g ? v || (e ? h : c || m) ? [] : t : u;
                if (g && g(u, p, i, n),
                m)
                    for (o = _e(p, l),
                    m(o, [], i, n),
                    s = o.length; s--; )
                        (r = o[s]) && (p[l[s]] = !(u[l[s]] = r));
                if (e) {
                    if (v || h) {
                        if (v) {
                            for (o = [],
                            s = p.length; s--; )
                                (r = p[s]) && o.push(u[s] = r);
                            v(null, p = [], o, n)
                        }
                        for (s = p.length; s--; )
                            (r = p[s]) && -1 < (o = v ? M(e, r) : a[s]) && (e[o] = !(t[o] = r))
                    }
                } else
                    p = _e(p === t ? p.splice(c, p.length) : p),
                    v ? v(null, t, p, n) : P.apply(t, p)
            })
        }
        function Te(e) {
            for (var o, t, i, n = e.length, s = b.relative[e[0].type], r = s || b.relative[" "], a = s ? 1 : 0, l = be(function(e) {
                return e === o
            }, r, !0), c = be(function(e) {
                return -1 < M(o, e)
            }, r, !0), d = [function(e, t, i) {
                var n = !s && (i || t !== x) || ((o = t).nodeType ? l : c)(e, t, i);
                return o = null,
                n
            }
            ]; a < n; a++)
                if (t = b.relative[e[a].type])
                    d = [be(xe(d), t)];
                else {
                    if ((t = b.filter[e[a].type].apply(null, e[a].matches))[S]) {
                        for (i = ++a; i < n && !b.relative[e[i].type]; i++)
                            ;
                        return Ce(1 < a && xe(d), 1 < a && we(e.slice(0, a - 1).concat({
                            value: " " === e[a - 2].type ? "*" : ""
                        })).replace(B, "$1"), t, a < i && Te(e.slice(a, i)), i < n && Te(e = e.slice(i)), i < n && we(e))
                    }
                    d.push(t)
                }
            return xe(d)
        }
        return ye.prototype = b.filters = b.pseudos,
        b.setFilters = new ye,
        f = ae.tokenize = function(e, t) {
            var i, n, o, s, r, a, l, c = A[e + " "];
            if (c)
                return t ? 0 : c.slice(0);
            for (r = e,
            a = [],
            l = b.preFilter; r; ) {
                for (s in i && !(n = U.exec(r)) || (n && (r = r.slice(n[0].length) || r),
                a.push(o = [])),
                i = !1,
                (n = X.exec(r)) && (i = n.shift(),
                o.push({
                    value: i,
                    type: n[0].replace(B, " ")
                }),
                r = r.slice(i.length)),
                b.filter)
                    !(n = Q[s].exec(r)) || l[s] && !(n = l[s](n)) || (i = n.shift(),
                    o.push({
                        value: i,
                        type: s,
                        matches: n
                    }),
                    r = r.slice(i.length));
                if (!i)
                    break
            }
            return t ? r.length : r ? ae.error(e) : A(e, a).slice(0)
        }
        ,
        p = ae.compile = function(e, t) {
            var i, m, v, y, w, n, o = [], s = [], r = E[e + " "];
            if (!r) {
                for (i = (t = t || f(e)).length; i--; )
                    (r = Te(t[i]))[S] ? o.push(r) : s.push(r);
                (r = E(e, (m = s,
                y = 0 < (v = o).length,
                w = 0 < m.length,
                n = function(e, t, i, n, o) {
                    var s, r, a, l = 0, c = "0", d = e && [], u = [], p = x, h = e || w && b.find.TAG("*", o), f = $ += null == p ? 1 : Math.random() || .1, g = h.length;
                    for (o && (x = t == C || t || o); c !== g && null != (s = h[c]); c++) {
                        if (w && s) {
                            for (r = 0,
                            t || s.ownerDocument == C || (_(s),
                            i = !T); a = m[r++]; )
                                if (a(s, t || C, i)) {
                                    n.push(s);
                                    break
                                }
                            o && ($ = f)
                        }
                        y && ((s = !a && s) && l--,
                        e && d.push(s))
                    }
                    if (l += c,
                    y && c !== l) {
                        for (r = 0; a = v[r++]; )
                            a(d, u, t, i);
                        if (e) {
                            if (0 < l)
                                for (; c--; )
                                    d[c] || u[c] || (u[c] = j.call(n));
                            u = _e(u)
                        }
                        P.apply(n, u),
                        o && !e && 0 < u.length && 1 < l + v.length && ae.uniqueSort(n)
                    }
                    return o && ($ = f,
                    x = p),
                    d
                }
                ,
                y ? ce(n) : n))).selector = e
            }
            return r
        }
        ,
        g = ae.select = function(e, t, i, n) {
            var o, s, r, a, l, c = "function" == typeof e && e, d = !n && f(e = c.selector || e);
            if (i = i || [],
            1 === d.length) {
                if (2 < (s = d[0] = d[0].slice(0)).length && "ID" === (r = s[0]).type && 9 === t.nodeType && T && b.relative[s[1].type]) {
                    if (!(t = (b.find.ID(r.matches[0].replace(ne, u), t) || [])[0]))
                        return i;
                    c && (t = t.parentNode),
                    e = e.slice(s.shift().value.length)
                }
                for (o = Q.needsContext.test(e) ? 0 : s.length; o-- && (r = s[o],
                !b.relative[a = r.type]); )
                    if ((l = b.find[a]) && (n = l(r.matches[0].replace(ne, u), ie.test(s[0].type) && ve(t.parentNode) || t))) {
                        if (s.splice(o, 1),
                        !(e = n.length && we(s)))
                            return P.apply(i, n),
                            i;
                        break
                    }
            }
            return (c || p(e, d))(n, t, !T, i, !t || ie.test(e) && ve(t.parentNode) || t),
            i
        }
        ,
        h.sortStable = S.split("").sort(D).join("") === S,
        h.detectDuplicates = !!c,
        _(),
        h.sortDetached = de(function(e) {
            return 1 & e.compareDocumentPosition(C.createElement("fieldset"))
        }),
        de(function(e) {
            return e.innerHTML = "<a href='#'></a>",
            "#" === e.firstChild.getAttribute("href")
        }) || ue("type|href|height|width", function(e, t, i) {
            if (!i)
                return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }),
        h.attributes && de(function(e) {
            return e.innerHTML = "<input/>",
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
        }) || ue("value", function(e, t, i) {
            if (!i && "input" === e.nodeName.toLowerCase())
                return e.defaultValue
        }),
        de(function(e) {
            return null == e.getAttribute("disabled")
        }) || ue(I, function(e, t, i) {
            var n;
            if (!i)
                return !0 === e[t] ? t.toLowerCase() : (n = e.getAttributeNode(t)) && n.specified ? n.value : null
        }),
        ae
    }(C);
    S.find = h,
    S.expr = h.selectors,
    S.expr[":"] = S.expr.pseudos,
    S.uniqueSort = S.unique = h.uniqueSort,
    S.text = h.getText,
    S.isXMLDoc = h.isXML,
    S.contains = h.contains,
    S.escapeSelector = h.escape;
    function f(e, t, i) {
        for (var n = [], o = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
            if (1 === e.nodeType) {
                if (o && S(e).is(i))
                    break;
                n.push(e)
            }
        return n
    }
    function _(e, t) {
        for (var i = []; e; e = e.nextSibling)
            1 === e.nodeType && e !== t && i.push(e);
        return i
    }
    var $ = S.expr.match.needsContext;
    function k(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
    }
    var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function E(e, i, n) {
        return w(i) ? S.grep(e, function(e, t) {
            return !!i.call(e, t, e) !== n
        }) : i.nodeType ? S.grep(e, function(e) {
            return e === i !== n
        }) : "string" != typeof i ? S.grep(e, function(e) {
            return -1 < o.call(i, e) !== n
        }) : S.filter(i, e, n)
    }
    S.filter = function(e, t, i) {
        var n = t[0];
        return i && (e = ":not(" + e + ")"),
        1 === t.length && 1 === n.nodeType ? S.find.matchesSelector(n, e) ? [n] : [] : S.find.matches(e, S.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }
    ,
    S.fn.extend({
        find: function(e) {
            var t, i, n = this.length, o = this;
            if ("string" != typeof e)
                return this.pushStack(S(e).filter(function() {
                    for (t = 0; t < n; t++)
                        if (S.contains(o[t], this))
                            return !0
                }));
            for (i = this.pushStack([]),
            t = 0; t < n; t++)
                S.find(e, o[t], i);
            return 1 < n ? S.uniqueSort(i) : i
        },
        filter: function(e) {
            return this.pushStack(E(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(E(this, e || [], !0))
        },
        is: function(e) {
            return !!E(this, "string" == typeof e && $.test(e) ? S(e) : e || [], !1).length
        }
    });
    var z, D = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (S.fn.init = function(e, t, i) {
        var n, o;
        if (!e)
            return this;
        if (i = i || z,
        "string" != typeof e)
            return e.nodeType ? (this[0] = e,
            this.length = 1,
            this) : w(e) ? void 0 !== i.ready ? i.ready(e) : e(S) : S.makeArray(e, this);
        if (!(n = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : D.exec(e)) || !n[1] && t)
            return !t || t.jquery ? (t || i).find(e) : this.constructor(t).find(e);
        if (n[1]) {
            if (t = t instanceof S ? t[0] : t,
            S.merge(this, S.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : T, !0)),
            A.test(n[1]) && S.isPlainObject(t))
                for (n in t)
                    w(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
            return this
        }
        return (o = T.getElementById(n[2])) && (this[0] = o,
        this.length = 1),
        this
    }
    ).prototype = S.fn,
    z = S(T);
    var O = /^(?:parents|prev(?:Until|All))/
      , j = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    function L(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType; )
            ;
        return e
    }
    S.fn.extend({
        has: function(e) {
            var t = S(e, this)
              , i = t.length;
            return this.filter(function() {
                for (var e = 0; e < i; e++)
                    if (S.contains(this, t[e]))
                        return !0
            })
        },
        closest: function(e, t) {
            var i, n = 0, o = this.length, s = [], r = "string" != typeof e && S(e);
            if (!$.test(e))
                for (; n < o; n++)
                    for (i = this[n]; i && i !== t; i = i.parentNode)
                        if (i.nodeType < 11 && (r ? -1 < r.index(i) : 1 === i.nodeType && S.find.matchesSelector(i, e))) {
                            s.push(i);
                            break
                        }
            return this.pushStack(1 < s.length ? S.uniqueSort(s) : s)
        },
        index: function(e) {
            return e ? "string" == typeof e ? o.call(S(e), this[0]) : o.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }),
    S.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return f(e, "parentNode")
        },
        parentsUntil: function(e, t, i) {
            return f(e, "parentNode", i)
        },
        next: function(e) {
            return L(e, "nextSibling")
        },
        prev: function(e) {
            return L(e, "previousSibling")
        },
        nextAll: function(e) {
            return f(e, "nextSibling")
        },
        prevAll: function(e) {
            return f(e, "previousSibling")
        },
        nextUntil: function(e, t, i) {
            return f(e, "nextSibling", i)
        },
        prevUntil: function(e, t, i) {
            return f(e, "previousSibling", i)
        },
        siblings: function(e) {
            return _((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return _(e.firstChild)
        },
        contents: function(e) {
            return null != e.contentDocument && n(e.contentDocument) ? e.contentDocument : (k(e, "template") && (e = e.content || e),
            S.merge([], e.childNodes))
        }
    }, function(n, o) {
        S.fn[n] = function(e, t) {
            var i = S.map(this, o, e);
            return "Until" !== n.slice(-5) && (t = e),
            t && "string" == typeof t && (i = S.filter(t, i)),
            1 < this.length && (j[n] || S.uniqueSort(i),
            O.test(n) && i.reverse()),
            this.pushStack(i)
        }
    });
    var P = /[^\x20\t\r\n\f]+/g;
    function N(e) {
        return e
    }
    function M(e) {
        throw e
    }
    function I(e, t, i, n) {
        var o;
        try {
            e && w(o = e.promise) ? o.call(e).done(t).fail(i) : e && w(o = e.then) ? o.call(e, t, i) : t.apply(void 0, [e].slice(n))
        } catch (e) {
            i.apply(void 0, [e])
        }
    }
    S.Callbacks = function(n) {
        var i;
        n = "string" == typeof n ? (i = {},
        S.each(n.match(P) || [], function(e, t) {
            i[t] = !0
        }),
        i) : S.extend({}, n);
        function o() {
            for (r = r || n.once,
            t = s = !0; l.length; c = -1)
                for (e = l.shift(); ++c < a.length; )
                    !1 === a[c].apply(e[0], e[1]) && n.stopOnFalse && (c = a.length,
                    e = !1);
            n.memory || (e = !1),
            s = !1,
            r && (a = e ? [] : "")
        }
        var s, e, t, r, a = [], l = [], c = -1, d = {
            add: function() {
                return a && (e && !s && (c = a.length - 1,
                l.push(e)),
                function i(e) {
                    S.each(e, function(e, t) {
                        w(t) ? n.unique && d.has(t) || a.push(t) : t && t.length && "string" !== x(t) && i(t)
                    })
                }(arguments),
                e && !s && o()),
                this
            },
            remove: function() {
                return S.each(arguments, function(e, t) {
                    for (var i; -1 < (i = S.inArray(t, a, i)); )
                        a.splice(i, 1),
                        i <= c && c--
                }),
                this
            },
            has: function(e) {
                return e ? -1 < S.inArray(e, a) : 0 < a.length
            },
            empty: function() {
                return a = a && [],
                this
            },
            disable: function() {
                return r = l = [],
                a = e = "",
                this
            },
            disabled: function() {
                return !a
            },
            lock: function() {
                return r = l = [],
                e || s || (a = e = ""),
                this
            },
            locked: function() {
                return !!r
            },
            fireWith: function(e, t) {
                return r || (t = [e, (t = t || []).slice ? t.slice() : t],
                l.push(t),
                s || o()),
                this
            },
            fire: function() {
                return d.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!t
            }
        };
        return d
    }
    ,
    S.extend({
        Deferred: function(e) {
            var s = [["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2], ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"]]
              , o = "pending"
              , r = {
                state: function() {
                    return o
                },
                always: function() {
                    return a.done(arguments).fail(arguments),
                    this
                },
                catch: function(e) {
                    return r.then(null, e)
                },
                pipe: function() {
                    var o = arguments;
                    return S.Deferred(function(n) {
                        S.each(s, function(e, t) {
                            var i = w(o[t[4]]) && o[t[4]];
                            a[t[1]](function() {
                                var e = i && i.apply(this, arguments);
                                e && w(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[t[0] + "With"](this, i ? [e] : arguments)
                            })
                        }),
                        o = null
                    }).promise()
                },
                then: function(t, i, n) {
                    var l = 0;
                    function c(o, s, r, a) {
                        return function() {
                            function e() {
                                var e, t;
                                if (!(o < l)) {
                                    if ((e = r.apply(i, n)) === s.promise())
                                        throw new TypeError("Thenable self-resolution");
                                    t = e && ("object" == _typeof(e) || "function" == typeof e) && e.then,
                                    w(t) ? a ? t.call(e, c(l, s, N, a), c(l, s, M, a)) : (l++,
                                    t.call(e, c(l, s, N, a), c(l, s, M, a), c(l, s, N, s.notifyWith))) : (r !== N && (i = void 0,
                                    n = [e]),
                                    (a || s.resolveWith)(i, n))
                                }
                            }
                            var i = this
                              , n = arguments
                              , t = a ? e : function() {
                                try {
                                    e()
                                } catch (e) {
                                    S.Deferred.exceptionHook && S.Deferred.exceptionHook(e, t.stackTrace),
                                    l <= o + 1 && (r !== M && (i = void 0,
                                    n = [e]),
                                    s.rejectWith(i, n))
                                }
                            }
                            ;
                            o ? t() : (S.Deferred.getStackHook && (t.stackTrace = S.Deferred.getStackHook()),
                            C.setTimeout(t))
                        }
                    }
                    return S.Deferred(function(e) {
                        s[0][3].add(c(0, e, w(n) ? n : N, e.notifyWith)),
                        s[1][3].add(c(0, e, w(t) ? t : N)),
                        s[2][3].add(c(0, e, w(i) ? i : M))
                    }).promise()
                },
                promise: function(e) {
                    return null != e ? S.extend(e, r) : r
                }
            }
              , a = {};
            return S.each(s, function(e, t) {
                var i = t[2]
                  , n = t[5];
                r[t[1]] = i.add,
                n && i.add(function() {
                    o = n
                }, s[3 - e][2].disable, s[3 - e][3].disable, s[0][2].lock, s[0][3].lock),
                i.add(t[3].fire),
                a[t[0]] = function() {
                    return a[t[0] + "With"](this === a ? void 0 : this, arguments),
                    this
                }
                ,
                a[t[0] + "With"] = i.fireWith
            }),
            r.promise(a),
            e && e.call(a, a),
            a
        },
        when: function(e) {
            function t(t) {
                return function(e) {
                    o[t] = this,
                    s[t] = 1 < arguments.length ? a.call(arguments) : e,
                    --i || r.resolveWith(o, s)
                }
            }
            var i = arguments.length
              , n = i
              , o = Array(n)
              , s = a.call(arguments)
              , r = S.Deferred();
            if (i <= 1 && (I(e, r.done(t(n)).resolve, r.reject, !i),
            "pending" === r.state() || w(s[n] && s[n].then)))
                return r.then();
            for (; n--; )
                I(s[n], t(n), r.reject);
            return r.promise()
        }
    });
    var q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    S.Deferred.exceptionHook = function(e, t) {
        C.console && C.console.warn && e && q.test(e.name) && C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t)
    }
    ,
    S.readyException = function(e) {
        C.setTimeout(function() {
            throw e
        })
    }
    ;
    var H = S.Deferred();
    function R() {
        T.removeEventListener("DOMContentLoaded", R),
        C.removeEventListener("load", R),
        S.ready()
    }
    S.fn.ready = function(e) {
        return H.then(e).catch(function(e) {
            S.readyException(e)
        }),
        this
    }
    ,
    S.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(e) {
            (!0 === e ? --S.readyWait : S.isReady) || (S.isReady = !0) !== e && 0 < --S.readyWait || H.resolveWith(T, [S])
        }
    }),
    S.ready.then = H.then,
    "complete" === T.readyState || "loading" !== T.readyState && !T.documentElement.doScroll ? C.setTimeout(S.ready) : (T.addEventListener("DOMContentLoaded", R),
    C.addEventListener("load", R));
    function W(e, t, i, n, o, s, r) {
        var a = 0
          , l = e.length
          , c = null == i;
        if ("object" === x(i))
            for (a in o = !0,
            i)
                W(e, t, a, i[a], !0, s, r);
        else if (void 0 !== n && (o = !0,
        w(n) || (r = !0),
        c && (t = r ? (t.call(e, n),
        null) : (c = t,
        function(e, t, i) {
            return c.call(S(e), i)
        }
        )),
        t))
            for (; a < l; a++)
                t(e[a], i, r ? n : n.call(e[a], a, t(e[a], i)));
        return o ? e : c ? t.call(e) : l ? t(e[0], i) : s
    }
    var F = /^-ms-/
      , B = /-([a-z])/g;
    function U(e, t) {
        return t.toUpperCase()
    }
    function X(e) {
        return e.replace(F, "ms-").replace(B, U)
    }
    function G(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    }
    function Y() {
        this.expando = S.expando + Y.uid++
    }
    Y.uid = 1,
    Y.prototype = {
        cache: function(e) {
            var t = e[this.expando];
            return t || (t = {},
            G(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))),
            t
        },
        set: function(e, t, i) {
            var n, o = this.cache(e);
            if ("string" == typeof t)
                o[X(t)] = i;
            else
                for (n in t)
                    o[X(n)] = t[n];
            return o
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][X(t)]
        },
        access: function(e, t, i) {
            return void 0 === t || t && "string" == typeof t && void 0 === i ? this.get(e, t) : (this.set(e, t, i),
            void 0 !== i ? i : t)
        },
        remove: function(e, t) {
            var i, n = e[this.expando];
            if (void 0 !== n) {
                if (void 0 !== t) {
                    i = (t = Array.isArray(t) ? t.map(X) : (t = X(t))in n ? [t] : t.match(P) || []).length;
                    for (; i--; )
                        delete n[t[i]]
                }
                void 0 !== t && !S.isEmptyObject(n) || (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !S.isEmptyObject(t)
        }
    };
    var V = new Y
      , Q = new Y
      , K = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , Z = /[A-Z]/g;
    function J(e, t, i) {
        var n, o;
        if (void 0 === i && 1 === e.nodeType)
            if (n = "data-" + t.replace(Z, "-$&").toLowerCase(),
            "string" == typeof (i = e.getAttribute(n))) {
                try {
                    i = "true" === (o = i) || "false" !== o && ("null" === o ? null : o === +o + "" ? +o : K.test(o) ? JSON.parse(o) : o)
                } catch (e) {}
                Q.set(e, t, i)
            } else
                i = void 0;
        return i
    }
    S.extend({
        hasData: function(e) {
            return Q.hasData(e) || V.hasData(e)
        },
        data: function(e, t, i) {
            return Q.access(e, t, i)
        },
        removeData: function(e, t) {
            Q.remove(e, t)
        },
        _data: function(e, t, i) {
            return V.access(e, t, i)
        },
        _removeData: function(e, t) {
            V.remove(e, t)
        }
    }),
    S.fn.extend({
        data: function(i, e) {
            var t, n, o, s = this[0], r = s && s.attributes;
            if (void 0 !== i)
                return "object" == _typeof(i) ? this.each(function() {
                    Q.set(this, i)
                }) : W(this, function(e) {
                    var t;
                    if (s && void 0 === e)
                        return void 0 !== (t = Q.get(s, i)) || void 0 !== (t = J(s, i)) ? t : void 0;
                    this.each(function() {
                        Q.set(this, i, e)
                    })
                }, null, e, 1 < arguments.length, null, !0);
            if (this.length && (o = Q.get(s),
            1 === s.nodeType && !V.get(s, "hasDataAttrs"))) {
                for (t = r.length; t--; )
                    r[t] && 0 === (n = r[t].name).indexOf("data-") && (n = X(n.slice(5)),
                    J(s, n, o[n]));
                V.set(s, "hasDataAttrs", !0)
            }
            return o
        },
        removeData: function(e) {
            return this.each(function() {
                Q.remove(this, e)
            })
        }
    }),
    S.extend({
        queue: function(e, t, i) {
            var n;
            if (e)
                return t = (t || "fx") + "queue",
                n = V.get(e, t),
                i && (!n || Array.isArray(i) ? n = V.access(e, t, S.makeArray(i)) : n.push(i)),
                n || []
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var i = S.queue(e, t)
              , n = i.length
              , o = i.shift()
              , s = S._queueHooks(e, t);
            "inprogress" === o && (o = i.shift(),
            n--),
            o && ("fx" === t && i.unshift("inprogress"),
            delete s.stop,
            o.call(e, function() {
                S.dequeue(e, t)
            }, s)),
            !n && s && s.empty.fire()
        },
        _queueHooks: function(e, t) {
            var i = t + "queueHooks";
            return V.get(e, i) || V.access(e, i, {
                empty: S.Callbacks("once memory").add(function() {
                    V.remove(e, [t + "queue", i])
                })
            })
        }
    }),
    S.fn.extend({
        queue: function(t, i) {
            var e = 2;
            return "string" != typeof t && (i = t,
            t = "fx",
            e--),
            arguments.length < e ? S.queue(this[0], t) : void 0 === i ? this : this.each(function() {
                var e = S.queue(this, t, i);
                S._queueHooks(this, t),
                "fx" === t && "inprogress" !== e[0] && S.dequeue(this, t)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                S.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            function i() {
                --o || s.resolveWith(r, [r])
            }
            var n, o = 1, s = S.Deferred(), r = this, a = this.length;
            for ("string" != typeof e && (t = e,
            e = void 0),
            e = e || "fx"; a--; )
                (n = V.get(r[a], e + "queueHooks")) && n.empty && (o++,
                n.empty.add(i));
            return i(),
            s.promise(t)
        }
    });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$","i")
      , ie = ["Top", "Right", "Bottom", "Left"]
      , ne = T.documentElement
      , oe = function(e) {
        return S.contains(e.ownerDocument, e)
    }
      , se = {
        composed: !0
    };
    ne.getRootNode && (oe = function(e) {
        return S.contains(e.ownerDocument, e) || e.getRootNode(se) === e.ownerDocument
    }
    );
    function re(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && oe(e) && "none" === S.css(e, "display")
    }
    function ae(e, t, i, n) {
        var o, s, r = 20, a = n ? function() {
            return n.cur()
        }
        : function() {
            return S.css(e, t, "")
        }
        , l = a(), c = i && i[3] || (S.cssNumber[t] ? "" : "px"), d = e.nodeType && (S.cssNumber[t] || "px" !== c && +l) && te.exec(S.css(e, t));
        if (d && d[3] !== c) {
            for (l /= 2,
            c = c || d[3],
            d = +l || 1; r--; )
                S.style(e, t, d + c),
                (1 - s) * (1 - (s = a() / l || .5)) <= 0 && (r = 0),
                d /= s;
            d *= 2,
            S.style(e, t, d + c),
            i = i || []
        }
        return i && (d = +d || +l || 0,
        o = i[1] ? d + (i[1] + 1) * i[2] : +i[2],
        n && (n.unit = c,
        n.start = d,
        n.end = o)),
        o
    }
    var le = {};
    function ce(e, t) {
        for (var i, n, o, s, r, a, l = [], c = 0, d = e.length; c < d; c++)
            (n = e[c]).style && (i = n.style.display,
            t ? ("none" === i && (l[c] = V.get(n, "display") || null,
            l[c] || (n.style.display = "")),
            "" === n.style.display && re(n) && (l[c] = (a = s = o = void 0,
            s = n.ownerDocument,
            r = n.nodeName,
            (a = le[r]) || (o = s.body.appendChild(s.createElement(r)),
            a = S.css(o, "display"),
            o.parentNode.removeChild(o),
            "none" === a && (a = "block"),
            le[r] = a)))) : "none" !== i && (l[c] = "none",
            V.set(n, "display", i)));
        for (c = 0; c < d; c++)
            null != l[c] && (e[c].style.display = l[c]);
        return e
    }
    S.fn.extend({
        show: function() {
            return ce(this, !0)
        },
        hide: function() {
            return ce(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                re(this) ? S(this).show() : S(this).hide()
            })
        }
    });
    var de, ue, pe = /^(?:checkbox|radio)$/i, he = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, fe = /^$|^module$|\/(?:java|ecma)script/i;
    de = T.createDocumentFragment().appendChild(T.createElement("div")),
    (ue = T.createElement("input")).setAttribute("type", "radio"),
    ue.setAttribute("checked", "checked"),
    ue.setAttribute("name", "t"),
    de.appendChild(ue),
    y.checkClone = de.cloneNode(!0).cloneNode(!0).lastChild.checked,
    de.innerHTML = "<textarea>x</textarea>",
    y.noCloneChecked = !!de.cloneNode(!0).lastChild.defaultValue,
    de.innerHTML = "<option></option>",
    y.option = !!de.lastChild;
    var ge = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    function me(e, t) {
        var i;
        return i = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [],
        void 0 === t || t && k(e, t) ? S.merge([e], i) : i
    }
    function ve(e, t) {
        for (var i = 0, n = e.length; i < n; i++)
            V.set(e[i], "globalEval", !t || V.get(t[i], "globalEval"))
    }
    ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead,
    ge.th = ge.td,
    y.option || (ge.optgroup = ge.option = [1, "<select multiple='multiple'>", "</select>"]);
    var ye = /<|&#?\w+;/;
    function we(e, t, i, n, o) {
        for (var s, r, a, l, c, d, u = t.createDocumentFragment(), p = [], h = 0, f = e.length; h < f; h++)
            if ((s = e[h]) || 0 === s)
                if ("object" === x(s))
                    S.merge(p, s.nodeType ? [s] : s);
                else if (ye.test(s)) {
                    for (r = r || u.appendChild(t.createElement("div")),
                    a = (he.exec(s) || ["", ""])[1].toLowerCase(),
                    l = ge[a] || ge._default,
                    r.innerHTML = l[1] + S.htmlPrefilter(s) + l[2],
                    d = l[0]; d--; )
                        r = r.lastChild;
                    S.merge(p, r.childNodes),
                    (r = u.firstChild).textContent = ""
                } else
                    p.push(t.createTextNode(s));
        for (u.textContent = "",
        h = 0; s = p[h++]; )
            if (n && -1 < S.inArray(s, n))
                o && o.push(s);
            else if (c = oe(s),
            r = me(u.appendChild(s), "script"),
            c && ve(r),
            i)
                for (d = 0; s = r[d++]; )
                    fe.test(s.type || "") && i.push(s);
        return u
    }
    var be = /^key/
      , xe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , _e = /^([^.]*)(?:\.(.+)|)/;
    function Ce() {
        return !0
    }
    function Te() {
        return !1
    }
    function Se(e, t) {
        return e === function() {
            try {
                return T.activeElement
            } catch (e) {}
        }() == ("focus" === t)
    }
    function $e(e, t, i, n, o, s) {
        var r, a;
        if ("object" == _typeof(t)) {
            for (a in "string" != typeof i && (n = n || i,
            i = void 0),
            t)
                $e(e, a, i, n, t[a], s);
            return e
        }
        if (null == n && null == o ? (o = i,
        n = i = void 0) : null == o && ("string" == typeof i ? (o = n,
        n = void 0) : (o = n,
        n = i,
        i = void 0)),
        !1 === o)
            o = Te;
        else if (!o)
            return e;
        return 1 === s && (r = o,
        (o = function(e) {
            return S().off(e),
            r.apply(this, arguments)
        }
        ).guid = r.guid || (r.guid = S.guid++)),
        e.each(function() {
            S.event.add(this, t, o, n, i)
        })
    }
    function ke(e, o, s) {
        s ? (V.set(e, o, !1),
        S.event.add(e, o, {
            namespace: !1,
            handler: function(e) {
                var t, i, n = V.get(this, o);
                if (1 & e.isTrigger && this[o]) {
                    if (n.length)
                        (S.event.special[o] || {}).delegateType && e.stopPropagation();
                    else if (n = a.call(arguments),
                    V.set(this, o, n),
                    t = s(this, o),
                    this[o](),
                    n !== (i = V.get(this, o)) || t ? V.set(this, o, !1) : i = {},
                    n !== i)
                        return e.stopImmediatePropagation(),
                        e.preventDefault(),
                        i.value
                } else
                    n.length && (V.set(this, o, {
                        value: S.event.trigger(S.extend(n[0], S.Event.prototype), n.slice(1), this)
                    }),
                    e.stopImmediatePropagation())
            }
        })) : void 0 === V.get(e, o) && S.event.add(e, o, Ce)
    }
    S.event = {
        global: {},
        add: function(t, e, i, n, o) {
            var s, r, a, l, c, d, u, p, h, f, g, m = V.get(t);
            if (G(t))
                for (i.handler && (i = (s = i).handler,
                o = s.selector),
                o && S.find.matchesSelector(ne, o),
                i.guid || (i.guid = S.guid++),
                (l = m.events) || (l = m.events = Object.create(null)),
                (r = m.handle) || (r = m.handle = function(e) {
                    return void 0 !== S && S.event.triggered !== e.type ? S.event.dispatch.apply(t, arguments) : void 0
                }
                ),
                c = (e = (e || "").match(P) || [""]).length; c--; )
                    h = g = (a = _e.exec(e[c]) || [])[1],
                    f = (a[2] || "").split(".").sort(),
                    h && (u = S.event.special[h] || {},
                    h = (o ? u.delegateType : u.bindType) || h,
                    u = S.event.special[h] || {},
                    d = S.extend({
                        type: h,
                        origType: g,
                        data: n,
                        handler: i,
                        guid: i.guid,
                        selector: o,
                        needsContext: o && S.expr.match.needsContext.test(o),
                        namespace: f.join(".")
                    }, s),
                    (p = l[h]) || ((p = l[h] = []).delegateCount = 0,
                    u.setup && !1 !== u.setup.call(t, n, f, r) || t.addEventListener && t.addEventListener(h, r)),
                    u.add && (u.add.call(t, d),
                    d.handler.guid || (d.handler.guid = i.guid)),
                    o ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                    S.event.global[h] = !0)
        },
        remove: function(e, t, i, n, o) {
            var s, r, a, l, c, d, u, p, h, f, g, m = V.hasData(e) && V.get(e);
            if (m && (l = m.events)) {
                for (c = (t = (t || "").match(P) || [""]).length; c--; )
                    if (h = g = (a = _e.exec(t[c]) || [])[1],
                    f = (a[2] || "").split(".").sort(),
                    h) {
                        for (u = S.event.special[h] || {},
                        p = l[h = (n ? u.delegateType : u.bindType) || h] || [],
                        a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        r = s = p.length; s--; )
                            d = p[s],
                            !o && g !== d.origType || i && i.guid !== d.guid || a && !a.test(d.namespace) || n && n !== d.selector && ("**" !== n || !d.selector) || (p.splice(s, 1),
                            d.selector && p.delegateCount--,
                            u.remove && u.remove.call(e, d));
                        r && !p.length && (u.teardown && !1 !== u.teardown.call(e, f, m.handle) || S.removeEvent(e, h, m.handle),
                        delete l[h])
                    } else
                        for (h in l)
                            S.event.remove(e, h + t[c], i, n, !0);
                S.isEmptyObject(l) && V.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            var t, i, n, o, s, r, a = new Array(arguments.length), l = S.event.fix(e), c = (V.get(this, "events") || Object.create(null))[l.type] || [], d = S.event.special[l.type] || {};
            for (a[0] = l,
            t = 1; t < arguments.length; t++)
                a[t] = arguments[t];
            if (l.delegateTarget = this,
            !d.preDispatch || !1 !== d.preDispatch.call(this, l)) {
                for (r = S.event.handlers.call(this, l, c),
                t = 0; (o = r[t++]) && !l.isPropagationStopped(); )
                    for (l.currentTarget = o.elem,
                    i = 0; (s = o.handlers[i++]) && !l.isImmediatePropagationStopped(); )
                        l.rnamespace && !1 !== s.namespace && !l.rnamespace.test(s.namespace) || (l.handleObj = s,
                        l.data = s.data,
                        void 0 !== (n = ((S.event.special[s.origType] || {}).handle || s.handler).apply(o.elem, a)) && !1 === (l.result = n) && (l.preventDefault(),
                        l.stopPropagation()));
                return d.postDispatch && d.postDispatch.call(this, l),
                l.result
            }
        },
        handlers: function(e, t) {
            var i, n, o, s, r, a = [], l = t.delegateCount, c = e.target;
            if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                        for (s = [],
                        r = {},
                        i = 0; i < l; i++)
                            void 0 === r[o = (n = t[i]).selector + " "] && (r[o] = n.needsContext ? -1 < S(o, this).index(c) : S.find(o, this, null, [c]).length),
                            r[o] && s.push(n);
                        s.length && a.push({
                            elem: c,
                            handlers: s
                        })
                    }
            return c = this,
            l < t.length && a.push({
                elem: c,
                handlers: t.slice(l)
            }),
            a
        },
        addProp: function(t, e) {
            Object.defineProperty(S.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: w(e) ? function() {
                    if (this.originalEvent)
                        return e(this.originalEvent)
                }
                : function() {
                    if (this.originalEvent)
                        return this.originalEvent[t]
                }
                ,
                set: function(e) {
                    Object.defineProperty(this, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: e
                    })
                }
            })
        },
        fix: function(e) {
            return e[S.expando] ? e : new S.Event(e)
        },
        special: {
            load: {
                noBubble: !0
            },
            click: {
                setup: function(e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && k(t, "input") && ke(t, "click", Ce),
                    !1
                },
                trigger: function(e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && k(t, "input") && ke(t, "click"),
                    !0
                },
                _default: function(e) {
                    var t = e.target;
                    return pe.test(t.type) && t.click && k(t, "input") && V.get(t, "click") || k(t, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    },
    S.removeEvent = function(e, t, i) {
        e.removeEventListener && e.removeEventListener(t, i)
    }
    ,
    S.Event = function(e, t) {
        if (!(this instanceof S.Event))
            return new S.Event(e,t);
        e && e.type ? (this.originalEvent = e,
        this.type = e.type,
        this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ce : Te,
        this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target,
        this.currentTarget = e.currentTarget,
        this.relatedTarget = e.relatedTarget) : this.type = e,
        t && S.extend(this, t),
        this.timeStamp = e && e.timeStamp || Date.now(),
        this[S.expando] = !0
    }
    ,
    S.Event.prototype = {
        constructor: S.Event,
        isDefaultPrevented: Te,
        isPropagationStopped: Te,
        isImmediatePropagationStopped: Te,
        isSimulated: !1,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = Ce,
            e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = Ce,
            e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = Ce,
            e && !this.isSimulated && e.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    S.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(e) {
            var t = e.button;
            return null == e.which && be.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && xe.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
        }
    }, S.event.addProp),
    S.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        S.event.special[e] = {
            setup: function() {
                return ke(this, e, Se),
                !1
            },
            trigger: function() {
                return ke(this, e),
                !0
            },
            delegateType: t
        }
    }),
    S.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, o) {
        S.event.special[e] = {
            delegateType: o,
            bindType: o,
            handle: function(e) {
                var t, i = e.relatedTarget, n = e.handleObj;
                return i && (i === this || S.contains(this, i)) || (e.type = n.origType,
                t = n.handler.apply(this, arguments),
                e.type = o),
                t
            }
        }
    }),
    S.fn.extend({
        on: function(e, t, i, n) {
            return $e(this, e, t, i, n)
        },
        one: function(e, t, i, n) {
            return $e(this, e, t, i, n, 1)
        },
        off: function(e, t, i) {
            var n, o;
            if (e && e.preventDefault && e.handleObj)
                return n = e.handleObj,
                S(e.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler),
                this;
            if ("object" != _typeof(e))
                return !1 !== t && "function" != typeof t || (i = t,
                t = void 0),
                !1 === i && (i = Te),
                this.each(function() {
                    S.event.remove(this, e, i, t)
                });
            for (o in e)
                this.off(o, t, e[o]);
            return this
        }
    });
    var Ae = /<script|<style|<link/i
      , Ee = /checked\s*(?:[^=]|=\s*.checked.)/i
      , ze = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function De(e, t) {
        return k(e, "table") && k(11 !== t.nodeType ? t : t.firstChild, "tr") && S(e).children("tbody")[0] || e
    }
    function Oe(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type,
        e
    }
    function je(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"),
        e
    }
    function Le(e, t) {
        var i, n, o, s, r, a;
        if (1 === t.nodeType) {
            if (V.hasData(e) && (a = V.get(e).events))
                for (o in V.remove(t, "handle events"),
                a)
                    for (i = 0,
                    n = a[o].length; i < n; i++)
                        S.event.add(t, o, a[o][i]);
            Q.hasData(e) && (s = Q.access(e),
            r = S.extend({}, s),
            Q.set(t, r))
        }
    }
    function Pe(i, n, o, s) {
        n = m(n);
        var e, t, r, a, l, c, d = 0, u = i.length, p = u - 1, h = n[0], f = w(h);
        if (f || 1 < u && "string" == typeof h && !y.checkClone && Ee.test(h))
            return i.each(function(e) {
                var t = i.eq(e);
                f && (n[0] = h.call(this, e, t.html())),
                Pe(t, n, o, s)
            });
        if (u && (t = (e = we(n, i[0].ownerDocument, !1, i, s)).firstChild,
        1 === e.childNodes.length && (e = t),
        t || s)) {
            for (a = (r = S.map(me(e, "script"), Oe)).length; d < u; d++)
                l = e,
                d !== p && (l = S.clone(l, !0, !0),
                a && S.merge(r, me(l, "script"))),
                o.call(i[d], l, d);
            if (a)
                for (c = r[r.length - 1].ownerDocument,
                S.map(r, je),
                d = 0; d < a; d++)
                    l = r[d],
                    fe.test(l.type || "") && !V.access(l, "globalEval") && S.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? S._evalUrl && !l.noModule && S._evalUrl(l.src, {
                        nonce: l.nonce || l.getAttribute("nonce")
                    }, c) : b(l.textContent.replace(ze, ""), l, c))
        }
        return i
    }
    function Ne(e, t, i) {
        for (var n, o = t ? S.filter(t, e) : e, s = 0; null != (n = o[s]); s++)
            i || 1 !== n.nodeType || S.cleanData(me(n)),
            n.parentNode && (i && oe(n) && ve(me(n, "script")),
            n.parentNode.removeChild(n));
        return e
    }
    S.extend({
        htmlPrefilter: function(e) {
            return e
        },
        clone: function(e, t, i) {
            var n, o, s, r, a, l, c, d = e.cloneNode(!0), u = oe(e);
            if (!(y.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || S.isXMLDoc(e)))
                for (r = me(d),
                n = 0,
                o = (s = me(e)).length; n < o; n++)
                    a = s[n],
                    "input" === (c = (l = r[n]).nodeName.toLowerCase()) && pe.test(a.type) ? l.checked = a.checked : "input" !== c && "textarea" !== c || (l.defaultValue = a.defaultValue);
            if (t)
                if (i)
                    for (s = s || me(e),
                    r = r || me(d),
                    n = 0,
                    o = s.length; n < o; n++)
                        Le(s[n], r[n]);
                else
                    Le(e, d);
            return 0 < (r = me(d, "script")).length && ve(r, !u && me(e, "script")),
            d
        },
        cleanData: function(e) {
            for (var t, i, n, o = S.event.special, s = 0; void 0 !== (i = e[s]); s++)
                if (G(i)) {
                    if (t = i[V.expando]) {
                        if (t.events)
                            for (n in t.events)
                                o[n] ? S.event.remove(i, n) : S.removeEvent(i, n, t.handle);
                        i[V.expando] = void 0
                    }
                    i[Q.expando] && (i[Q.expando] = void 0)
                }
        }
    }),
    S.fn.extend({
        detach: function(e) {
            return Ne(this, e, !0)
        },
        remove: function(e) {
            return Ne(this, e)
        },
        text: function(e) {
            return W(this, function(e) {
                return void 0 === e ? S.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return Pe(this, arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || De(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return Pe(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = De(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return Pe(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return Pe(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++)
                1 === e.nodeType && (S.cleanData(me(e, !1)),
                e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e,
            t = null == t ? e : t,
            this.map(function() {
                return S.clone(this, e, t)
            })
        },
        html: function(e) {
            return W(this, function(e) {
                var t = this[0] || {}
                  , i = 0
                  , n = this.length;
                if (void 0 === e && 1 === t.nodeType)
                    return t.innerHTML;
                if ("string" == typeof e && !Ae.test(e) && !ge[(he.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = S.htmlPrefilter(e);
                    try {
                        for (; i < n; i++)
                            1 === (t = this[i] || {}).nodeType && (S.cleanData(me(t, !1)),
                            t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var i = [];
            return Pe(this, arguments, function(e) {
                var t = this.parentNode;
                S.inArray(this, i) < 0 && (S.cleanData(me(this)),
                t && t.replaceChild(e, this))
            }, i)
        }
    }),
    S.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, r) {
        S.fn[e] = function(e) {
            for (var t, i = [], n = S(e), o = n.length - 1, s = 0; s <= o; s++)
                t = s === o ? this : this.clone(!0),
                S(n[s])[r](t),
                l.apply(i, t.get());
            return this.pushStack(i)
        }
    });
    function Me(e, t, i) {
        var n, o, s = {};
        for (o in t)
            s[o] = e.style[o],
            e.style[o] = t[o];
        for (o in n = i.call(e),
        t)
            e.style[o] = s[o];
        return n
    }
    var Ie, qe, He, Re, We, Fe, Be, Ue, Xe = new RegExp("^(" + ee + ")(?!px)[a-z%]+$","i"), Ge = function(e) {
        var t = e.ownerDocument.defaultView;
        return t && t.opener || (t = C),
        t.getComputedStyle(e)
    }, Ye = new RegExp(ie.join("|"),"i");
    function Ve(e, t, i) {
        var n, o, s, r, a = e.style;
        return (i = i || Ge(e)) && ("" !== (r = i.getPropertyValue(t) || i[t]) || oe(e) || (r = S.style(e, t)),
        !y.pixelBoxStyles() && Xe.test(r) && Ye.test(t) && (n = a.width,
        o = a.minWidth,
        s = a.maxWidth,
        a.minWidth = a.maxWidth = a.width = r,
        r = i.width,
        a.width = n,
        a.minWidth = o,
        a.maxWidth = s)),
        void 0 !== r ? r + "" : r
    }
    function Qe(e, t) {
        return {
            get: function() {
                if (!e())
                    return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }
    function Ke() {
        if (Ue) {
            Be.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
            Ue.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
            ne.appendChild(Be).appendChild(Ue);
            var e = C.getComputedStyle(Ue);
            Ie = "1%" !== e.top,
            Fe = 12 === Ze(e.marginLeft),
            Ue.style.right = "60%",
            Re = 36 === Ze(e.right),
            qe = 36 === Ze(e.width),
            Ue.style.position = "absolute",
            He = 12 === Ze(Ue.offsetWidth / 3),
            ne.removeChild(Be),
            Ue = null
        }
    }
    function Ze(e) {
        return Math.round(parseFloat(e))
    }
    Be = T.createElement("div"),
    (Ue = T.createElement("div")).style && (Ue.style.backgroundClip = "content-box",
    Ue.cloneNode(!0).style.backgroundClip = "",
    y.clearCloneStyle = "content-box" === Ue.style.backgroundClip,
    S.extend(y, {
        boxSizingReliable: function() {
            return Ke(),
            qe
        },
        pixelBoxStyles: function() {
            return Ke(),
            Re
        },
        pixelPosition: function() {
            return Ke(),
            Ie
        },
        reliableMarginLeft: function() {
            return Ke(),
            Fe
        },
        scrollboxSize: function() {
            return Ke(),
            He
        },
        reliableTrDimensions: function() {
            var e, t, i, n;
            return null == We && (e = T.createElement("table"),
            t = T.createElement("tr"),
            i = T.createElement("div"),
            e.style.cssText = "position:absolute;left:-11111px",
            t.style.height = "1px",
            i.style.height = "9px",
            ne.appendChild(e).appendChild(t).appendChild(i),
            n = C.getComputedStyle(t),
            We = 3 < parseInt(n.height),
            ne.removeChild(e)),
            We
        }
    }));
    var Je = ["Webkit", "Moz", "ms"]
      , et = T.createElement("div").style
      , tt = {};
    function it(e) {
        return S.cssProps[e] || tt[e] || (e in et ? e : tt[e] = function(e) {
            for (var t = e[0].toUpperCase() + e.slice(1), i = Je.length; i--; )
                if ((e = Je[i] + t)in et)
                    return e
        }(e) || e)
    }
    var nt = /^(none|table(?!-c[ea]).+)/
      , ot = /^--/
      , st = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , rt = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function at(e, t, i) {
        var n = te.exec(t);
        return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t
    }
    function lt(e, t, i, n, o, s) {
        var r = "width" === t ? 1 : 0
          , a = 0
          , l = 0;
        if (i === (n ? "border" : "content"))
            return 0;
        for (; r < 4; r += 2)
            "margin" === i && (l += S.css(e, i + ie[r], !0, o)),
            n ? ("content" === i && (l -= S.css(e, "padding" + ie[r], !0, o)),
            "margin" !== i && (l -= S.css(e, "border" + ie[r] + "Width", !0, o))) : (l += S.css(e, "padding" + ie[r], !0, o),
            "padding" !== i ? l += S.css(e, "border" + ie[r] + "Width", !0, o) : a += S.css(e, "border" + ie[r] + "Width", !0, o));
        return !n && 0 <= s && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - s - l - a - .5)) || 0),
        l
    }
    function ct(e, t, i) {
        var n = Ge(e)
          , o = (!y.boxSizingReliable() || i) && "border-box" === S.css(e, "boxSizing", !1, n)
          , s = o
          , r = Ve(e, t, n)
          , a = "offset" + t[0].toUpperCase() + t.slice(1);
        if (Xe.test(r)) {
            if (!i)
                return r;
            r = "auto"
        }
        return (!y.boxSizingReliable() && o || !y.reliableTrDimensions() && k(e, "tr") || "auto" === r || !parseFloat(r) && "inline" === S.css(e, "display", !1, n)) && e.getClientRects().length && (o = "border-box" === S.css(e, "boxSizing", !1, n),
        (s = a in e) && (r = e[a])),
        (r = parseFloat(r) || 0) + lt(e, t, i || (o ? "border" : "content"), s, n, r) + "px"
    }
    function dt(e, t, i, n, o) {
        return new dt.prototype.init(e,t,i,n,o)
    }
    S.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var i = Ve(e, "opacity");
                        return "" === i ? "1" : i
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(e, t, i, n) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var o, s, r, a = X(t), l = ot.test(t), c = e.style;
                if (l || (t = it(a)),
                r = S.cssHooks[t] || S.cssHooks[a],
                void 0 === i)
                    return r && "get"in r && void 0 !== (o = r.get(e, !1, n)) ? o : c[t];
                "string" === (s = _typeof(i)) && (o = te.exec(i)) && o[1] && (i = ae(e, t, o),
                s = "number"),
                null != i && i == i && ("number" !== s || l || (i += o && o[3] || (S.cssNumber[a] ? "" : "px")),
                y.clearCloneStyle || "" !== i || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                r && "set"in r && void 0 === (i = r.set(e, i, n)) || (l ? c.setProperty(t, i) : c[t] = i))
            }
        },
        css: function(e, t, i, n) {
            var o, s, r, a = X(t);
            return ot.test(t) || (t = it(a)),
            (r = S.cssHooks[t] || S.cssHooks[a]) && "get"in r && (o = r.get(e, !0, i)),
            void 0 === o && (o = Ve(e, t, n)),
            "normal" === o && t in rt && (o = rt[t]),
            "" === i || i ? (s = parseFloat(o),
            !0 === i || isFinite(s) ? s || 0 : o) : o
        }
    }),
    S.each(["height", "width"], function(e, l) {
        S.cssHooks[l] = {
            get: function(e, t, i) {
                if (t)
                    return !nt.test(S.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? ct(e, l, i) : Me(e, st, function() {
                        return ct(e, l, i)
                    })
            },
            set: function(e, t, i) {
                var n, o = Ge(e), s = !y.scrollboxSize() && "absolute" === o.position, r = (s || i) && "border-box" === S.css(e, "boxSizing", !1, o), a = i ? lt(e, l, i, r, o) : 0;
                return r && s && (a -= Math.ceil(e["offset" + l[0].toUpperCase() + l.slice(1)] - parseFloat(o[l]) - lt(e, l, "border", !1, o) - .5)),
                a && (n = te.exec(t)) && "px" !== (n[3] || "px") && (e.style[l] = t,
                t = S.css(e, l)),
                at(0, t, a)
            }
        }
    }),
    S.cssHooks.marginLeft = Qe(y.reliableMarginLeft, function(e, t) {
        if (t)
            return (parseFloat(Ve(e, "marginLeft")) || e.getBoundingClientRect().left - Me(e, {
                marginLeft: 0
            }, function() {
                return e.getBoundingClientRect().left
            })) + "px"
    }),
    S.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(o, s) {
        S.cssHooks[o + s] = {
            expand: function(e) {
                for (var t = 0, i = {}, n = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++)
                    i[o + ie[t] + s] = n[t] || n[t - 2] || n[0];
                return i
            }
        },
        "margin" !== o && (S.cssHooks[o + s].set = at)
    }),
    S.fn.extend({
        css: function(e, t) {
            return W(this, function(e, t, i) {
                var n, o, s = {}, r = 0;
                if (Array.isArray(t)) {
                    for (n = Ge(e),
                    o = t.length; r < o; r++)
                        s[t[r]] = S.css(e, t[r], !1, n);
                    return s
                }
                return void 0 !== i ? S.style(e, t, i) : S.css(e, t)
            }, e, t, 1 < arguments.length)
        }
    }),
    ((S.Tween = dt).prototype = {
        constructor: dt,
        init: function(e, t, i, n, o, s) {
            this.elem = e,
            this.prop = i,
            this.easing = o || S.easing._default,
            this.options = t,
            this.start = this.now = this.cur(),
            this.end = n,
            this.unit = s || (S.cssNumber[i] ? "" : "px")
        },
        cur: function() {
            var e = dt.propHooks[this.prop];
            return e && e.get ? e.get(this) : dt.propHooks._default.get(this)
        },
        run: function(e) {
            var t, i = dt.propHooks[this.prop];
            return this.options.duration ? this.pos = t = S.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e,
            this.now = (this.end - this.start) * t + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            i && i.set ? i.set(this) : dt.propHooks._default.set(this),
            this
        }
    }).init.prototype = dt.prototype,
    (dt.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = S.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            },
            set: function(e) {
                S.fx.step[e.prop] ? S.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !S.cssHooks[e.prop] && null == e.elem.style[it(e.prop)] ? e.elem[e.prop] = e.now : S.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    }).scrollTop = dt.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    },
    S.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    },
    S.fx = dt.prototype.init,
    S.fx.step = {};
    var ut, pt, ht, ft, gt = /^(?:toggle|show|hide)$/, mt = /queueHooks$/;
    function vt() {
        pt && (!1 === T.hidden && C.requestAnimationFrame ? C.requestAnimationFrame(vt) : C.setTimeout(vt, S.fx.interval),
        S.fx.tick())
    }
    function yt() {
        return C.setTimeout(function() {
            ut = void 0
        }),
        ut = Date.now()
    }
    function wt(e, t) {
        var i, n = 0, o = {
            height: e
        };
        for (t = t ? 1 : 0; n < 4; n += 2 - t)
            o["margin" + (i = ie[n])] = o["padding" + i] = e;
        return t && (o.opacity = o.width = e),
        o
    }
    function bt(e, t, i) {
        for (var n, o = (xt.tweeners[t] || []).concat(xt.tweeners["*"]), s = 0, r = o.length; s < r; s++)
            if (n = o[s].call(i, t, e))
                return n
    }
    function xt(s, e, t) {
        var i, r, n = 0, o = xt.prefilters.length, a = S.Deferred().always(function() {
            delete l.elem
        }), l = function() {
            if (r)
                return !1;
            for (var e = ut || yt(), t = Math.max(0, c.startTime + c.duration - e), i = 1 - (t / c.duration || 0), n = 0, o = c.tweens.length; n < o; n++)
                c.tweens[n].run(i);
            return a.notifyWith(s, [c, i, t]),
            i < 1 && o ? t : (o || a.notifyWith(s, [c, 1, 0]),
            a.resolveWith(s, [c]),
            !1)
        }, c = a.promise({
            elem: s,
            props: S.extend({}, e),
            opts: S.extend(!0, {
                specialEasing: {},
                easing: S.easing._default
            }, t),
            originalProperties: e,
            originalOptions: t,
            startTime: ut || yt(),
            duration: t.duration,
            tweens: [],
            createTween: function(e, t) {
                var i = S.Tween(s, c.opts, e, t, c.opts.specialEasing[e] || c.opts.easing);
                return c.tweens.push(i),
                i
            },
            stop: function(e) {
                var t = 0
                  , i = e ? c.tweens.length : 0;
                if (r)
                    return this;
                for (r = !0; t < i; t++)
                    c.tweens[t].run(1);
                return e ? (a.notifyWith(s, [c, 1, 0]),
                a.resolveWith(s, [c, e])) : a.rejectWith(s, [c, e]),
                this
            }
        }), d = c.props;
        for (function(e, t) {
            var i, n, o, s, r;
            for (i in e)
                if (o = t[n = X(i)],
                s = e[i],
                Array.isArray(s) && (o = s[1],
                s = e[i] = s[0]),
                i !== n && (e[n] = s,
                delete e[i]),
                (r = S.cssHooks[n]) && "expand"in r)
                    for (i in s = r.expand(s),
                    delete e[n],
                    s)
                        i in e || (e[i] = s[i],
                        t[i] = o);
                else
                    t[n] = o
        }(d, c.opts.specialEasing); n < o; n++)
            if (i = xt.prefilters[n].call(c, s, d, c.opts))
                return w(i.stop) && (S._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)),
                i;
        return S.map(d, bt, c),
        w(c.opts.start) && c.opts.start.call(s, c),
        c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
        S.fx.timer(S.extend(l, {
            elem: s,
            anim: c,
            queue: c.opts.queue
        })),
        c
    }
    S.Animation = S.extend(xt, {
        tweeners: {
            "*": [function(e, t) {
                var i = this.createTween(e, t);
                return ae(i.elem, e, te.exec(t), i),
                i
            }
            ]
        },
        tweener: function(e, t) {
            for (var i, n = 0, o = (e = w(e) ? (t = e,
            ["*"]) : e.match(P)).length; n < o; n++)
                i = e[n],
                xt.tweeners[i] = xt.tweeners[i] || [],
                xt.tweeners[i].unshift(t)
        },
        prefilters: [function(e, t, i) {
            var n, o, s, r, a, l, c, d, u = "width"in t || "height"in t, p = this, h = {}, f = e.style, g = e.nodeType && re(e), m = V.get(e, "fxshow");
            for (n in i.queue || (null == (r = S._queueHooks(e, "fx")).unqueued && (r.unqueued = 0,
            a = r.empty.fire,
            r.empty.fire = function() {
                r.unqueued || a()
            }
            ),
            r.unqueued++,
            p.always(function() {
                p.always(function() {
                    r.unqueued--,
                    S.queue(e, "fx").length || r.empty.fire()
                })
            })),
            t)
                if (o = t[n],
                gt.test(o)) {
                    if (delete t[n],
                    s = s || "toggle" === o,
                    o === (g ? "hide" : "show")) {
                        if ("show" !== o || !m || void 0 === m[n])
                            continue;
                        g = !0
                    }
                    h[n] = m && m[n] || S.style(e, n)
                }
            if ((l = !S.isEmptyObject(t)) || !S.isEmptyObject(h))
                for (n in u && 1 === e.nodeType && (i.overflow = [f.overflow, f.overflowX, f.overflowY],
                null == (c = m && m.display) && (c = V.get(e, "display")),
                "none" === (d = S.css(e, "display")) && (c ? d = c : (ce([e], !0),
                c = e.style.display || c,
                d = S.css(e, "display"),
                ce([e]))),
                ("inline" === d || "inline-block" === d && null != c) && "none" === S.css(e, "float") && (l || (p.done(function() {
                    f.display = c
                }),
                null == c && (d = f.display,
                c = "none" === d ? "" : d)),
                f.display = "inline-block")),
                i.overflow && (f.overflow = "hidden",
                p.always(function() {
                    f.overflow = i.overflow[0],
                    f.overflowX = i.overflow[1],
                    f.overflowY = i.overflow[2]
                })),
                l = !1,
                h)
                    l || (m ? "hidden"in m && (g = m.hidden) : m = V.access(e, "fxshow", {
                        display: c
                    }),
                    s && (m.hidden = !g),
                    g && ce([e], !0),
                    p.done(function() {
                        for (n in g || ce([e]),
                        V.remove(e, "fxshow"),
                        h)
                            S.style(e, n, h[n])
                    })),
                    l = bt(g ? m[n] : 0, n, p),
                    n in m || (m[n] = l.start,
                    g && (l.end = l.start,
                    l.start = 0))
        }
        ],
        prefilter: function(e, t) {
            t ? xt.prefilters.unshift(e) : xt.prefilters.push(e)
        }
    }),
    S.speed = function(e, t, i) {
        var n = e && "object" == _typeof(e) ? S.extend({}, e) : {
            complete: i || !i && t || w(e) && e,
            duration: e,
            easing: i && t || t && !w(t) && t
        };
        return S.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in S.fx.speeds ? n.duration = S.fx.speeds[n.duration] : n.duration = S.fx.speeds._default),
        null != n.queue && !0 !== n.queue || (n.queue = "fx"),
        n.old = n.complete,
        n.complete = function() {
            w(n.old) && n.old.call(this),
            n.queue && S.dequeue(this, n.queue)
        }
        ,
        n
    }
    ,
    S.fn.extend({
        fadeTo: function(e, t, i, n) {
            return this.filter(re).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, i, n)
        },
        animate: function(t, e, i, n) {
            function o() {
                var e = xt(this, S.extend({}, t), r);
                (s || V.get(this, "finish")) && e.stop(!0)
            }
            var s = S.isEmptyObject(t)
              , r = S.speed(e, i, n);
            return o.finish = o,
            s || !1 === r.queue ? this.each(o) : this.queue(r.queue, o)
        },
        stop: function(o, e, s) {
            function r(e) {
                var t = e.stop;
                delete e.stop,
                t(s)
            }
            return "string" != typeof o && (s = e,
            e = o,
            o = void 0),
            e && this.queue(o || "fx", []),
            this.each(function() {
                var e = !0
                  , t = null != o && o + "queueHooks"
                  , i = S.timers
                  , n = V.get(this);
                if (t)
                    n[t] && n[t].stop && r(n[t]);
                else
                    for (t in n)
                        n[t] && n[t].stop && mt.test(t) && r(n[t]);
                for (t = i.length; t--; )
                    i[t].elem !== this || null != o && i[t].queue !== o || (i[t].anim.stop(s),
                    e = !1,
                    i.splice(t, 1));
                !e && s || S.dequeue(this, o)
            })
        },
        finish: function(r) {
            return !1 !== r && (r = r || "fx"),
            this.each(function() {
                var e, t = V.get(this), i = t[r + "queue"], n = t[r + "queueHooks"], o = S.timers, s = i ? i.length : 0;
                for (t.finish = !0,
                S.queue(this, r, []),
                n && n.stop && n.stop.call(this, !0),
                e = o.length; e--; )
                    o[e].elem === this && o[e].queue === r && (o[e].anim.stop(!0),
                    o.splice(e, 1));
                for (e = 0; e < s; e++)
                    i[e] && i[e].finish && i[e].finish.call(this);
                delete t.finish
            })
        }
    }),
    S.each(["toggle", "show", "hide"], function(e, n) {
        var o = S.fn[n];
        S.fn[n] = function(e, t, i) {
            return null == e || "boolean" == typeof e ? o.apply(this, arguments) : this.animate(wt(n, !0), e, t, i)
        }
    }),
    S.each({
        slideDown: wt("show"),
        slideUp: wt("hide"),
        slideToggle: wt("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, n) {
        S.fn[e] = function(e, t, i) {
            return this.animate(n, e, t, i)
        }
    }),
    S.timers = [],
    S.fx.tick = function() {
        var e, t = 0, i = S.timers;
        for (ut = Date.now(); t < i.length; t++)
            (e = i[t])() || i[t] !== e || i.splice(t--, 1);
        i.length || S.fx.stop(),
        ut = void 0
    }
    ,
    S.fx.timer = function(e) {
        S.timers.push(e),
        S.fx.start()
    }
    ,
    S.fx.interval = 13,
    S.fx.start = function() {
        pt || (pt = !0,
        vt())
    }
    ,
    S.fx.stop = function() {
        pt = null
    }
    ,
    S.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    S.fn.delay = function(n, e) {
        return n = S.fx && S.fx.speeds[n] || n,
        e = e || "fx",
        this.queue(e, function(e, t) {
            var i = C.setTimeout(e, n);
            t.stop = function() {
                C.clearTimeout(i)
            }
        })
    }
    ,
    ht = T.createElement("input"),
    ft = T.createElement("select").appendChild(T.createElement("option")),
    ht.type = "checkbox",
    y.checkOn = "" !== ht.value,
    y.optSelected = ft.selected,
    (ht = T.createElement("input")).value = "t",
    ht.type = "radio",
    y.radioValue = "t" === ht.value;
    var _t, Ct = S.expr.attrHandle;
    S.fn.extend({
        attr: function(e, t) {
            return W(this, S.attr, e, t, 1 < arguments.length)
        },
        removeAttr: function(e) {
            return this.each(function() {
                S.removeAttr(this, e)
            })
        }
    }),
    S.extend({
        attr: function(e, t, i) {
            var n, o, s = e.nodeType;
            if (3 !== s && 8 !== s && 2 !== s)
                return void 0 === e.getAttribute ? S.prop(e, t, i) : (1 === s && S.isXMLDoc(e) || (o = S.attrHooks[t.toLowerCase()] || (S.expr.match.bool.test(t) ? _t : void 0)),
                void 0 !== i ? null === i ? void S.removeAttr(e, t) : o && "set"in o && void 0 !== (n = o.set(e, i, t)) ? n : (e.setAttribute(t, i + ""),
                i) : !(o && "get"in o && null !== (n = o.get(e, t))) && null == (n = S.find.attr(e, t)) ? void 0 : n)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!y.radioValue && "radio" === t && k(e, "input")) {
                        var i = e.value;
                        return e.setAttribute("type", t),
                        i && (e.value = i),
                        t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var i, n = 0, o = t && t.match(P);
            if (o && 1 === e.nodeType)
                for (; i = o[n++]; )
                    e.removeAttribute(i)
        }
    }),
    _t = {
        set: function(e, t, i) {
            return !1 === t ? S.removeAttr(e, i) : e.setAttribute(i, i),
            i
        }
    },
    S.each(S.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var r = Ct[t] || S.find.attr;
        Ct[t] = function(e, t, i) {
            var n, o, s = t.toLowerCase();
            return i || (o = Ct[s],
            Ct[s] = n,
            n = null != r(e, t, i) ? s : null,
            Ct[s] = o),
            n
        }
    });
    var Tt = /^(?:input|select|textarea|button)$/i
      , St = /^(?:a|area)$/i;
    function $t(e) {
        return (e.match(P) || []).join(" ")
    }
    function kt(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }
    function At(e) {
        return Array.isArray(e) ? e : "string" == typeof e && e.match(P) || []
    }
    S.fn.extend({
        prop: function(e, t) {
            return W(this, S.prop, e, t, 1 < arguments.length)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[S.propFix[e] || e]
            })
        }
    }),
    S.extend({
        prop: function(e, t, i) {
            var n, o, s = e.nodeType;
            if (3 !== s && 8 !== s && 2 !== s)
                return 1 === s && S.isXMLDoc(e) || (t = S.propFix[t] || t,
                o = S.propHooks[t]),
                void 0 !== i ? o && "set"in o && void 0 !== (n = o.set(e, i, t)) ? n : e[t] = i : o && "get"in o && null !== (n = o.get(e, t)) ? n : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = S.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : Tt.test(e.nodeName) || St.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }),
    y.optSelected || (S.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex,
            null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex,
            t.parentNode && t.parentNode.selectedIndex)
        }
    }),
    S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        S.propFix[this.toLowerCase()] = this
    }),
    S.fn.extend({
        addClass: function(t) {
            var e, i, n, o, s, r, a, l = 0;
            if (w(t))
                return this.each(function(e) {
                    S(this).addClass(t.call(this, e, kt(this)))
                });
            if ((e = At(t)).length)
                for (; i = this[l++]; )
                    if (o = kt(i),
                    n = 1 === i.nodeType && " " + $t(o) + " ") {
                        for (r = 0; s = e[r++]; )
                            n.indexOf(" " + s + " ") < 0 && (n += s + " ");
                        o !== (a = $t(n)) && i.setAttribute("class", a)
                    }
            return this
        },
        removeClass: function(t) {
            var e, i, n, o, s, r, a, l = 0;
            if (w(t))
                return this.each(function(e) {
                    S(this).removeClass(t.call(this, e, kt(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ((e = At(t)).length)
                for (; i = this[l++]; )
                    if (o = kt(i),
                    n = 1 === i.nodeType && " " + $t(o) + " ") {
                        for (r = 0; s = e[r++]; )
                            for (; -1 < n.indexOf(" " + s + " "); )
                                n = n.replace(" " + s + " ", " ");
                        o !== (a = $t(n)) && i.setAttribute("class", a)
                    }
            return this
        },
        toggleClass: function(o, t) {
            var s = _typeof(o)
              , r = "string" === s || Array.isArray(o);
            return "boolean" == typeof t && r ? t ? this.addClass(o) : this.removeClass(o) : w(o) ? this.each(function(e) {
                S(this).toggleClass(o.call(this, e, kt(this), t), t)
            }) : this.each(function() {
                var e, t, i, n;
                if (r)
                    for (t = 0,
                    i = S(this),
                    n = At(o); e = n[t++]; )
                        i.hasClass(e) ? i.removeClass(e) : i.addClass(e);
                else
                    void 0 !== o && "boolean" !== s || ((e = kt(this)) && V.set(this, "__className__", e),
                    this.setAttribute && this.setAttribute("class", !e && !1 !== o && V.get(this, "__className__") || ""))
            })
        },
        hasClass: function(e) {
            var t, i, n = 0;
            for (t = " " + e + " "; i = this[n++]; )
                if (1 === i.nodeType && -1 < (" " + $t(kt(i)) + " ").indexOf(t))
                    return !0;
            return !1
        }
    });
    var Et = /\r/g;
    S.fn.extend({
        val: function(i) {
            var n, e, o, t = this[0];
            return arguments.length ? (o = w(i),
            this.each(function(e) {
                var t;
                1 === this.nodeType && (null == (t = o ? i.call(this, e, S(this).val()) : i) ? t = "" : "number" == typeof t ? t += "" : Array.isArray(t) && (t = S.map(t, function(e) {
                    return null == e ? "" : e + ""
                })),
                (n = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) && "set"in n && void 0 !== n.set(this, t, "value") || (this.value = t))
            })) : t ? (n = S.valHooks[t.type] || S.valHooks[t.nodeName.toLowerCase()]) && "get"in n && void 0 !== (e = n.get(t, "value")) ? e : "string" == typeof (e = t.value) ? e.replace(Et, "") : null == e ? "" : e : void 0
        }
    }),
    S.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = S.find.attr(e, "value");
                    return null != t ? t : $t(S.text(e))
                }
            },
            select: {
                get: function(e) {
                    var t, i, n, o = e.options, s = e.selectedIndex, r = "select-one" === e.type, a = r ? null : [], l = r ? s + 1 : o.length;
                    for (n = s < 0 ? l : r ? s : 0; n < l; n++)
                        if (((i = o[n]).selected || n === s) && !i.disabled && (!i.parentNode.disabled || !k(i.parentNode, "optgroup"))) {
                            if (t = S(i).val(),
                            r)
                                return t;
                            a.push(t)
                        }
                    return a
                },
                set: function(e, t) {
                    for (var i, n, o = e.options, s = S.makeArray(t), r = o.length; r--; )
                        ((n = o[r]).selected = -1 < S.inArray(S.valHooks.option.get(n), s)) && (i = !0);
                    return i || (e.selectedIndex = -1),
                    s
                }
            }
        }
    }),
    S.each(["radio", "checkbox"], function() {
        S.valHooks[this] = {
            set: function(e, t) {
                if (Array.isArray(t))
                    return e.checked = -1 < S.inArray(S(e).val(), t)
            }
        },
        y.checkOn || (S.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        }
        )
    }),
    y.focusin = "onfocusin"in C;
    function zt(e) {
        e.stopPropagation()
    }
    var Dt = /^(?:focusinfocus|focusoutblur)$/;
    S.extend(S.event, {
        trigger: function(e, t, i, n) {
            var o, s, r, a, l, c, d, u, p = [i || T], h = v.call(e, "type") ? e.type : e, f = v.call(e, "namespace") ? e.namespace.split(".") : [];
            if (s = u = r = i = i || T,
            3 !== i.nodeType && 8 !== i.nodeType && !Dt.test(h + S.event.triggered) && (-1 < h.indexOf(".") && (h = (f = h.split(".")).shift(),
            f.sort()),
            l = h.indexOf(":") < 0 && "on" + h,
            (e = e[S.expando] ? e : new S.Event(h,"object" == _typeof(e) && e)).isTrigger = n ? 2 : 3,
            e.namespace = f.join("."),
            e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            e.result = void 0,
            e.target || (e.target = i),
            t = null == t ? [e] : S.makeArray(t, [e]),
            d = S.event.special[h] || {},
            n || !d.trigger || !1 !== d.trigger.apply(i, t))) {
                if (!n && !d.noBubble && !g(i)) {
                    for (a = d.delegateType || h,
                    Dt.test(a + h) || (s = s.parentNode); s; s = s.parentNode)
                        p.push(s),
                        r = s;
                    r === (i.ownerDocument || T) && p.push(r.defaultView || r.parentWindow || C)
                }
                for (o = 0; (s = p[o++]) && !e.isPropagationStopped(); )
                    u = s,
                    e.type = 1 < o ? a : d.bindType || h,
                    (c = (V.get(s, "events") || Object.create(null))[e.type] && V.get(s, "handle")) && c.apply(s, t),
                    (c = l && s[l]) && c.apply && G(s) && (e.result = c.apply(s, t),
                    !1 === e.result && e.preventDefault());
                return e.type = h,
                n || e.isDefaultPrevented() || d._default && !1 !== d._default.apply(p.pop(), t) || !G(i) || l && w(i[h]) && !g(i) && ((r = i[l]) && (i[l] = null),
                S.event.triggered = h,
                e.isPropagationStopped() && u.addEventListener(h, zt),
                i[h](),
                e.isPropagationStopped() && u.removeEventListener(h, zt),
                S.event.triggered = void 0,
                r && (i[l] = r)),
                e.result
            }
        },
        simulate: function(e, t, i) {
            var n = S.extend(new S.Event, i, {
                type: e,
                isSimulated: !0
            });
            S.event.trigger(n, null, t)
        }
    }),
    S.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                S.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var i = this[0];
            if (i)
                return S.event.trigger(e, t, i, !0)
        }
    }),
    y.focusin || S.each({
        focus: "focusin",
        blur: "focusout"
    }, function(i, n) {
        function o(e) {
            S.event.simulate(n, e.target, S.event.fix(e))
        }
        S.event.special[n] = {
            setup: function() {
                var e = this.ownerDocument || this.document || this
                  , t = V.access(e, n);
                t || e.addEventListener(i, o, !0),
                V.access(e, n, (t || 0) + 1)
            },
            teardown: function() {
                var e = this.ownerDocument || this.document || this
                  , t = V.access(e, n) - 1;
                t ? V.access(e, n, t) : (e.removeEventListener(i, o, !0),
                V.remove(e, n))
            }
        }
    });
    var Ot = C.location
      , jt = {
        guid: Date.now()
    }
      , Lt = /\?/;
    S.parseXML = function(e) {
        var t;
        if (!e || "string" != typeof e)
            return null;
        try {
            t = (new C.DOMParser).parseFromString(e, "text/xml")
        } catch (e) {
            t = void 0
        }
        return t && !t.getElementsByTagName("parsererror").length || S.error("Invalid XML: " + e),
        t
    }
    ;
    var Pt = /\[\]$/
      , Nt = /\r?\n/g
      , Mt = /^(?:submit|button|image|reset|file)$/i
      , It = /^(?:input|select|textarea|keygen)/i;
    function qt(i, e, n, o) {
        var t;
        if (Array.isArray(e))
            S.each(e, function(e, t) {
                n || Pt.test(i) ? o(i, t) : qt(i + "[" + ("object" == _typeof(t) && null != t ? e : "") + "]", t, n, o)
            });
        else if (n || "object" !== x(e))
            o(i, e);
        else
            for (t in e)
                qt(i + "[" + t + "]", e[t], n, o)
    }
    S.param = function(e, t) {
        function i(e, t) {
            var i = w(t) ? t() : t;
            o[o.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == i ? "" : i)
        }
        var n, o = [];
        if (null == e)
            return "";
        if (Array.isArray(e) || e.jquery && !S.isPlainObject(e))
            S.each(e, function() {
                i(this.name, this.value)
            });
        else
            for (n in e)
                qt(n, e[n], t, i);
        return o.join("&")
    }
    ,
    S.fn.extend({
        serialize: function() {
            return S.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = S.prop(this, "elements");
                return e ? S.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !S(this).is(":disabled") && It.test(this.nodeName) && !Mt.test(e) && (this.checked || !pe.test(e))
            }).map(function(e, t) {
                var i = S(this).val();
                return null == i ? null : Array.isArray(i) ? S.map(i, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Nt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: i.replace(Nt, "\r\n")
                }
            }).get()
        }
    });
    var Ht = /%20/g
      , Rt = /#.*$/
      , Wt = /([?&])_=[^&]*/
      , Ft = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , Bt = /^(?:GET|HEAD)$/
      , Ut = /^\/\//
      , Xt = {}
      , Gt = {}
      , Yt = "*/".concat("*")
      , Vt = T.createElement("a");
    function Qt(s) {
        return function(e, t) {
            "string" != typeof e && (t = e,
            e = "*");
            var i, n = 0, o = e.toLowerCase().match(P) || [];
            if (w(t))
                for (; i = o[n++]; )
                    "+" === i[0] ? (i = i.slice(1) || "*",
                    (s[i] = s[i] || []).unshift(t)) : (s[i] = s[i] || []).push(t)
        }
    }
    function Kt(t, o, s, r) {
        var a = {}
          , l = t === Gt;
        function c(e) {
            var n;
            return a[e] = !0,
            S.each(t[e] || [], function(e, t) {
                var i = t(o, s, r);
                return "string" != typeof i || l || a[i] ? l ? !(n = i) : void 0 : (o.dataTypes.unshift(i),
                c(i),
                !1)
            }),
            n
        }
        return c(o.dataTypes[0]) || !a["*"] && c("*")
    }
    function Zt(e, t) {
        var i, n, o = S.ajaxSettings.flatOptions || {};
        for (i in t)
            void 0 !== t[i] && ((o[i] ? e : n = n || {})[i] = t[i]);
        return n && S.extend(!0, e, n),
        e
    }
    Vt.href = Ot.href,
    S.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Ot.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ot.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Yt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": S.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? Zt(Zt(e, S.ajaxSettings), t) : Zt(S.ajaxSettings, e)
        },
        ajaxPrefilter: Qt(Xt),
        ajaxTransport: Qt(Gt),
        ajax: function(e, t) {
            "object" == _typeof(e) && (t = e,
            e = void 0),
            t = t || {};
            var d, u, p, i, h, n, f, g, o, s, m = S.ajaxSetup({}, t), v = m.context || m, y = m.context && (v.nodeType || v.jquery) ? S(v) : S.event, w = S.Deferred(), b = S.Callbacks("once memory"), x = m.statusCode || {}, r = {}, a = {}, l = "canceled", _ = {
                readyState: 0,
                getResponseHeader: function(e) {
                    var t;
                    if (f) {
                        if (!i)
                            for (i = {}; t = Ft.exec(p); )
                                i[t[1].toLowerCase() + " "] = (i[t[1].toLowerCase() + " "] || []).concat(t[2]);
                        t = i[e.toLowerCase() + " "]
                    }
                    return null == t ? null : t.join(", ")
                },
                getAllResponseHeaders: function() {
                    return f ? p : null
                },
                setRequestHeader: function(e, t) {
                    return null == f && (e = a[e.toLowerCase()] = a[e.toLowerCase()] || e,
                    r[e] = t),
                    this
                },
                overrideMimeType: function(e) {
                    return null == f && (m.mimeType = e),
                    this
                },
                statusCode: function(e) {
                    var t;
                    if (e)
                        if (f)
                            _.always(e[_.status]);
                        else
                            for (t in e)
                                x[t] = [x[t], e[t]];
                    return this
                },
                abort: function(e) {
                    var t = e || l;
                    return d && d.abort(t),
                    c(0, t),
                    this
                }
            };
            if (w.promise(_),
            m.url = ((e || m.url || Ot.href) + "").replace(Ut, Ot.protocol + "//"),
            m.type = t.method || t.type || m.method || m.type,
            m.dataTypes = (m.dataType || "*").toLowerCase().match(P) || [""],
            null == m.crossDomain) {
                n = T.createElement("a");
                try {
                    n.href = m.url,
                    n.href = n.href,
                    m.crossDomain = Vt.protocol + "//" + Vt.host != n.protocol + "//" + n.host
                } catch (e) {
                    m.crossDomain = !0
                }
            }
            if (m.data && m.processData && "string" != typeof m.data && (m.data = S.param(m.data, m.traditional)),
            Kt(Xt, m, t, _),
            f)
                return _;
            for (o in (g = S.event && m.global) && 0 == S.active++ && S.event.trigger("ajaxStart"),
            m.type = m.type.toUpperCase(),
            m.hasContent = !Bt.test(m.type),
            u = m.url.replace(Rt, ""),
            m.hasContent ? m.data && m.processData && 0 === (m.contentType || "").indexOf("application/x-www-form-urlencoded") && (m.data = m.data.replace(Ht, "+")) : (s = m.url.slice(u.length),
            m.data && (m.processData || "string" == typeof m.data) && (u += (Lt.test(u) ? "&" : "?") + m.data,
            delete m.data),
            !1 === m.cache && (u = u.replace(Wt, "$1"),
            s = (Lt.test(u) ? "&" : "?") + "_=" + jt.guid++ + s),
            m.url = u + s),
            m.ifModified && (S.lastModified[u] && _.setRequestHeader("If-Modified-Since", S.lastModified[u]),
            S.etag[u] && _.setRequestHeader("If-None-Match", S.etag[u])),
            (m.data && m.hasContent && !1 !== m.contentType || t.contentType) && _.setRequestHeader("Content-Type", m.contentType),
            _.setRequestHeader("Accept", m.dataTypes[0] && m.accepts[m.dataTypes[0]] ? m.accepts[m.dataTypes[0]] + ("*" !== m.dataTypes[0] ? ", " + Yt + "; q=0.01" : "") : m.accepts["*"]),
            m.headers)
                _.setRequestHeader(o, m.headers[o]);
            if (m.beforeSend && (!1 === m.beforeSend.call(v, _, m) || f))
                return _.abort();
            if (l = "abort",
            b.add(m.complete),
            _.done(m.success),
            _.fail(m.error),
            d = Kt(Gt, m, t, _)) {
                if (_.readyState = 1,
                g && y.trigger("ajaxSend", [_, m]),
                f)
                    return _;
                m.async && 0 < m.timeout && (h = C.setTimeout(function() {
                    _.abort("timeout")
                }, m.timeout));
                try {
                    f = !1,
                    d.send(r, c)
                } catch (e) {
                    if (f)
                        throw e;
                    c(-1, e)
                }
            } else
                c(-1, "No Transport");
            function c(e, t, i, n) {
                var o, s, r, a, l, c = t;
                f || (f = !0,
                h && C.clearTimeout(h),
                d = void 0,
                p = n || "",
                _.readyState = 0 < e ? 4 : 0,
                o = 200 <= e && e < 300 || 304 === e,
                i && (a = function(e, t, i) {
                    for (var n, o, s, r, a = e.contents, l = e.dataTypes; "*" === l[0]; )
                        l.shift(),
                        void 0 === n && (n = e.mimeType || t.getResponseHeader("Content-Type"));
                    if (n)
                        for (o in a)
                            if (a[o] && a[o].test(n)) {
                                l.unshift(o);
                                break
                            }
                    if (l[0]in i)
                        s = l[0];
                    else {
                        for (o in i) {
                            if (!l[0] || e.converters[o + " " + l[0]]) {
                                s = o;
                                break
                            }
                            r = r || o
                        }
                        s = s || r
                    }
                    if (s)
                        return s !== l[0] && l.unshift(s),
                        i[s]
                }(m, _, i)),
                !o && -1 < S.inArray("script", m.dataTypes) && (m.converters["text script"] = function() {}
                ),
                a = function(e, t, i, n) {
                    var o, s, r, a, l, c = {}, d = e.dataTypes.slice();
                    if (d[1])
                        for (r in e.converters)
                            c[r.toLowerCase()] = e.converters[r];
                    for (s = d.shift(); s; )
                        if (e.responseFields[s] && (i[e.responseFields[s]] = t),
                        !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                        l = s,
                        s = d.shift())
                            if ("*" === s)
                                s = l;
                            else if ("*" !== l && l !== s) {
                                if (!(r = c[l + " " + s] || c["* " + s]))
                                    for (o in c)
                                        if ((a = o.split(" "))[1] === s && (r = c[l + " " + a[0]] || c["* " + a[0]])) {
                                            !0 === r ? r = c[o] : !0 !== c[o] && (s = a[0],
                                            d.unshift(a[1]));
                                            break
                                        }
                                if (!0 !== r)
                                    if (r && e.throws)
                                        t = r(t);
                                    else
                                        try {
                                            t = r(t)
                                        } catch (e) {
                                            return {
                                                state: "parsererror",
                                                error: r ? e : "No conversion from " + l + " to " + s
                                            }
                                        }
                            }
                    return {
                        state: "success",
                        data: t
                    }
                }(m, a, _, o),
                o ? (m.ifModified && ((l = _.getResponseHeader("Last-Modified")) && (S.lastModified[u] = l),
                (l = _.getResponseHeader("etag")) && (S.etag[u] = l)),
                204 === e || "HEAD" === m.type ? c = "nocontent" : 304 === e ? c = "notmodified" : (c = a.state,
                s = a.data,
                o = !(r = a.error))) : (r = c,
                !e && c || (c = "error",
                e < 0 && (e = 0))),
                _.status = e,
                _.statusText = (t || c) + "",
                o ? w.resolveWith(v, [s, c, _]) : w.rejectWith(v, [_, c, r]),
                _.statusCode(x),
                x = void 0,
                g && y.trigger(o ? "ajaxSuccess" : "ajaxError", [_, m, o ? s : r]),
                b.fireWith(v, [_, c]),
                g && (y.trigger("ajaxComplete", [_, m]),
                --S.active || S.event.trigger("ajaxStop")))
            }
            return _
        },
        getJSON: function(e, t, i) {
            return S.get(e, t, i, "json")
        },
        getScript: function(e, t) {
            return S.get(e, void 0, t, "script")
        }
    }),
    S.each(["get", "post"], function(e, o) {
        S[o] = function(e, t, i, n) {
            return w(t) && (n = n || i,
            i = t,
            t = void 0),
            S.ajax(S.extend({
                url: e,
                type: o,
                dataType: n,
                data: t,
                success: i
            }, S.isPlainObject(e) && e))
        }
    }),
    S.ajaxPrefilter(function(e) {
        var t;
        for (t in e.headers)
            "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "")
    }),
    S._evalUrl = function(e, t, i) {
        return S.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function() {}
            },
            dataFilter: function(e) {
                S.globalEval(e, t, i)
            }
        })
    }
    ,
    S.fn.extend({
        wrapAll: function(e) {
            var t;
            return this[0] && (w(e) && (e = e.call(this[0])),
            t = S(e, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && t.insertBefore(this[0]),
            t.map(function() {
                for (var e = this; e.firstElementChild; )
                    e = e.firstElementChild;
                return e
            }).append(this)),
            this
        },
        wrapInner: function(i) {
            return w(i) ? this.each(function(e) {
                S(this).wrapInner(i.call(this, e))
            }) : this.each(function() {
                var e = S(this)
                  , t = e.contents();
                t.length ? t.wrapAll(i) : e.append(i)
            })
        },
        wrap: function(t) {
            var i = w(t);
            return this.each(function(e) {
                S(this).wrapAll(i ? t.call(this, e) : t)
            })
        },
        unwrap: function(e) {
            return this.parent(e).not("body").each(function() {
                S(this).replaceWith(this.childNodes)
            }),
            this
        }
    }),
    S.expr.pseudos.hidden = function(e) {
        return !S.expr.pseudos.visible(e)
    }
    ,
    S.expr.pseudos.visible = function(e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }
    ,
    S.ajaxSettings.xhr = function() {
        try {
            return new C.XMLHttpRequest
        } catch (e) {}
    }
    ;
    var Jt = {
        0: 200,
        1223: 204
    }
      , ei = S.ajaxSettings.xhr();
    y.cors = !!ei && "withCredentials"in ei,
    y.ajax = ei = !!ei,
    S.ajaxTransport(function(o) {
        var s, r;
        if (y.cors || ei && !o.crossDomain)
            return {
                send: function(e, t) {
                    var i, n = o.xhr();
                    if (n.open(o.type, o.url, o.async, o.username, o.password),
                    o.xhrFields)
                        for (i in o.xhrFields)
                            n[i] = o.xhrFields[i];
                    for (i in o.mimeType && n.overrideMimeType && n.overrideMimeType(o.mimeType),
                    o.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"),
                    e)
                        n.setRequestHeader(i, e[i]);
                    s = function(e) {
                        return function() {
                            s && (s = r = n.onload = n.onerror = n.onabort = n.ontimeout = n.onreadystatechange = null,
                            "abort" === e ? n.abort() : "error" === e ? "number" != typeof n.status ? t(0, "error") : t(n.status, n.statusText) : t(Jt[n.status] || n.status, n.statusText, "text" !== (n.responseType || "text") || "string" != typeof n.responseText ? {
                                binary: n.response
                            } : {
                                text: n.responseText
                            }, n.getAllResponseHeaders()))
                        }
                    }
                    ,
                    n.onload = s(),
                    r = n.onerror = n.ontimeout = s("error"),
                    void 0 !== n.onabort ? n.onabort = r : n.onreadystatechange = function() {
                        4 === n.readyState && C.setTimeout(function() {
                            s && r()
                        })
                    }
                    ,
                    s = s("abort");
                    try {
                        n.send(o.hasContent && o.data || null)
                    } catch (e) {
                        if (s)
                            throw e
                    }
                },
                abort: function() {
                    s && s()
                }
            }
    }),
    S.ajaxPrefilter(function(e) {
        e.crossDomain && (e.contents.script = !1)
    }),
    S.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return S.globalEval(e),
                e
            }
        }
    }),
    S.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1),
        e.crossDomain && (e.type = "GET")
    }),
    S.ajaxTransport("script", function(i) {
        var n, o;
        if (i.crossDomain || i.scriptAttrs)
            return {
                send: function(e, t) {
                    n = S("<script>").attr(i.scriptAttrs || {}).prop({
                        charset: i.scriptCharset,
                        src: i.url
                    }).on("load error", o = function(e) {
                        n.remove(),
                        o = null,
                        e && t("error" === e.type ? 404 : 200, e.type)
                    }
                    ),
                    T.head.appendChild(n[0])
                },
                abort: function() {
                    o && o()
                }
            }
    });
    var ti, ii = [], ni = /(=)\?(?=&|$)|\?\?/;
    S.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = ii.pop() || S.expando + "_" + jt.guid++;
            return this[e] = !0,
            e
        }
    }),
    S.ajaxPrefilter("json jsonp", function(e, t, i) {
        var n, o, s, r = !1 !== e.jsonp && (ni.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && ni.test(e.data) && "data");
        if (r || "jsonp" === e.dataTypes[0])
            return n = e.jsonpCallback = w(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback,
            r ? e[r] = e[r].replace(ni, "$1" + n) : !1 !== e.jsonp && (e.url += (Lt.test(e.url) ? "&" : "?") + e.jsonp + "=" + n),
            e.converters["script json"] = function() {
                return s || S.error(n + " was not called"),
                s[0]
            }
            ,
            e.dataTypes[0] = "json",
            o = C[n],
            C[n] = function() {
                s = arguments
            }
            ,
            i.always(function() {
                void 0 === o ? S(C).removeProp(n) : C[n] = o,
                e[n] && (e.jsonpCallback = t.jsonpCallback,
                ii.push(n)),
                s && w(o) && o(s[0]),
                s = o = void 0
            }),
            "script"
    }),
    y.createHTMLDocument = ((ti = T.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>",
    2 === ti.childNodes.length),
    S.parseHTML = function(e, t, i) {
        return "string" != typeof e ? [] : ("boolean" == typeof t && (i = t,
        t = !1),
        t || (y.createHTMLDocument ? ((n = (t = T.implementation.createHTMLDocument("")).createElement("base")).href = T.location.href,
        t.head.appendChild(n)) : t = T),
        s = !i && [],
        (o = A.exec(e)) ? [t.createElement(o[1])] : (o = we([e], t, s),
        s && s.length && S(s).remove(),
        S.merge([], o.childNodes)));
        var n, o, s
    }
    ,
    S.fn.load = function(e, t, i) {
        var n, o, s, r = this, a = e.indexOf(" ");
        return -1 < a && (n = $t(e.slice(a)),
        e = e.slice(0, a)),
        w(t) ? (i = t,
        t = void 0) : t && "object" == _typeof(t) && (o = "POST"),
        0 < r.length && S.ajax({
            url: e,
            type: o || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            s = arguments,
            r.html(n ? S("<div>").append(S.parseHTML(e)).find(n) : e)
        }).always(i && function(e, t) {
            r.each(function() {
                i.apply(this, s || [e.responseText, t, e])
            })
        }
        ),
        this
    }
    ,
    S.expr.pseudos.animated = function(t) {
        return S.grep(S.timers, function(e) {
            return t === e.elem
        }).length
    }
    ,
    S.offset = {
        setOffset: function(e, t, i) {
            var n, o, s, r, a, l, c = S.css(e, "position"), d = S(e), u = {};
            "static" === c && (e.style.position = "relative"),
            a = d.offset(),
            s = S.css(e, "top"),
            l = S.css(e, "left"),
            o = ("absolute" === c || "fixed" === c) && -1 < (s + l).indexOf("auto") ? (r = (n = d.position()).top,
            n.left) : (r = parseFloat(s) || 0,
            parseFloat(l) || 0),
            w(t) && (t = t.call(e, i, S.extend({}, a))),
            null != t.top && (u.top = t.top - a.top + r),
            null != t.left && (u.left = t.left - a.left + o),
            "using"in t ? t.using.call(e, u) : ("number" == typeof u.top && (u.top += "px"),
            "number" == typeof u.left && (u.left += "px"),
            d.css(u))
        }
    },
    S.fn.extend({
        offset: function(t) {
            if (arguments.length)
                return void 0 === t ? this : this.each(function(e) {
                    S.offset.setOffset(this, t, e)
                });
            var e, i, n = this[0];
            return n ? n.getClientRects().length ? (e = n.getBoundingClientRect(),
            i = n.ownerDocument.defaultView,
            {
                top: e.top + i.pageYOffset,
                left: e.left + i.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, i, n = this[0], o = {
                    top: 0,
                    left: 0
                };
                if ("fixed" === S.css(n, "position"))
                    t = n.getBoundingClientRect();
                else {
                    for (t = this.offset(),
                    i = n.ownerDocument,
                    e = n.offsetParent || i.documentElement; e && (e === i.body || e === i.documentElement) && "static" === S.css(e, "position"); )
                        e = e.parentNode;
                    e && e !== n && 1 === e.nodeType && ((o = S(e).offset()).top += S.css(e, "borderTopWidth", !0),
                    o.left += S.css(e, "borderLeftWidth", !0))
                }
                return {
                    top: t.top - o.top - S.css(n, "marginTop", !0),
                    left: t.left - o.left - S.css(n, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent; e && "static" === S.css(e, "position"); )
                    e = e.offsetParent;
                return e || ne
            })
        }
    }),
    S.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, o) {
        var s = "pageYOffset" === o;
        S.fn[t] = function(e) {
            return W(this, function(e, t, i) {
                var n;
                if (g(e) ? n = e : 9 === e.nodeType && (n = e.defaultView),
                void 0 === i)
                    return n ? n[o] : e[t];
                n ? n.scrollTo(s ? n.pageXOffset : i, s ? i : n.pageYOffset) : e[t] = i
            }, t, e, arguments.length)
        }
    }),
    S.each(["top", "left"], function(e, i) {
        S.cssHooks[i] = Qe(y.pixelPosition, function(e, t) {
            if (t)
                return t = Ve(e, i),
                Xe.test(t) ? S(e).position()[i] + "px" : t
        })
    }),
    S.each({
        Height: "height",
        Width: "width"
    }, function(r, a) {
        S.each({
            padding: "inner" + r,
            content: a,
            "": "outer" + r
        }, function(n, s) {
            S.fn[s] = function(e, t) {
                var i = arguments.length && (n || "boolean" != typeof e)
                  , o = n || (!0 === e || !0 === t ? "margin" : "border");
                return W(this, function(e, t, i) {
                    var n;
                    return g(e) ? 0 === s.indexOf("outer") ? e["inner" + r] : e.document.documentElement["client" + r] : 9 === e.nodeType ? (n = e.documentElement,
                    Math.max(e.body["scroll" + r], n["scroll" + r], e.body["offset" + r], n["offset" + r], n["client" + r])) : void 0 === i ? S.css(e, t, o) : S.style(e, t, i, o)
                }, a, i ? e : void 0, i)
            }
        })
    }),
    S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        S.fn[t] = function(e) {
            return this.on(t, e)
        }
    }),
    S.fn.extend({
        bind: function(e, t, i) {
            return this.on(e, null, t, i)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, i, n) {
            return this.on(t, e, i, n)
        },
        undelegate: function(e, t, i) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", i)
        },
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }),
    S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, i) {
        S.fn[i] = function(e, t) {
            return 0 < arguments.length ? this.on(i, null, e, t) : this.trigger(i)
        }
    });
    var oi = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    S.proxy = function(e, t) {
        var i, n, o;
        if ("string" == typeof t && (i = e[t],
        t = e,
        e = i),
        w(e))
            return n = a.call(arguments, 2),
            (o = function() {
                return e.apply(t || this, n.concat(a.call(arguments)))
            }
            ).guid = e.guid = e.guid || S.guid++,
            o
    }
    ,
    S.holdReady = function(e) {
        e ? S.readyWait++ : S.ready(!0)
    }
    ,
    S.isArray = Array.isArray,
    S.parseJSON = JSON.parse,
    S.nodeName = k,
    S.isFunction = w,
    S.isWindow = g,
    S.camelCase = X,
    S.type = x,
    S.now = Date.now,
    S.isNumeric = function(e) {
        var t = S.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }
    ,
    S.trim = function(e) {
        return null == e ? "" : (e + "").replace(oi, "")
    }
    ,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return S
    });
    var si = C.jQuery
      , ri = C.$;
    return S.noConflict = function(e) {
        return C.$ === S && (C.$ = ri),
        e && C.jQuery === S && (C.jQuery = si),
        S
    }
    ,
    void 0 === e && (C.jQuery = C.$ = S),
    S
}),
theme.jQuery = $,
function(p) {
    var e, t, i, n, o, s, r, a, l, c, d, u, h, f, g, m, v, y, w, b, x, _, C, T, S, $, k, A, E, z, D, O, j, L, P, N, M, I, q, H, R, W, F, B, U, X, G, Y, V, Q, K, Z, J, ee, te, ie, ne, oe, se, re, ae, le, ce, de, ue, pe, he, fe, ge, me, ve, ye, we, be, xe, _e, Ce, Te, Se, $e, ke, Ae, Ee, ze, De, Oe, je, Le, Pe, Ne, Me, Ie, qe, He, Re, We;
    p = jQuery = p;
    function Fe() {
        n(i.lazySizes),
        i.removeEventListener("lazyunveilread", Fe, !0)
    }
    function Be() {
        s(o.lazySizes),
        o.removeEventListener("lazyunveilread", Be, !0)
    }
    function Ue() {
        a(r.lazySizes),
        r.removeEventListener("lazyunveilread", Ue, !0)
    }
    function Xe() {
        c(l.lazySizes),
        l.removeEventListener("lazyunveilread", Xe, !0)
    }
    function Ge() {
        u(d.lazySizes),
        d.removeEventListener("lazyunveilread", Ge, !0)
    }
    function Ye() {
        g.hide(),
        L.onerror = L.onload = null,
        j && j.abort(),
        f.empty()
    }
    function Ve() {
        !1 === A.onError(E, k, A) ? (g.hide(),
        H = !1) : (A.titleShow = !1,
        A.width = "auto",
        A.height = "auto",
        f.html('<p id="fancybox-error">The requested content cannot be loaded.<br />Please try again later.</p>'),
        F())
    }
    function Qe() {
        var n, e, t, i, o, s, r = E[k];
        if (Ye(),
        A = h.extend({}, h.fn.fancybox.defaults, void 0 === h(r).data("fancybox") ? A : h(r).data("fancybox")),
        !1 === (s = A.onStart(E, k, A)))
            H = !1;
        else if ("object" == _typeof(s) && (A = h.extend(A, s)),
        t = A.title || (r.nodeName ? h(r).attr("title") : r.title) || "",
        r.nodeName && !A.orig && (A.orig = h(r).children("img:first").length ? h(r).children("img:first") : h(r)),
        "" === t && A.orig && A.titleFromAlt && (t = A.orig.attr("alt")),
        n = A.href || (r.nodeName ? h(r).attr("href") : r.href) || null,
        !/^(?:javascript)/i.test(n) && "#" != n || (n = null),
        A.type ? (e = A.type,
        n = n || A.content) : A.content ? e = "html" : n && (e = n.match(P) ? "image" : n.match(N) ? "swf" : h(r).hasClass("iframe") ? "iframe" : 0 === n.indexOf("#") ? "inline" : "ajax"),
        e)
            switch ("inline" == e && (r = n.substr(n.indexOf("#")),
            e = 0 < h(r).length ? "inline" : "ajax"),
            A.type = e,
            A.href = n,
            A.title = t,
            A.autoDimensions && ("html" == A.type || "inline" == A.type || "ajax" == A.type ? (A.width = "auto",
            A.height = "auto") : A.autoDimensions = !1),
            A.modal && (A.overlayShow = !0,
            A.hideOnOverlayClick = !1,
            A.hideOnContentClick = !1,
            A.enableEscapeButton = !1,
            A.showCloseButton = !1),
            A.padding = parseInt(A.padding, 10),
            A.margin = parseInt(A.margin, 10),
            f.css("padding", A.padding + A.margin),
            h(".fancybox-inline-tmp").unbind("fancybox-cancel").bind("fancybox-change", function() {
                h(this).replaceWith(w.children())
            }),
            e) {
            case "html":
                f.html(A.content),
                F();
                break;
            case "inline":
                if (!0 === h(r).parent().is("#fancybox-content")) {
                    H = !1;
                    break
                }
                h('<div class="fancybox-inline-tmp" />').hide().insertBefore(h(r)).bind("fancybox-cleanup", function() {
                    h(this).replaceWith(w.children())
                }).bind("fancybox-cancel", function() {
                    h(this).replaceWith(f.children())
                }),
                h(r).appendTo(f),
                F();
                break;
            case "image":
                H = !1,
                h.fancybox.showActivity(),
                (L = new Image).onerror = function() {
                    Ve()
                }
                ,
                L.onload = function() {
                    H = !0,
                    L.onerror = L.onload = null,
                    A.width = L.width,
                    A.height = L.height,
                    h("<img />").attr({
                        id: "fancybox-img",
                        src: L.src,
                        alt: A.title
                    }).appendTo(f),
                    B()
                }
                ,
                L.src = n;
                break;
            case "swf":
                A.scrolling = "no",
                i = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="' + A.width + '" height="' + A.height + '"><param name="movie" value="' + n + '"></param>',
                o = "",
                h.each(A.swf, function(e, t) {
                    i += '<param name="' + e + '" value="' + t + '"></param>',
                    o += " " + e + '="' + t + '"'
                }),
                i += '<embed src="' + n + '" type="application/x-shockwave-flash" width="' + A.width + '" height="' + A.height + '"' + o + "></embed></object>",
                f.html(i),
                F();
                break;
            case "ajax":
                H = !1,
                h.fancybox.showActivity(),
                A.ajax.win = A.ajax.success,
                j = h.ajax(h.extend({}, A.ajax, {
                    url: n,
                    data: A.ajax.data || {},
                    error: function(e) {
                        0 < e.status && Ve()
                    },
                    success: function(e, t, i) {
                        if (200 == ("object" == _typeof(i) ? i : j).status) {
                            if ("function" == typeof A.ajax.win) {
                                if (!1 === (s = A.ajax.win(n, e, t, i)))
                                    return void g.hide();
                                "string" != typeof s && "object" != _typeof(s) || (e = s)
                            }
                            f.html(e),
                            F()
                        }
                    }
                }));
                break;
            case "iframe":
                B()
            }
        else
            Ve()
    }
    function Ke() {
        return [h(window).width() - 2 * D.margin, h(window).height() - 2 * D.margin, h(document).scrollLeft() + D.margin, h(document).scrollTop() + D.margin]
    }
    function Ze() {
        g.is(":visible") ? (h("div", g).css("top", -40 * M + "px"),
        M = (M + 1) % 12) : clearInterval(T)
    }
    function Je(e) {
        return "[object Function]" == ie.call(e)
    }
    function et(e) {
        return "string" == typeof e
    }
    function tt() {}
    function it(e) {
        return !e || "loaded" == e || "complete" == e || "uninitialized" == e
    }
    function nt() {
        var e = ne.shift();
        oe = 1,
        e ? e.t ? ee(function() {
            ("c" == e.t ? Z.injectCss : Z.injectJs)(e.s, 0, e.a, e.x, e.e, 1)
        }, 0) : (e(),
        nt()) : oe = 0
    }
    function ot(e, t, i, n, o) {
        return oe = 0,
        t = t || "j",
        et(e) ? function(i, n, e, t, o, s, r) {
            function a(e) {
                if (!c && it(l.readyState) && (u.r = c = 1,
                oe || nt(),
                l.onload = l.onreadystatechange = null,
                e))
                    for (var t in "img" != i && ee(function() {
                        ae.removeChild(l)
                    }, 50),
                    pe[n])
                        pe[n].hasOwnProperty(t) && pe[n][t].onload()
            }
            r = r || Z.errorTimeout;
            var l = Q.createElement(i)
              , c = 0
              , d = 0
              , u = {
                t: e,
                s: n,
                e: o,
                a: s,
                x: r
            };
            1 === pe[n] && (d = 1,
            pe[n] = []),
            "object" == i ? l.data = n : (l.src = n,
            l.type = i),
            l.width = l.height = "0",
            l.onerror = l.onload = l.onreadystatechange = function() {
                a.call(this, d)
            }
            ,
            ne.splice(t, 0, u),
            "img" != i && (d || 2 === pe[n] ? (ae.insertBefore(l, re ? null : te),
            ee(a, r)) : pe[n].push(l))
        }("c" == t ? ce : le, e, t, this.i++, i, n, o) : (ne.splice(this.i++, 0, e),
        1 == ne.length && nt()),
        this
    }
    function st() {
        var e = Z;
        return e.loader = {
            load: ot,
            i: 0
        },
        e
    }
    function rt(e, i) {
        var n = !1
          , t = e.charAt(0).toUpperCase() + e.slice(1);
        return we.each((e + " " + _e.join(t + " ") + t).split(" "), function(e, t) {
            if (xe[t] !== be)
                return n = !i || t,
                !1
        }),
        n
    }
    function at(e) {
        return rt(e, !0)
    }
    function lt(e) {
        this._core = e,
        this._call = null,
        this._time = 0,
        this._timeout = 0,
        this._paused = !0,
        this._handlers = {
            "changed.owl.carousel": ke.proxy(function(e) {
                e.namespace && "settings" === e.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : e.namespace && "position" === e.property.name && this._paused && (this._time = 0)
            }, this),
            "initialized.owl.carousel": ke.proxy(function(e) {
                e.namespace && this._core.settings.autoplay && this.play()
            }, this),
            "play.owl.autoplay": ke.proxy(function(e, t, i) {
                e.namespace && this.play(t, i)
            }, this),
            "stop.owl.autoplay": ke.proxy(function(e) {
                e.namespace && this.stop()
            }, this),
            "mouseover.owl.autoplay": ke.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this),
            "mouseleave.owl.autoplay": ke.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
            }, this),
            "touchstart.owl.core": ke.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
            }, this),
            "touchend.owl.core": ke.proxy(function() {
                this._core.settings.autoplayHoverPause && this.play()
            }, this)
        },
        this._core.$element.on(this._handlers),
        this._core.options = ke.extend({}, lt.Defaults, this._core.options)
    }
    function ct(e) {
        this.core = e,
        this.core.options = ze.extend({}, ct.Defaults, this.core.options),
        this.swapping = !0,
        this.previous = void 0,
        this.next = void 0,
        this.handlers = {
            "change.owl.carousel": ze.proxy(function(e) {
                e.namespace && "position" == e.property.name && (this.previous = this.core.current(),
                this.next = e.property.value)
            }, this),
            "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": ze.proxy(function(e) {
                e.namespace && (this.swapping = "translated" == e.type)
            }, this),
            "translate.owl.carousel": ze.proxy(function(e) {
                e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
            }, this)
        },
        this.core.$element.on(this.handlers)
    }
    function dt(e) {
        this._core = e,
        this._videos = {},
        this._playing = null,
        this._handlers = {
            "initialized.owl.carousel": De.proxy(function(e) {
                e.namespace && this._core.register({
                    type: "state",
                    name: "playing",
                    tags: ["interacting"]
                })
            }, this),
            "resize.owl.carousel": De.proxy(function(e) {
                e.namespace && this._core.settings.video && this.isInFullScreen() && e.preventDefault()
            }, this),
            "refreshed.owl.carousel": De.proxy(function(e) {
                e.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove()
            }, this),
            "changed.owl.carousel": De.proxy(function(e) {
                e.namespace && "position" === e.property.name && this._playing && this.stop()
            }, this),
            "prepared.owl.carousel": De.proxy(function(e) {
                if (e.namespace) {
                    var t = De(e.content).find(".owl-video");
                    t.length && (t.css("display", "none"),
                    this.fetch(t, De(e.content)))
                }
            }, this)
        },
        this._core.options = De.extend({}, dt.Defaults, this._core.options),
        this._core.$element.on(this._handlers),
        this._core.$element.on("click.owl.video", ".owl-video-play-icon", De.proxy(function(e) {
            this.play(e)
        }, this))
    }
    function ut(e) {
        this._core = e,
        this._previousHeight = null,
        this._handlers = {
            "initialized.owl.carousel refreshed.owl.carousel": je.proxy(function(e) {
                e.namespace && this._core.settings.autoHeight && this.update()
            }, this),
            "changed.owl.carousel": je.proxy(function(e) {
                e.namespace && this._core.settings.autoHeight && "position" === e.property.name && this.update()
            }, this),
            "loaded.owl.lazy": je.proxy(function(e) {
                e.namespace && this._core.settings.autoHeight && e.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
            }, this)
        },
        this._core.options = je.extend({}, ut.Defaults, this._core.options),
        this._core.$element.on(this._handlers),
        this._intervalId = null;
        var t = this;
        je(Le).on("load", function() {
            t._core.settings.autoHeight && t.update()
        }),
        je(Le).resize(function() {
            t._core.settings.autoHeight && (null != t._intervalId && clearTimeout(t._intervalId),
            t._intervalId = setTimeout(function() {
                t.update()
            }, 250))
        })
    }
    function pt(e) {
        this._core = e,
        this._loaded = [],
        this._handlers = {
            "initialized.owl.carousel change.owl.carousel resized.owl.carousel": Pe.proxy(function(e) {
                if (e.namespace && this._core.settings && this._core.settings.lazyLoad && (e.property && "position" == e.property.name || "initialized" == e.type)) {
                    var t = this._core.settings
                      , i = t.center && Math.ceil(t.items / 2) || t.items
                      , n = t.center && -1 * i || 0
                      , o = (e.property && void 0 !== e.property.value ? e.property.value : this._core.current()) + n
                      , s = this._core.clones().length
                      , r = Pe.proxy(function(e, t) {
                        this.load(t)
                    }, this);
                    for (0 < t.lazyLoadEager && (i += t.lazyLoadEager,
                    t.loop && (o -= t.lazyLoadEager,
                    i++)); n++ < i; )
                        this.load(s / 2 + this._core.relative(o)),
                        s && Pe.each(this._core.clones(this._core.relative(o)), r),
                        o++
                }
            }, this)
        },
        this._core.options = Pe.extend({}, pt.Defaults, this._core.options),
        this._core.$element.on(this._handlers)
    }
    function ht(e) {
        this._core = e,
        this._interval = null,
        this._visible = null,
        this._handlers = {
            "initialized.owl.carousel": Me.proxy(function(e) {
                e.namespace && this._core.settings.autoRefresh && this.watch()
            }, this)
        },
        this._core.options = Me.extend({}, ht.Defaults, this._core.options),
        this._core.$element.on(this._handlers)
    }
    function ft(e, t) {
        this.settings = null,
        this.options = qe.extend({}, ft.Defaults, t),
        this.$element = qe(e),
        this._handlers = {},
        this._plugins = {},
        this._supress = {},
        this._current = null,
        this._speed = null,
        this._coordinates = [],
        this._breakpoint = null,
        this._width = null,
        this._items = [],
        this._clones = [],
        this._mergers = [],
        this._widths = [],
        this._invalidated = {},
        this._pipe = [],
        this._drag = {
            time: null,
            target: null,
            pointer: null,
            stage: {
                start: null,
                current: null
            },
            direction: null
        },
        this._states = {
            current: {},
            tags: {
                initializing: ["busy"],
                animating: ["busy"],
                dragging: ["interacting"]
            }
        },
        qe.each(["onResize", "onThrottledResize"], qe.proxy(function(e, t) {
            this._handlers[t] = qe.proxy(this[t], this)
        }, this)),
        qe.each(ft.Plugins, qe.proxy(function(e, t) {
            this._plugins[e.charAt(0).toLowerCase() + e.slice(1)] = new t(this)
        }, this)),
        qe.each(ft.Workers, qe.proxy(function(e, t) {
            this._pipe.push({
                filter: t.filter,
                run: qe.proxy(t.run, this)
            })
        }, this)),
        this.setup(),
        this.initialize()
    }
    e = window,
    t = function(l, M) {
        "use strict";
        if (M.getElementsByClassName) {
            var I, q, H = M.documentElement, c = l.Date, o = l.HTMLPictureElement, d = "addEventListener", R = "getAttribute", W = l[d], F = l.setTimeout, u = l.requestAnimationFrame || F, p = l.requestIdleCallback, B = /^picture$/i, s = ["load", "error", "lazyincluded", "_lazyloaded"], n = {}, U = Array.prototype.forEach, X = function e(t, i) {
                return n[i] || (n[i] = new RegExp("(\\s|^)" + i + "(\\s|$)")),
                n[i].test(t[R]("class") || "") && n[i]
            }, G = function e(t, i) {
                X(t, i) || t.setAttribute("class", (t[R]("class") || "").trim() + " " + i)
            }, Y = function e(t, i) {
                var n;
                (n = X(t, i)) && t.setAttribute("class", (t[R]("class") || "").replace(n, " "))
            }, V = function e(t, i, n) {
                var o = n ? d : "removeEventListener";
                n && e(t, i),
                s.forEach(function(e) {
                    t[o](e, i)
                })
            }, Q = function e(t, i, n, o, s) {
                var r = M.createEvent("CustomEvent");
                return n || (n = {}),
                n.instance = I,
                r.initCustomEvent(i, !o, !s, n),
                t.dispatchEvent(r),
                r
            }, K = function e(t, i) {
                var n;
                !o && (n = l.picturefill || q.pf) ? n({
                    reevaluate: !0,
                    elements: [t]
                }) : i && i.src && (t.src = i.src)
            }, Z = function e(t, i) {
                return (getComputedStyle(t, null) || {})[i]
            }, r = function e(t, i, n) {
                for (n = n || t.offsetWidth; n < q.minSize && i && !t._lazysizesWidth; ) {
                    n = i.offsetWidth,
                    i = i.parentNode
                }
                return n
            }, J = function() {
                var n, o, i = [], s = [], r = i, a = function e() {
                    var t = r;
                    for (r = i.length ? s : i,
                    n = !0,
                    o = !1; t.length; ) {
                        t.shift()()
                    }
                    n = !1
                }, e = function e(t, i) {
                    n && !i ? t.apply(this, arguments) : (r.push(t),
                    o || (o = !0,
                    (M.hidden ? F : u)(a)))
                };
                return e._lsFlush = a,
                e
            }(), ee = function e(i, t) {
                return t ? function() {
                    J(i)
                }
                : function() {
                    var e = this
                      , t = arguments;
                    J(function() {
                        i.apply(e, t)
                    })
                }
            }, e = function e(t) {
                var i, n = 0, o = 125, s = q.ricTimeout, r = function e() {
                    i = !1,
                    n = c.now(),
                    t()
                }, a = p && q.ricTimeout ? function() {
                    p(r, {
                        timeout: s
                    }),
                    s !== q.ricTimeout && (s = q.ricTimeout)
                }
                : ee(function() {
                    F(r)
                }, !0);
                return function(e) {
                    var t;
                    (e = e === !0) && (s = 33),
                    i || (i = !0,
                    t = o - (c.now() - n),
                    0 > t && (t = 0),
                    e || 9 > t && p ? a() : F(a, t))
                }
            }, te = function e(t) {
                var i, n, o = 99, s = function e() {
                    i = null,
                    t()
                }, r = function e() {
                    var t = c.now() - n;
                    o > t ? F(e, o - t) : (p || s)(s)
                };
                return function() {
                    n = c.now(),
                    i || (i = F(r, o))
                }
            };
            !function() {
                var e, t = {
                    lazyClass: "lazyload",
                    loadedClass: "lazyloaded",
                    loadingClass: "lazyloading",
                    preloadClass: "lazypreload",
                    errorClass: "lazyerror",
                    autosizesClass: "lazyautosizes",
                    srcAttr: "data-src",
                    srcsetAttr: "data-srcset",
                    sizesAttr: "data-sizes",
                    minSize: 40,
                    customMedia: {},
                    init: !0,
                    expFactor: 1.5,
                    hFac: .8,
                    loadMode: 2,
                    loadHidden: !0,
                    ricTimeout: 300
                };
                q = l.lazySizesConfig || l.lazysizesConfig || {};
                for (e in t) {
                    e in q || (q[e] = t[e])
                }
                l.lazySizesConfig = q,
                F(function() {
                    q.init && i()
                })
            }();
            var t = function() {
                var u, p, h, f, i, g, m, v, y, w, b, x, _, C, r = /^img$/i, T = /^iframe$/i, S = "onscroll"in l && !/glebot/.test(navigator.userAgent), $ = 0, k = 0, A = 0, E = -1, z = function e(t) {
                    A--,
                    t && t.target && V(t.target, e),
                    (!t || 0 > A || !t.target) && (A = 0)
                }, D = function e(t, i) {
                    var n, o = t, s = "hidden" == Z(M.body, "visibility") || "hidden" != Z(t, "visibility");
                    for (v -= i,
                    b += i,
                    y -= i,
                    w += i; s && (o = o.offsetParent) && o != M.body && o != H; ) {
                        s = (Z(o, "opacity") || 1) > 0,
                        s && "visible" != Z(o, "overflow") && (n = o.getBoundingClientRect(),
                        s = w > n.left && y < n.right && b > n.top - 1 && v < n.bottom + 1)
                    }
                    return s
                }, t = function e() {
                    var t, i, n, o, s, r, a, l, c, d = I.elements;
                    if ((f = q.loadMode) && 8 > A && (t = d.length)) {
                        i = 0,
                        E++,
                        null == _ && ("expand"in q || (q.expand = H.clientHeight > 500 && H.clientWidth > 500 ? 500 : 370),
                        x = q.expand,
                        _ = x * q.expFactor),
                        _ > k && 1 > A && E > 2 && f > 2 && !M.hidden ? (k = _,
                        E = 0) : k = f > 1 && E > 1 && 6 > A ? x : $;
                        for (; t > i; i++) {
                            if (d[i] && !d[i]._lazyRace)
                                if (S) {
                                    if ((l = d[i][R]("data-expand")) && (r = 1 * l) || (r = k),
                                    c !== r && (g = innerWidth + r * C,
                                    m = innerHeight + r,
                                    a = -1 * r,
                                    c = r),
                                    n = d[i].getBoundingClientRect(),
                                    (b = n.bottom) >= a && (v = n.top) <= m && (w = n.right) >= a * C && (y = n.left) <= g && (b || w || y || v) && (q.loadHidden || "hidden" != Z(d[i], "visibility")) && (p && 3 > A && !l && (3 > f || 4 > E) || D(d[i], r))) {
                                        if (N(d[i]),
                                        s = !0,
                                        A > 9)
                                            break
                                    } else
                                        !s && p && !o && 4 > A && 4 > E && f > 2 && (u[0] || q.preloadAfterLoad) && (u[0] || !l && (b || w || y || v || "auto" != d[i][R](q.sizesAttr))) && (o = u[0] || d[i])
                                } else
                                    N(d[i])
                        }
                        o && !s && N(o)
                    }
                }, n = e(t), O = function e(t) {
                    G(t.target, q.loadedClass),
                    Y(t.target, q.loadingClass),
                    V(t.target, j),
                    Q(t.target, "lazyloaded")
                }, o = ee(O), j = function e(t) {
                    o({
                        target: t.target
                    })
                }, L = function e(t, i) {
                    try {
                        t.contentWindow.location.replace(i)
                    } catch (e) {
                        t.src = i
                    }
                }, P = function e(t) {
                    var i, n = t[R](q.srcsetAttr);
                    (i = q.customMedia[t[R]("data-media") || t[R]("media")]) && t.setAttribute("media", i),
                    n && t.setAttribute("srcset", n)
                }, a = ee(function(e, t, i, n, o) {
                    var s, r, a, l, c, d;
                    (c = Q(e, "lazybeforeunveil", t)).defaultPrevented || (n && (i ? G(e, q.autosizesClass) : e.setAttribute("sizes", n)),
                    r = e[R](q.srcsetAttr),
                    s = e[R](q.srcAttr),
                    o && (a = e.parentNode,
                    l = a && B.test(a.nodeName || "")),
                    d = t.firesLoad || "src"in e && (r || s || l),
                    c = {
                        target: e
                    },
                    d && (V(e, z, !0),
                    clearTimeout(h),
                    h = F(z, 2500),
                    G(e, q.loadingClass),
                    V(e, j, !0)),
                    l && U.call(a.getElementsByTagName("source"), P),
                    r ? e.setAttribute("srcset", r) : s && !l && (T.test(e.nodeName) ? L(e, s) : e.src = s),
                    o && (r || l) && K(e, {
                        src: s
                    })),
                    e._lazyRace && delete e._lazyRace,
                    Y(e, q.lazyClass),
                    J(function() {
                        (!d || e.complete && e.naturalWidth > 1) && (d ? z(c) : A--,
                        O(c))
                    }, !0)
                }), N = function e(t) {
                    var i, n = r.test(t.nodeName), o = n && (t[R](q.sizesAttr) || t[R]("sizes")), s = "auto" == o;
                    (!s && p || !n || !t[R]("src") && !t.srcset || t.complete || X(t, q.errorClass) || !X(t, q.lazyClass)) && (i = Q(t, "lazyunveilread").detail,
                    s && ie.updateElem(t, !0, t.offsetWidth),
                    t._lazyRace = !0,
                    A++,
                    a(t, i, s, o, n))
                }, s = function e() {
                    if (!p) {
                        if (c.now() - i < 999)
                            return void F(e, 999);
                        var t = te(function() {
                            q.loadMode = 3,
                            n()
                        });
                        p = !0,
                        q.loadMode = 3,
                        n(),
                        W("scroll", function() {
                            3 == q.loadMode && (q.loadMode = 2),
                            t()
                        }, !0)
                    }
                };
                return {
                    _: function e() {
                        i = c.now(),
                        I.elements = M.getElementsByClassName(q.lazyClass),
                        u = M.getElementsByClassName(q.lazyClass + " " + q.preloadClass),
                        C = q.hFac,
                        W("scroll", n, !0),
                        W("resize", n, !0),
                        l.MutationObserver ? new MutationObserver(n).observe(H, {
                            childList: !0,
                            subtree: !0,
                            attributes: !0
                        }) : (H[d]("DOMNodeInserted", n, !0),
                        H[d]("DOMAttrModified", n, !0),
                        setInterval(n, 999)),
                        W("hashchange", n, !0),
                        ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(e) {
                            M[d](e, n, !0)
                        }),
                        /d$|^c/.test(M.readyState) ? s() : (W("load", s),
                        M[d]("DOMContentLoaded", n),
                        F(s, 2e4)),
                        I.elements.length ? (t(),
                        J._lsFlush()) : n()
                    },
                    checkElems: n,
                    unveil: N
                }
            }()
              , ie = function() {
                var n, s = ee(function(e, t, i, n) {
                    var o, s, r;
                    if (e._lazysizesWidth = n,
                    n += "px",
                    e.setAttribute("sizes", n),
                    B.test(t.nodeName || ""))
                        for (o = t.getElementsByTagName("source"),
                        s = 0,
                        r = o.length; r > s; s++) {
                            o[s].setAttribute("sizes", n)
                        }
                    i.detail.dataAttr || K(e, i.detail)
                }), o = function e(t, i, n) {
                    var e, o = t.parentNode;
                    o && (n = r(t, o, n),
                    e = Q(t, "lazybeforesizes", {
                        width: n,
                        dataAttr: !!i
                    }),
                    e.defaultPrevented || (n = e.detail.width,
                    n && n !== t._lazysizesWidth && s(t, o, e, n)))
                }, e = function e() {
                    var t, i = n.length;
                    if (i)
                        for (t = 0; i > t; t++) {
                            o(n[t])
                        }
                }, t = te(e);
                return {
                    _: function e() {
                        n = M.getElementsByClassName(q.autosizesClass),
                        W("resize", t)
                    },
                    checkElems: t,
                    updateElem: o
                }
            }()
              , i = function e() {
                e.i || (e.i = !0,
                ie._(),
                t._())
            };
            return I = {
                cfg: q,
                autoSizer: ie,
                loader: t,
                init: i,
                uP: K,
                aC: G,
                rC: Y,
                hC: X,
                fire: Q,
                gW: r,
                rAF: J
            }
        }
    }(e, e.document),
    e.lazySizes = t,
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports && (module.exports = t),
    i = window,
    n = (n = function(u, c, f) {
        "use strict";
        function g(e, t, i) {
            var n, o, s, r = 0, a = 0, l = i;
            if (e) {
                if ("container" === t.ratio) {
                    for (r = l.scrollWidth,
                    a = l.scrollHeight; !(r && a || l === c); )
                        r = (l = l.parentNode).scrollWidth,
                        a = l.scrollHeight;
                    r && a && (t.ratio = a / r)
                }
                n = e,
                o = t,
                (s = []).srcset = [],
                o.absUrl && (C.setAttribute("href", n),
                n = C.href),
                n = ((o.prefix || "") + n + (o.postfix || "")).replace(h, function(e, t) {
                    return d[_typeof(o[t])] ? o[t] : e
                }),
                o.widths.forEach(function(e) {
                    var t = o.widthmap[e] || e
                      , i = {
                        u: n.replace(b, t).replace(p, o.ratio ? Math.round(e * o.ratio) : ""),
                        w: e
                    };
                    s.push(i),
                    s.srcset.push(i.c = i.u + " " + e + "w")
                }),
                (e = s).isPicture = t.isPicture,
                T && "IMG" == i.nodeName.toUpperCase() ? i.removeAttribute(y.srcsetAttr) : i.setAttribute(y.srcsetAttr, e.srcset.join(", ")),
                Object.defineProperty(i, "_lazyrias", {
                    value: e,
                    writable: !0
                })
            }
        }
        function m(e, t) {
            var i = function(o, e) {
                var t, i, n, s, r = u.getComputedStyle(o);
                for (t in i = o.parentNode,
                s = {
                    isPicture: !(!i || !l.test(i.nodeName || ""))
                },
                n = function(e, t) {
                    var i = o.getAttribute("data-" + e);
                    if (!i) {
                        var n = r.getPropertyValue("--ls-" + e);
                        n && (i = n.trim())
                    }
                    if (i) {
                        if ("true" == i)
                            i = !0;
                        else if ("false" == i)
                            i = !1;
                        else if (a.test(i))
                            i = parseFloat(i);
                        else if ("function" == typeof w[e])
                            i = w[e](o, i);
                        else if (x.test(i))
                            try {
                                i = JSON.parse(i)
                            } catch (e) {}
                        s[e] = i
                    } else
                        e in w && "function" != typeof w[e] ? s[e] = w[e] : t && "function" == typeof w[e] && (s[e] = w[e](o, i))
                }
                ,
                w)
                    n(t);
                return e.replace(h, function(e, t) {
                    t in s || n(t, !0)
                }),
                s
            }(e, t);
            return w.modifyOptions.call(e, {
                target: e,
                details: i,
                detail: i
            }),
            f.fire(e, "lazyriasmodifyoptions", i),
            i
        }
        function v(e) {
            return e.getAttribute(e.getAttribute("data-srcattr") || w.srcAttr) || e.getAttribute(y.srcsetAttr) || e.getAttribute(y.srcAttr) || e.getAttribute("data-pfsrcset") || ""
        }
        var y, w, d = {
            string: 1,
            number: 1
        }, a = /^\-*\+*\d+\.*\d*$/, l = /^picture$/i, b = /\s*\{\s*width\s*\}\s*/i, p = /\s*\{\s*height\s*\}\s*/i, h = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, x = /^\[.*\]|\{.*\}$/, _ = /^(?:auto|\d+(px)?)$/, C = c.createElement("a"), e = c.createElement("img"), T = "srcset"in e && !("sizes"in e), S = !!u.HTMLPictureElement && !T;
        !function() {
            var e, t = {
                prefix: "",
                postfix: "",
                srcAttr: "data-src",
                absUrl: !1,
                modifyOptions: function() {},
                widthmap: {},
                ratio: !1
            };
            for (e in (y = f && f.cfg || u.lazySizesConfig) || (y = {},
            u.lazySizesConfig = y),
            y.supportsType || (y.supportsType = function(e) {
                return !e
            }
            ),
            y.rias || (y.rias = {}),
            "widths"in (w = y.rias) || (w.widths = [],
            function(e) {
                for (var t, i = 0; !t || t < 3e3; )
                    30 < (i += 5) && (i += 1),
                    t = 36 * i,
                    e.push(t)
            }(w.widths)),
            t)
                e in w || (w[e] = t[e])
        }(),
        addEventListener("lazybeforesizes", function(e) {
            var t, i, n, o, s, r, a, l, c, d, u, p, h;
            if (e.detail.instance == f && (t = e.target,
            e.detail.dataAttr && !e.defaultPrevented && !w.disabled && (c = t.getAttribute(y.sizesAttr) || t.getAttribute("sizes")) && _.test(c))) {
                if (n = m(t, i = v(t)),
                u = b.test(n.prefix) || b.test(n.postfix),
                n.isPicture && (o = t.parentNode))
                    for (r = 0,
                    a = (s = o.getElementsByTagName("source")).length; r < a; r++)
                        (u || b.test(l = v(s[r]))) && (g(l, n, s[r]),
                        p = !0);
                u || b.test(i) ? (g(i, n, t),
                p = !0) : p && ((h = []).srcset = [],
                h.isPicture = !0,
                Object.defineProperty(t, "_lazyrias", {
                    value: h,
                    writable: !0
                })),
                p && (S ? t.removeAttribute(y.srcAttr) : "auto" != c && (d = {
                    width: parseInt(c, 10)
                },
                $({
                    target: t,
                    detail: d
                })))
            }
        }, !0);
        var n, $ = (n = function(e) {
            if (e.detail.instance == f) {
                var t, i = e.target;
                return !T && (u.respimage || u.picturefill || lazySizesConfig.pf) ? void c.removeEventListener("lazybeforesizes", n) : void (("_lazyrias"in i || e.detail.dataAttr && A(i, !0)) && ((t = o(i, e.detail.width)) && t.u && i._lazyrias.cur != t.u && (i._lazyrias.cur = t.u,
                t.cached = !0,
                f.rAF(function() {
                    i.setAttribute(y.srcAttr, t.u),
                    i.setAttribute("src", t.u)
                }))))
            }
        }
        ,
        S ? n = function() {}
        : addEventListener("lazybeforesizes", n),
        n);
        function k(e, t) {
            return e.w - t.w
        }
        function A(e, t) {
            var i;
            return !e._lazyrias && f.pWS && (i = f.pWS(e.getAttribute(y.srcsetAttr || ""))).length && (Object.defineProperty(e, "_lazyrias", {
                value: i,
                writable: !0
            }),
            t && e.parentNode && (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
            e._lazyrias
        }
        function o(e, t) {
            var i, n, o, s, r, a, l, c, d;
            if ((r = e._lazyrias).isPicture && u.matchMedia)
                for (n = 0,
                i = e.parentNode.getElementsByTagName("source"),
                o = i.length; n < o; n++)
                    if (A(i[n]) && !i[n].getAttribute("type") && (!(s = i[n].getAttribute("media")) || (matchMedia(s) || {}).matches)) {
                        r = i[n]._lazyrias;
                        break
                    }
            return (!r.w || r.w < t) && (r.w = t,
            r.d = (l = e,
            c = u.devicePixelRatio || 1,
            d = f.getX && f.getX(l),
            Math.min(d || c, 2.4, c)),
            a = function(e) {
                for (var t, i, n = e.length, o = e[n - 1], s = 0; s < n; s++)
                    if (o = e[s],
                    o.d = o.w / e.w,
                    o.d >= e.d) {
                        !o.cached && (t = e[s - 1]) && t.d > e.d - .13 * Math.pow(e.d, 2.2) && (i = Math.pow(t.d - .6, 1.6),
                        t.cached && (t.d += .15 * i),
                        t.d + (o.d - e.d) * i > e.d && (o = t));
                        break
                    }
                return o
            }(r.sort(k))),
            a
        }
    }
    ).bind(null, i, i.document),
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? n(require("lazysizes")) : i.lazySizes ? Fe() : i.addEventListener("lazyunveilread", Fe, !0),
    function(t, e) {
        "use strict";
        if (t.addEventListener) {
            var l, r = /^picture$/i, i = e.documentElement, o = (m = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g,
            function(e) {
                return g = [],
                e.replace(m, f),
                g
            }
            ), c = function(e, t) {
                var i, n, o, s;
                if (!e[t] && (s = e.parentNode || {},
                e[t] = h(e, t),
                e[t].isImg = !0,
                r.test(s.nodeName || "")))
                    for (e[t].picture = !0,
                    n = 0,
                    o = (i = s.getElementsByTagName("source")).length; n < o; n++)
                        h(i[n], t).isImg = !1;
                return e[t]
            }, a = {
                _lazyOptimumx: function(e, t, i) {
                    var n, o, s, r, a, l, c;
                    for (n = 0; n < e.cands.length; n++)
                        if ((o = e.cands[n]).d = (o.w || 1) / t,
                        !(e.index >= n)) {
                            if (!(o.d <= i) && (s = e.cands[n - 1],
                            r = o.d,
                            a = i,
                            c = l = void 0,
                            s && s.d && (c = .7 < a ? .6 : .4,
                            s.d >= a || ((l = Math.pow(s.d - c, 1.6) || .1) < .1 ? l = .1 : 3 < l && (l = 3),
                            !(s.d + (r - a) * l < a)))))
                                break;
                            e.cSrcset.push(o.c),
                            e.index = n
                        }
                }
            }, d = function(e, t, i, n, o) {
                var s, r, a, l, c = e[o];
                if (c.width = t,
                c.picture && (r = e.parentNode))
                    for (l = 0,
                    a = (s = r.getElementsByTagName("source")).length; l < a; l++)
                        p(s[l], t, i, n, o);
                p(e, t, i, n, o)
            }, u = function(e) {
                var t = e.getAttribute("data-optimumx") || e.getAttribute("data-maxdpr");
                return !t && l.constrainPixelDensity && (t = "auto"),
                t = t && ("auto" == t ? l.getOptimumX(e) : parseFloat(t, 10))
            }, n = function e() {
                t.lazySizes && !t.lazySizes.getOptimumX && (lazySizes.getX = u,
                lazySizes.pWS = o,
                i.removeEventListener("lazybeforeunveil", e))
            };
            i.addEventListener("lazybeforeunveil", n),
            setTimeout(n),
            (l = t.lazySizes && lazySizes.cfg || t.lazySizesConfig) || (l = {},
            t.lazySizesConfig = l),
            "function" != typeof l.getOptimumX && (l.getOptimumX = function() {
                var e = t.devicePixelRatio || 1;
                return 2.6 < e ? e *= .6 : 1.9 < e ? e *= .8 : e -= .01,
                Math.min(Math.round(100 * e) / 100, 2)
            }
            ),
            t.devicePixelRatio && addEventListener("lazybeforesizes", function(e) {
                var t, i, n, o, s = e.target, r = e.detail, a = r.dataAttr;
                e.defaultPrevented || !(t = u(s)) || t >= devicePixelRatio || (!a || !s._lazyOptimumx || r.reloaded || l.unloadedClass && lazySizes.hC(s, l.unloadedClass) || (s._lazyOptimumx = null),
                i = c(s, "_lazyOptimumx"),
                (n = r.width) && (i.width || 0) < n && (o = a ? lazySizes.cfg.srcsetAttr : "srcset",
                lazySizes.rAF(function() {
                    d(s, n, t, o, "_lazyOptimumx")
                })))
            })
        }
        function p(e, t, i, n, o) {
            var s, r = e[o];
            r && (s = r.index,
            a[o](r, t, i),
            r.dirty && s == r.index || (r.cSrcset.join(", "),
            e.setAttribute(n, r.cSrcset.join(", ")),
            r.dirty = !0))
        }
        function s(e, t) {
            return e.w - t.w
        }
        function h(e, t) {
            var i = {
                srcset: e.getAttribute(lazySizes.cfg.srcsetAttr) || ""
            }
              , n = o(i.srcset);
            return Object.defineProperty(e, t, {
                value: i,
                writable: !0
            }),
            i.cands = n,
            i.index = 0,
            i.dirty = !1,
            n[0] && n[0].w ? (n.sort(s),
            i.cSrcset = [n[i.index].c]) : (i.cSrcset = i.srcset ? [i.srcset] : [],
            i.cands = []),
            i
        }
        function f(e, t, i, n, o, s, r, a) {
            g.push({
                c: t,
                u: i,
                w: +("w" == a ? r : n)
            })
        }
        var g, m
    }(window, document),
    o = window,
    s = (s = function(e, t, n) {
        "use strict";
        var o, s;
        "srcset"in t.createElement("img") && (o = /^img$/i,
        s = function(e) {
            e.target.style.backgroundSize = "",
            e.target.style.backgroundImage = "",
            e.target.removeEventListener(e.type, s)
        }
        ,
        t.addEventListener("lazybeforeunveil", function(e) {
            if (e.detail.instance == n) {
                var t = e.target;
                if (o.test(t.nodeName)) {
                    var i = t.getAttribute("src");
                    i && (t.style.backgroundSize = "100% 100%",
                    t.style.backgroundImage = "url(" + i + ")",
                    t.removeAttribute("src"),
                    t.addEventListener("load", s))
                }
            }
        }, !1))
    }
    ).bind(null, o, o.document),
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? s(require("lazysizes")) : o.lazySizes ? Be() : o.addEventListener("lazyunveilread", Be, !0),
    r = window,
    a = (a = function(a, e, i) {
        "use strict";
        if (a.addEventListener) {
            var l = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
              , r = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/
              , c = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/
              , d = /^picture$/i
              , u = {
                getParent: function(e, t) {
                    var i = e
                      , n = e.parentNode;
                    return t && "prev" != t || !n || !d.test(n.nodeName || "") || (n = n.parentNode),
                    "self" != t && (i = "prev" == t ? e.previousElementSibling : t && (n.closest || a.jQuery) && (n.closest ? n.closest(t) : jQuery(n).closest(t)[0]) || n),
                    i
                },
                getFit: function(e) {
                    var t, i, n = getComputedStyle(e, null) || {}, o = n.content || n.fontFamily, s = {
                        fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit")
                    };
                    return !s.fit && o && (t = o.match(r)) && (s.fit = t[1]),
                    s.fit ? (!(i = e._lazysizesParentContainer || e.getAttribute("data-parent-container")) && o && (t = o.match(c)) && (i = t[1]),
                    s.parent = u.getParent(e, i)) : s.fit = n.objectFit,
                    s
                },
                getImageRatio: function(e) {
                    var t, i, n, o, s = e.parentNode, r = s && d.test(s.nodeName || "") ? s.querySelectorAll("source, img") : [e];
                    for (t = 0; t < r.length; t++)
                        if (i = (e = r[t]).getAttribute(lazySizesConfig.srcsetAttr) || e.getAttribute("srcset") || e.getAttribute("data-pfsrcset") || e.getAttribute("data-risrcset") || "",
                        n = e._lsMedia || e.getAttribute("media"),
                        n = lazySizesConfig.customMedia[e.getAttribute("data-media") || n] || n,
                        i && (!n || (a.matchMedia && matchMedia(n) || {}).matches)) {
                            !(o = parseFloat(e.getAttribute("data-aspectratio"))) && i.match(l) && (o = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                            break
                        }
                    return o
                },
                calculateSize: function(e, t) {
                    var i, n, o, s, r = this.getFit(e), a = r.fit, l = r.parent;
                    return "width" == a || ("contain" == a || "cover" == a) && (o = this.getImageRatio(e)) ? (l ? t = l.clientWidth : l = e,
                    s = t,
                    "width" == a ? s = t : 40 < (n = l.clientHeight) && (i = t / n) && ("cover" == a && i < o || "contain" == a && o < i) && (s = t * (o / i)),
                    s) : t
                }
            };
            i.parentFit = u,
            e.addEventListener("lazybeforesizes", function(e) {
                if (!e.defaultPrevented && e.detail.instance == i) {
                    var t = e.target;
                    e.detail.width = u.calculateSize(t, e.detail.width)
                }
            })
        }
    }
    ).bind(null, r, r.document),
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? a(require("lazysizes")) : r.lazySizes ? Ue() : r.addEventListener("lazyunveilread", Ue, !0),
    l = window,
    c = (c = function(u, s, p) {
        "use strict";
        var n, r, a, t, o, i, l, h, c, f, g = p && p.cfg || u.lazySizesConfig, e = s.createElement("img"), d = "sizes"in e && "srcset"in e, m = /\s+\d+h/g, v = (r = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
        a = Array.prototype.forEach,
        function(e) {
            function i(e) {
                var t, i, n = e.getAttribute(lazySizesConfig.srcsetAttr);
                n && (!(i = n.match(r)) || (t = "w" == i[2] ? i[1] / i[3] : i[3] / i[1]) && e.setAttribute("data-aspectratio", t),
                e.setAttribute(lazySizesConfig.srcsetAttr, n.replace(m, "")))
            }
            function t(e) {
                var t = e.target.parentNode;
                t && "PICTURE" == t.nodeName && a.call(t.getElementsByTagName("source"), i),
                i(e.target)
            }
            function n() {
                o.currentSrc && s.removeEventListener("lazybeforeunveil", t)
            }
            var o = s.createElement("img");
            e[1] && (s.addEventListener("lazybeforeunveil", t),
            o.onload = n,
            o.onerror = n,
            o.srcset = "data:,a 1w 1h",
            o.complete && n())
        }
        );
        if (g || (g = {},
        u.lazySizesConfig = g),
        g.supportsType || (g.supportsType = function(e) {
            return !e
        }
        ),
        !u.picturefill && !g.pf) {
            if (u.HTMLPictureElement && d)
                return s.msElementsFromPoint && v(navigator.userAgent.match(/Edge\/(\d+)/)),
                void (g.pf = function() {}
                );
            g.pf = function(e) {
                var t, i;
                if (!u.picturefill)
                    for (t = 0,
                    i = e.elements.length; t < i; t++)
                        n(e.elements[t])
            }
            ,
            h = /^\s*\d+\.*\d*px\s*$/,
            i = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
            l = /\s/,
            f = function(e) {
                return u.matchMedia ? (f = function(e) {
                    return !e || (matchMedia(e) || {}).matches
                }
                )(e) : !e
            }
            ,
            _.parse = c = function(e) {
                return o = [],
                (e = e.trim()).replace(m, "").replace(i, C),
                o.length || !e || l.test(e) || o.push({
                    c: e,
                    u: e,
                    w: 99
                }),
                o
            }
            ,
            n = _,
            g.loadedClass && g.loadingClass && (t = [],
            ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(e) {
                t.push(e + g.loadedClass),
                t.push(e + g.loadingClass)
            }),
            g.pf({
                elements: s.querySelectorAll(t.join(", "))
            }))
        }
        function y(e, t) {
            return e.w - t.w
        }
        function w() {
            function e() {
                var e, t;
                for (e = 0,
                t = i.length; e < t; e++)
                    n(i[e])
            }
            var t, i;
            w.init || (w.init = !0,
            addEventListener("resize", (i = s.getElementsByClassName("lazymatchmedia"),
            function() {
                clearTimeout(t),
                t = setTimeout(e, 66)
            }
            )))
        }
        function b(e, t) {
            var i, n = e.getAttribute("srcset") || e.getAttribute(g.srcsetAttr);
            !n && t && (n = e._lazypolyfill ? e._lazypolyfill._set : e.getAttribute(g.srcAttr) || e.getAttribute("src")),
            e._lazypolyfill && e._lazypolyfill._set == n || (i = c(n || ""),
            t && e.parentNode && (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase(),
            i.isPicture && u.matchMedia && (p.aC(e, "lazymatchmedia"),
            w())),
            i._set = n,
            Object.defineProperty(e, "_lazypolyfill", {
                value: i,
                writable: !0
            }))
        }
        function x(e) {
            var t, i, n, o, s, r, a, l, c, d;
            if (b(o = e, !0),
            (s = o._lazypolyfill).isPicture)
                for (i = 0,
                n = (t = e.parentNode.getElementsByTagName("source")).length; i < n; i++)
                    if (g.supportsType(t[i].getAttribute("type"), e) && f(t[i].getAttribute("media"))) {
                        o = t[i],
                        b(o),
                        s = o._lazypolyfill;
                        break
                    }
            return 1 < s.length ? (a = o.getAttribute("sizes") || "",
            a = h.test(a) && parseInt(a, 10) || p.gW(e, e.parentNode),
            s.d = (l = e,
            c = u.devicePixelRatio || 1,
            d = p.getX && p.getX(l),
            Math.min(d || c, 2.5, c)),
            !s.src || !s.w || s.w < a ? (s.w = a,
            r = function(e) {
                for (var t, i, n = e.length, o = e[n - 1], s = 0; s < n; s++)
                    if ((o = e[s]).d = o.w / e.w,
                    o.d >= e.d) {
                        !o.cached && (t = e[s - 1]) && t.d > e.d - .13 * Math.pow(e.d, 2.2) && (i = Math.pow(t.d - .6, 1.6),
                        t.cached && (t.d += .15 * i),
                        t.d + (o.d - e.d) * i > e.d && (o = t));
                        break
                    }
                return o
            }(s.sort(y)),
            s.src = r) : r = s.src) : r = s[0],
            r
        }
        function _(e) {
            if (!d || !e.parentNode || "PICTURE" == e.parentNode.nodeName.toUpperCase()) {
                var t = x(e);
                t && t.u && e._lazypolyfill.cur != t.u && (e._lazypolyfill.cur = t.u,
                t.cached = !0,
                e.setAttribute(g.srcAttr, t.u),
                e.setAttribute("src", t.u))
            }
        }
        function C(e, t, i, n) {
            o.push({
                c: t,
                u: i,
                w: +n
            })
        }
    }
    ).bind(null, l, l.document),
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? c(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : l.lazySizes ? Xe() : l.addEventListener("lazyunveilread", Xe, !0),
    d = window,
    u = (u = function(e, u, p) {
        "use strict";
        if (e.addEventListener) {
            var h = /\s+/g
              , f = /\s*\|\s+|\s+\|\s*/g
              , g = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/
              , o = /\(|\)|'/
              , s = {
                contain: 1,
                cover: 1
            }
              , m = function(e) {
                if (e.target._lazybgset) {
                    var t = e.target
                      , i = t._lazybgset
                      , n = t.currentSrc || t.src;
                    n && (i.style.backgroundImage = "url(" + (o.test(n) ? JSON.stringify(n) : n) + ")"),
                    t._lazybgsetLoading && (p.fire(i, "_lazyloaded", {}, !1, !0),
                    delete t._lazybgsetLoading)
                }
            };
            addEventListener("lazybeforeunveil", function(e) {
                var t, i, n, o, s, r, a, l, c, d;
                !e.defaultPrevented && (t = e.target.getAttribute("data-bgset")) && (n = e.target,
                (i = u.createElement("img")).alt = "",
                i._lazybgsetLoading = !0,
                e.detail.firesLoad = !0,
                o = t,
                s = n,
                r = i,
                a = u.createElement("picture"),
                l = s.getAttribute(lazySizesConfig.sizesAttr),
                c = s.getAttribute("data-ratio"),
                d = s.getAttribute("data-optimumx"),
                s._lazybgset && s._lazybgset.parentNode == s && s.removeChild(s._lazybgset),
                Object.defineProperty(r, "_lazybgset", {
                    value: s,
                    writable: !0
                }),
                Object.defineProperty(s, "_lazybgset", {
                    value: a,
                    writable: !0
                }),
                o = o.replace(h, " ").split(f),
                a.style.display = "none",
                r.className = lazySizesConfig.lazyClass,
                1 != o.length || l || (l = "auto"),
                o.forEach(function(e) {
                    var t = u.createElement("source");
                    l && "auto" != l && t.setAttribute("sizes", l),
                    e.match(g) && (t.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1),
                    RegExp.$2 && t.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                    a.appendChild(t)
                }),
                l && (r.setAttribute(lazySizesConfig.sizesAttr, l),
                s.removeAttribute(lazySizesConfig.sizesAttr),
                s.removeAttribute("sizes")),
                d && r.setAttribute("data-optimumx", d),
                c && r.setAttribute("data-ratio", c),
                a.appendChild(r),
                s.appendChild(a),
                setTimeout(function() {
                    p.loader.unveil(i),
                    p.rAF(function() {
                        p.fire(i, "_lazyloaded", {}, !0, !0),
                        i.complete && m({
                            target: i
                        })
                    })
                }))
            }),
            u.addEventListener("load", m, !0),
            e.addEventListener("lazybeforesizes", function(e) {
                if (e.detail.instance == p && e.target._lazybgset && e.detail.dataAttr) {
                    var t = e.target._lazybgset
                      , i = (n = t,
                    o = (getComputedStyle(n) || {
                        getPropertyValue: function() {}
                    }).getPropertyValue("background-size"),
                    !s[o] && s[n.style.backgroundSize] && (o = n.style.backgroundSize),
                    o);
                    s[i] && (e.target._lazysizesParentFit = i,
                    p.rAF(function() {
                        e.target.setAttribute("data-parent-fit", i),
                        e.target._lazysizesParentFit && delete e.target._lazysizesParentFit
                    }))
                }
                var n, o
            }, !0),
            u.documentElement.addEventListener("lazybeforesizes", function(e) {
                var t, i;
                !e.defaultPrevented && e.target._lazybgset && e.detail.instance == p && (e.detail.width = (t = e.target._lazybgset,
                i = p.gW(t, t.parentNode),
                (!t._lazysizesWidth || i > t._lazysizesWidth) && (t._lazysizesWidth = i),
                t._lazysizesWidth))
            })
        }
    }
    ).bind(null, d, d.document),
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? u(require("lazysizes")) : d.lazySizes ? Ge() : d.addEventListener("lazyunveilread", Ge, !0),
    document.addEventListener("lazyloaded", function(e) {
        e.target.parentElement.className = e.target.parentElement.className.replace("lazyload--placeholder", "")
    }),
    h = jQuery,
    A = {},
    E = [],
    z = k = 0,
    D = {},
    O = [],
    j = null,
    L = new Image,
    P = /\.(jpg|gif|png|bmp|jpeg)(.*)?$/i,
    N = /[^\.]\.(swf)\s*$/i,
    I = 0,
    q = "",
    H = !(M = 1),
    R = h.extend(h("<div/>")[0], {
        prop: 0
    }),
    W = h.browser && h.browser.msie && h.browser.version < 7 && !window.XMLHttpRequest,
    F = function() {
        var e = A.width
          , t = A.height;
        e = -1 < e.toString().indexOf("%") ? parseInt((h(window).width() - 2 * A.margin) * parseFloat(e) / 100, 10) + "px" : "auto" == e ? "auto" : e + "px",
        t = -1 < t.toString().indexOf("%") ? parseInt((h(window).height() - 2 * A.margin) * parseFloat(t) / 100, 10) + "px" : "auto" == t ? "auto" : t + "px",
        f.wrapInner('<div style="width:' + e + ";height:" + t + ";overflow: " + ("auto" == A.scrolling ? "auto" : "yes" == A.scrolling ? "scroll" : "hidden") + ';position:relative;"></div>'),
        A.width = f.width(),
        A.height = f.height(),
        B()
    }
    ,
    B = function() {
        var e, t;
        if (g.hide(),
        v.is(":visible") && !1 === D.onCleanup(O, z, D))
            h.event.trigger("fancybox-cancel"),
            H = !1;
        else {
            if (H = !0,
            h(w.add(m)).unbind(),
            h(window).unbind("resize.fb scroll.fb"),
            h(document).unbind("keydown.fb"),
            v.is(":visible") && "outside" !== D.titlePosition && v.css("height", v.height()),
            O = E,
            z = k,
            (D = A).overlayShow ? (m.css({
                "background-color": D.overlayColor,
                opacity: D.overlayOpacity,
                cursor: D.hideOnOverlayClick ? "pointer" : "auto",
                height: h(document).height()
            }),
            m.is(":visible") || (W && h("select:not(#fancybox-tmp select)").filter(function() {
                return "hidden" !== this.style.visibility
            }).css({
                visibility: "hidden"
            }).one("fancybox-cleanup", function() {
                this.style.visibility = "inherit"
            }),
            m.show())) : m.hide(),
            $ = G(),
            q = D.title || "",
            I = 0,
            x.empty().removeAttr("style").removeClass(),
            !1 !== D.titleShow && (e = h.isFunction(D.titleFormat) ? D.titleFormat(q, O, z, D) : !(!q || !q.length) && ("float" == D.titlePosition ? '<table id="fancybox-title-float-wrap" cellpadding="0" cellspacing="0"><tr><td id="fancybox-title-float-left"></td><td id="fancybox-title-float-main">' + q + '</td><td id="fancybox-title-float-right"></td></tr></table>' : '<div id="fancybox-title-' + D.titlePosition + '">' + q + "</div>"),
            (q = e) && "" !== q))
                switch (x.addClass("fancybox-title-" + D.titlePosition).html(q).appendTo("body").show(),
                D.titlePosition) {
                case "inside":
                    x.css({
                        width: $.width - 2 * D.padding,
                        marginLeft: D.padding,
                        marginRight: D.padding
                    }),
                    I = x.outerHeight(!0),
                    x.appendTo(y),
                    $.height += I;
                    break;
                case "over":
                    x.css({
                        marginLeft: D.padding,
                        width: $.width - 2 * D.padding,
                        bottom: D.padding
                    }).appendTo(y);
                    break;
                case "float":
                    x.css("left", -1 * parseInt((x.width() - $.width - 40) / 2, 10)).appendTo(v);
                    break;
                default:
                    x.css({
                        width: $.width - 2 * D.padding,
                        paddingLeft: D.padding,
                        paddingRight: D.padding
                    }).appendTo(v)
                }
            x.hide(),
            v.is(":visible") ? (h(b.add(_).add(C)).hide(),
            e = v.position(),
            S = {
                top: e.top,
                left: e.left,
                width: v.width(),
                height: v.height()
            },
            t = S.width == $.width && S.height == $.height,
            w.fadeTo(D.changeFade, .3, function() {
                function e() {
                    w.html(f.contents()).fadeTo(D.changeFade, 1, U)
                }
                h.event.trigger("fancybox-change"),
                w.empty().removeAttr("filter").css({
                    "border-width": D.padding,
                    width: $.width - 2 * D.padding,
                    height: A.autoDimensions ? "auto" : $.height - I - 2 * D.padding
                }),
                t ? e() : (R.prop = 0,
                h(R).animate({
                    prop: 1
                }, {
                    duration: D.changeSpeed,
                    easing: D.easingChange,
                    step: X,
                    complete: e
                }))
            })) : (v.removeAttr("style"),
            w.css("border-width", D.padding),
            "elastic" == D.transitionIn ? (S = Y(),
            w.html(f.contents()),
            v.show(),
            D.opacity && ($.opacity = 0),
            R.prop = 0,
            h(R).animate({
                prop: 1
            }, {
                duration: D.speedIn,
                easing: D.easingIn,
                step: X,
                complete: U
            })) : ("inside" == D.titlePosition && 0 < I && x.show(),
            w.css({
                width: $.width - 2 * D.padding,
                height: A.autoDimensions ? "auto" : $.height - I - 2 * D.padding
            }).html(f.contents()),
            v.css($).fadeIn("none" == D.transitionIn ? 0 : D.speedIn, U)))
        }
    }
    ,
    U = function() {
        var e;
        h.support.opacity || (h(w).css("filter", ""),
        h(v).css("filter", "")),
        A.autoDimensions && w.css("height", "auto"),
        v.css("height", "auto"),
        q && q.length && x.show(),
        D.showCloseButton && b.show(),
        (D.enableEscapeButton || D.enableKeyboardNav) && h(document).bind("keydown.fb", function(e) {
            27 == e.keyCode && D.enableEscapeButton ? (e.preventDefault(),
            h.fancybox.close()) : 37 != e.keyCode && 39 != e.keyCode || !D.enableKeyboardNav || "INPUT" === e.target.tagName || "TEXTAREA" === e.target.tagName || "SELECT" === e.target.tagName || (e.preventDefault(),
            h.fancybox[37 == e.keyCode ? "prev" : "next"]())
        }),
        D.showNavArrows ? ((D.cyclic && 1 < O.length || 0 !== z) && _.show(),
        (D.cyclic && 1 < O.length || z != O.length - 1) && C.show()) : (_.hide(),
        C.hide()),
        D.hideOnContentClick && w.bind("click", h.fancybox.close),
        D.hideOnOverlayClick && m.bind("click", h.fancybox.close),
        h(window).bind("resize.fb", h.fancybox.resize),
        D.centerOnScroll && h(window).bind("scroll.fb", h.fancybox.center),
        "iframe" == D.type && h('<iframe id="fancybox-frame" name="fancybox-frame' + (new Date).getTime() + '" frameborder="0" hspace="0" ' + (h.browser && h.browser.msie ? 'allowtransparency="true""' : "") + ' scrolling="' + A.scrolling + '" src="' + D.href + '"></iframe>').appendTo(w),
        v.show(),
        H = !1,
        h.fancybox.center(),
        D.onComplete(O, z, D),
        O.length - 1 > z && void 0 !== (e = O[z + 1].href) && e.match(P) && ((new Image).src = e),
        0 < z && void 0 !== (e = O[z - 1].href) && e.match(P) && ((new Image).src = e)
    }
    ,
    X = function(e) {
        var t = {
            width: parseInt(S.width + ($.width - S.width) * e, 10),
            height: parseInt(S.height + ($.height - S.height) * e, 10),
            top: parseInt(S.top + ($.top - S.top) * e, 10),
            left: parseInt(S.left + ($.left - S.left) * e, 10)
        };
        void 0 !== $.opacity && (t.opacity = e < .5 ? .5 : e),
        v.css(t),
        w.css({
            width: t.width - 2 * D.padding,
            height: t.height - I * e - 2 * D.padding
        })
    }
    ,
    G = function() {
        var e = Ke()
          , t = {}
          , i = D.autoScale
          , n = 2 * D.padding;
        return t.width = -1 < D.width.toString().indexOf("%") ? parseInt(e[0] * parseFloat(D.width) / 100, 10) : D.width + n,
        t.height = -1 < D.height.toString().indexOf("%") ? parseInt(e[1] * parseFloat(D.height) / 100, 10) : D.height + n,
        i && (t.width > e[0] || t.height > e[1]) && ("image" == A.type || "swf" == A.type ? (i = D.width / D.height,
        t.width > e[0] && (t.width = e[0],
        t.height = parseInt((t.width - n) / i + n, 10)),
        t.height > e[1] && (t.height = e[1],
        t.width = parseInt((t.height - n) * i + n, 10))) : (t.width = Math.min(t.width, e[0]),
        t.height = Math.min(t.height, e[1]))),
        t.top = parseInt(Math.max(e[3] - 20, e[3] + .5 * (e[1] - t.height - 40)), 10),
        t.left = parseInt(Math.max(e[2] - 20, e[2] + .5 * (e[0] - t.width - 40)), 10),
        t
    }
    ,
    Y = function() {
        var e = !!A.orig && h(A.orig)
          , t = {};
        return t = e && e.length ? ((t = e.offset()).top += parseInt(e.css("paddingTop"), 10) || 0,
        t.left += parseInt(e.css("paddingLeft"), 10) || 0,
        t.top += parseInt(e.css("border-top-width"), 10) || 0,
        t.left += parseInt(e.css("border-left-width"), 10) || 0,
        t.width = e.width(),
        t.height = e.height(),
        {
            width: t.width + 2 * D.padding,
            height: t.height + 2 * D.padding,
            top: t.top - D.padding - 20,
            left: t.left - D.padding - 20
        }) : (e = Ke(),
        {
            width: 2 * D.padding,
            height: 2 * D.padding,
            top: parseInt(e[3] + .5 * e[1], 10),
            left: parseInt(e[2] + .5 * e[0], 10)
        })
    }
    ,
    h.fn.fancybox = function(e) {
        return h(this).length && h(this).data("fancybox", h.extend({}, e, h.metadata ? h(this).metadata() : {})).unbind("click.fb").bind("click.fb", function(e) {
            e.preventDefault(),
            H || (H = !0,
            h(this).blur(),
            E = [],
            k = 0,
            (e = h(this).attr("rel") || "") && "" != e && "nofollow" !== e ? (E = h("a[rel=" + e + "], area[rel=" + e + "]"),
            k = E.index(this)) : E.push(this),
            Qe())
        }),
        this
    }
    ,
    h.fancybox = function(e, t) {
        var i;
        if (!H) {
            if (H = !0,
            i = void 0 !== t ? t : {},
            E = [],
            k = parseInt(i.index, 10) || 0,
            h.isArray(e)) {
                for (var n = 0, o = e.length; n < o; n++)
                    "object" == _typeof(e[n]) ? h(e[n]).data("fancybox", h.extend({}, i, e[n])) : e[n] = h({}).data("fancybox", h.extend({
                        content: e[n]
                    }, i));
                E = jQuery.merge(E, e)
            } else
                "object" == _typeof(e) ? h(e).data("fancybox", h.extend({}, i, e)) : e = h({}).data("fancybox", h.extend({
                    content: e
                }, i)),
                E.push(e);
            (k > E.length || k < 0) && (k = 0),
            Qe()
        }
    }
    ,
    h.fancybox.showActivity = function() {
        clearInterval(T),
        g.show(),
        T = setInterval(Ze, 66)
    }
    ,
    h.fancybox.hideActivity = function() {
        g.hide()
    }
    ,
    h.fancybox.next = function() {
        return h.fancybox.pos(z + 1)
    }
    ,
    h.fancybox.prev = function() {
        return h.fancybox.pos(z - 1)
    }
    ,
    h.fancybox.pos = function(e) {
        H || (e = parseInt(e),
        E = O,
        -1 < e && e < O.length ? (k = e,
        Qe()) : D.cyclic && 1 < O.length && (k = e >= O.length ? 0 : O.length - 1,
        Qe()))
    }
    ,
    h.fancybox.cancel = function() {
        H || (H = !0,
        h.event.trigger("fancybox-cancel"),
        Ye(),
        A.onCancel(E, k, A),
        H = !1)
    }
    ,
    h.fancybox.close = function() {
        function e() {
            m.fadeOut("fast"),
            x.empty().hide(),
            v.hide(),
            h.event.trigger("fancybox-cleanup"),
            w.empty(),
            D.onClosed(O, z, D),
            O = A = [],
            z = k = 0,
            D = A = {},
            H = !1
        }
        if (!H && !v.is(":hidden"))
            if (H = !0,
            D && !1 === D.onCleanup(O, z, D))
                H = !1;
            else if (Ye(),
            h(b.add(_).add(C)).hide(),
            h(w.add(m)).unbind(),
            h(window).unbind("resize.fb scroll.fb"),
            h(document).unbind("keydown.fb"),
            w.find("iframe").attr("src", W && /^https/i.test(window.location.href || "") ? "javascript:void(false)" : "about:blank"),
            "inside" !== D.titlePosition && x.empty(),
            v.stop(),
            "elastic" == D.transitionOut) {
                S = Y();
                var t = v.position();
                $ = {
                    top: t.top,
                    left: t.left,
                    width: v.width(),
                    height: v.height()
                },
                D.opacity && ($.opacity = 1),
                x.empty().hide(),
                R.prop = 1,
                h(R).animate({
                    prop: 0
                }, {
                    duration: D.speedOut,
                    easing: D.easingOut,
                    step: X,
                    complete: e
                })
            } else
                v.fadeOut("none" == D.transitionOut ? 0 : D.speedOut, e)
    }
    ,
    h.fancybox.resize = function() {
        m.is(":visible") && m.css("height", h(document).height()),
        h.fancybox.center(!0)
    }
    ,
    h.fancybox.center = function(e) {
        var t, i;
        H || (i = !0 === e ? 1 : 0,
        t = Ke(),
        !i && (v.width() > t[0] || v.height() > t[1]) || v.stop().animate({
            top: parseInt(Math.max(t[3] - 20, t[3] + .5 * (t[1] - w.height() - 40) - D.padding)),
            left: parseInt(Math.max(t[2] - 20, t[2] + .5 * (t[0] - w.width() - 40) - D.padding))
        }, "number" == typeof e ? e : 200))
    }
    ,
    h.fancybox.init = function() {
        h("#fancybox-wrap").length || (h("body").append(f = h('<div id="fancybox-tmp"></div>'), g = h('<div id="fancybox-loading"><div></div></div>'), m = h('<div id="fancybox-overlay"></div>'), v = h('<div id="fancybox-wrap"></div>')),
        (y = h('<div id="fancybox-outer"></div>').append('<div class="fancybox-bg" id="fancybox-bg-n"></div><div class="fancybox-bg" id="fancybox-bg-ne"></div><div class="fancybox-bg" id="fancybox-bg-e"></div><div class="fancybox-bg" id="fancybox-bg-se"></div><div class="fancybox-bg" id="fancybox-bg-s"></div><div class="fancybox-bg" id="fancybox-bg-sw"></div><div class="fancybox-bg" id="fancybox-bg-w"></div><div class="fancybox-bg" id="fancybox-bg-nw"></div>').appendTo(v)).append(w = h('<div id="fancybox-content"></div>'), b = h('<a id="fancybox-close"></a>'), x = h('<div id="fancybox-title"></div>'), _ = h('<a href="javascript:;" id="fancybox-left" aria-label="' + theme.strings.previous + '"><span class="fancy-ico" id="fancybox-left-ico"></span></a>'), C = h('<a href="javascript:;" id="fancybox-right" aria-label="' + theme.strings.next + '"><span class="fancy-ico" id="fancybox-right-ico"></span></a>')),
        b.click(h.fancybox.close),
        g.click(h.fancybox.cancel),
        _.click(function(e) {
            e.preventDefault(),
            h.fancybox.prev()
        }),
        C.click(function(e) {
            e.preventDefault(),
            h.fancybox.next()
        }),
        h.fn.mousewheel && v.bind("mousewheel.fb", function(e, t) {
            H ? e.preventDefault() : 0 != h(e.target).get(0).clientHeight && h(e.target).get(0).scrollHeight !== h(e.target).get(0).clientHeight || (e.preventDefault(),
            h.fancybox[0 < t ? "prev" : "next"]())
        }),
        h.support.opacity || v.addClass("fancybox-ie"),
        W && (g.addClass("fancybox-ie6"),
        v.addClass("fancybox-ie6"),
        h('<iframe id="fancybox-hide-sel-frame" src="' + (/^https/i.test(window.location.href || "") ? "javascript:void(false)" : "about:blank") + '" scrolling="no" border="0" frameborder="0" tabindex="-1"></iframe>').prependTo(y)))
    }
    ,
    h.fn.fancybox.defaults = {
        padding: 10,
        margin: 40,
        opacity: !1,
        modal: !1,
        cyclic: !1,
        scrolling: "auto",
        width: 560,
        height: 340,
        autoScale: !0,
        autoDimensions: !0,
        centerOnScroll: !1,
        ajax: {},
        swf: {
            wmode: "transparent"
        },
        hideOnOverlayClick: !0,
        hideOnContentClick: !1,
        overlayShow: !0,
        overlayOpacity: .7,
        overlayColor: "#777",
        titleShow: !0,
        titlePosition: "float",
        titleFormat: null,
        titleFromAlt: !1,
        transitionIn: "fade",
        transitionOut: "fade",
        speedIn: 300,
        speedOut: 300,
        changeSpeed: 300,
        changeFade: "fast",
        easingIn: "swing",
        easingOut: "swing",
        showCloseButton: !0,
        showNavArrows: !0,
        enableEscapeButton: !0,
        enableKeyboardNav: !0,
        onStart: function() {},
        onCancel: function() {},
        onComplete: function() {},
        onCleanup: function() {},
        onClosed: function() {},
        onError: function() {}
    },
    h(document).ready(function() {
        h.fancybox.init()
    }),
    function(e) {
        "use strict";
        "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
    }(function(c) {
        "use strict";
        var o, r = window.Slick || {};
        o = 0,
        (r = function(e, t) {
            var i, n = this;
            n.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: c(e),
                appendDots: c(e),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + theme.strings.previous + '" tabindex="0" role="button">' + theme.strings.previous + "</button>",
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + theme.strings.next + '" tabindex="0" role="button">' + theme.strings.next + "</button>",
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(e, t) {
                    return c('<button type="button" data-role="none" role="button" tabindex="0" />').text(t + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            },
            n.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            },
            c.extend(n, n.initials),
            n.activeBreakpoint = null,
            n.animType = null,
            n.animProp = null,
            n.breakpoints = [],
            n.breakpointSettings = [],
            n.cssTransitions = !1,
            n.focussed = !1,
            n.interrupted = !1,
            n.hidden = "hidden",
            n.paused = !0,
            n.positionProp = null,
            n.respondTo = null,
            n.rowCount = 1,
            n.shouldClick = !0,
            n.$slider = c(e),
            n.$slidesCache = null,
            n.transformType = null,
            n.transitionType = null,
            n.visibilityChange = "visibilitychange",
            n.windowWidth = 0,
            n.windowTimer = null,
            i = c(e).data("slick") || {},
            n.options = c.extend({}, n.defaults, t, i),
            n.currentSlide = n.options.initialSlide,
            n.originalSettings = n.options,
            void 0 !== document.mozHidden ? (n.hidden = "mozHidden",
            n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden",
            n.visibilityChange = "webkitvisibilitychange"),
            n.autoPlay = c.proxy(n.autoPlay, n),
            n.autoPlayClear = c.proxy(n.autoPlayClear, n),
            n.autoPlayIterator = c.proxy(n.autoPlayIterator, n),
            n.changeSlide = c.proxy(n.changeSlide, n),
            n.clickHandler = c.proxy(n.clickHandler, n),
            n.selectHandler = c.proxy(n.selectHandler, n),
            n.setPosition = c.proxy(n.setPosition, n),
            n.swipeHandler = c.proxy(n.swipeHandler, n),
            n.dragHandler = c.proxy(n.dragHandler, n),
            n.keyHandler = c.proxy(n.keyHandler, n),
            n.instanceUid = o++,
            n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
            n.registerBreakpoints(),
            n.init(!0)
        }
        ).prototype.activateADA = function() {
            this.$slideTrack.find(".slick-active").attr({
                "aria-hidden": "false"
            }).find("a, input, button, select").attr({
                tabindex: "0"
            })
        }
        ,
        r.prototype.addSlide = r.prototype.slickAdd = function(e, t, i) {
            var n = this;
            if ("boolean" == typeof t)
                i = t,
                t = null;
            else if (t < 0 || t >= n.slideCount)
                return !1;
            n.unload(),
            "number" == typeof t ? 0 === t && 0 === n.$slides.length ? c(e).appendTo(n.$slideTrack) : i ? c(e).insertBefore(n.$slides.eq(t)) : c(e).insertAfter(n.$slides.eq(t)) : !0 === i ? c(e).prependTo(n.$slideTrack) : c(e).appendTo(n.$slideTrack),
            n.$slides = n.$slideTrack.children(this.options.slide),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            n.$slides.each(function(e, t) {
                c(t).attr("data-slick-index", e)
            }),
            n.$slidesCache = n.$slides,
            n.reinit()
        }
        ,
        r.prototype.animateHeight = function() {
            var e = this;
            if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                e.$list.animate({
                    height: t
                }, e.options.speed)
            }
        }
        ,
        r.prototype.animateSlide = function(e, t) {
            var i = {}
              , n = this;
            n.animateHeight(),
            !0 === n.options.rtl && !1 === n.options.vertical && (e = -e),
            !1 === n.transformsEnabled ? !1 === n.options.vertical ? n.$slideTrack.animate({
                left: e
            }, n.options.speed, n.options.easing, t) : n.$slideTrack.animate({
                top: e
            }, n.options.speed, n.options.easing, t) : !1 === n.cssTransitions ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
            c({
                animStart: n.currentLeft
            }).animate({
                animStart: e
            }, {
                duration: n.options.speed,
                easing: n.options.easing,
                step: function(e) {
                    e = Math.ceil(e),
                    !1 === n.options.vertical ? i[n.animType] = "translate(" + e + "px, 0px)" : i[n.animType] = "translate(0px," + e + "px)",
                    n.$slideTrack.css(i)
                },
                complete: function() {
                    t && t.call()
                }
            })) : (n.applyTransition(),
            e = Math.ceil(e),
            !1 === n.options.vertical ? i[n.animType] = "translate3d(" + e + "px, 0px, 0px)" : i[n.animType] = "translate3d(0px," + e + "px, 0px)",
            n.$slideTrack.css(i),
            t && setTimeout(function() {
                n.disableTransition(),
                t.call()
            }, n.options.speed))
        }
        ,
        r.prototype.getNavTarget = function() {
            var e = this.options.asNavFor;
            return e && null !== e && (e = c(e).not(this.$slider)),
            e
        }
        ,
        r.prototype.asNavFor = function(t) {
            var e = this.getNavTarget();
            null !== e && "object" == _typeof(e) && e.each(function() {
                var e = c(this).slick("getSlick");
                e.unslicked || e.slideHandler(t, !0)
            })
        }
        ,
        r.prototype.applyTransition = function(e) {
            var t = this
              , i = {};
            !1 === t.options.fade ? i[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : i[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase,
            !1 === t.options.fade ? t.$slideTrack.css(i) : t.$slides.eq(e).css(i)
        }
        ,
        r.prototype.autoPlay = function() {
            var e = this;
            e.autoPlayClear(),
            e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed))
        }
        ,
        r.prototype.autoPlayClear = function() {
            this.autoPlayTimer && clearInterval(this.autoPlayTimer)
        }
        ,
        r.prototype.autoPlayIterator = function() {
            var e = this
              , t = e.currentSlide + e.options.slidesToScroll;
            e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll,
            e.currentSlide - 1 == 0 && (e.direction = 1))),
            e.slideHandler(t))
        }
        ,
        r.prototype.buildArrows = function() {
            var e = this;
            !0 === e.options.arrows && (e.$prevArrow = c(e.options.prevArrow).addClass("slick-arrow"),
            e.$nextArrow = c(e.options.nextArrow).addClass("slick-arrow"),
            e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
            e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
            e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
            e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
            !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
                "aria-disabled": "true",
                tabindex: "-1"
            }))
        }
        ,
        r.prototype.buildDots = function() {
            var e, t, i = this;
            if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
                for (i.$slider.addClass("slick-dotted"),
                t = c("<ul />").addClass(i.options.dotsClass),
                e = 0; e <= i.getDotCount(); e += 1)
                    t.append(c("<li />").append(i.options.customPaging.call(this, i, e)));
                i.$dots = t.appendTo(i.options.appendDots),
                i.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
            }
        }
        ,
        r.prototype.buildOut = function() {
            var e = this;
            e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
            e.slideCount = e.$slides.length,
            e.$slides.each(function(e, t) {
                c(t).attr("data-slick-index", e).data("originalStyling", c(t).attr("style") || "")
            }),
            e.$slider.addClass("slick-slider"),
            e.$slideTrack = 0 === e.slideCount ? c('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider ? theme.strings.imageSlider : "", '"/>')).appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider ? theme.strings.imageSlider : "", '"/>')).parent(),
            e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),
            e.$slideTrack.css("opacity", 0),
            !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1),
            c("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
            e.setupInfinite(),
            e.buildArrows(),
            e.buildDots(),
            e.updateDots(),
            e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
            !0 === e.options.draggable && e.$list.addClass("draggable")
        }
        ,
        r.prototype.buildRows = function() {
            var e, t, i, n, o, s, r, a = this;
            if (n = document.createDocumentFragment(),
            s = a.$slider.children(),
            1 < a.options.rows) {
                for (r = a.options.slidesPerRow * a.options.rows,
                o = Math.ceil(s.length / r),
                e = 0; e < o; e++) {
                    var l = document.createElement("div");
                    for (t = 0; t < a.options.rows; t++) {
                        var c = document.createElement("div");
                        for (i = 0; i < a.options.slidesPerRow; i++) {
                            var d = e * r + (t * a.options.slidesPerRow + i);
                            s.get(d) && c.appendChild(s.get(d))
                        }
                        l.appendChild(c)
                    }
                    n.appendChild(l)
                }
                a.$slider.empty().append(n),
                a.$slider.children().children().children().css({
                    width: 100 / a.options.slidesPerRow + "%",
                    display: "inline-block"
                })
            }
        }
        ,
        r.prototype.checkResponsive = function(e, t) {
            var i, n, o, s = this, r = !1, a = s.$slider.width(), l = window.innerWidth || c(window).width();
            if ("window" === s.respondTo ? o = l : "slider" === s.respondTo ? o = a : "min" === s.respondTo && (o = Math.min(l, a)),
            s.options.responsive && s.options.responsive.length && null !== s.options.responsive) {
                for (i in n = null,
                s.breakpoints)
                    s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? o < s.breakpoints[i] && (n = s.breakpoints[i]) : o > s.breakpoints[i] && (n = s.breakpoints[i]));
                null !== n ? null !== s.activeBreakpoint && n === s.activeBreakpoint && !t || (s.activeBreakpoint = n,
                "unslick" === s.breakpointSettings[n] ? s.unslick(n) : (s.options = c.extend({}, s.originalSettings, s.breakpointSettings[n]),
                !0 === e && (s.currentSlide = s.options.initialSlide),
                s.refresh(e)),
                r = n) : null !== s.activeBreakpoint && (s.activeBreakpoint = null,
                s.options = s.originalSettings,
                !0 === e && (s.currentSlide = s.options.initialSlide),
                s.refresh(e),
                r = n),
                e || !1 === r || s.$slider.trigger("breakpoint", [s, r])
            }
        }
        ,
        r.prototype.changeSlide = function(e, t) {
            var i, n, o = this, s = c(e.currentTarget);
            switch (s.is("a") && e.preventDefault(),
            s.is("li") || (s = s.closest("li")),
            i = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll,
            e.data.message) {
            case "previous":
                n = 0 == i ? o.options.slidesToScroll : o.options.slidesToShow - i,
                o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - n, !1, t);
                break;
            case "next":
                n = 0 == i ? o.options.slidesToScroll : i,
                o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + n, !1, t);
                break;
            case "index":
                var r = 0 === e.data.index ? 0 : e.data.index || s.index() * o.options.slidesToScroll;
                o.slideHandler(o.checkNavigable(r), !1, t),
                s.children().trigger("focus");
                break;
            default:
                return
            }
        }
        ,
        r.prototype.checkNavigable = function(e) {
            var t, i;
            if (i = 0,
            e > (t = this.getNavigableIndexes())[t.length - 1])
                e = t[t.length - 1];
            else
                for (var n in t) {
                    if (e < t[n]) {
                        e = i;
                        break
                    }
                    i = t[n]
                }
            return e
        }
        ,
        r.prototype.cleanUpEvents = function() {
            var e = this;
            e.options.dots && null !== e.$dots && c("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", c.proxy(e.interrupt, e, !0)).off("mouseleave.slick", c.proxy(e.interrupt, e, !1)),
            e.$slider.off("focus.slick blur.slick"),
            !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
            e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
            e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
            e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
            e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
            e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
            e.$list.off("click.slick", e.clickHandler),
            c(document).off(e.visibilityChange, e.visibility),
            e.cleanUpSlideEvents(),
            !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler),
            !0 === e.options.focusOnSelect && c(e.$slideTrack).children().off("click.slick", e.selectHandler),
            c(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
            c(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
            c("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
            c(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
            c(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition)
        }
        ,
        r.prototype.cleanUpSlideEvents = function() {
            var e = this;
            e.$list.off("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
            e.$list.off("mouseleave.slick", c.proxy(e.interrupt, e, !1))
        }
        ,
        r.prototype.cleanUpRows = function() {
            var e;
            1 < this.options.rows && ((e = this.$slides.children().children()).removeAttr("style"),
            this.$slider.empty().append(e))
        }
        ,
        r.prototype.clickHandler = function(e) {
            !1 === this.shouldClick && (e.stopImmediatePropagation(),
            e.stopPropagation(),
            e.preventDefault())
        }
        ,
        r.prototype.destroy = function(e) {
            var t = this;
            t.autoPlayClear(),
            t.touchObject = {},
            t.cleanUpEvents(),
            c(".slick-cloned", t.$slider).detach(),
            t.$dots && t.$dots.remove(),
            t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
            t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
            t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
            t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
            t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
                c(this).attr("style", c(this).data("originalStyling"))
            }),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slideTrack.detach(),
            t.$list.detach(),
            t.$slider.append(t.$slides)),
            t.cleanUpRows(),
            t.$slider.removeClass("slick-slider"),
            t.$slider.removeClass("slick-initialized"),
            t.$slider.removeClass("slick-dotted"),
            t.unslicked = !0,
            e || t.$slider.trigger("destroy", [t])
        }
        ,
        r.prototype.disableTransition = function(e) {
            var t = {};
            t[this.transitionType] = "",
            !1 === this.options.fade ? this.$slideTrack.css(t) : this.$slides.eq(e).css(t)
        }
        ,
        r.prototype.fadeSlide = function(e, t) {
            var i = this;
            !1 === i.cssTransitions ? (i.$slides.eq(e).css({
                zIndex: i.options.zIndex
            }),
            i.$slides.eq(e).animate({
                opacity: 1
            }, i.options.speed, i.options.easing, t)) : (i.applyTransition(e),
            i.$slides.eq(e).css({
                opacity: 1,
                zIndex: i.options.zIndex
            }),
            t && setTimeout(function() {
                i.disableTransition(e),
                t.call()
            }, i.options.speed))
        }
        ,
        r.prototype.fadeSlideOut = function(e) {
            var t = this;
            !1 === t.cssTransitions ? t.$slides.eq(e).animate({
                opacity: 0,
                zIndex: t.options.zIndex - 2
            }, t.options.speed, t.options.easing) : (t.applyTransition(e),
            t.$slides.eq(e).css({
                opacity: 0,
                zIndex: t.options.zIndex - 2
            }))
        }
        ,
        r.prototype.filterSlides = r.prototype.slickFilter = function(e) {
            var t = this;
            null !== e && (t.$slidesCache = t.$slides,
            t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.filter(e).appendTo(t.$slideTrack),
            t.reinit())
        }
        ,
        r.prototype.focusHandler = function() {
            var i = this;
            i.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(e) {
                var t = c(this);
                setTimeout(function() {
                    i.options.pauseOnFocus && (i.focussed = t.is(":focus"),
                    i.autoPlay())
                }, 0)
            })
        }
        ,
        r.prototype.getCurrent = r.prototype.slickCurrentSlide = function() {
            return this.currentSlide
        }
        ,
        r.prototype.getDotCount = function() {
            var e = this
              , t = 0
              , i = 0
              , n = 0;
            if (!0 === e.options.infinite)
                for (; t < e.slideCount; )
                    ++n,
                    t = i + e.options.slidesToScroll,
                    i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
            else if (!0 === e.options.centerMode)
                n = e.slideCount;
            else if (e.options.asNavFor)
                for (; t < e.slideCount; )
                    ++n,
                    t = i + e.options.slidesToScroll,
                    i += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
            else
                n = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
            return n - 1
        }
        ,
        r.prototype.getLeft = function(e) {
            var t, i, n, o = this, s = 0;
            return o.slideOffset = 0,
            i = o.$slides.first().outerHeight(!0),
            !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1,
            s = i * o.options.slidesToShow * -1),
            o.slideCount % o.options.slidesToScroll != 0 && e + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (s = e > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth * -1,
            (o.options.slidesToShow - (e - o.slideCount)) * i * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1,
            o.slideCount % o.options.slidesToScroll * i * -1))) : e + o.options.slidesToShow > o.slideCount && (o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth,
            s = (e + o.options.slidesToShow - o.slideCount) * i),
            o.slideCount <= o.options.slidesToShow && (s = o.slideOffset = 0),
            !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0,
            o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)),
            t = !1 === o.options.vertical ? e * o.slideWidth * -1 + o.slideOffset : e * i * -1 + s,
            !0 === o.options.variableWidth && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow),
            t = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0,
            !0 === o.options.centerMode && (n = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1),
            t = !0 === o.options.rtl ? n[0] ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width()) : 0 : n[0] ? -1 * n[0].offsetLeft : 0,
            t += (o.$list.width() - n.outerWidth()) / 2)),
            t
        }
        ,
        r.prototype.getOption = r.prototype.slickGetOption = function(e) {
            return this.options[e]
        }
        ,
        r.prototype.getNavigableIndexes = function() {
            var e, t = this, i = 0, n = 0, o = [];
            for (e = !1 === t.options.infinite ? t.slideCount : (i = -1 * t.options.slidesToScroll,
            n = -1 * t.options.slidesToScroll,
            2 * t.slideCount); i < e; )
                o.push(i),
                i = n + t.options.slidesToScroll,
                n += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
            return o
        }
        ,
        r.prototype.getSlick = function() {
            return this
        }
        ,
        r.prototype.getSlideCount = function() {
            var i, n, o = this;
            return n = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0,
            !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function(e, t) {
                return t.offsetLeft - n + c(t).outerWidth() / 2 > -1 * o.swipeLeft ? (i = t,
                !1) : void 0
            }),
            Math.abs(c(i).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
        }
        ,
        r.prototype.goTo = r.prototype.slickGoTo = function(e, t) {
            this.changeSlide({
                data: {
                    message: "index",
                    index: parseInt(e)
                }
            }, t)
        }
        ,
        r.prototype.init = function(e) {
            var t = this;
            c(t.$slider).hasClass("slick-initialized") || (c(t.$slider).addClass("slick-initialized"),
            t.buildRows(),
            t.buildOut(),
            t.setProps(),
            t.startLoad(),
            t.loadSlider(),
            t.initializeEvents(),
            t.updateArrows(),
            t.updateDots(),
            t.checkResponsive(!0),
            t.focusHandler()),
            e && t.$slider.trigger("init", [t]),
            !0 === t.options.accessibility && t.initADA(),
            t.options.autoplay && (t.paused = !1,
            t.autoPlay())
        }
        ,
        r.prototype.initADA = function() {
            var t = this;
            t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({
                "aria-hidden": "true",
                tabindex: "-1"
            }).find("a, input, button, select").attr({
                tabindex: "-1"
            }),
            t.$slideTrack.attr("role", "listbox"),
            t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(e) {
                c(this).attr({
                    role: "option"
                })
            }),
            null !== t.$dots && t.$dots.attr("aria-hidden", "true").find("li").each(function(e) {
                c(this).attr({
                    role: "presentation",
                    "aria-selected": "false",
                    "aria-controls": "navigation" + t.instanceUid + e,
                    id: "slick-slide" + t.instanceUid + e
                })
            }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"),
            t.activateADA()
        }
        ,
        r.prototype.initArrowEvents = function() {
            var e = this;
            !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.off("click.slick").on("click.slick", {
                message: "previous"
            }, e.changeSlide),
            e.$nextArrow.off("click.slick").on("click.slick", {
                message: "next"
            }, e.changeSlide))
        }
        ,
        r.prototype.initDotEvents = function() {
            var e = this;
            !0 === e.options.dots && e.slideCount > e.options.slidesToShow && c("li", e.$dots).on("click.slick", {
                message: "index"
            }, e.changeSlide),
            !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && c("li", e.$dots).on("mouseenter.slick", c.proxy(e.interrupt, e, !0)).on("mouseleave.slick", c.proxy(e.interrupt, e, !1))
        }
        ,
        r.prototype.initSlideEvents = function() {
            var e = this;
            e.options.pauseOnHover && (e.$list.on("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
            e.$list.on("mouseleave.slick", c.proxy(e.interrupt, e, !1)))
        }
        ,
        r.prototype.initializeEvents = function() {
            var e = this;
            e.initArrowEvents(),
            e.initDotEvents(),
            e.initSlideEvents(),
            e.$list.on("touchstart.slick mousedown.slick", {
                action: "start"
            }, e.swipeHandler),
            e.$list.on("touchmove.slick mousemove.slick", {
                action: "move"
            }, e.swipeHandler),
            e.$list.on("touchend.slick mouseup.slick", {
                action: "end"
            }, e.swipeHandler),
            e.$list.on("touchcancel.slick mouseleave.slick", {
                action: "end"
            }, e.swipeHandler),
            e.$list.on("click.slick", e.clickHandler),
            c(document).on(e.visibilityChange, c.proxy(e.visibility, e)),
            !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler),
            !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler),
            c(window).on("orientationchange.slick.slick-" + e.instanceUid, c.proxy(e.orientationChange, e)),
            c(window).on("resize.slick.slick-" + e.instanceUid, c.proxy(e.resize, e)),
            c("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
            c(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
            c(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition)
        }
        ,
        r.prototype.initUI = function() {
            var e = this;
            !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(),
            e.$nextArrow.show()),
            !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show()
        }
        ,
        r.prototype.keyHandler = function(e) {
            var t = this;
            e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === t.options.accessibility ? t.changeSlide({
                data: {
                    message: !0 === t.options.rtl ? "next" : "previous"
                }
            }) : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({
                data: {
                    message: !0 === t.options.rtl ? "previous" : "next"
                }
            }))
        }
        ,
        r.prototype.lazyLoad = function() {
            function e(e) {
                c("img[data-lazy]", e).each(function() {
                    var e = c(this)
                      , t = c(this).attr("data-lazy")
                      , i = document.createElement("img");
                    i.onload = function() {
                        e.animate({
                            opacity: 0
                        }, 100, function() {
                            e.attr("src", t).animate({
                                opacity: 1
                            }, 200, function() {
                                e.removeAttr("data-lazy").removeClass("slick-loading")
                            }),
                            n.$slider.trigger("lazyLoaded", [n, e, t])
                        })
                    }
                    ,
                    i.onerror = function() {
                        e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                        n.$slider.trigger("lazyLoadError", [n, e, t])
                    }
                    ,
                    i.src = t
                })
            }
            var t, i, n = this;
            !0 === n.options.centerMode ? i = !0 === n.options.infinite ? (t = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (t = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)),
            n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (t = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide,
            i = Math.ceil(t + n.options.slidesToShow),
            !0 === n.options.fade && (0 < t && t--,
            i <= n.slideCount && i++)),
            e(n.$slider.find(".slick-slide").slice(t, i)),
            n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
        }
        ,
        r.prototype.loadSlider = function() {
            var e = this;
            e.setPosition(),
            e.$slideTrack.css({
                opacity: 1
            }),
            e.$slider.removeClass("slick-loading"),
            e.initUI(),
            "progressive" === e.options.lazyLoad && e.progressiveLazyLoad()
        }
        ,
        r.prototype.next = r.prototype.slickNext = function() {
            this.changeSlide({
                data: {
                    message: "next"
                }
            })
        }
        ,
        r.prototype.orientationChange = function() {
            this.checkResponsive(),
            this.setPosition()
        }
        ,
        r.prototype.pause = r.prototype.slickPause = function() {
            this.autoPlayClear(),
            this.paused = !0
        }
        ,
        r.prototype.play = r.prototype.slickPlay = function() {
            var e = this;
            e.autoPlay(),
            e.options.autoplay = !0,
            e.paused = !1,
            e.focussed = !1,
            e.interrupted = !1
        }
        ,
        r.prototype.postSlide = function(e) {
            var t = this;
            t.unslicked || (t.$slider.trigger("afterChange", [t, e]),
            t.animating = !1,
            t.setPosition(),
            t.swipeLeft = null,
            t.options.autoplay && t.autoPlay(),
            !0 === t.options.accessibility && t.initADA())
        }
        ,
        r.prototype.prev = r.prototype.slickPrev = function() {
            this.changeSlide({
                data: {
                    message: "previous"
                }
            })
        }
        ,
        r.prototype.preventDefault = function(e) {
            e.preventDefault()
        }
        ,
        r.prototype.progressiveLazyLoad = function(e) {
            e = e || 1;
            var t, i, n, o = this, s = c("img[data-lazy]", o.$slider);
            s.length ? (t = s.first(),
            i = t.attr("data-lazy"),
            (n = document.createElement("img")).onload = function() {
                t.attr("src", i).removeAttr("data-lazy").removeClass("slick-loading"),
                !0 === o.options.adaptiveHeight && o.setPosition(),
                o.$slider.trigger("lazyLoaded", [o, t, i]),
                o.progressiveLazyLoad()
            }
            ,
            n.onerror = function() {
                e < 3 ? setTimeout(function() {
                    o.progressiveLazyLoad(e + 1)
                }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                o.$slider.trigger("lazyLoadError", [o, t, i]),
                o.progressiveLazyLoad())
            }
            ,
            n.src = i) : o.$slider.trigger("allImagesLoaded", [o])
        }
        ,
        r.prototype.refresh = function(e) {
            var t, i, n = this;
            i = n.slideCount - n.options.slidesToShow,
            !n.options.infinite && n.currentSlide > i && (n.currentSlide = i),
            n.slideCount <= n.options.slidesToShow && (n.currentSlide = 0),
            t = n.currentSlide,
            n.destroy(!0),
            c.extend(n, n.initials, {
                currentSlide: t
            }),
            n.init(),
            e || n.changeSlide({
                data: {
                    message: "index",
                    index: t
                }
            }, !1)
        }
        ,
        r.prototype.registerBreakpoints = function() {
            var e, t, i, n = this, o = n.options.responsive || null;
            if ("array" === c.type(o) && o.length) {
                for (e in n.respondTo = n.options.respondTo || "window",
                o)
                    if (i = n.breakpoints.length - 1,
                    t = o[e].breakpoint,
                    o.hasOwnProperty(e)) {
                        for (; 0 <= i; )
                            n.breakpoints[i] && n.breakpoints[i] === t && n.breakpoints.splice(i, 1),
                            i--;
                        n.breakpoints.push(t),
                        n.breakpointSettings[t] = o[e].settings
                    }
                n.breakpoints.sort(function(e, t) {
                    return n.options.mobileFirst ? e - t : t - e
                })
            }
        }
        ,
        r.prototype.reinit = function() {
            var e = this;
            e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"),
            e.slideCount = e.$slides.length,
            e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
            e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
            e.registerBreakpoints(),
            e.setProps(),
            e.setupInfinite(),
            e.buildArrows(),
            e.updateArrows(),
            e.initArrowEvents(),
            e.buildDots(),
            e.updateDots(),
            e.initDotEvents(),
            e.cleanUpSlideEvents(),
            e.initSlideEvents(),
            e.checkResponsive(!1, !0),
            !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler),
            e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0),
            e.setPosition(),
            e.focusHandler(),
            e.paused = !e.options.autoplay,
            e.autoPlay(),
            e.$slider.trigger("reInit", [e])
        }
        ,
        r.prototype.resize = function() {
            var e = this;
            c(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay),
            e.windowDelay = window.setTimeout(function() {
                e.windowWidth = c(window).width(),
                e.checkResponsive(),
                e.unslicked || e.setPosition()
            }, 50))
        }
        ,
        r.prototype.removeSlide = r.prototype.slickRemove = function(e, t, i) {
            var n = this;
            return e = "boolean" == typeof e ? !0 === (t = e) ? 0 : n.slideCount - 1 : !0 === t ? --e : e,
            !(n.slideCount < 1 || e < 0 || e > n.slideCount - 1) && (n.unload(),
            !0 === i ? n.$slideTrack.children().remove() : n.$slideTrack.children(this.options.slide).eq(e).remove(),
            n.$slides = n.$slideTrack.children(this.options.slide),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            n.$slidesCache = n.$slides,
            void n.reinit())
        }
        ,
        r.prototype.setCSS = function(e) {
            var t, i, n = this, o = {};
            !0 === n.options.rtl && (e = -e),
            t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px",
            i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px",
            o[n.positionProp] = e,
            !1 === n.transformsEnabled || (!(o = {}) === n.cssTransitions ? o[n.animType] = "translate(" + t + ", " + i + ")" : o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)"),
            n.$slideTrack.css(o)
        }
        ,
        r.prototype.setDimensions = function() {
            var e = this;
            !1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({
                padding: "0px " + e.options.centerPadding
            }) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow),
            !0 === e.options.centerMode && e.$list.css({
                padding: e.options.centerPadding + " 0px"
            })),
            e.listWidth = e.$list.width(),
            e.listHeight = e.$list.height(),
            !1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow),
            e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth),
            e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
            var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
            !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)
        }
        ,
        r.prototype.setFade = function() {
            var i, n = this;
            n.$slides.each(function(e, t) {
                i = n.slideWidth * e * -1,
                !0 === n.options.rtl ? c(t).css({
                    position: "relative",
                    right: i,
                    top: 0,
                    zIndex: n.options.zIndex - 2,
                    opacity: 0
                }) : c(t).css({
                    position: "relative",
                    left: i,
                    top: 0,
                    zIndex: n.options.zIndex - 2,
                    opacity: 0
                })
            }),
            n.$slides.eq(n.currentSlide).css({
                zIndex: n.options.zIndex - 1,
                opacity: 1
            })
        }
        ,
        r.prototype.setHeight = function() {
            var e = this;
            if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
                var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                e.$list.css("height", t)
            }
        }
        ,
        r.prototype.setOption = r.prototype.slickSetOption = function() {
            var e, t, i, n, o, s = this, r = !1;
            if ("object" === c.type(arguments[0]) ? (i = arguments[0],
            r = arguments[1],
            o = "multiple") : "string" === c.type(arguments[0]) && (n = arguments[1],
            r = arguments[2],
            "responsive" === (i = arguments[0]) && "array" === c.type(arguments[1]) ? o = "responsive" : void 0 !== arguments[1] && (o = "single")),
            "single" === o)
                s.options[i] = n;
            else if ("multiple" === o)
                c.each(i, function(e, t) {
                    s.options[e] = t
                });
            else if ("responsive" === o)
                for (t in n)
                    if ("array" !== c.type(s.options.responsive))
                        s.options.responsive = [n[t]];
                    else {
                        for (e = s.options.responsive.length - 1; 0 <= e; )
                            s.options.responsive[e].breakpoint === n[t].breakpoint && s.options.responsive.splice(e, 1),
                            e--;
                        s.options.responsive.push(n[t])
                    }
            r && (s.unload(),
            s.reinit())
        }
        ,
        r.prototype.setPosition = function() {
            var e = this;
            e.setDimensions(),
            e.setHeight(),
            !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(),
            e.$slider.trigger("setPosition", [e])
        }
        ,
        r.prototype.setProps = function() {
            var e = this
              , t = document.body.style;
            e.positionProp = !0 === e.options.vertical ? "top" : "left",
            "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
            void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 !== e.options.useCSS || (e.cssTransitions = !0),
            e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex),
            void 0 !== t.OTransform && (e.animType = "OTransform",
            e.transformType = "-o-transform",
            e.transitionType = "OTransition",
            void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
            void 0 !== t.MozTransform && (e.animType = "MozTransform",
            e.transformType = "-moz-transform",
            e.transitionType = "MozTransition",
            void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
            void 0 !== t.webkitTransform && (e.animType = "webkitTransform",
            e.transformType = "-webkit-transform",
            e.transitionType = "webkitTransition",
            void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
            void 0 !== t.msTransform && (e.animType = "msTransform",
            e.transformType = "-ms-transform",
            e.transitionType = "msTransition",
            void 0 === t.msTransform && (e.animType = !1)),
            void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform",
            e.transformType = "transform",
            e.transitionType = "transition"),
            e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType
        }
        ,
        r.prototype.setSlideClasses = function(e) {
            var t, i, n, o, s = this;
            i = s.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"),
            s.$slides.eq(e).addClass("slick-current"),
            !0 === s.options.centerMode ? (t = Math.floor(s.options.slidesToShow / 2),
            !0 === s.options.infinite && (t <= e && e <= s.slideCount - 1 - t ? s.$slides.slice(e - t, e + t + 1).addClass("slick-active").attr("aria-hidden", "false") : (n = s.options.slidesToShow + e,
            i.slice(n - t + 1, n + t + 2).addClass("slick-active").attr("aria-hidden", "false")),
            0 === e ? i.eq(i.length - 1 - s.options.slidesToShow).addClass("slick-center") : e === s.slideCount - 1 && i.eq(s.options.slidesToShow).addClass("slick-center")),
            s.$slides.eq(e).addClass("slick-center")) : 0 <= e && e <= s.slideCount - s.options.slidesToShow ? s.$slides.slice(e, e + s.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : i.length <= s.options.slidesToShow ? i.addClass("slick-active").attr("aria-hidden", "false") : (o = s.slideCount % s.options.slidesToShow,
            n = !0 === s.options.infinite ? s.options.slidesToShow + e : e,
            s.options.slidesToShow == s.options.slidesToScroll && s.slideCount - e < s.options.slidesToShow ? i.slice(n - (s.options.slidesToShow - o), n + o).addClass("slick-active").attr("aria-hidden", "false") : i.slice(n, n + s.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")),
            "ondemand" === s.options.lazyLoad && s.lazyLoad()
        }
        ,
        r.prototype.setupInfinite = function() {
            var e, t, i, n = this;
            if (!0 === n.options.fade && (n.options.centerMode = !1),
            !0 === n.options.infinite && !1 === n.options.fade && (t = null,
            n.slideCount > n.options.slidesToShow)) {
                for (i = !0 === n.options.centerMode ? n.options.slidesToShow + 1 : n.options.slidesToShow,
                e = n.slideCount; e > n.slideCount - i; --e)
                    t = e - 1,
                    c(n.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - n.slideCount).prependTo(n.$slideTrack).addClass("slick-cloned");
                for (e = 0; e < i; e += 1)
                    t = e,
                    c(n.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + n.slideCount).appendTo(n.$slideTrack).addClass("slick-cloned");
                n.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                    c(this).attr("id", "")
                })
            }
        }
        ,
        r.prototype.interrupt = function(e) {
            e || this.autoPlay(),
            this.interrupted = e
        }
        ,
        r.prototype.selectHandler = function(e) {
            var t = this
              , i = c(e.target).is(".slick-slide") ? c(e.target) : c(e.target).parents(".slick-slide")
              , n = parseInt(i.attr("data-slick-index"));
            return n = n || 0,
            t.slideCount <= t.options.slidesToShow ? (t.setSlideClasses(n),
            void t.asNavFor(n)) : void t.slideHandler(n)
        }
        ,
        r.prototype.slideHandler = function(e, t, i) {
            var n, o, s, r, a, l = null, c = this;
            return t = t || !1,
            !0 === c.animating && !0 === c.options.waitForAnimate || !0 === c.options.fade && c.currentSlide === e || c.slideCount <= c.options.slidesToShow ? void 0 : (!1 === t && c.asNavFor(e),
            n = e,
            l = c.getLeft(n),
            r = c.getLeft(c.currentSlide),
            c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft,
            !1 === c.options.infinite && !1 === c.options.centerMode && (e < 0 || e > c.getDotCount() * c.options.slidesToScroll) || !1 === c.options.infinite && !0 === c.options.centerMode && (e < 0 || e > c.slideCount - c.options.slidesToScroll) ? void (!1 === c.options.fade && (n = c.currentSlide,
            !0 !== i ? c.animateSlide(r, function() {
                c.postSlide(n)
            }) : c.postSlide(n))) : (c.options.autoplay && clearInterval(c.autoPlayTimer),
            o = n < 0 ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + n : n >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : n - c.slideCount : n,
            c.animating = !0,
            c.$slider.trigger("beforeChange", [c, c.currentSlide, o]),
            s = c.currentSlide,
            c.currentSlide = o,
            c.setSlideClasses(c.currentSlide),
            c.options.asNavFor && ((a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide)),
            c.updateDots(),
            c.updateArrows(),
            !0 === c.options.fade ? (!0 !== i ? (c.fadeSlideOut(s),
            c.fadeSlide(o, function() {
                c.postSlide(o)
            })) : c.postSlide(o),
            void c.animateHeight()) : void (!0 !== i ? c.animateSlide(l, function() {
                c.postSlide(o)
            }) : c.postSlide(o))))
        }
        ,
        r.prototype.startLoad = function() {
            var e = this;
            !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(),
            e.$nextArrow.hide()),
            !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
            e.$slider.addClass("slick-loading")
        }
        ,
        r.prototype.swipeDirection = function() {
            var e, t, i, n, o = this;
            return e = o.touchObject.startX - o.touchObject.curX,
            t = o.touchObject.startY - o.touchObject.curY,
            i = Math.atan2(t, e),
            (n = Math.round(180 * i / Math.PI)) < 0 && (n = 360 - Math.abs(n)),
            n <= 45 && 0 <= n || n <= 360 && 315 <= n ? !1 === o.options.rtl ? "left" : "right" : 135 <= n && n <= 225 ? !1 === o.options.rtl ? "right" : "left" : !0 === o.options.verticalSwiping ? 35 <= n && n <= 135 ? "down" : "up" : "vertical"
        }
        ,
        r.prototype.swipeEnd = function(e) {
            var t, i, n = this;
            if (n.dragging = !1,
            n.interrupted = !1,
            n.shouldClick = !(10 < n.touchObject.swipeLength),
            void 0 === n.touchObject.curX)
                return !1;
            if (!0 === n.touchObject.edgeHit && n.$slider.trigger("edge", [n, n.swipeDirection()]),
            n.touchObject.swipeLength >= n.touchObject.minSwipe) {
                switch (i = n.swipeDirection()) {
                case "left":
                case "down":
                    t = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide + n.getSlideCount()) : n.currentSlide + n.getSlideCount(),
                    n.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    t = n.options.swipeToSlide ? n.checkNavigable(n.currentSlide - n.getSlideCount()) : n.currentSlide - n.getSlideCount(),
                    n.currentDirection = 1
                }
                "vertical" != i && (n.slideHandler(t),
                n.touchObject = {},
                n.$slider.trigger("swipe", [n, i]))
            } else
                n.touchObject.startX !== n.touchObject.curX && (n.slideHandler(n.currentSlide),
                n.touchObject = {})
        }
        ,
        r.prototype.swipeHandler = function(e) {
            var t = this;
            if (!(!1 === t.options.swipe || "ontouchend"in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse")))
                switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1,
                t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold,
                !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold),
                e.data.action) {
                case "start":
                    t.swipeStart(e);
                    break;
                case "move":
                    t.swipeMove(e);
                    break;
                case "end":
                    t.swipeEnd(e)
                }
        }
        ,
        r.prototype.swipeMove = function(e) {
            var t, i, n, o, s, r = this;
            return s = void 0 !== e.originalEvent ? e.originalEvent.touches : null,
            !(!r.dragging || s && 1 !== s.length) && (t = r.getLeft(r.currentSlide),
            r.touchObject.curX = void 0 !== s ? s[0].pageX : e.clientX,
            r.touchObject.curY = void 0 !== s ? s[0].pageY : e.clientY,
            r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))),
            !0 === r.options.verticalSwiping && (r.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2)))),
            "vertical" !== (i = r.swipeDirection()) ? (void 0 !== e.originalEvent && 4 < r.touchObject.swipeLength && e.preventDefault(),
            o = (!1 === r.options.rtl ? 1 : -1) * (r.touchObject.curX > r.touchObject.startX ? 1 : -1),
            !0 === r.options.verticalSwiping && (o = r.touchObject.curY > r.touchObject.startY ? 1 : -1),
            n = r.touchObject.swipeLength,
            (r.touchObject.edgeHit = !1) === r.options.infinite && (0 === r.currentSlide && "right" === i || r.currentSlide >= r.getDotCount() && "left" === i) && (n = r.touchObject.swipeLength * r.options.edgeFriction,
            r.touchObject.edgeHit = !0),
            !1 === r.options.vertical ? r.swipeLeft = t + n * o : r.swipeLeft = t + n * (r.$list.height() / r.listWidth) * o,
            !0 === r.options.verticalSwiping && (r.swipeLeft = t + n * o),
            !0 !== r.options.fade && !1 !== r.options.touchMove && (!0 === r.animating ? (r.swipeLeft = null,
            !1) : void r.setCSS(r.swipeLeft))) : void 0)
        }
        ,
        r.prototype.swipeStart = function(e) {
            var t, i = this;
            return i.interrupted = !0,
            1 !== i.touchObject.fingerCount || i.slideCount <= i.options.slidesToShow ? !(i.touchObject = {}) : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
            i.touchObject.startX = i.touchObject.curX = void 0 !== t ? t.pageX : e.clientX,
            i.touchObject.startY = i.touchObject.curY = void 0 !== t ? t.pageY : e.clientY,
            void (i.dragging = !0))
        }
        ,
        r.prototype.unfilterSlides = r.prototype.slickUnfilter = function() {
            var e = this;
            null !== e.$slidesCache && (e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.appendTo(e.$slideTrack),
            e.reinit())
        }
        ,
        r.prototype.unload = function() {
            var e = this;
            c(".slick-cloned", e.$slider).remove(),
            e.$dots && e.$dots.remove(),
            e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
            e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
            e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
        }
        ,
        r.prototype.unslick = function(e) {
            this.$slider.trigger("unslick", [this, e]),
            this.destroy()
        }
        ,
        r.prototype.updateArrows = function() {
            var e = this;
            Math.floor(e.options.slidesToShow / 2),
            !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
            e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
            0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
            e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : (e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode || e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode) && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
            e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
        }
        ,
        r.prototype.updateDots = function() {
            var e = this;
            null !== e.$dots && (e.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
            e.$dots.find("li").eq(Math.floor(e.currentSlide / e.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
        }
        ,
        r.prototype.visibility = function() {
            this.options.autoplay && (document[this.hidden] ? this.interrupted = !0 : this.interrupted = !1)
        }
        ,
        c.fn.slick = function() {
            var e, t, i = this, n = arguments[0], o = Array.prototype.slice.call(arguments, 1), s = i.length;
            for (e = 0; e < s; e++)
                if ("object" == _typeof(n) || void 0 === n ? i[e].slick = new r(i[e],n) : t = i[e].slick[n].apply(i[e].slick, o),
                void 0 !== t)
                    return t;
            return i
        }
    }),
    jQuery.cookie = function(e, t, i) {
        if (void 0 === t) {
            var n = null;
            if (document.cookie && "" != document.cookie)
                for (var o = document.cookie.split(";"), s = 0; s < o.length; s++) {
                    var r = jQuery.trim(o[s]);
                    if (r.substring(0, e.length + 1) == e + "=") {
                        n = decodeURIComponent(r.substring(e.length + 1));
                        break
                    }
                }
            return n
        }
        i = i || {},
        null === t && (t = "",
        i.expires = -1);
        var a, l = "";
        i.expires && ("number" == typeof i.expires || i.expires.toUTCString) && ("number" == typeof i.expires ? (a = new Date).setTime(a.getTime() + 24 * i.expires * 60 * 60 * 1e3) : a = i.expires,
        l = "; expires=" + a.toUTCString());
        var c = i.path ? "; path=" + i.path : ""
          , d = i.domain ? "; domain=" + i.domain : ""
          , u = i.secure ? "; secure" : "";
        document.cookie = [e, "=", encodeURIComponent(t), l, c, d, u].join("")
    }
    ,
    window.Modernizr = function(n, o, s) {
        function e(e) {
            p.cssText = e
        }
        function r(e, t) {
            return _typeof(e) === t
        }
        function a(e, t) {
            for (var i in e) {
                var n = e[i];
                if (!~("" + n).indexOf("-") && p[n] !== s)
                    return "pfx" != t || n
            }
            return !1
        }
        function t(e, t, i) {
            var n = e.charAt(0).toUpperCase() + e.slice(1)
              , o = (e + " " + g.join(n + " ") + n).split(" ");
            return r(t, "string") || r(t, "undefined") ? a(o, t) : function(e, t, i) {
                for (var n in e) {
                    var o = t[e[n]];
                    if (o !== s)
                        return !1 === i ? e[n] : r(o, "function") ? o.bind(i || t) : o
                }
                return !1
            }(o = (e + " " + m.join(n + " ") + n).split(" "), t, i)
        }
        var i, l, c = {}, d = o.documentElement, u = o.createElement("modernizr"), p = u.style, h = o.createElement("input"), f = "Webkit Moz O ms", g = f.split(" "), m = f.toLowerCase().split(" "), v = {}, y = {}, w = [], b = w.slice, x = {}.hasOwnProperty;
        for (var _ in l = r(x, "undefined") || r(x.call, "undefined") ? function(e, t) {
            return t in e && r(e.constructor.prototype[t], "undefined")
        }
        : function(e, t) {
            return x.call(e, t)
        }
        ,
        Function.prototype.bind || (Function.prototype.bind = function(o) {
            var s = this;
            if ("function" != typeof s)
                throw new TypeError;
            var r = b.call(arguments, 1);
            return function e() {
                if (this instanceof e) {
                    function t() {}
                    t.prototype = s.prototype;
                    var i = new t
                      , n = s.apply(i, r.concat(b.call(arguments)));
                    return Object(n) === n ? n : i
                }
                return s.apply(o, r.concat(b.call(arguments)))
            }
        }
        ),
        v.csstransitions = function() {
            return t("transition")
        }
        ,
        v)
            l(v, _) && (i = _.toLowerCase(),
            c[i] = v[_](),
            w.push((c[i] ? "" : "no-") + i));
        return c.input || (c.input = function(e) {
            for (var t = 0, i = e.length; t < i; t++)
                y[e[t]] = e[t]in h;
            return y.list && (y.list = !!o.createElement("datalist") && !!n.HTMLDataListElement),
            y
        }("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "))),
        c.addTest = function(e, t) {
            if ("object" == _typeof(e))
                for (var i in e)
                    l(e, i) && c.addTest(i, e[i]);
            else {
                if (e = e.toLowerCase(),
                c[e] !== s)
                    return c;
                t = "function" == typeof t ? t() : t,
                "undefined" != typeof enableClasses && enableClasses && (d.className += " " + (t ? "" : "no-") + e),
                c[e] = t
            }
            return c
        }
        ,
        e(""),
        u = h = null,
        c._version = "2.6.2",
        c._domPrefixes = m,
        c._cssomPrefixes = g,
        c.testProp = function(e) {
            return a([e])
        }
        ,
        c.testAllProps = t,
        c
    }(this, this.document),
    V = this,
    Q = document,
    J = Q.documentElement,
    ee = V.setTimeout,
    te = Q.getElementsByTagName("script")[0],
    ie = {}.toString,
    ne = [],
    oe = 0,
    se = "MozAppearance"in J.style,
    re = se && !!Q.createRange().compareNode,
    ae = re ? J : te.parentNode,
    J = V.opera && "[object Opera]" == ie.call(V.opera),
    J = !!Q.attachEvent && !J,
    le = se ? "object" : J ? "script" : "img",
    ce = J ? "script" : le,
    de = Array.isArray || function(e) {
        return "[object Array]" == ie.call(e)
    }
    ,
    ue = [],
    pe = {},
    he = {
        timeout: function(e, t) {
            return t.length && (e.timeout = t[0]),
            e
        }
    },
    (Z = function(e) {
        function d(e, t, i, n, o) {
            var s = function(e) {
                e = e.split("!");
                var t, i, n, o = ue.length, s = e.pop(), r = e.length;
                for (s = {
                    url: s,
                    origUrl: s,
                    prefixes: e
                },
                i = 0; i < r; i++)
                    n = e[i].split("="),
                    (t = he[n.shift()]) && (s = t(s, n));
                for (i = 0; i < o; i++)
                    s = ue[i](s);
                return s
            }(e)
              , r = s.autoCallback;
            s.url.split(".").pop().split("?").shift(),
            s.bypass || (t = t && (Je(t) ? t : t[e] || t[n] || t[e.split("/").pop().split("?")[0]]),
            s.instead ? s.instead(e, t, i, n, o) : (pe[s.url] ? s.noexec = !0 : pe[s.url] = 1,
            i.load(s.url, s.forceCSS || !s.forceJS && "css" == s.url.split(".").pop().split("?").shift() ? "c" : void 0, s.noexec, s.attrs, s.timeout),
            (Je(t) || Je(r)) && i.load(function() {
                st(),
                t && t(s.origUrl, o, n),
                r && r(s.origUrl, o, n),
                pe[s.url] = 2
            })))
        }
        function t(e, t) {
            function i(i, e) {
                if (i) {
                    if (et(i))
                        e || (a = function() {
                            var e = [].slice.call(arguments);
                            l.apply(this, e),
                            c()
                        }
                        ),
                        d(i, a, t, 0, s);
                    else if (Object(i) === i)
                        for (o in n = function() {
                            var e, t = 0;
                            for (e in i)
                                i.hasOwnProperty(e) && t++;
                            return t
                        }(),
                        i)
                            i.hasOwnProperty(o) && (e || --n || (Je(a) ? a = function() {
                                var e = [].slice.call(arguments);
                                l.apply(this, e),
                                c()
                            }
                            : a[o] = function(t) {
                                return function() {
                                    var e = [].slice.call(arguments);
                                    t && t.apply(this, e),
                                    c()
                                }
                            }(l[o])),
                            d(i[o], a, t, o, s))
                } else
                    e || c()
            }
            var n, o, s = !!e.test, r = e.load || e.both, a = e.callback || tt, l = a, c = e.complete || tt;
            i(s ? e.yep : e.nope, !!r),
            r && i(r)
        }
        var i, n, o = this.yepnope.loader;
        if (et(e))
            d(e, 0, o, 0);
        else if (de(e))
            for (i = 0; i < e.length; i++)
                et(n = e[i]) ? d(n, 0, o, 0) : de(n) ? Z(n) : Object(n) === n && t(n, o);
        else
            Object(e) === e && t(e, o)
    }
    ).addPrefix = function(e, t) {
        he[e] = t
    }
    ,
    Z.addFilter = function(e) {
        ue.push(e)
    }
    ,
    Z.errorTimeout = 1e4,
    null == Q.readyState && Q.addEventListener && (Q.readyState = "loading",
    Q.addEventListener("DOMContentLoaded", K = function() {
        Q.removeEventListener("DOMContentLoaded", K, 0),
        Q.readyState = "complete"
    }
    , 0)),
    V.yepnope = st(),
    V.yepnope.executeStack = nt,
    V.yepnope.injectJs = function(e, t, i, n, o, s) {
        var r, a, l = Q.createElement("script");
        n = n || Z.errorTimeout;
        for (a in l.src = e,
        i)
            l.setAttribute(a, i[a]);
        t = s ? nt : t || tt,
        l.onreadystatechange = l.onload = function() {
            !r && it(l.readyState) && (r = 1,
            t(),
            l.onload = l.onreadystatechange = null)
        }
        ,
        ee(function() {
            r || t(r = 1)
        }, n),
        o ? l.onload() : te.parentNode.insertBefore(l, te)
    }
    ,
    V.yepnope.injectCss = function(e, t, i, n, o, s) {
        var r;
        n = Q.createElement("link"),
        t = s ? nt : t || tt;
        for (r in n.href = e,
        n.rel = "stylesheet",
        n.type = "text/css",
        i)
            n.setAttribute(r, i[r]);
        o || (te.parentNode.insertBefore(n, te),
        ee(t, 0))
    }
    ,
    Modernizr.load = function() {
        yepnope.apply(window, [].slice.call(arguments, 0))
    }
    ,
    me = p.event,
    ve = window.innerWidth,
    fe = me.special.debouncedresize = {
        setup: function() {
            p(this).on("resize", fe.handler)
        },
        teardown: function() {
            p(this).off("resize", fe.handler)
        },
        handler: function(e, t) {
            function i() {
                e.type = "debouncedresize",
                me.dispatch.apply(n, o),
                ve !== window.innerWidth && (e.type = "debouncedresizewidth",
                me.dispatch.apply(n, o),
                ve = window.innerWidth)
            }
            var n = this
              , o = arguments;
            ge && clearTimeout(ge),
            t ? i() : ge = setTimeout(i, fe.threshold)
        },
        threshold: 150
    },
    function() {
        for (var e = [{
            base: "A",
            letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
        }, {
            base: "AA",
            letters: "Ꜳ"
        }, {
            base: "AE",
            letters: "ÆǼǢ"
        }, {
            base: "AO",
            letters: "Ꜵ"
        }, {
            base: "AU",
            letters: "Ꜷ"
        }, {
            base: "AV",
            letters: "ꜸꜺ"
        }, {
            base: "AY",
            letters: "Ꜽ"
        }, {
            base: "B",
            letters: "BⒷＢḂḄḆɃƂƁ"
        }, {
            base: "C",
            letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
        }, {
            base: "D",
            letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹÐ"
        }, {
            base: "DZ",
            letters: "ǱǄ"
        }, {
            base: "Dz",
            letters: "ǲǅ"
        }, {
            base: "E",
            letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
        }, {
            base: "F",
            letters: "FⒻＦḞƑꝻ"
        }, {
            base: "G",
            letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
        }, {
            base: "H",
            letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
        }, {
            base: "I",
            letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
        }, {
            base: "J",
            letters: "JⒿＪĴɈ"
        }, {
            base: "K",
            letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
        }, {
            base: "L",
            letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
        }, {
            base: "LJ",
            letters: "Ǉ"
        }, {
            base: "Lj",
            letters: "ǈ"
        }, {
            base: "M",
            letters: "MⓂＭḾṀṂⱮƜ"
        }, {
            base: "N",
            letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
        }, {
            base: "NJ",
            letters: "Ǌ"
        }, {
            base: "Nj",
            letters: "ǋ"
        }, {
            base: "O",
            letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
        }, {
            base: "OI",
            letters: "Ƣ"
        }, {
            base: "OO",
            letters: "Ꝏ"
        }, {
            base: "OU",
            letters: "Ȣ"
        }, {
            base: "OE",
            letters: "Œ"
        }, {
            base: "oe",
            letters: "œ"
        }, {
            base: "P",
            letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
        }, {
            base: "Q",
            letters: "QⓆＱꝖꝘɊ"
        }, {
            base: "R",
            letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
        }, {
            base: "S",
            letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
        }, {
            base: "T",
            letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
        }, {
            base: "TZ",
            letters: "Ꜩ"
        }, {
            base: "U",
            letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
        }, {
            base: "V",
            letters: "VⓋＶṼṾƲꝞɅ"
        }, {
            base: "VY",
            letters: "Ꝡ"
        }, {
            base: "W",
            letters: "WⓌＷẀẂŴẆẄẈⱲ"
        }, {
            base: "X",
            letters: "XⓍＸẊẌ"
        }, {
            base: "Y",
            letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
        }, {
            base: "Z",
            letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
        }, {
            base: "a",
            letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
        }, {
            base: "aa",
            letters: "ꜳ"
        }, {
            base: "ae",
            letters: "æǽǣ"
        }, {
            base: "ao",
            letters: "ꜵ"
        }, {
            base: "au",
            letters: "ꜷ"
        }, {
            base: "av",
            letters: "ꜹꜻ"
        }, {
            base: "ay",
            letters: "ꜽ"
        }, {
            base: "b",
            letters: "bⓑｂḃḅḇƀƃɓ"
        }, {
            base: "c",
            letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
        }, {
            base: "d",
            letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
        }, {
            base: "dz",
            letters: "ǳǆ"
        }, {
            base: "e",
            letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
        }, {
            base: "f",
            letters: "fⓕｆḟƒꝼ"
        }, {
            base: "g",
            letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
        }, {
            base: "h",
            letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
        }, {
            base: "hv",
            letters: "ƕ"
        }, {
            base: "i",
            letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
        }, {
            base: "j",
            letters: "jⓙｊĵǰɉ"
        }, {
            base: "k",
            letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
        }, {
            base: "l",
            letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
        }, {
            base: "lj",
            letters: "ǉ"
        }, {
            base: "m",
            letters: "mⓜｍḿṁṃɱɯ"
        }, {
            base: "n",
            letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
        }, {
            base: "nj",
            letters: "ǌ"
        }, {
            base: "o",
            letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
        }, {
            base: "oi",
            letters: "ƣ"
        }, {
            base: "ou",
            letters: "ȣ"
        }, {
            base: "oo",
            letters: "ꝏ"
        }, {
            base: "p",
            letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
        }, {
            base: "q",
            letters: "qⓠｑɋꝗꝙ"
        }, {
            base: "r",
            letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
        }, {
            base: "s",
            letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
        }, {
            base: "t",
            letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
        }, {
            base: "tz",
            letters: "ꜩ"
        }, {
            base: "u",
            letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
        }, {
            base: "v",
            letters: "vⓥｖṽṿʋꝟʌ"
        }, {
            base: "vy",
            letters: "ꝡ"
        }, {
            base: "w",
            letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
        }, {
            base: "x",
            letters: "xⓧｘẋẍ"
        }, {
            base: "y",
            letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
        }, {
            base: "z",
            letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
        }], t = {}, i = 0; i < e.length; i++)
            for (var n = e[i].letters, o = 0; o < n.length; o++)
                t[n[o]] = e[i].base;
        window.removeDiacritics = function(e) {
            return "string" != typeof e ? (console.warn("Invalid parameter passed to window.removeDiacritics (".concat(_typeof(e), ")"), e),
            e) : e.replace(/[^\u0000-\u007E]/g, function(e) {
                return t[e] || e
            })
        }
    }(),
    ye = function(u) {
        var e = function() {
            if (u && u.fn && u.fn.select2 && u.fn.select2.amd)
                var e = u.fn.select2.amd;
            var t, i, n, h, s, r, f, g, m, v, y, w, o, a, b, l;
            function x(e, t) {
                return o.call(e, t)
            }
            function c(e, t) {
                var i, n, o, s, r, a, l, c, d, u, p, h = t && t.split("/"), f = y.map, g = f && f["*"] || {};
                if (e) {
                    for (r = (e = e.split("/")).length - 1,
                    y.nodeIdCompat && b.test(e[r]) && (e[r] = e[r].replace(b, "")),
                    "." === e[0].charAt(0) && h && (e = h.slice(0, h.length - 1).concat(e)),
                    d = 0; d < e.length; d++)
                        if ("." === (p = e[d]))
                            e.splice(d, 1),
                            --d;
                        else if (".." === p) {
                            if (0 === d || 1 === d && ".." === e[2] || ".." === e[d - 1])
                                continue;
                            0 < d && (e.splice(d - 1, 2),
                            d -= 2)
                        }
                    e = e.join("/")
                }
                if ((h || g) && f) {
                    for (d = (i = e.split("/")).length; 0 < d; --d) {
                        if (n = i.slice(0, d).join("/"),
                        h)
                            for (u = h.length; 0 < u; --u)
                                if (o = (o = f[h.slice(0, u).join("/")]) && o[n]) {
                                    s = o,
                                    a = d;
                                    break
                                }
                        if (s)
                            break;
                        !l && g && g[n] && (l = g[n],
                        c = d)
                    }
                    !s && l && (s = l,
                    a = c),
                    s && (i.splice(0, a, s),
                    e = i.join("/"))
                }
                return e
            }
            function _(t, i) {
                return function() {
                    var e = a.call(arguments, 0);
                    return "string" != typeof e[0] && 1 === e.length && e.push(null),
                    r.apply(h, e.concat([t, i]))
                }
            }
            function C(t) {
                return function(e) {
                    m[t] = e
                }
            }
            function T(e) {
                if (x(v, e)) {
                    var t = v[e];
                    delete v[e],
                    w[e] = !0,
                    s.apply(h, t)
                }
                if (!x(m, e) && !x(w, e))
                    throw new Error("No " + e);
                return m[e]
            }
            function d(e) {
                var t, i = e ? e.indexOf("!") : -1;
                return -1 < i && (t = e.substring(0, i),
                e = e.substring(i + 1, e.length)),
                [t, e]
            }
            function S(e) {
                return e ? d(e) : []
            }
            return e && e.requirejs || (e ? i = e : e = {},
            m = {},
            v = {},
            y = {},
            w = {},
            o = Object.prototype.hasOwnProperty,
            a = [].slice,
            b = /\.js$/,
            f = function(e, t) {
                var i, n, o = d(e), s = o[0], r = t[1];
                return e = o[1],
                s && (i = T(s = c(s, r))),
                s ? e = i && i.normalize ? i.normalize(e, (n = r,
                function(e) {
                    return c(e, n)
                }
                )) : c(e, r) : (s = (o = d(e = c(e, r)))[0],
                e = o[1],
                s && (i = T(s))),
                {
                    f: s ? s + "!" + e : e,
                    n: e,
                    pr: s,
                    p: i
                }
            }
            ,
            g = {
                require: function(e) {
                    return _(e)
                },
                exports: function(e) {
                    var t = m[e];
                    return void 0 !== t ? t : m[e] = {}
                },
                module: function(e) {
                    return {
                        id: e,
                        uri: "",
                        exports: m[e],
                        config: (t = e,
                        function() {
                            return y && y.config && y.config[t] || {}
                        }
                        )
                    };
                    var t
                }
            },
            s = function(e, t, i, n) {
                var o, s, r, a, l, c, d, u = [], p = _typeof(i);
                if (c = S(n = n || e),
                "undefined" == p || "function" == p) {
                    for (t = !t.length && i.length ? ["require", "exports", "module"] : t,
                    l = 0; l < t.length; l += 1)
                        if ("require" === (s = (a = f(t[l], c)).f))
                            u[l] = g.require(e);
                        else if ("exports" === s)
                            u[l] = g.exports(e),
                            d = !0;
                        else if ("module" === s)
                            o = u[l] = g.module(e);
                        else if (x(m, s) || x(v, s) || x(w, s))
                            u[l] = T(s);
                        else {
                            if (!a.p)
                                throw new Error(e + " missing " + s);
                            a.p.load(a.n, _(n, !0), C(s), {}),
                            u[l] = m[s]
                        }
                    r = i ? i.apply(m[e], u) : void 0,
                    e && (o && o.exports !== h && o.exports !== m[e] ? m[e] = o.exports : r === h && d || (m[e] = r))
                } else
                    e && (m[e] = i)
            }
            ,
            t = i = r = function(e, t, i, n, o) {
                if ("string" == typeof e)
                    return g[e] ? g[e](t) : T(f(e, S(t)).f);
                if (!e.splice) {
                    if ((y = e).deps && r(y.deps, y.callback),
                    !t)
                        return;
                    t.splice ? (e = t,
                    t = i,
                    i = null) : e = h
                }
                return t = t || function() {}
                ,
                "function" == typeof i && (i = n,
                n = o),
                n ? s(h, e, t, i) : setTimeout(function() {
                    s(h, e, t, i)
                }, 4),
                r
            }
            ,
            r.config = function(e) {
                return r(e)
            }
            ,
            t._defined = m,
            (n = function(e, t, i) {
                if ("string" != typeof e)
                    throw new Error("See almond README: incorrect module build, no module name");
                t.splice || (i = t,
                t = []),
                x(m, e) || x(v, e) || (v[e] = [e, t, i])
            }
            ).amd = {
                jQuery: !0
            },
            e.requirejs = t,
            e.require = i,
            e.define = n),
            e.define("almond", function() {}),
            e.define("jquery", [], function() {
                var e = u || p;
                return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."),
                e
            }),
            e.define("select2/utils", ["jquery"], function(s) {
                var o = {};
                function d(e) {
                    var t = e.prototype
                      , i = [];
                    for (var n in t)
                        "function" == typeof t[n] && "constructor" !== n && i.push(n);
                    return i
                }
                function e() {
                    this.listeners = {}
                }
                o.Extend = function(e, t) {
                    var i = {}.hasOwnProperty;
                    function n() {
                        this.constructor = e
                    }
                    for (var o in t)
                        i.call(t, o) && (e[o] = t[o]);
                    return n.prototype = t.prototype,
                    e.prototype = new n,
                    e.__super__ = t.prototype,
                    e
                }
                ,
                o.Decorate = function(n, o) {
                    var e = d(o)
                      , t = d(n);
                    function s() {
                        var e = Array.prototype.unshift
                          , t = o.prototype.constructor.length
                          , i = n.prototype.constructor;
                        0 < t && (e.call(arguments, n.prototype.constructor),
                        i = o.prototype.constructor),
                        i.apply(this, arguments)
                    }
                    o.displayName = n.displayName,
                    s.prototype = new function() {
                        this.constructor = s
                    }
                    ;
                    for (var i = 0; i < t.length; i++) {
                        var r = t[i];
                        s.prototype[r] = n.prototype[r]
                    }
                    function a(e) {
                        var t = function() {};
                        e in s.prototype && (t = s.prototype[e]);
                        var i = o.prototype[e];
                        return function() {
                            return Array.prototype.unshift.call(arguments, t),
                            i.apply(this, arguments)
                        }
                    }
                    for (var l = 0; l < e.length; l++) {
                        var c = e[l];
                        s.prototype[c] = a(c)
                    }
                    return s
                }
                ,
                e.prototype.on = function(e, t) {
                    this.listeners = this.listeners || {},
                    e in this.listeners ? this.listeners[e].push(t) : this.listeners[e] = [t]
                }
                ,
                e.prototype.trigger = function(e) {
                    var t = Array.prototype.slice
                      , i = t.call(arguments, 1);
                    this.listeners = this.listeners || {},
                    null == i && (i = []),
                    0 === i.length && i.push({}),
                    (i[0]._type = e)in this.listeners && this.invoke(this.listeners[e], t.call(arguments, 1)),
                    "*"in this.listeners && this.invoke(this.listeners["*"], arguments)
                }
                ,
                e.prototype.invoke = function(e, t) {
                    for (var i = 0, n = e.length; i < n; i++)
                        e[i].apply(this, t)
                }
                ,
                o.Observable = e,
                o.generateChars = function(e) {
                    for (var t = "", i = 0; i < e; i++)
                        t += Math.floor(36 * Math.random()).toString(36);
                    return t
                }
                ,
                o.bind = function(e, t) {
                    return function() {
                        e.apply(t, arguments)
                    }
                }
                ,
                o._convertData = function(e) {
                    for (var t in e) {
                        var i = t.split("-")
                          , n = e;
                        if (1 !== i.length) {
                            for (var o = 0; o < i.length; o++) {
                                var s = i[o];
                                (s = s.substring(0, 1).toLowerCase() + s.substring(1))in n || (n[s] = {}),
                                o == i.length - 1 && (n[s] = e[t]),
                                n = n[s]
                            }
                            delete e[t]
                        }
                    }
                    return e
                }
                ,
                o.hasScroll = function(e, t) {
                    var i = s(t)
                      , n = t.style.overflowX
                      , o = t.style.overflowY;
                    return (n !== o || "hidden" !== o && "visible" !== o) && ("scroll" === n || "scroll" === o || i.innerHeight() < t.scrollHeight || i.innerWidth() < t.scrollWidth)
                }
                ,
                o.escapeMarkup = function(e) {
                    var t = {
                        "\\": "&#92;",
                        "&": "&amp;",
                        "<": "&lt;",
                        ">": "&gt;",
                        '"': "&quot;",
                        "'": "&#39;",
                        "/": "&#47;"
                    };
                    return "string" != typeof e ? e : String(e).replace(/[&<>"'\/\\]/g, function(e) {
                        return t[e]
                    })
                }
                ,
                o.appendMany = function(e, t) {
                    if ("1.7" === s.fn.jquery.substr(0, 3)) {
                        var i = s();
                        s.map(t, function(e) {
                            i = i.add(e)
                        }),
                        t = i
                    }
                    e.append(t)
                }
                ,
                o.__cache = {};
                var i = 0;
                return o.GetUniqueElementId = function(e) {
                    var t = e.getAttribute("data-select2-id");
                    return null == t && (e.id ? (t = e.id,
                    e.setAttribute("data-select2-id", t)) : (e.setAttribute("data-select2-id", ++i),
                    t = i.toString())),
                    t
                }
                ,
                o.StoreData = function(e, t, i) {
                    var n = o.GetUniqueElementId(e);
                    o.__cache[n] || (o.__cache[n] = {}),
                    o.__cache[n][t] = i
                }
                ,
                o.GetData = function(e, t) {
                    var i = o.GetUniqueElementId(e);
                    return t ? o.__cache[i] && null != o.__cache[i][t] ? o.__cache[i][t] : s(e).data(t) : o.__cache[i]
                }
                ,
                o.RemoveData = function(e) {
                    var t = o.GetUniqueElementId(e);
                    null != o.__cache[t] && delete o.__cache[t],
                    e.removeAttribute("data-select2-id")
                }
                ,
                o
            }),
            e.define("select2/results", ["jquery", "./utils"], function(h, f) {
                function n(e, t, i) {
                    this.$element = e,
                    this.data = i,
                    this.options = t,
                    n.__super__.constructor.call(this)
                }
                return f.Extend(n, f.Observable),
                n.prototype.render = function() {
                    var e = h('<ul class="select2-results__options" role="listbox"></ul>');
                    return this.options.get("multiple") && e.attr("aria-multiselectable", "true"),
                    this.$results = e
                }
                ,
                n.prototype.clear = function() {
                    this.$results.empty()
                }
                ,
                n.prototype.displayMessage = function(e) {
                    var t = this.options.get("escapeMarkup");
                    this.clear(),
                    this.hideLoading();
                    var i = h('<li role="alert" aria-live="assertive" class="select2-results__option"></li>')
                      , n = this.options.get("translations").get(e.message);
                    i.append(t(n(e.args))),
                    i[0].className += " select2-results__message",
                    this.$results.append(i)
                }
                ,
                n.prototype.hideMessages = function() {
                    this.$results.find(".select2-results__message").remove()
                }
                ,
                n.prototype.append = function(e) {
                    this.hideLoading();
                    var t = [];
                    if (null != e.results && 0 !== e.results.length) {
                        e.results = this.sort(e.results);
                        for (var i = 0; i < e.results.length; i++) {
                            var n = e.results[i]
                              , o = this.option(n);
                            t.push(o)
                        }
                        this.$results.append(t)
                    } else
                        0 === this.$results.children().length && this.trigger("results:message", {
                            message: "noResults"
                        })
                }
                ,
                n.prototype.position = function(e, t) {
                    t.find(".select2-results").append(e)
                }
                ,
                n.prototype.sort = function(e) {
                    return this.options.get("sorter")(e)
                }
                ,
                n.prototype.highlightFirstItem = function() {
                    var e = this.$results.find(".select2-results__option[aria-selected]")
                      , t = e.filter("[aria-selected=true]");
                    0 < t.length ? t.first().trigger("mouseenter") : e.first().trigger("mouseenter"),
                    this.ensureHighlightVisible()
                }
                ,
                n.prototype.setClasses = function() {
                    var t = this;
                    this.data.current(function(e) {
                        var n = h.map(e, function(e) {
                            return e.id.toString()
                        });
                        t.$results.find(".select2-results__option[aria-selected]").each(function() {
                            var e = h(this)
                              , t = f.GetData(this, "data")
                              , i = "" + t.id;
                            null != t.element && t.element.selected || null == t.element && -1 < h.inArray(i, n) ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false")
                        })
                    })
                }
                ,
                n.prototype.showLoading = function(e) {
                    this.hideLoading();
                    var t = {
                        disabled: !0,
                        loading: !0,
                        text: this.options.get("translations").get("searching")(e)
                    }
                      , i = this.option(t);
                    i.className += " loading-results",
                    this.$results.prepend(i)
                }
                ,
                n.prototype.hideLoading = function() {
                    this.$results.find(".loading-results").remove()
                }
                ,
                n.prototype.option = function(e) {
                    var t = document.createElement("li");
                    t.className = "select2-results__option";
                    var i = {
                        role: "option",
                        "aria-selected": "false"
                    }
                      , n = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
                    for (var o in (null != e.element && n.call(e.element, ":disabled") || null == e.element && e.disabled) && (delete i["aria-selected"],
                    i["aria-disabled"] = "true"),
                    null == e.id && delete i["aria-selected"],
                    null != e._resultId && (t.id = e._resultId),
                    e.title && (t.title = e.title),
                    e.children && (i.role = "group",
                    i["aria-label"] = e.text,
                    delete i["aria-selected"]),
                    i) {
                        var s = i[o];
                        t.setAttribute(o, s)
                    }
                    if (e.children) {
                        var r = h(t)
                          , a = document.createElement("strong");
                        a.className = "select2-results__group",
                        h(a),
                        this.template(e, a);
                        for (var l = [], c = 0; c < e.children.length; c++) {
                            var d = e.children[c]
                              , u = this.option(d);
                            l.push(u)
                        }
                        var p = h("<ul></ul>", {
                            class: "select2-results__options select2-results__options--nested"
                        });
                        p.append(l),
                        r.append(a),
                        r.append(p)
                    } else
                        this.template(e, t);
                    return f.StoreData(t, "data", e),
                    t
                }
                ,
                n.prototype.bind = function(t, e) {
                    var l = this
                      , i = t.id + "-results";
                    this.$results.attr("id", i),
                    t.on("results:all", function(e) {
                        l.clear(),
                        l.append(e.data),
                        t.isOpen() && (l.setClasses(),
                        l.highlightFirstItem())
                    }),
                    t.on("results:append", function(e) {
                        l.append(e.data),
                        t.isOpen() && l.setClasses()
                    }),
                    t.on("query", function(e) {
                        l.hideMessages(),
                        l.showLoading(e)
                    }),
                    t.on("select", function() {
                        t.isOpen() && (l.setClasses(),
                        l.options.get("scrollAfterSelect") && l.highlightFirstItem())
                    }),
                    t.on("unselect", function() {
                        t.isOpen() && (l.setClasses(),
                        l.options.get("scrollAfterSelect") && l.highlightFirstItem())
                    }),
                    t.on("open", function() {
                        l.$results.attr("aria-expanded", "true"),
                        l.$results.attr("aria-hidden", "false"),
                        l.setClasses(),
                        l.ensureHighlightVisible()
                    }),
                    t.on("close", function() {
                        l.$results.attr("aria-expanded", "false"),
                        l.$results.attr("aria-hidden", "true"),
                        l.$results.removeAttr("aria-activedescendant")
                    }),
                    t.on("results:toggle", function() {
                        var e = l.getHighlightedResults();
                        0 !== e.length && e.trigger("mouseup")
                    }),
                    t.on("results:select", function() {
                        var e = l.getHighlightedResults();
                        if (0 !== e.length) {
                            var t = f.GetData(e[0], "data");
                            "true" == e.attr("aria-selected") ? l.trigger("close", {}) : l.trigger("select", {
                                data: t
                            })
                        }
                    }),
                    t.on("results:previous", function() {
                        var e = l.getHighlightedResults()
                          , t = l.$results.find("[aria-selected]")
                          , i = t.index(e);
                        if (!(i <= 0)) {
                            var n = i - 1;
                            0 === e.length && (n = 0);
                            var o = t.eq(n);
                            o.trigger("mouseenter");
                            var s = l.$results.offset().top
                              , r = o.offset().top
                              , a = l.$results.scrollTop() + (r - s);
                            0 === n ? l.$results.scrollTop(0) : r - s < 0 && l.$results.scrollTop(a)
                        }
                    }),
                    t.on("results:next", function() {
                        var e = l.getHighlightedResults()
                          , t = l.$results.find("[aria-selected]")
                          , i = t.index(e) + 1;
                        if (!(i >= t.length)) {
                            var n = t.eq(i);
                            n.trigger("mouseenter");
                            var o = l.$results.offset().top + l.$results.outerHeight(!1)
                              , s = n.offset().top + n.outerHeight(!1)
                              , r = l.$results.scrollTop() + s - o;
                            0 === i ? l.$results.scrollTop(0) : o < s && l.$results.scrollTop(r)
                        }
                    }),
                    t.on("results:focus", function(e) {
                        e.element.addClass("select2-results__option--highlighted")
                    }),
                    t.on("results:message", function(e) {
                        l.displayMessage(e)
                    }),
                    h.fn.mousewheel && this.$results.on("mousewheel", function(e) {
                        var t = l.$results.scrollTop()
                          , i = l.$results.get(0).scrollHeight - t + e.deltaY
                          , n = 0 < e.deltaY && t - e.deltaY <= 0
                          , o = e.deltaY < 0 && i <= l.$results.height();
                        n ? (l.$results.scrollTop(0),
                        e.preventDefault(),
                        e.stopPropagation()) : o && (l.$results.scrollTop(l.$results.get(0).scrollHeight - l.$results.height()),
                        e.preventDefault(),
                        e.stopPropagation())
                    }),
                    this.$results.on("mouseup", ".select2-results__option[aria-selected]", function(e) {
                        var t = h(this)
                          , i = f.GetData(this, "data");
                        "true" !== t.attr("aria-selected") ? l.trigger("select", {
                            originalEvent: e,
                            data: i
                        }) : l.options.get("multiple") ? l.trigger("unselect", {
                            originalEvent: e,
                            data: i
                        }) : l.trigger("close", {})
                    }),
                    this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function(e) {
                        var t = f.GetData(this, "data");
                        l.getHighlightedResults().removeClass("select2-results__option--highlighted"),
                        l.trigger("results:focus", {
                            data: t,
                            element: h(this)
                        })
                    })
                }
                ,
                n.prototype.getHighlightedResults = function() {
                    return this.$results.find(".select2-results__option--highlighted")
                }
                ,
                n.prototype.destroy = function() {
                    this.$results.remove()
                }
                ,
                n.prototype.ensureHighlightVisible = function() {
                    var e = this.getHighlightedResults();
                    if (0 !== e.length) {
                        var t = this.$results.find("[aria-selected]").index(e)
                          , i = this.$results.offset().top
                          , n = e.offset().top
                          , o = this.$results.scrollTop() + (n - i)
                          , s = n - i;
                        o -= 2 * e.outerHeight(!1),
                        t <= 2 ? this.$results.scrollTop(0) : (s > this.$results.outerHeight() || s < 0) && this.$results.scrollTop(o)
                    }
                }
                ,
                n.prototype.template = function(e, t) {
                    var i = this.options.get("templateResult")
                      , n = this.options.get("escapeMarkup")
                      , o = i(e, t);
                    null == o ? t.style.display = "none" : "string" == typeof o ? t.innerHTML = n(o) : h(t).append(o)
                }
                ,
                n
            }),
            e.define("select2/keys", [], function() {
                return {
                    BACKSPACE: 8,
                    TAB: 9,
                    ENTER: 13,
                    SHIFT: 16,
                    CTRL: 17,
                    ALT: 18,
                    ESC: 27,
                    SPACE: 32,
                    PAGE_UP: 33,
                    PAGE_DOWN: 34,
                    END: 35,
                    HOME: 36,
                    LEFT: 37,
                    UP: 38,
                    RIGHT: 39,
                    DOWN: 40,
                    DELETE: 46
                }
            }),
            e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function(i, n, o) {
                function s(e, t) {
                    this.$element = e,
                    this.options = t,
                    s.__super__.constructor.call(this)
                }
                return n.Extend(s, n.Observable),
                s.prototype.render = function() {
                    var e = i('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
                    return this._tabindex = 0,
                    null != n.GetData(this.$element[0], "old-tabindex") ? this._tabindex = n.GetData(this.$element[0], "old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")),
                    e.attr("title", this.$element.attr("title")),
                    e.attr("tabindex", this._tabindex),
                    e.attr("aria-disabled", "false"),
                    this.$selection = e
                }
                ,
                s.prototype.bind = function(e, t) {
                    var i = this
                      , n = e.id + "-results";
                    this.container = e,
                    this.$selection.on("focus", function(e) {
                        i.trigger("focus", e)
                    }),
                    this.$selection.on("blur", function(e) {
                        i._handleBlur(e)
                    }),
                    this.$selection.on("keydown", function(e) {
                        i.trigger("keypress", e),
                        e.which === o.SPACE && e.preventDefault()
                    }),
                    e.on("results:focus", function(e) {
                        i.$selection.attr("aria-activedescendant", e.data._resultId)
                    }),
                    e.on("selection:update", function(e) {
                        i.update(e.data)
                    }),
                    e.on("open", function() {
                        i.$selection.attr("aria-expanded", "true"),
                        i.$selection.attr("aria-owns", n),
                        i._attachCloseHandler(e)
                    }),
                    e.on("close", function() {
                        i.$selection.attr("aria-expanded", "false"),
                        i.$selection.removeAttr("aria-activedescendant"),
                        i.$selection.removeAttr("aria-owns"),
                        i.$selection.trigger("focus"),
                        i._detachCloseHandler(e)
                    }),
                    e.on("enable", function() {
                        i.$selection.attr("tabindex", i._tabindex),
                        i.$selection.attr("aria-disabled", "false")
                    }),
                    e.on("disable", function() {
                        i.$selection.attr("tabindex", "-1"),
                        i.$selection.attr("aria-disabled", "true")
                    })
                }
                ,
                s.prototype._handleBlur = function(e) {
                    var t = this;
                    window.setTimeout(function() {
                        document.activeElement == t.$selection[0] || i.contains(t.$selection[0], document.activeElement) || t.trigger("blur", e)
                    }, 1)
                }
                ,
                s.prototype._attachCloseHandler = function(e) {
                    i(document.body).on("mousedown.select2." + e.id, function(e) {
                        var t = i(e.target).closest(".select2");
                        i(".select2.select2-container--open").each(function() {
                            this != t[0] && n.GetData(this, "element").select2("close")
                        })
                    })
                }
                ,
                s.prototype._detachCloseHandler = function(e) {
                    i(document.body).off("mousedown.select2." + e.id)
                }
                ,
                s.prototype.position = function(e, t) {
                    t.find(".selection").append(e)
                }
                ,
                s.prototype.destroy = function() {
                    this._detachCloseHandler(this.container)
                }
                ,
                s.prototype.update = function(e) {
                    throw new Error("The `update` method must be defined in child classes.")
                }
                ,
                s
            }),
            e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function(e, t, i, n) {
                function o() {
                    o.__super__.constructor.apply(this, arguments)
                }
                return i.Extend(o, t),
                o.prototype.render = function() {
                    var e = o.__super__.render.call(this);
                    return e.addClass("select2-selection--single"),
                    e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'),
                    e
                }
                ,
                o.prototype.bind = function(t, e) {
                    var i = this;
                    o.__super__.bind.apply(this, arguments);
                    var n = t.id + "-container";
                    this.$selection.find(".select2-selection__rendered").attr("id", n).attr("role", "textbox").attr("aria-readonly", "true"),
                    this.$selection.attr("aria-labelledby", n),
                    this.$selection.on("mousedown", function(e) {
                        1 === e.which && i.trigger("toggle", {
                            originalEvent: e
                        })
                    }),
                    this.$selection.on("focus", function(e) {}),
                    this.$selection.on("blur", function(e) {}),
                    t.on("focus", function(e) {
                        t.isOpen() || i.$selection.trigger("focus")
                    })
                }
                ,
                o.prototype.clear = function() {
                    var e = this.$selection.find(".select2-selection__rendered");
                    e.empty(),
                    e.removeAttr("title")
                }
                ,
                o.prototype.display = function(e, t) {
                    var i = this.options.get("templateSelection");
                    return this.options.get("escapeMarkup")(i(e, t))
                }
                ,
                o.prototype.selectionContainer = function() {
                    return e("<span></span>")
                }
                ,
                o.prototype.update = function(e) {
                    if (0 !== e.length) {
                        var t = e[0]
                          , i = this.$selection.find(".select2-selection__rendered")
                          , n = this.display(t, i);
                        i.empty().append(n);
                        var o = t.title || t.text;
                        o ? i.attr("title", o) : i.removeAttr("title")
                    } else
                        this.clear()
                }
                ,
                o
            }),
            e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function(o, e, l) {
                function i(e, t) {
                    i.__super__.constructor.apply(this, arguments)
                }
                return l.Extend(i, e),
                i.prototype.render = function() {
                    var e = i.__super__.render.call(this);
                    return e.addClass("select2-selection--multiple"),
                    e.html('<ul class="select2-selection__rendered"></ul>'),
                    e
                }
                ,
                i.prototype.bind = function(e, t) {
                    var n = this;
                    i.__super__.bind.apply(this, arguments),
                    this.$selection.on("click", function(e) {
                        n.trigger("toggle", {
                            originalEvent: e
                        })
                    }),
                    this.$selection.on("click", ".select2-selection__choice__remove", function(e) {
                        if (!n.options.get("disabled")) {
                            var t = o(this).parent()
                              , i = l.GetData(t[0], "data");
                            n.trigger("unselect", {
                                originalEvent: e,
                                data: i
                            })
                        }
                    })
                }
                ,
                i.prototype.clear = function() {
                    var e = this.$selection.find(".select2-selection__rendered");
                    e.empty(),
                    e.removeAttr("title")
                }
                ,
                i.prototype.display = function(e, t) {
                    var i = this.options.get("templateSelection");
                    return this.options.get("escapeMarkup")(i(e, t))
                }
                ,
                i.prototype.selectionContainer = function() {
                    return o('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>')
                }
                ,
                i.prototype.update = function(e) {
                    if (this.clear(),
                    0 !== e.length) {
                        for (var t = [], i = 0; i < e.length; i++) {
                            var n = e[i]
                              , o = this.selectionContainer()
                              , s = this.display(n, o);
                            o.append(s);
                            var r = n.title || n.text;
                            r && o.attr("title", r),
                            l.StoreData(o[0], "data", n),
                            t.push(o)
                        }
                        var a = this.$selection.find(".select2-selection__rendered");
                        l.appendMany(a, t)
                    }
                }
                ,
                i
            }),
            e.define("select2/selection/placeholder", ["../utils"], function(e) {
                function t(e, t, i) {
                    this.placeholder = this.normalizePlaceholder(i.get("placeholder")),
                    e.call(this, t, i)
                }
                return t.prototype.normalizePlaceholder = function(e, t) {
                    return "string" == typeof t && (t = {
                        id: "",
                        text: t
                    }),
                    t
                }
                ,
                t.prototype.createPlaceholder = function(e, t) {
                    var i = this.selectionContainer();
                    return i.html(this.display(t)),
                    i.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"),
                    i
                }
                ,
                t.prototype.update = function(e, t) {
                    var i = 1 == t.length && t[0].id != this.placeholder.id;
                    if (1 < t.length || i)
                        return e.call(this, t);
                    this.clear();
                    var n = this.createPlaceholder(this.placeholder);
                    this.$selection.find(".select2-selection__rendered").append(n)
                }
                ,
                t
            }),
            e.define("select2/selection/allowClear", ["jquery", "../keys", "../utils"], function(o, n, a) {
                function e() {}
                return e.prototype.bind = function(e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                    null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."),
                    this.$selection.on("mousedown", ".select2-selection__clear", function(e) {
                        n._handleClear(e)
                    }),
                    t.on("keypress", function(e) {
                        n._handleKeyboardClear(e, t)
                    })
                }
                ,
                e.prototype._handleClear = function(e, t) {
                    if (!this.options.get("disabled")) {
                        var i = this.$selection.find(".select2-selection__clear");
                        if (0 !== i.length) {
                            t.stopPropagation();
                            var n = a.GetData(i[0], "data")
                              , o = this.$element.val();
                            this.$element.val(this.placeholder.id);
                            var s = {
                                data: n
                            };
                            if (this.trigger("clear", s),
                            s.prevented)
                                this.$element.val(o);
                            else {
                                for (var r = 0; r < n.length; r++)
                                    if (s = {
                                        data: n[r]
                                    },
                                    this.trigger("unselect", s),
                                    s.prevented)
                                        return void this.$element.val(o);
                                this.$element.trigger("change"),
                                this.trigger("toggle", {})
                            }
                        }
                    }
                }
                ,
                e.prototype._handleKeyboardClear = function(e, t, i) {
                    i.isOpen() || t.which != n.DELETE && t.which != n.BACKSPACE || this._handleClear(t)
                }
                ,
                e.prototype.update = function(e, t) {
                    if (e.call(this, t),
                    !(0 < this.$selection.find(".select2-selection__placeholder").length || 0 === t.length)) {
                        var i = this.options.get("translations").get("removeAllItems")
                          , n = o('<span class="select2-selection__clear" title="' + i() + '">&times;</span>');
                        a.StoreData(n[0], "data", t),
                        this.$selection.find(".select2-selection__rendered").prepend(n)
                    }
                }
                ,
                e
            }),
            e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function(n, a, l) {
                function e(e, t, i) {
                    e.call(this, t, i)
                }
                return e.prototype.render = function(e) {
                    var t = n('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>');
                    this.$searchContainer = t,
                    this.$search = t.find("input");
                    var i = e.call(this);
                    return this._transferTabIndex(),
                    i
                }
                ,
                e.prototype.bind = function(e, t, i) {
                    var n = this
                      , o = t.id + "-results";
                    e.call(this, t, i),
                    t.on("open", function() {
                        n.$search.attr("aria-controls", o),
                        n.$search.trigger("focus")
                    }),
                    t.on("close", function() {
                        n.$search.val(""),
                        n.$search.removeAttr("aria-controls"),
                        n.$search.removeAttr("aria-activedescendant"),
                        n.$search.trigger("focus")
                    }),
                    t.on("enable", function() {
                        n.$search.prop("disabled", !1),
                        n._transferTabIndex()
                    }),
                    t.on("disable", function() {
                        n.$search.prop("disabled", !0)
                    }),
                    t.on("focus", function(e) {
                        n.$search.trigger("focus")
                    }),
                    t.on("results:focus", function(e) {
                        e.data._resultId ? n.$search.attr("aria-activedescendant", e.data._resultId) : n.$search.removeAttr("aria-activedescendant")
                    }),
                    this.$selection.on("focusin", ".select2-search--inline", function(e) {
                        n.trigger("focus", e)
                    }),
                    this.$selection.on("focusout", ".select2-search--inline", function(e) {
                        n._handleBlur(e)
                    }),
                    this.$selection.on("keydown", ".select2-search--inline", function(e) {
                        if (e.stopPropagation(),
                        n.trigger("keypress", e),
                        n._keyUpPrevented = e.isDefaultPrevented(),
                        e.which === l.BACKSPACE && "" === n.$search.val()) {
                            var t = n.$searchContainer.prev(".select2-selection__choice");
                            if (0 < t.length) {
                                var i = a.GetData(t[0], "data");
                                n.searchRemoveChoice(i),
                                e.preventDefault()
                            }
                        }
                    }),
                    this.$selection.on("click", ".select2-search--inline", function(e) {
                        n.$search.val() && e.stopPropagation()
                    });
                    var s = document.documentMode
                      , r = s && s <= 11;
                    this.$selection.on("input.searchcheck", ".select2-search--inline", function(e) {
                        r ? n.$selection.off("input.search input.searchcheck") : n.$selection.off("keyup.search")
                    }),
                    this.$selection.on("keyup.search input.search", ".select2-search--inline", function(e) {
                        if (r && "input" === e.type)
                            n.$selection.off("input.search input.searchcheck");
                        else {
                            var t = e.which;
                            t != l.SHIFT && t != l.CTRL && t != l.ALT && t != l.TAB && n.handleSearch(e)
                        }
                    })
                }
                ,
                e.prototype._transferTabIndex = function(e) {
                    this.$search.attr("tabindex", this.$selection.attr("tabindex")),
                    this.$selection.attr("tabindex", "-1")
                }
                ,
                e.prototype.createPlaceholder = function(e, t) {
                    this.$search.attr("placeholder", t.text)
                }
                ,
                e.prototype.update = function(e, t) {
                    var i = this.$search[0] == document.activeElement;
                    this.$search.attr("placeholder", ""),
                    e.call(this, t),
                    this.$selection.find(".select2-selection__rendered").append(this.$searchContainer),
                    this.resizeSearch(),
                    i && this.$search.trigger("focus")
                }
                ,
                e.prototype.handleSearch = function() {
                    if (this.resizeSearch(),
                    !this._keyUpPrevented) {
                        var e = this.$search.val();
                        this.trigger("query", {
                            term: e
                        })
                    }
                    this._keyUpPrevented = !1
                }
                ,
                e.prototype.searchRemoveChoice = function(e, t) {
                    this.trigger("unselect", {
                        data: t
                    }),
                    this.$search.val(t.text),
                    this.handleSearch()
                }
                ,
                e.prototype.resizeSearch = function() {
                    this.$search.css("width", "25px");
                    var e = "";
                    e = "" !== this.$search.attr("placeholder") ? this.$selection.find(".select2-selection__rendered").width() : .75 * (this.$search.val().length + 1) + "em",
                    this.$search.css("width", e)
                }
                ,
                e
            }),
            e.define("select2/selection/eventRelay", ["jquery"], function(r) {
                function e() {}
                return e.prototype.bind = function(e, t, i) {
                    var n = this
                      , o = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting", "clear", "clearing"]
                      , s = ["opening", "closing", "selecting", "unselecting", "clearing"];
                    e.call(this, t, i),
                    t.on("*", function(e, t) {
                        if (-1 !== r.inArray(e, o)) {
                            t = t || {};
                            var i = r.Event("select2:" + e, {
                                params: t
                            });
                            n.$element.trigger(i),
                            -1 !== r.inArray(e, s) && (t.prevented = i.isDefaultPrevented())
                        }
                    })
                }
                ,
                e
            }),
            e.define("select2/translation", ["jquery", "require"], function(t, i) {
                function n(e) {
                    this.dict = e || {}
                }
                return n.prototype.all = function() {
                    return this.dict
                }
                ,
                n.prototype.get = function(e) {
                    return this.dict[e]
                }
                ,
                n.prototype.extend = function(e) {
                    this.dict = t.extend({}, e.all(), this.dict)
                }
                ,
                n._cache = {},
                n.loadPath = function(e) {
                    if (!(e in n._cache)) {
                        var t = i(e);
                        n._cache[e] = t
                    }
                    return new n(n._cache[e])
                }
                ,
                n
            }),
            e.define("select2/diacritics", [], function() {
                return {
                    "Ⓐ": "A",
                    "Ａ": "A",
                    "À": "A",
                    "Á": "A",
                    "Â": "A",
                    "Ầ": "A",
                    "Ấ": "A",
                    "Ẫ": "A",
                    "Ẩ": "A",
                    "Ã": "A",
                    "Ā": "A",
                    "Ă": "A",
                    "Ằ": "A",
                    "Ắ": "A",
                    "Ẵ": "A",
                    "Ẳ": "A",
                    "Ȧ": "A",
                    "Ǡ": "A",
                    "Ä": "A",
                    "Ǟ": "A",
                    "Ả": "A",
                    "Å": "A",
                    "Ǻ": "A",
                    "Ǎ": "A",
                    "Ȁ": "A",
                    "Ȃ": "A",
                    "Ạ": "A",
                    "Ậ": "A",
                    "Ặ": "A",
                    "Ḁ": "A",
                    "Ą": "A",
                    "Ⱥ": "A",
                    "Ɐ": "A",
                    "Ꜳ": "AA",
                    "Æ": "AE",
                    "Ǽ": "AE",
                    "Ǣ": "AE",
                    "Ꜵ": "AO",
                    "Ꜷ": "AU",
                    "Ꜹ": "AV",
                    "Ꜻ": "AV",
                    "Ꜽ": "AY",
                    "Ⓑ": "B",
                    "Ｂ": "B",
                    "Ḃ": "B",
                    "Ḅ": "B",
                    "Ḇ": "B",
                    "Ƀ": "B",
                    "Ƃ": "B",
                    "Ɓ": "B",
                    "Ⓒ": "C",
                    "Ｃ": "C",
                    "Ć": "C",
                    "Ĉ": "C",
                    "Ċ": "C",
                    "Č": "C",
                    "Ç": "C",
                    "Ḉ": "C",
                    "Ƈ": "C",
                    "Ȼ": "C",
                    "Ꜿ": "C",
                    "Ⓓ": "D",
                    "Ｄ": "D",
                    "Ḋ": "D",
                    "Ď": "D",
                    "Ḍ": "D",
                    "Ḑ": "D",
                    "Ḓ": "D",
                    "Ḏ": "D",
                    "Đ": "D",
                    "Ƌ": "D",
                    "Ɗ": "D",
                    "Ɖ": "D",
                    "Ꝺ": "D",
                    "Ǳ": "DZ",
                    "Ǆ": "DZ",
                    "ǲ": "Dz",
                    "ǅ": "Dz",
                    "Ⓔ": "E",
                    "Ｅ": "E",
                    "È": "E",
                    "É": "E",
                    "Ê": "E",
                    "Ề": "E",
                    "Ế": "E",
                    "Ễ": "E",
                    "Ể": "E",
                    "Ẽ": "E",
                    "Ē": "E",
                    "Ḕ": "E",
                    "Ḗ": "E",
                    "Ĕ": "E",
                    "Ė": "E",
                    "Ë": "E",
                    "Ẻ": "E",
                    "Ě": "E",
                    "Ȅ": "E",
                    "Ȇ": "E",
                    "Ẹ": "E",
                    "Ệ": "E",
                    "Ȩ": "E",
                    "Ḝ": "E",
                    "Ę": "E",
                    "Ḙ": "E",
                    "Ḛ": "E",
                    "Ɛ": "E",
                    "Ǝ": "E",
                    "Ⓕ": "F",
                    "Ｆ": "F",
                    "Ḟ": "F",
                    "Ƒ": "F",
                    "Ꝼ": "F",
                    "Ⓖ": "G",
                    "Ｇ": "G",
                    "Ǵ": "G",
                    "Ĝ": "G",
                    "Ḡ": "G",
                    "Ğ": "G",
                    "Ġ": "G",
                    "Ǧ": "G",
                    "Ģ": "G",
                    "Ǥ": "G",
                    "Ɠ": "G",
                    "Ꞡ": "G",
                    "Ᵹ": "G",
                    "Ꝿ": "G",
                    "Ⓗ": "H",
                    "Ｈ": "H",
                    "Ĥ": "H",
                    "Ḣ": "H",
                    "Ḧ": "H",
                    "Ȟ": "H",
                    "Ḥ": "H",
                    "Ḩ": "H",
                    "Ḫ": "H",
                    "Ħ": "H",
                    "Ⱨ": "H",
                    "Ⱶ": "H",
                    "Ɥ": "H",
                    "Ⓘ": "I",
                    "Ｉ": "I",
                    "Ì": "I",
                    "Í": "I",
                    "Î": "I",
                    "Ĩ": "I",
                    "Ī": "I",
                    "Ĭ": "I",
                    "İ": "I",
                    "Ï": "I",
                    "Ḯ": "I",
                    "Ỉ": "I",
                    "Ǐ": "I",
                    "Ȉ": "I",
                    "Ȋ": "I",
                    "Ị": "I",
                    "Į": "I",
                    "Ḭ": "I",
                    "Ɨ": "I",
                    "Ⓙ": "J",
                    "Ｊ": "J",
                    "Ĵ": "J",
                    "Ɉ": "J",
                    "Ⓚ": "K",
                    "Ｋ": "K",
                    "Ḱ": "K",
                    "Ǩ": "K",
                    "Ḳ": "K",
                    "Ķ": "K",
                    "Ḵ": "K",
                    "Ƙ": "K",
                    "Ⱪ": "K",
                    "Ꝁ": "K",
                    "Ꝃ": "K",
                    "Ꝅ": "K",
                    "Ꞣ": "K",
                    "Ⓛ": "L",
                    "Ｌ": "L",
                    "Ŀ": "L",
                    "Ĺ": "L",
                    "Ľ": "L",
                    "Ḷ": "L",
                    "Ḹ": "L",
                    "Ļ": "L",
                    "Ḽ": "L",
                    "Ḻ": "L",
                    "Ł": "L",
                    "Ƚ": "L",
                    "Ɫ": "L",
                    "Ⱡ": "L",
                    "Ꝉ": "L",
                    "Ꝇ": "L",
                    "Ꞁ": "L",
                    "Ǉ": "LJ",
                    "ǈ": "Lj",
                    "Ⓜ": "M",
                    "Ｍ": "M",
                    "Ḿ": "M",
                    "Ṁ": "M",
                    "Ṃ": "M",
                    "Ɱ": "M",
                    "Ɯ": "M",
                    "Ⓝ": "N",
                    "Ｎ": "N",
                    "Ǹ": "N",
                    "Ń": "N",
                    "Ñ": "N",
                    "Ṅ": "N",
                    "Ň": "N",
                    "Ṇ": "N",
                    "Ņ": "N",
                    "Ṋ": "N",
                    "Ṉ": "N",
                    "Ƞ": "N",
                    "Ɲ": "N",
                    "Ꞑ": "N",
                    "Ꞥ": "N",
                    "Ǌ": "NJ",
                    "ǋ": "Nj",
                    "Ⓞ": "O",
                    "Ｏ": "O",
                    "Ò": "O",
                    "Ó": "O",
                    "Ô": "O",
                    "Ồ": "O",
                    "Ố": "O",
                    "Ỗ": "O",
                    "Ổ": "O",
                    "Õ": "O",
                    "Ṍ": "O",
                    "Ȭ": "O",
                    "Ṏ": "O",
                    "Ō": "O",
                    "Ṑ": "O",
                    "Ṓ": "O",
                    "Ŏ": "O",
                    "Ȯ": "O",
                    "Ȱ": "O",
                    "Ö": "O",
                    "Ȫ": "O",
                    "Ỏ": "O",
                    "Ő": "O",
                    "Ǒ": "O",
                    "Ȍ": "O",
                    "Ȏ": "O",
                    "Ơ": "O",
                    "Ờ": "O",
                    "Ớ": "O",
                    "Ỡ": "O",
                    "Ở": "O",
                    "Ợ": "O",
                    "Ọ": "O",
                    "Ộ": "O",
                    "Ǫ": "O",
                    "Ǭ": "O",
                    "Ø": "O",
                    "Ǿ": "O",
                    "Ɔ": "O",
                    "Ɵ": "O",
                    "Ꝋ": "O",
                    "Ꝍ": "O",
                    "Œ": "OE",
                    "Ƣ": "OI",
                    "Ꝏ": "OO",
                    "Ȣ": "OU",
                    "Ⓟ": "P",
                    "Ｐ": "P",
                    "Ṕ": "P",
                    "Ṗ": "P",
                    "Ƥ": "P",
                    "Ᵽ": "P",
                    "Ꝑ": "P",
                    "Ꝓ": "P",
                    "Ꝕ": "P",
                    "Ⓠ": "Q",
                    "Ｑ": "Q",
                    "Ꝗ": "Q",
                    "Ꝙ": "Q",
                    "Ɋ": "Q",
                    "Ⓡ": "R",
                    "Ｒ": "R",
                    "Ŕ": "R",
                    "Ṙ": "R",
                    "Ř": "R",
                    "Ȑ": "R",
                    "Ȓ": "R",
                    "Ṛ": "R",
                    "Ṝ": "R",
                    "Ŗ": "R",
                    "Ṟ": "R",
                    "Ɍ": "R",
                    "Ɽ": "R",
                    "Ꝛ": "R",
                    "Ꞧ": "R",
                    "Ꞃ": "R",
                    "Ⓢ": "S",
                    "Ｓ": "S",
                    "ẞ": "S",
                    "Ś": "S",
                    "Ṥ": "S",
                    "Ŝ": "S",
                    "Ṡ": "S",
                    "Š": "S",
                    "Ṧ": "S",
                    "Ṣ": "S",
                    "Ṩ": "S",
                    "Ș": "S",
                    "Ş": "S",
                    "Ȿ": "S",
                    "Ꞩ": "S",
                    "Ꞅ": "S",
                    "Ⓣ": "T",
                    "Ｔ": "T",
                    "Ṫ": "T",
                    "Ť": "T",
                    "Ṭ": "T",
                    "Ț": "T",
                    "Ţ": "T",
                    "Ṱ": "T",
                    "Ṯ": "T",
                    "Ŧ": "T",
                    "Ƭ": "T",
                    "Ʈ": "T",
                    "Ⱦ": "T",
                    "Ꞇ": "T",
                    "Ꜩ": "TZ",
                    "Ⓤ": "U",
                    "Ｕ": "U",
                    "Ù": "U",
                    "Ú": "U",
                    "Û": "U",
                    "Ũ": "U",
                    "Ṹ": "U",
                    "Ū": "U",
                    "Ṻ": "U",
                    "Ŭ": "U",
                    "Ü": "U",
                    "Ǜ": "U",
                    "Ǘ": "U",
                    "Ǖ": "U",
                    "Ǚ": "U",
                    "Ủ": "U",
                    "Ů": "U",
                    "Ű": "U",
                    "Ǔ": "U",
                    "Ȕ": "U",
                    "Ȗ": "U",
                    "Ư": "U",
                    "Ừ": "U",
                    "Ứ": "U",
                    "Ữ": "U",
                    "Ử": "U",
                    "Ự": "U",
                    "Ụ": "U",
                    "Ṳ": "U",
                    "Ų": "U",
                    "Ṷ": "U",
                    "Ṵ": "U",
                    "Ʉ": "U",
                    "Ⓥ": "V",
                    "Ｖ": "V",
                    "Ṽ": "V",
                    "Ṿ": "V",
                    "Ʋ": "V",
                    "Ꝟ": "V",
                    "Ʌ": "V",
                    "Ꝡ": "VY",
                    "Ⓦ": "W",
                    "Ｗ": "W",
                    "Ẁ": "W",
                    "Ẃ": "W",
                    "Ŵ": "W",
                    "Ẇ": "W",
                    "Ẅ": "W",
                    "Ẉ": "W",
                    "Ⱳ": "W",
                    "Ⓧ": "X",
                    "Ｘ": "X",
                    "Ẋ": "X",
                    "Ẍ": "X",
                    "Ⓨ": "Y",
                    "Ｙ": "Y",
                    "Ỳ": "Y",
                    "Ý": "Y",
                    "Ŷ": "Y",
                    "Ỹ": "Y",
                    "Ȳ": "Y",
                    "Ẏ": "Y",
                    "Ÿ": "Y",
                    "Ỷ": "Y",
                    "Ỵ": "Y",
                    "Ƴ": "Y",
                    "Ɏ": "Y",
                    "Ỿ": "Y",
                    "Ⓩ": "Z",
                    "Ｚ": "Z",
                    "Ź": "Z",
                    "Ẑ": "Z",
                    "Ż": "Z",
                    "Ž": "Z",
                    "Ẓ": "Z",
                    "Ẕ": "Z",
                    "Ƶ": "Z",
                    "Ȥ": "Z",
                    "Ɀ": "Z",
                    "Ⱬ": "Z",
                    "Ꝣ": "Z",
                    "ⓐ": "a",
                    "ａ": "a",
                    "ẚ": "a",
                    "à": "a",
                    "á": "a",
                    "â": "a",
                    "ầ": "a",
                    "ấ": "a",
                    "ẫ": "a",
                    "ẩ": "a",
                    "ã": "a",
                    "ā": "a",
                    "ă": "a",
                    "ằ": "a",
                    "ắ": "a",
                    "ẵ": "a",
                    "ẳ": "a",
                    "ȧ": "a",
                    "ǡ": "a",
                    "ä": "a",
                    "ǟ": "a",
                    "ả": "a",
                    "å": "a",
                    "ǻ": "a",
                    "ǎ": "a",
                    "ȁ": "a",
                    "ȃ": "a",
                    "ạ": "a",
                    "ậ": "a",
                    "ặ": "a",
                    "ḁ": "a",
                    "ą": "a",
                    "ⱥ": "a",
                    "ɐ": "a",
                    "ꜳ": "aa",
                    "æ": "ae",
                    "ǽ": "ae",
                    "ǣ": "ae",
                    "ꜵ": "ao",
                    "ꜷ": "au",
                    "ꜹ": "av",
                    "ꜻ": "av",
                    "ꜽ": "ay",
                    "ⓑ": "b",
                    "ｂ": "b",
                    "ḃ": "b",
                    "ḅ": "b",
                    "ḇ": "b",
                    "ƀ": "b",
                    "ƃ": "b",
                    "ɓ": "b",
                    "ⓒ": "c",
                    "ｃ": "c",
                    "ć": "c",
                    "ĉ": "c",
                    "ċ": "c",
                    "č": "c",
                    "ç": "c",
                    "ḉ": "c",
                    "ƈ": "c",
                    "ȼ": "c",
                    "ꜿ": "c",
                    "ↄ": "c",
                    "ⓓ": "d",
                    "ｄ": "d",
                    "ḋ": "d",
                    "ď": "d",
                    "ḍ": "d",
                    "ḑ": "d",
                    "ḓ": "d",
                    "ḏ": "d",
                    "đ": "d",
                    "ƌ": "d",
                    "ɖ": "d",
                    "ɗ": "d",
                    "ꝺ": "d",
                    "ǳ": "dz",
                    "ǆ": "dz",
                    "ⓔ": "e",
                    "ｅ": "e",
                    "è": "e",
                    "é": "e",
                    "ê": "e",
                    "ề": "e",
                    "ế": "e",
                    "ễ": "e",
                    "ể": "e",
                    "ẽ": "e",
                    "ē": "e",
                    "ḕ": "e",
                    "ḗ": "e",
                    "ĕ": "e",
                    "ė": "e",
                    "ë": "e",
                    "ẻ": "e",
                    "ě": "e",
                    "ȅ": "e",
                    "ȇ": "e",
                    "ẹ": "e",
                    "ệ": "e",
                    "ȩ": "e",
                    "ḝ": "e",
                    "ę": "e",
                    "ḙ": "e",
                    "ḛ": "e",
                    "ɇ": "e",
                    "ɛ": "e",
                    "ǝ": "e",
                    "ⓕ": "f",
                    "ｆ": "f",
                    "ḟ": "f",
                    "ƒ": "f",
                    "ꝼ": "f",
                    "ⓖ": "g",
                    "ｇ": "g",
                    "ǵ": "g",
                    "ĝ": "g",
                    "ḡ": "g",
                    "ğ": "g",
                    "ġ": "g",
                    "ǧ": "g",
                    "ģ": "g",
                    "ǥ": "g",
                    "ɠ": "g",
                    "ꞡ": "g",
                    "ᵹ": "g",
                    "ꝿ": "g",
                    "ⓗ": "h",
                    "ｈ": "h",
                    "ĥ": "h",
                    "ḣ": "h",
                    "ḧ": "h",
                    "ȟ": "h",
                    "ḥ": "h",
                    "ḩ": "h",
                    "ḫ": "h",
                    "ẖ": "h",
                    "ħ": "h",
                    "ⱨ": "h",
                    "ⱶ": "h",
                    "ɥ": "h",
                    "ƕ": "hv",
                    "ⓘ": "i",
                    "ｉ": "i",
                    "ì": "i",
                    "í": "i",
                    "î": "i",
                    "ĩ": "i",
                    "ī": "i",
                    "ĭ": "i",
                    "ï": "i",
                    "ḯ": "i",
                    "ỉ": "i",
                    "ǐ": "i",
                    "ȉ": "i",
                    "ȋ": "i",
                    "ị": "i",
                    "į": "i",
                    "ḭ": "i",
                    "ɨ": "i",
                    "ı": "i",
                    "ⓙ": "j",
                    "ｊ": "j",
                    "ĵ": "j",
                    "ǰ": "j",
                    "ɉ": "j",
                    "ⓚ": "k",
                    "ｋ": "k",
                    "ḱ": "k",
                    "ǩ": "k",
                    "ḳ": "k",
                    "ķ": "k",
                    "ḵ": "k",
                    "ƙ": "k",
                    "ⱪ": "k",
                    "ꝁ": "k",
                    "ꝃ": "k",
                    "ꝅ": "k",
                    "ꞣ": "k",
                    "ⓛ": "l",
                    "ｌ": "l",
                    "ŀ": "l",
                    "ĺ": "l",
                    "ľ": "l",
                    "ḷ": "l",
                    "ḹ": "l",
                    "ļ": "l",
                    "ḽ": "l",
                    "ḻ": "l",
                    "ſ": "l",
                    "ł": "l",
                    "ƚ": "l",
                    "ɫ": "l",
                    "ⱡ": "l",
                    "ꝉ": "l",
                    "ꞁ": "l",
                    "ꝇ": "l",
                    "ǉ": "lj",
                    "ⓜ": "m",
                    "ｍ": "m",
                    "ḿ": "m",
                    "ṁ": "m",
                    "ṃ": "m",
                    "ɱ": "m",
                    "ɯ": "m",
                    "ⓝ": "n",
                    "ｎ": "n",
                    "ǹ": "n",
                    "ń": "n",
                    "ñ": "n",
                    "ṅ": "n",
                    "ň": "n",
                    "ṇ": "n",
                    "ņ": "n",
                    "ṋ": "n",
                    "ṉ": "n",
                    "ƞ": "n",
                    "ɲ": "n",
                    "ŉ": "n",
                    "ꞑ": "n",
                    "ꞥ": "n",
                    "ǌ": "nj",
                    "ⓞ": "o",
                    "ｏ": "o",
                    "ò": "o",
                    "ó": "o",
                    "ô": "o",
                    "ồ": "o",
                    "ố": "o",
                    "ỗ": "o",
                    "ổ": "o",
                    "õ": "o",
                    "ṍ": "o",
                    "ȭ": "o",
                    "ṏ": "o",
                    "ō": "o",
                    "ṑ": "o",
                    "ṓ": "o",
                    "ŏ": "o",
                    "ȯ": "o",
                    "ȱ": "o",
                    "ö": "o",
                    "ȫ": "o",
                    "ỏ": "o",
                    "ő": "o",
                    "ǒ": "o",
                    "ȍ": "o",
                    "ȏ": "o",
                    "ơ": "o",
                    "ờ": "o",
                    "ớ": "o",
                    "ỡ": "o",
                    "ở": "o",
                    "ợ": "o",
                    "ọ": "o",
                    "ộ": "o",
                    "ǫ": "o",
                    "ǭ": "o",
                    "ø": "o",
                    "ǿ": "o",
                    "ɔ": "o",
                    "ꝋ": "o",
                    "ꝍ": "o",
                    "ɵ": "o",
                    "œ": "oe",
                    "ƣ": "oi",
                    "ȣ": "ou",
                    "ꝏ": "oo",
                    "ⓟ": "p",
                    "ｐ": "p",
                    "ṕ": "p",
                    "ṗ": "p",
                    "ƥ": "p",
                    "ᵽ": "p",
                    "ꝑ": "p",
                    "ꝓ": "p",
                    "ꝕ": "p",
                    "ⓠ": "q",
                    "ｑ": "q",
                    "ɋ": "q",
                    "ꝗ": "q",
                    "ꝙ": "q",
                    "ⓡ": "r",
                    "ｒ": "r",
                    "ŕ": "r",
                    "ṙ": "r",
                    "ř": "r",
                    "ȑ": "r",
                    "ȓ": "r",
                    "ṛ": "r",
                    "ṝ": "r",
                    "ŗ": "r",
                    "ṟ": "r",
                    "ɍ": "r",
                    "ɽ": "r",
                    "ꝛ": "r",
                    "ꞧ": "r",
                    "ꞃ": "r",
                    "ⓢ": "s",
                    "ｓ": "s",
                    "ß": "s",
                    "ś": "s",
                    "ṥ": "s",
                    "ŝ": "s",
                    "ṡ": "s",
                    "š": "s",
                    "ṧ": "s",
                    "ṣ": "s",
                    "ṩ": "s",
                    "ș": "s",
                    "ş": "s",
                    "ȿ": "s",
                    "ꞩ": "s",
                    "ꞅ": "s",
                    "ẛ": "s",
                    "ⓣ": "t",
                    "ｔ": "t",
                    "ṫ": "t",
                    "ẗ": "t",
                    "ť": "t",
                    "ṭ": "t",
                    "ț": "t",
                    "ţ": "t",
                    "ṱ": "t",
                    "ṯ": "t",
                    "ŧ": "t",
                    "ƭ": "t",
                    "ʈ": "t",
                    "ⱦ": "t",
                    "ꞇ": "t",
                    "ꜩ": "tz",
                    "ⓤ": "u",
                    "ｕ": "u",
                    "ù": "u",
                    "ú": "u",
                    "û": "u",
                    "ũ": "u",
                    "ṹ": "u",
                    "ū": "u",
                    "ṻ": "u",
                    "ŭ": "u",
                    "ü": "u",
                    "ǜ": "u",
                    "ǘ": "u",
                    "ǖ": "u",
                    "ǚ": "u",
                    "ủ": "u",
                    "ů": "u",
                    "ű": "u",
                    "ǔ": "u",
                    "ȕ": "u",
                    "ȗ": "u",
                    "ư": "u",
                    "ừ": "u",
                    "ứ": "u",
                    "ữ": "u",
                    "ử": "u",
                    "ự": "u",
                    "ụ": "u",
                    "ṳ": "u",
                    "ų": "u",
                    "ṷ": "u",
                    "ṵ": "u",
                    "ʉ": "u",
                    "ⓥ": "v",
                    "ｖ": "v",
                    "ṽ": "v",
                    "ṿ": "v",
                    "ʋ": "v",
                    "ꝟ": "v",
                    "ʌ": "v",
                    "ꝡ": "vy",
                    "ⓦ": "w",
                    "ｗ": "w",
                    "ẁ": "w",
                    "ẃ": "w",
                    "ŵ": "w",
                    "ẇ": "w",
                    "ẅ": "w",
                    "ẘ": "w",
                    "ẉ": "w",
                    "ⱳ": "w",
                    "ⓧ": "x",
                    "ｘ": "x",
                    "ẋ": "x",
                    "ẍ": "x",
                    "ⓨ": "y",
                    "ｙ": "y",
                    "ỳ": "y",
                    "ý": "y",
                    "ŷ": "y",
                    "ỹ": "y",
                    "ȳ": "y",
                    "ẏ": "y",
                    "ÿ": "y",
                    "ỷ": "y",
                    "ẙ": "y",
                    "ỵ": "y",
                    "ƴ": "y",
                    "ɏ": "y",
                    "ỿ": "y",
                    "ⓩ": "z",
                    "ｚ": "z",
                    "ź": "z",
                    "ẑ": "z",
                    "ż": "z",
                    "ž": "z",
                    "ẓ": "z",
                    "ẕ": "z",
                    "ƶ": "z",
                    "ȥ": "z",
                    "ɀ": "z",
                    "ⱬ": "z",
                    "ꝣ": "z",
                    "Ά": "Α",
                    "Έ": "Ε",
                    "Ή": "Η",
                    "Ί": "Ι",
                    "Ϊ": "Ι",
                    "Ό": "Ο",
                    "Ύ": "Υ",
                    "Ϋ": "Υ",
                    "Ώ": "Ω",
                    "ά": "α",
                    "έ": "ε",
                    "ή": "η",
                    "ί": "ι",
                    "ϊ": "ι",
                    "ΐ": "ι",
                    "ό": "ο",
                    "ύ": "υ",
                    "ϋ": "υ",
                    "ΰ": "υ",
                    "ώ": "ω",
                    "ς": "σ",
                    "’": "'"
                }
            }),
            e.define("select2/data/base", ["../utils"], function(n) {
                function i(e, t) {
                    i.__super__.constructor.call(this)
                }
                return n.Extend(i, n.Observable),
                i.prototype.current = function(e) {
                    throw new Error("The `current` method must be defined in child classes.")
                }
                ,
                i.prototype.query = function(e, t) {
                    throw new Error("The `query` method must be defined in child classes.")
                }
                ,
                i.prototype.bind = function(e, t) {}
                ,
                i.prototype.destroy = function() {}
                ,
                i.prototype.generateResultId = function(e, t) {
                    var i = e.id + "-result-";
                    return i += n.generateChars(4),
                    null != t.id ? i += "-" + t.id.toString() : i += "-" + n.generateChars(4),
                    i
                }
                ,
                i
            }),
            e.define("select2/data/select", ["./base", "../utils", "jquery"], function(e, a, l) {
                function i(e, t) {
                    this.$element = e,
                    this.options = t,
                    i.__super__.constructor.call(this)
                }
                return a.Extend(i, e),
                i.prototype.current = function(e) {
                    var i = []
                      , n = this;
                    this.$element.find(":selected").each(function() {
                        var e = l(this)
                          , t = n.item(e);
                        i.push(t)
                    }),
                    e(i)
                }
                ,
                i.prototype.select = function(o) {
                    var s = this;
                    if (o.selected = !0,
                    l(o.element).is("option"))
                        return o.element.selected = !0,
                        void this.$element.trigger("change");
                    if (this.$element.prop("multiple"))
                        this.current(function(e) {
                            var t = [];
                            (o = [o]).push.apply(o, e);
                            for (var i = 0; i < o.length; i++) {
                                var n = o[i].id;
                                -1 === l.inArray(n, t) && t.push(n)
                            }
                            s.$element.val(t),
                            s.$element.trigger("change")
                        });
                    else {
                        var e = o.id;
                        this.$element.val(e),
                        this.$element.trigger("change")
                    }
                }
                ,
                i.prototype.unselect = function(o) {
                    var s = this;
                    if (this.$element.prop("multiple")) {
                        if (o.selected = !1,
                        l(o.element).is("option"))
                            return o.element.selected = !1,
                            void this.$element.trigger("change");
                        this.current(function(e) {
                            for (var t = [], i = 0; i < e.length; i++) {
                                var n = e[i].id;
                                n !== o.id && -1 === l.inArray(n, t) && t.push(n)
                            }
                            s.$element.val(t),
                            s.$element.trigger("change")
                        })
                    }
                }
                ,
                i.prototype.bind = function(e, t) {
                    var i = this;
                    (this.container = e).on("select", function(e) {
                        i.select(e.data)
                    }),
                    e.on("unselect", function(e) {
                        i.unselect(e.data)
                    })
                }
                ,
                i.prototype.destroy = function() {
                    this.$element.find("*").each(function() {
                        a.RemoveData(this)
                    })
                }
                ,
                i.prototype.query = function(n, e) {
                    var o = []
                      , s = this;
                    this.$element.children().each(function() {
                        var e = l(this);
                        if (e.is("option") || e.is("optgroup")) {
                            var t = s.item(e)
                              , i = s.matches(n, t);
                            null !== i && o.push(i)
                        }
                    }),
                    e({
                        results: o
                    })
                }
                ,
                i.prototype.addOptions = function(e) {
                    a.appendMany(this.$element, e)
                }
                ,
                i.prototype.option = function(e) {
                    var t;
                    e.children ? (t = document.createElement("optgroup")).label = e.text : void 0 !== (t = document.createElement("option")).textContent ? t.textContent = e.text : t.innerText = e.text,
                    void 0 !== e.id && (t.value = e.id),
                    e.disabled && (t.disabled = !0),
                    e.selected && (t.selected = !0),
                    e.title && (t.title = e.title);
                    var i = l(t)
                      , n = this._normalizeItem(e);
                    return n.element = t,
                    a.StoreData(t, "data", n),
                    i
                }
                ,
                i.prototype.item = function(e) {
                    var t = {};
                    if (null != (t = a.GetData(e[0], "data")))
                        return t;
                    if (e.is("option"))
                        t = {
                            id: e.val(),
                            text: e.text(),
                            disabled: e.prop("disabled"),
                            selected: e.prop("selected"),
                            title: e.prop("title")
                        };
                    else if (e.is("optgroup")) {
                        t = {
                            text: e.prop("label"),
                            children: [],
                            title: e.prop("title")
                        };
                        for (var i = e.children("option"), n = [], o = 0; o < i.length; o++) {
                            var s = l(i[o])
                              , r = this.item(s);
                            n.push(r)
                        }
                        t.children = n
                    }
                    return (t = this._normalizeItem(t)).element = e[0],
                    a.StoreData(e[0], "data", t),
                    t
                }
                ,
                i.prototype._normalizeItem = function(e) {
                    return e !== Object(e) && (e = {
                        id: e,
                        text: e
                    }),
                    null != (e = l.extend({}, {
                        text: ""
                    }, e)).id && (e.id = e.id.toString()),
                    null != e.text && (e.text = e.text.toString()),
                    null == e._resultId && e.id && null != this.container && (e._resultId = this.generateResultId(this.container, e)),
                    l.extend({}, {
                        selected: !1,
                        disabled: !1
                    }, e)
                }
                ,
                i.prototype.matches = function(e, t) {
                    return this.options.get("matcher")(e, t)
                }
                ,
                i
            }),
            e.define("select2/data/array", ["./select", "../utils", "jquery"], function(e, f, g) {
                function n(e, t) {
                    this._dataToConvert = t.get("data") || [],
                    n.__super__.constructor.call(this, e, t)
                }
                return f.Extend(n, e),
                n.prototype.bind = function(e, t) {
                    n.__super__.bind.call(this, e, t),
                    this.addOptions(this.convertToOptions(this._dataToConvert))
                }
                ,
                n.prototype.select = function(i) {
                    var e = this.$element.find("option").filter(function(e, t) {
                        return t.value == i.id.toString()
                    });
                    0 === e.length && (e = this.option(i),
                    this.addOptions(e)),
                    n.__super__.select.call(this, i)
                }
                ,
                n.prototype.convertToOptions = function(e) {
                    var t = this
                      , i = this.$element.find("option")
                      , n = i.map(function() {
                        return t.item(g(this)).id
                    }).get()
                      , o = [];
                    function s(e) {
                        return function() {
                            return g(this).val() == e.id
                        }
                    }
                    for (var r = 0; r < e.length; r++) {
                        var a = this._normalizeItem(e[r]);
                        if (0 <= g.inArray(a.id, n)) {
                            var l = i.filter(s(a))
                              , c = this.item(l)
                              , d = g.extend(!0, {}, a, c)
                              , u = this.option(d);
                            l.replaceWith(u)
                        } else {
                            var p = this.option(a);
                            if (a.children) {
                                var h = this.convertToOptions(a.children);
                                f.appendMany(p, h)
                            }
                            o.push(p)
                        }
                    }
                    return o
                }
                ,
                n
            }),
            e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function(e, t, s) {
                function i(e, t) {
                    this.ajaxOptions = this._applyDefaults(t.get("ajax")),
                    null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults),
                    i.__super__.constructor.call(this, e, t)
                }
                return t.Extend(i, e),
                i.prototype._applyDefaults = function(e) {
                    var t = {
                        data: function(e) {
                            return s.extend({}, e, {
                                q: e.term
                            })
                        },
                        transport: function(e, t, i) {
                            var n = s.ajax(e);
                            return n.then(t),
                            n.fail(i),
                            n
                        }
                    };
                    return s.extend({}, t, e, !0)
                }
                ,
                i.prototype.processResults = function(e) {
                    return e
                }
                ,
                i.prototype.query = function(i, n) {
                    var o = this;
                    null != this._request && (s.isFunction(this._request.abort) && this._request.abort(),
                    this._request = null);
                    var t = s.extend({
                        type: "GET"
                    }, this.ajaxOptions);
                    function e() {
                        var e = t.transport(t, function(e) {
                            var t = o.processResults(e, i);
                            o.options.get("debug") && window.console && console.error && (t && t.results && s.isArray(t.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")),
                            n(t)
                        }, function() {
                            "status"in e && (0 === e.status || "0" === e.status) || o.trigger("results:message", {
                                message: "errorLoading"
                            })
                        });
                        o._request = e
                    }
                    "function" == typeof t.url && (t.url = t.url.call(this.$element, i)),
                    "function" == typeof t.data && (t.data = t.data.call(this.$element, i)),
                    this.ajaxOptions.delay && null != i.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout),
                    this._queryTimeout = window.setTimeout(e, this.ajaxOptions.delay)) : e()
                }
                ,
                i
            }),
            e.define("select2/data/tags", ["jquery"], function(d) {
                function e(e, t, i) {
                    var n = i.get("tags")
                      , o = i.get("createTag");
                    void 0 !== o && (this.createTag = o);
                    var s = i.get("insertTag");
                    if (void 0 !== s && (this.insertTag = s),
                    e.call(this, t, i),
                    d.isArray(n))
                        for (var r = 0; r < n.length; r++) {
                            var a = n[r]
                              , l = this._normalizeItem(a)
                              , c = this.option(l);
                            this.$element.append(c)
                        }
                }
                return e.prototype.query = function(e, c, d) {
                    var u = this;
                    this._removeOldTags(),
                    null != c.term && null == c.page ? e.call(this, c, function e(t, i) {
                        for (var n = t.results, o = 0; o < n.length; o++) {
                            var s = n[o]
                              , r = null != s.children && !e({
                                results: s.children
                            }, !0);
                            if ((s.text || "").toUpperCase() === (c.term || "").toUpperCase() || r)
                                return !i && (t.data = n,
                                void d(t))
                        }
                        if (i)
                            return !0;
                        var a = u.createTag(c);
                        if (null != a) {
                            var l = u.option(a);
                            l.attr("data-select2-tag", !0),
                            u.addOptions([l]),
                            u.insertTag(n, a)
                        }
                        t.results = n,
                        d(t)
                    }) : e.call(this, c, d)
                }
                ,
                e.prototype.createTag = function(e, t) {
                    var i = d.trim(t.term);
                    return "" === i ? null : {
                        id: i,
                        text: i
                    }
                }
                ,
                e.prototype.insertTag = function(e, t, i) {
                    t.unshift(i)
                }
                ,
                e.prototype._removeOldTags = function(e) {
                    this.$element.find("option[data-select2-tag]").each(function() {
                        this.selected || d(this).remove()
                    })
                }
                ,
                e
            }),
            e.define("select2/data/tokenizer", ["jquery"], function(u) {
                function e(e, t, i) {
                    var n = i.get("tokenizer");
                    void 0 !== n && (this.tokenizer = n),
                    e.call(this, t, i)
                }
                return e.prototype.bind = function(e, t, i) {
                    e.call(this, t, i),
                    this.$search = t.dropdown.$search || t.selection.$search || i.find(".select2-search__field")
                }
                ,
                e.prototype.query = function(e, t, i) {
                    var o = this;
                    t.term = t.term || "";
                    var n = this.tokenizer(t, this.options, function(e) {
                        var t, i = o._normalizeItem(e);
                        if (!o.$element.find("option").filter(function() {
                            return u(this).val() === i.id
                        }).length) {
                            var n = o.option(i);
                            n.attr("data-select2-tag", !0),
                            o._removeOldTags(),
                            o.addOptions([n])
                        }
                        t = i,
                        o.trigger("select", {
                            data: t
                        })
                    });
                    n.term !== t.term && (this.$search.length && (this.$search.val(n.term),
                    this.$search.trigger("focus")),
                    t.term = n.term),
                    e.call(this, t, i)
                }
                ,
                e.prototype.tokenizer = function(e, t, i, n) {
                    for (var o = i.get("tokenSeparators") || [], s = t.term, r = 0, a = this.createTag || function(e) {
                        return {
                            id: e.term,
                            text: e.term
                        }
                    }
                    ; r < s.length; ) {
                        var l = s[r];
                        if (-1 !== u.inArray(l, o)) {
                            var c = s.substr(0, r)
                              , d = a(u.extend({}, t, {
                                term: c
                            }));
                            null != d ? (n(d),
                            s = s.substr(r + 1) || "",
                            r = 0) : r++
                        } else
                            r++
                    }
                    return {
                        term: s
                    }
                }
                ,
                e
            }),
            e.define("select2/data/minimumInputLength", [], function() {
                function e(e, t, i) {
                    this.minimumInputLength = i.get("minimumInputLength"),
                    e.call(this, t, i)
                }
                return e.prototype.query = function(e, t, i) {
                    t.term = t.term || "",
                    t.term.length < this.minimumInputLength ? this.trigger("results:message", {
                        message: "inputTooShort",
                        args: {
                            minimum: this.minimumInputLength,
                            input: t.term,
                            params: t
                        }
                    }) : e.call(this, t, i)
                }
                ,
                e
            }),
            e.define("select2/data/maximumInputLength", [], function() {
                function e(e, t, i) {
                    this.maximumInputLength = i.get("maximumInputLength"),
                    e.call(this, t, i)
                }
                return e.prototype.query = function(e, t, i) {
                    t.term = t.term || "",
                    0 < this.maximumInputLength && t.term.length > this.maximumInputLength ? this.trigger("results:message", {
                        message: "inputTooLong",
                        args: {
                            maximum: this.maximumInputLength,
                            input: t.term,
                            params: t
                        }
                    }) : e.call(this, t, i)
                }
                ,
                e
            }),
            e.define("select2/data/maximumSelectionLength", [], function() {
                function e(e, t, i) {
                    this.maximumSelectionLength = i.get("maximumSelectionLength"),
                    e.call(this, t, i)
                }
                return e.prototype.bind = function(e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                    t.on("select", function() {
                        n._checkIfMaximumSelected()
                    })
                }
                ,
                e.prototype.query = function(e, t, i) {
                    var n = this;
                    this._checkIfMaximumSelected(function() {
                        e.call(n, t, i)
                    })
                }
                ,
                e.prototype._checkIfMaximumSelected = function(e, i) {
                    var n = this;
                    this.current(function(e) {
                        var t = null != e ? e.length : 0;
                        0 < n.maximumSelectionLength && t >= n.maximumSelectionLength ? n.trigger("results:message", {
                            message: "maximumSelected",
                            args: {
                                maximum: n.maximumSelectionLength
                            }
                        }) : i && i()
                    })
                }
                ,
                e
            }),
            e.define("select2/dropdown", ["jquery", "./utils"], function(t, e) {
                function i(e, t) {
                    this.$element = e,
                    this.options = t,
                    i.__super__.constructor.call(this)
                }
                return e.Extend(i, e.Observable),
                i.prototype.render = function() {
                    var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');
                    return e.attr("dir", this.options.get("dir")),
                    this.$dropdown = e
                }
                ,
                i.prototype.bind = function() {}
                ,
                i.prototype.position = function(e, t) {}
                ,
                i.prototype.destroy = function() {
                    this.$dropdown.remove()
                }
                ,
                i
            }),
            e.define("select2/dropdown/search", ["jquery", "../utils"], function(s, e) {
                function t() {}
                return t.prototype.render = function(e) {
                    var t = e.call(this)
                      , i = s('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>');
                    return this.$searchContainer = i,
                    this.$search = i.find("input"),
                    t.prepend(i),
                    t
                }
                ,
                t.prototype.bind = function(e, t, i) {
                    var n = this
                      , o = t.id + "-results";
                    e.call(this, t, i),
                    this.$search.on("keydown", function(e) {
                        n.trigger("keypress", e),
                        n._keyUpPrevented = e.isDefaultPrevented()
                    }),
                    this.$search.on("input", function(e) {
                        s(this).off("keyup")
                    }),
                    this.$search.on("keyup input", function(e) {
                        n.handleSearch(e)
                    }),
                    t.on("open", function() {
                        n.$search.attr("tabindex", 0),
                        n.$search.attr("aria-controls", o),
                        n.$search.trigger("focus"),
                        window.setTimeout(function() {
                            n.$search.trigger("focus")
                        }, 0)
                    }),
                    t.on("close", function() {
                        n.$search.attr("tabindex", -1),
                        n.$search.removeAttr("aria-controls"),
                        n.$search.removeAttr("aria-activedescendant"),
                        n.$search.val(""),
                        n.$search.trigger("blur")
                    }),
                    t.on("focus", function() {
                        t.isOpen() || n.$search.trigger("focus")
                    }),
                    t.on("results:all", function(e) {
                        null != e.query.term && "" !== e.query.term || (n.showSearch(e) ? n.$searchContainer.removeClass("select2-search--hide") : n.$searchContainer.addClass("select2-search--hide"))
                    }),
                    t.on("results:focus", function(e) {
                        e.data._resultId ? n.$search.attr("aria-activedescendant", e.data._resultId) : n.$search.removeAttr("aria-activedescendant")
                    })
                }
                ,
                t.prototype.handleSearch = function(e) {
                    if (!this._keyUpPrevented) {
                        var t = this.$search.val();
                        this.trigger("query", {
                            term: t
                        })
                    }
                    this._keyUpPrevented = !1
                }
                ,
                t.prototype.showSearch = function(e, t) {
                    return !0
                }
                ,
                t
            }),
            e.define("select2/dropdown/hidePlaceholder", [], function() {
                function e(e, t, i, n) {
                    this.placeholder = this.normalizePlaceholder(i.get("placeholder")),
                    e.call(this, t, i, n)
                }
                return e.prototype.append = function(e, t) {
                    t.results = this.removePlaceholder(t.results),
                    e.call(this, t)
                }
                ,
                e.prototype.normalizePlaceholder = function(e, t) {
                    return "string" == typeof t && (t = {
                        id: "",
                        text: t
                    }),
                    t
                }
                ,
                e.prototype.removePlaceholder = function(e, t) {
                    for (var i = t.slice(0), n = t.length - 1; 0 <= n; n--) {
                        var o = t[n];
                        this.placeholder.id === o.id && i.splice(n, 1)
                    }
                    return i
                }
                ,
                e
            }),
            e.define("select2/dropdown/infiniteScroll", ["jquery"], function(i) {
                function e(e, t, i, n) {
                    this.lastParams = {},
                    e.call(this, t, i, n),
                    this.$loadingMore = this.createLoadingMore(),
                    this.loading = !1
                }
                return e.prototype.append = function(e, t) {
                    this.$loadingMore.remove(),
                    this.loading = !1,
                    e.call(this, t),
                    this.showLoadingMore(t) && (this.$results.append(this.$loadingMore),
                    this.loadMoreIfNeeded())
                }
                ,
                e.prototype.bind = function(e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                    t.on("query", function(e) {
                        n.lastParams = e,
                        n.loading = !0
                    }),
                    t.on("query:append", function(e) {
                        n.lastParams = e,
                        n.loading = !0
                    }),
                    this.$results.on("scroll", this.loadMoreIfNeeded.bind(this))
                }
                ,
                e.prototype.loadMoreIfNeeded = function() {
                    var e = i.contains(document.documentElement, this.$loadingMore[0]);
                    if (!this.loading && e) {
                        var t = this.$results.offset().top + this.$results.outerHeight(!1);
                        this.$loadingMore.offset().top + this.$loadingMore.outerHeight(!1) <= t + 50 && this.loadMore()
                    }
                }
                ,
                e.prototype.loadMore = function() {
                    this.loading = !0;
                    var e = i.extend({}, {
                        page: 1
                    }, this.lastParams);
                    e.page++,
                    this.trigger("query:append", e)
                }
                ,
                e.prototype.showLoadingMore = function(e, t) {
                    return t.pagination && t.pagination.more
                }
                ,
                e.prototype.createLoadingMore = function() {
                    var e = i('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>')
                      , t = this.options.get("translations").get("loadingMore");
                    return e.html(t(this.lastParams)),
                    e
                }
                ,
                e
            }),
            e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function(f, a) {
                function e(e, t, i) {
                    this.$dropdownParent = f(i.get("dropdownParent") || document.body),
                    e.call(this, t, i)
                }
                return e.prototype.bind = function(e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                    t.on("open", function() {
                        n._showDropdown(),
                        n._attachPositioningHandler(t),
                        n._bindContainerResultHandlers(t)
                    }),
                    t.on("close", function() {
                        n._hideDropdown(),
                        n._detachPositioningHandler(t)
                    }),
                    this.$dropdownContainer.on("mousedown", function(e) {
                        e.stopPropagation()
                    })
                }
                ,
                e.prototype.destroy = function(e) {
                    e.call(this),
                    this.$dropdownContainer.remove()
                }
                ,
                e.prototype.position = function(e, t, i) {
                    t.attr("class", i.attr("class")),
                    t.removeClass("select2"),
                    t.addClass("select2-container--open"),
                    t.css({
                        position: "absolute",
                        top: -999999
                    }),
                    this.$container = i
                }
                ,
                e.prototype.render = function(e) {
                    var t = f("<span></span>")
                      , i = e.call(this);
                    return t.append(i),
                    this.$dropdownContainer = t
                }
                ,
                e.prototype._hideDropdown = function(e) {
                    this.$dropdownContainer.detach()
                }
                ,
                e.prototype._bindContainerResultHandlers = function(e, t) {
                    if (!this._containerResultsHandlersBound) {
                        var i = this;
                        t.on("results:all", function() {
                            i._positionDropdown(),
                            i._resizeDropdown()
                        }),
                        t.on("results:append", function() {
                            i._positionDropdown(),
                            i._resizeDropdown()
                        }),
                        t.on("results:message", function() {
                            i._positionDropdown(),
                            i._resizeDropdown()
                        }),
                        t.on("select", function() {
                            i._positionDropdown(),
                            i._resizeDropdown()
                        }),
                        t.on("unselect", function() {
                            i._positionDropdown(),
                            i._resizeDropdown()
                        }),
                        this._containerResultsHandlersBound = !0
                    }
                }
                ,
                e.prototype._attachPositioningHandler = function(e, t) {
                    var i = this
                      , n = "scroll.select2." + t.id
                      , o = "resize.select2." + t.id
                      , s = "orientationchange.select2." + t.id
                      , r = this.$container.parents().filter(a.hasScroll);
                    r.each(function() {
                        a.StoreData(this, "select2-scroll-position", {
                            x: f(this).scrollLeft(),
                            y: f(this).scrollTop()
                        })
                    }),
                    r.on(n, function(e) {
                        var t = a.GetData(this, "select2-scroll-position");
                        f(this).scrollTop(t.y)
                    }),
                    f(window).on(n + " " + o + " " + s, function(e) {
                        i._positionDropdown(),
                        i._resizeDropdown()
                    })
                }
                ,
                e.prototype._detachPositioningHandler = function(e, t) {
                    var i = "scroll.select2." + t.id
                      , n = "resize.select2." + t.id
                      , o = "orientationchange.select2." + t.id;
                    this.$container.parents().filter(a.hasScroll).off(i),
                    f(window).off(i + " " + n + " " + o)
                }
                ,
                e.prototype._positionDropdown = function() {
                    var e = f(window)
                      , t = this.$dropdown.hasClass("select2-dropdown--above")
                      , i = this.$dropdown.hasClass("select2-dropdown--below")
                      , n = null
                      , o = this.$container.offset();
                    o.bottom = o.top + this.$container.outerHeight(!1);
                    var s = {
                        height: this.$container.outerHeight(!1)
                    };
                    s.top = o.top,
                    s.bottom = o.top + s.height;
                    var r = this.$dropdown.outerHeight(!1)
                      , a = e.scrollTop()
                      , l = e.scrollTop() + e.height()
                      , c = a < o.top - r
                      , d = l > o.bottom + r
                      , u = {
                        left: o.left,
                        top: s.bottom
                    }
                      , p = this.$dropdownParent;
                    "static" === p.css("position") && (p = p.offsetParent());
                    var h = {
                        top: 0,
                        left: 0
                    };
                    (f.contains(document.body, p[0]) || p[0].isConnected) && (h = p.offset()),
                    u.top -= h.top,
                    u.left -= h.left,
                    t || i || (n = "below"),
                    d || !c || t ? !c && d && t && (n = "below") : n = "above",
                    ("above" == n || t && "below" !== n) && (u.top = s.top - h.top - r),
                    null != n && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + n),
                    this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + n)),
                    this.$dropdownContainer.css(u)
                }
                ,
                e.prototype._resizeDropdown = function() {
                    var e = {
                        width: this.$container.outerWidth(!1) + "px"
                    };
                    this.options.get("dropdownAutoWidth") && (e.minWidth = e.width,
                    e.position = "relative",
                    e.width = "auto"),
                    this.$dropdown.css(e)
                }
                ,
                e.prototype._showDropdown = function(e) {
                    this.$dropdownContainer.appendTo(this.$dropdownParent),
                    this._positionDropdown(),
                    this._resizeDropdown()
                }
                ,
                e
            }),
            e.define("select2/dropdown/minimumResultsForSearch", [], function() {
                function e(e, t, i, n) {
                    this.minimumResultsForSearch = i.get("minimumResultsForSearch"),
                    this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0),
                    e.call(this, t, i, n)
                }
                return e.prototype.showSearch = function(e, t) {
                    return !(function e(t) {
                        for (var i = 0, n = 0; n < t.length; n++) {
                            var o = t[n];
                            o.children ? i += e(o.children) : i++
                        }
                        return i
                    }(t.data.results) < this.minimumResultsForSearch) && e.call(this, t)
                }
                ,
                e
            }),
            e.define("select2/dropdown/selectOnClose", ["../utils"], function(s) {
                function e() {}
                return e.prototype.bind = function(e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                    t.on("close", function(e) {
                        n._handleSelectOnClose(e)
                    })
                }
                ,
                e.prototype._handleSelectOnClose = function(e, t) {
                    if (t && null != t.originalSelect2Event) {
                        var i = t.originalSelect2Event;
                        if ("select" === i._type || "unselect" === i._type)
                            return
                    }
                    var n = this.getHighlightedResults();
                    if (!(n.length < 1)) {
                        var o = s.GetData(n[0], "data");
                        null != o.element && o.element.selected || null == o.element && o.selected || this.trigger("select", {
                            data: o
                        })
                    }
                }
                ,
                e
            }),
            e.define("select2/dropdown/closeOnSelect", [], function() {
                function e() {}
                return e.prototype.bind = function(e, t, i) {
                    var n = this;
                    e.call(this, t, i),
                    t.on("select", function(e) {
                        n._selectTriggered(e)
                    }),
                    t.on("unselect", function(e) {
                        n._selectTriggered(e)
                    })
                }
                ,
                e.prototype._selectTriggered = function(e, t) {
                    var i = t.originalEvent;
                    i && (i.ctrlKey || i.metaKey) || this.trigger("close", {
                        originalEvent: i,
                        originalSelect2Event: t
                    })
                }
                ,
                e
            }),
            e.define("select2/i18n/en", [], function() {
                return {
                    errorLoading: function() {
                        return "The results could not be loaded."
                    },
                    inputTooLong: function(e) {
                        var t = e.input.length - e.maximum
                          , i = "Please delete " + t + " character";
                        return 1 != t && (i += "s"),
                        i
                    },
                    inputTooShort: function(e) {
                        return "Please enter " + (e.minimum - e.input.length) + " or more characters"
                    },
                    loadingMore: function() {
                        return "Loading more results…"
                    },
                    maximumSelected: function(e) {
                        var t = "You can only select " + e.maximum + " item";
                        return 1 != e.maximum && (t += "s"),
                        t
                    },
                    noResults: function() {
                        return "No results found"
                    },
                    searching: function() {
                        return "Searching…"
                    },
                    removeAllItems: function() {
                        return "Remove all items"
                    }
                }
            }),
            e.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function(c, d, u, p, h, f, g, m, v, y, r, t, w, b, x, _, C, T, S, $, k, A, E, z, D, O, j, L, e) {
                function i() {
                    this.reset()
                }
                return i.prototype.apply = function(e) {
                    if (null == (e = c.extend(!0, {}, this.defaults, e)).dataAdapter) {
                        if (null != e.ajax ? e.dataAdapter = x : null != e.data ? e.dataAdapter = b : e.dataAdapter = w,
                        0 < e.minimumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, T)),
                        0 < e.maximumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, S)),
                        0 < e.maximumSelectionLength && (e.dataAdapter = y.Decorate(e.dataAdapter, $)),
                        e.tags && (e.dataAdapter = y.Decorate(e.dataAdapter, _)),
                        null == e.tokenSeparators && null == e.tokenizer || (e.dataAdapter = y.Decorate(e.dataAdapter, C)),
                        null != e.query) {
                            var t = d(e.amdBase + "compat/query");
                            e.dataAdapter = y.Decorate(e.dataAdapter, t)
                        }
                        if (null != e.initSelection) {
                            var i = d(e.amdBase + "compat/initSelection");
                            e.dataAdapter = y.Decorate(e.dataAdapter, i)
                        }
                    }
                    if (null == e.resultsAdapter && (e.resultsAdapter = u,
                    null != e.ajax && (e.resultsAdapter = y.Decorate(e.resultsAdapter, z)),
                    null != e.placeholder && (e.resultsAdapter = y.Decorate(e.resultsAdapter, E)),
                    e.selectOnClose && (e.resultsAdapter = y.Decorate(e.resultsAdapter, j))),
                    null == e.dropdownAdapter) {
                        if (e.multiple)
                            e.dropdownAdapter = k;
                        else {
                            var n = y.Decorate(k, A);
                            e.dropdownAdapter = n
                        }
                        if (0 !== e.minimumResultsForSearch && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, O)),
                        e.closeOnSelect && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, L)),
                        null != e.dropdownCssClass || null != e.dropdownCss || null != e.adaptDropdownCssClass) {
                            var o = d(e.amdBase + "compat/dropdownCss");
                            e.dropdownAdapter = y.Decorate(e.dropdownAdapter, o)
                        }
                        e.dropdownAdapter = y.Decorate(e.dropdownAdapter, D)
                    }
                    if (null == e.selectionAdapter) {
                        if (e.multiple ? e.selectionAdapter = h : e.selectionAdapter = p,
                        null != e.placeholder && (e.selectionAdapter = y.Decorate(e.selectionAdapter, f)),
                        e.allowClear && (e.selectionAdapter = y.Decorate(e.selectionAdapter, g)),
                        e.multiple && (e.selectionAdapter = y.Decorate(e.selectionAdapter, m)),
                        null != e.containerCssClass || null != e.containerCss || null != e.adaptContainerCssClass) {
                            var s = d(e.amdBase + "compat/containerCss");
                            e.selectionAdapter = y.Decorate(e.selectionAdapter, s)
                        }
                        e.selectionAdapter = y.Decorate(e.selectionAdapter, v)
                    }
                    e.language = this._resolveLanguage(e.language),
                    e.language.push("en");
                    for (var r = [], a = 0; a < e.language.length; a++) {
                        var l = e.language[a];
                        -1 === r.indexOf(l) && r.push(l)
                    }
                    return e.language = r,
                    e.translations = this._processTranslations(e.language, e.debug),
                    e
                }
                ,
                i.prototype.reset = function() {
                    function a(e) {
                        return e.replace(/[^\u0000-\u007E]/g, function(e) {
                            return t[e] || e
                        })
                    }
                    this.defaults = {
                        amdBase: "./",
                        amdLanguageBase: "./i18n/",
                        closeOnSelect: !0,
                        debug: !1,
                        dropdownAutoWidth: !1,
                        escapeMarkup: y.escapeMarkup,
                        language: {},
                        matcher: function e(t, i) {
                            if ("" === c.trim(t.term))
                                return i;
                            if (i.children && 0 < i.children.length) {
                                for (var n = c.extend(!0, {}, i), o = i.children.length - 1; 0 <= o; o--)
                                    null == e(t, i.children[o]) && n.children.splice(o, 1);
                                return 0 < n.children.length ? n : e(t, n)
                            }
                            var s = a(i.text).toUpperCase()
                              , r = a(t.term).toUpperCase();
                            return -1 < s.indexOf(r) ? i : null
                        },
                        minimumInputLength: 0,
                        maximumInputLength: 0,
                        maximumSelectionLength: 0,
                        minimumResultsForSearch: 0,
                        selectOnClose: !1,
                        scrollAfterSelect: !1,
                        sorter: function(e) {
                            return e
                        },
                        templateResult: function(e) {
                            return e.text
                        },
                        templateSelection: function(e) {
                            return e.text
                        },
                        theme: "default",
                        width: "resolve"
                    }
                }
                ,
                i.prototype.applyFromElement = function(e, t) {
                    var i = e.language
                      , n = this.defaults.language
                      , o = t.prop("lang")
                      , s = t.closest("[lang]").prop("lang")
                      , r = Array.prototype.concat.call(this._resolveLanguage(o), this._resolveLanguage(i), this._resolveLanguage(n), this._resolveLanguage(s));
                    return e.language = r,
                    e
                }
                ,
                i.prototype._resolveLanguage = function(e) {
                    if (!e)
                        return [];
                    if (c.isEmptyObject(e))
                        return [];
                    if (c.isPlainObject(e))
                        return [e];
                    var t;
                    t = c.isArray(e) ? e : [e];
                    for (var i = [], n = 0; n < t.length; n++)
                        if (i.push(t[n]),
                        "string" == typeof t[n] && 0 < t[n].indexOf("-")) {
                            var o = t[n].split("-")[0];
                            i.push(o)
                        }
                    return i
                }
                ,
                i.prototype._processTranslations = function(e, t) {
                    for (var i = new r, n = 0; n < e.length; n++) {
                        var o = new r
                          , s = e[n];
                        if ("string" == typeof s)
                            try {
                                o = r.loadPath(s)
                            } catch (e) {
                                try {
                                    s = this.defaults.amdLanguageBase + s,
                                    o = r.loadPath(s)
                                } catch (e) {
                                    t && window.console && console.warn && console.warn('Select2: The language file for "' + s + '" could not be automatically loaded. A fallback will be used instead.')
                                }
                            }
                        else
                            o = c.isPlainObject(s) ? new r(s) : s;
                        i.extend(o)
                    }
                    return i
                }
                ,
                i.prototype.set = function(e, t) {
                    var i = {};
                    i[c.camelCase(e)] = t;
                    var n = y._convertData(i);
                    c.extend(!0, this.defaults, n)
                }
                ,
                new i
            }),
            e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function(n, d, o, u) {
                function e(e, t) {
                    if (this.options = e,
                    null != t && this.fromElement(t),
                    null != t && (this.options = o.applyFromElement(this.options, t)),
                    this.options = o.apply(this.options),
                    t && t.is("input")) {
                        var i = n(this.get("amdBase") + "compat/inputData");
                        this.options.dataAdapter = u.Decorate(this.options.dataAdapter, i)
                    }
                }
                return e.prototype.fromElement = function(e) {
                    var t = ["select2"];
                    null == this.options.multiple && (this.options.multiple = e.prop("multiple")),
                    null == this.options.disabled && (this.options.disabled = e.prop("disabled")),
                    null == this.options.dir && (e.prop("dir") ? this.options.dir = e.prop("dir") : e.closest("[dir]").prop("dir") ? this.options.dir = e.closest("[dir]").prop("dir") : this.options.dir = "ltr"),
                    e.prop("disabled", this.options.disabled),
                    e.prop("multiple", this.options.multiple),
                    u.GetData(e[0], "select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'),
                    u.StoreData(e[0], "data", u.GetData(e[0], "select2Tags")),
                    u.StoreData(e[0], "tags", !0)),
                    u.GetData(e[0], "ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."),
                    e.attr("ajax--url", u.GetData(e[0], "ajaxUrl")),
                    u.StoreData(e[0], "ajax-Url", u.GetData(e[0], "ajaxUrl")));
                    var i = {};
                    function n(e, t) {
                        return t.toUpperCase()
                    }
                    for (var o = 0; o < e[0].attributes.length; o++) {
                        var s = e[0].attributes[o].name;
                        if ("data-" == s.substr(0, "data-".length)) {
                            var r = s.substring("data-".length)
                              , a = u.GetData(e[0], r);
                            i[r.replace(/-([a-z])/g, n)] = a
                        }
                    }
                    d.fn.jquery && "1." == d.fn.jquery.substr(0, 2) && e[0].dataset && (i = d.extend(!0, {}, e[0].dataset, i));
                    var l = d.extend(!0, {}, u.GetData(e[0]), i);
                    for (var c in l = u._convertData(l))
                        -1 < d.inArray(c, t) || (d.isPlainObject(this.options[c]) ? d.extend(this.options[c], l[c]) : this.options[c] = l[c]);
                    return this
                }
                ,
                e.prototype.get = function(e) {
                    return this.options[e]
                }
                ,
                e.prototype.set = function(e, t) {
                    this.options[e] = t
                }
                ,
                e
            }),
            e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function(o, c, d, n) {
                function u(e, t) {
                    null != d.GetData(e[0], "select2") && d.GetData(e[0], "select2").destroy(),
                    this.$element = e,
                    this.id = this._generateId(e),
                    t = t || {},
                    this.options = new c(t,e),
                    u.__super__.constructor.call(this);
                    var i = e.attr("tabindex") || 0;
                    d.StoreData(e[0], "old-tabindex", i),
                    e.attr("tabindex", "-1");
                    var n = this.options.get("dataAdapter");
                    this.dataAdapter = new n(e,this.options);
                    var o = this.render();
                    this._placeContainer(o);
                    var s = this.options.get("selectionAdapter");
                    this.selection = new s(e,this.options),
                    this.$selection = this.selection.render(),
                    this.selection.position(this.$selection, o);
                    var r = this.options.get("dropdownAdapter");
                    this.dropdown = new r(e,this.options),
                    this.$dropdown = this.dropdown.render(),
                    this.dropdown.position(this.$dropdown, o);
                    var a = this.options.get("resultsAdapter");
                    this.results = new a(e,this.options,this.dataAdapter),
                    this.$results = this.results.render(),
                    this.results.position(this.$results, this.$dropdown);
                    var l = this;
                    this._bindAdapters(),
                    this._registerDomEvents(),
                    this._registerDataEvents(),
                    this._registerSelectionEvents(),
                    this._registerDropdownEvents(),
                    this._registerResultsEvents(),
                    this._registerEvents(),
                    this.dataAdapter.current(function(e) {
                        l.trigger("selection:update", {
                            data: e
                        })
                    }),
                    e.addClass("select2-hidden-accessible"),
                    e.attr("aria-hidden", "true"),
                    this._syncAttributes(),
                    d.StoreData(e[0], "select2", this),
                    e.data("select2", this)
                }
                return d.Extend(u, d.Observable),
                u.prototype._generateId = function(e) {
                    return "select2-" + (null != e.attr("id") ? e.attr("id") : null != e.attr("name") ? e.attr("name") + "-" + d.generateChars(2) : d.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "")
                }
                ,
                u.prototype._placeContainer = function(e) {
                    e.insertAfter(this.$element);
                    var t = this._resolveWidth(this.$element, this.options.get("width"));
                    null != t && e.css("width", t)
                }
                ,
                u.prototype._resolveWidth = function(e, t) {
                    var i = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                    if ("resolve" == t) {
                        var n = this._resolveWidth(e, "style");
                        return null != n ? n : this._resolveWidth(e, "element")
                    }
                    if ("element" == t) {
                        var o = e.outerWidth(!1);
                        return o <= 0 ? "auto" : o + "px"
                    }
                    if ("style" != t)
                        return "computedstyle" != t ? t : window.getComputedStyle(e[0]).width;
                    var s = e.attr("style");
                    if ("string" != typeof s)
                        return null;
                    for (var r = s.split(";"), a = 0, l = r.length; a < l; a += 1) {
                        var c = r[a].replace(/\s/g, "").match(i);
                        if (null !== c && 1 <= c.length)
                            return c[1]
                    }
                    return null
                }
                ,
                u.prototype._bindAdapters = function() {
                    this.dataAdapter.bind(this, this.$container),
                    this.selection.bind(this, this.$container),
                    this.dropdown.bind(this, this.$container),
                    this.results.bind(this, this.$container)
                }
                ,
                u.prototype._registerDomEvents = function() {
                    var t = this;
                    this.$element.on("change.select2", function() {
                        t.dataAdapter.current(function(e) {
                            t.trigger("selection:update", {
                                data: e
                            })
                        })
                    }),
                    this.$element.on("focus.select2", function(e) {
                        t.trigger("focus", e)
                    }),
                    this._syncA = d.bind(this._syncAttributes, this),
                    this._syncS = d.bind(this._syncSubtree, this),
                    this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
                    var e = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                    null != e ? (this._observer = new e(function(e) {
                        o.each(e, t._syncA),
                        o.each(e, t._syncS)
                    }
                    ),
                    this._observer.observe(this.$element[0], {
                        attributes: !0,
                        childList: !0,
                        subtree: !1
                    })) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", t._syncA, !1),
                    this.$element[0].addEventListener("DOMNodeInserted", t._syncS, !1),
                    this.$element[0].addEventListener("DOMNodeRemoved", t._syncS, !1))
                }
                ,
                u.prototype._registerDataEvents = function() {
                    var i = this;
                    this.dataAdapter.on("*", function(e, t) {
                        i.trigger(e, t)
                    })
                }
                ,
                u.prototype._registerSelectionEvents = function() {
                    var i = this
                      , n = ["toggle", "focus"];
                    this.selection.on("toggle", function() {
                        i.toggleDropdown()
                    }),
                    this.selection.on("focus", function(e) {
                        i.focus(e)
                    }),
                    this.selection.on("*", function(e, t) {
                        -1 === o.inArray(e, n) && i.trigger(e, t)
                    })
                }
                ,
                u.prototype._registerDropdownEvents = function() {
                    var i = this;
                    this.dropdown.on("*", function(e, t) {
                        i.trigger(e, t)
                    })
                }
                ,
                u.prototype._registerResultsEvents = function() {
                    var i = this;
                    this.results.on("*", function(e, t) {
                        i.trigger(e, t)
                    })
                }
                ,
                u.prototype._registerEvents = function() {
                    var i = this;
                    this.on("open", function() {
                        i.$container.addClass("select2-container--open")
                    }),
                    this.on("close", function() {
                        i.$container.removeClass("select2-container--open")
                    }),
                    this.on("enable", function() {
                        i.$container.removeClass("select2-container--disabled")
                    }),
                    this.on("disable", function() {
                        i.$container.addClass("select2-container--disabled")
                    }),
                    this.on("blur", function() {
                        i.$container.removeClass("select2-container--focus")
                    }),
                    this.on("query", function(t) {
                        i.isOpen() || i.trigger("open", {}),
                        this.dataAdapter.query(t, function(e) {
                            i.trigger("results:all", {
                                data: e,
                                query: t
                            })
                        })
                    }),
                    this.on("query:append", function(t) {
                        this.dataAdapter.query(t, function(e) {
                            i.trigger("results:append", {
                                data: e,
                                query: t
                            })
                        })
                    }),
                    this.on("keypress", function(e) {
                        var t = e.which;
                        i.isOpen() ? t === n.ESC || t === n.TAB || t === n.UP && e.altKey ? (i.close(),
                        e.preventDefault()) : t === n.ENTER ? (i.trigger("results:select", {}),
                        e.preventDefault()) : t === n.SPACE && e.ctrlKey ? (i.trigger("results:toggle", {}),
                        e.preventDefault()) : t === n.UP ? (i.trigger("results:previous", {}),
                        e.preventDefault()) : t === n.DOWN && (i.trigger("results:next", {}),
                        e.preventDefault()) : (t === n.ENTER || t === n.SPACE || t === n.DOWN && e.altKey) && (i.open(),
                        e.preventDefault())
                    })
                }
                ,
                u.prototype._syncAttributes = function() {
                    this.options.set("disabled", this.$element.prop("disabled")),
                    this.options.get("disabled") ? (this.isOpen() && this.close(),
                    this.trigger("disable", {})) : this.trigger("enable", {})
                }
                ,
                u.prototype._syncSubtree = function(e, t) {
                    var i = !1
                      , n = this;
                    if (!e || !e.target || "OPTION" === e.target.nodeName || "OPTGROUP" === e.target.nodeName) {
                        if (t)
                            if (t.addedNodes && 0 < t.addedNodes.length)
                                for (var o = 0; o < t.addedNodes.length; o++)
                                    t.addedNodes[o].selected && (i = !0);
                            else
                                t.removedNodes && 0 < t.removedNodes.length && (i = !0);
                        else
                            i = !0;
                        i && this.dataAdapter.current(function(e) {
                            n.trigger("selection:update", {
                                data: e
                            })
                        })
                    }
                }
                ,
                u.prototype.trigger = function(e, t) {
                    var i = u.__super__.trigger
                      , n = {
                        open: "opening",
                        close: "closing",
                        select: "selecting",
                        unselect: "unselecting",
                        clear: "clearing"
                    };
                    if (void 0 === t && (t = {}),
                    e in n) {
                        var o = n[e]
                          , s = {
                            prevented: !1,
                            name: e,
                            args: t
                        };
                        if (i.call(this, o, s),
                        s.prevented)
                            return void (t.prevented = !0)
                    }
                    i.call(this, e, t)
                }
                ,
                u.prototype.toggleDropdown = function() {
                    this.options.get("disabled") || (this.isOpen() ? this.close() : this.open())
                }
                ,
                u.prototype.open = function() {
                    this.isOpen() || this.trigger("query", {})
                }
                ,
                u.prototype.close = function() {
                    this.isOpen() && this.trigger("close", {})
                }
                ,
                u.prototype.isOpen = function() {
                    return this.$container.hasClass("select2-container--open")
                }
                ,
                u.prototype.hasFocus = function() {
                    return this.$container.hasClass("select2-container--focus")
                }
                ,
                u.prototype.focus = function(e) {
                    this.hasFocus() || (this.$container.addClass("select2-container--focus"),
                    this.trigger("focus", {}))
                }
                ,
                u.prototype.enable = function(e) {
                    this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'),
                    null != e && 0 !== e.length || (e = [!0]);
                    var t = !e[0];
                    this.$element.prop("disabled", t)
                }
                ,
                u.prototype.data = function() {
                    this.options.get("debug") && 0 < arguments.length && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
                    var t = [];
                    return this.dataAdapter.current(function(e) {
                        t = e
                    }),
                    t
                }
                ,
                u.prototype.val = function(e) {
                    if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'),
                    null == e || 0 === e.length)
                        return this.$element.val();
                    var t = e[0];
                    o.isArray(t) && (t = o.map(t, function(e) {
                        return e.toString()
                    })),
                    this.$element.val(t).trigger("change")
                }
                ,
                u.prototype.destroy = function() {
                    this.$container.remove(),
                    this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA),
                    null != this._observer ? (this._observer.disconnect(),
                    this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1),
                    this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1),
                    this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)),
                    this._syncA = null,
                    this._syncS = null,
                    this.$element.off(".select2"),
                    this.$element.attr("tabindex", d.GetData(this.$element[0], "old-tabindex")),
                    this.$element.removeClass("select2-hidden-accessible"),
                    this.$element.attr("aria-hidden", "false"),
                    d.RemoveData(this.$element[0]),
                    this.$element.removeData("select2"),
                    this.dataAdapter.destroy(),
                    this.selection.destroy(),
                    this.dropdown.destroy(),
                    this.results.destroy(),
                    this.dataAdapter = null,
                    this.selection = null,
                    this.dropdown = null,
                    this.results = null
                }
                ,
                u.prototype.render = function() {
                    var e = o('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
                    return e.attr("dir", this.options.get("dir")),
                    this.$container = e,
                    this.$container.addClass("select2-container--" + this.options.get("theme")),
                    d.StoreData(e[0], "element", this.$element),
                    e
                }
                ,
                u
            }),
            e.define("select2/compat/utils", ["jquery"], function(r) {
                return {
                    syncCssClasses: function(e, t, i) {
                        var n, o, s = [];
                        (n = r.trim(e.attr("class"))) && r((n = "" + n).split(/\s+/)).each(function() {
                            0 === this.indexOf("select2-") && s.push(this)
                        }),
                        (n = r.trim(t.attr("class"))) && r((n = "" + n).split(/\s+/)).each(function() {
                            0 !== this.indexOf("select2-") && null != (o = i(this)) && s.push(o)
                        }),
                        e.attr("class", s.join(" "))
                    }
                }
            }),
            e.define("select2/compat/containerCss", ["jquery", "./utils"], function(r, a) {
                function l(e) {
                    return null
                }
                function e() {}
                return e.prototype.render = function(e) {
                    var t = e.call(this)
                      , i = this.options.get("containerCssClass") || "";
                    r.isFunction(i) && (i = i(this.$element));
                    var n = this.options.get("adaptContainerCssClass");
                    if (n = n || l,
                    -1 !== i.indexOf(":all:")) {
                        i = i.replace(":all:", "");
                        var o = n;
                        n = function(e) {
                            var t = o(e);
                            return null != t ? t + " " + e : e
                        }
                    }
                    var s = this.options.get("containerCss") || {};
                    return r.isFunction(s) && (s = s(this.$element)),
                    a.syncCssClasses(t, this.$element, n),
                    t.css(s),
                    t.addClass(i),
                    t
                }
                ,
                e
            }),
            e.define("select2/compat/dropdownCss", ["jquery", "./utils"], function(r, a) {
                function l(e) {
                    return null
                }
                function e() {}
                return e.prototype.render = function(e) {
                    var t = e.call(this)
                      , i = this.options.get("dropdownCssClass") || "";
                    r.isFunction(i) && (i = i(this.$element));
                    var n = this.options.get("adaptDropdownCssClass");
                    if (n = n || l,
                    -1 !== i.indexOf(":all:")) {
                        i = i.replace(":all:", "");
                        var o = n;
                        n = function(e) {
                            var t = o(e);
                            return null != t ? t + " " + e : e
                        }
                    }
                    var s = this.options.get("dropdownCss") || {};
                    return r.isFunction(s) && (s = s(this.$element)),
                    a.syncCssClasses(t, this.$element, n),
                    t.css(s),
                    t.addClass(i),
                    t
                }
                ,
                e
            }),
            e.define("select2/compat/initSelection", ["jquery"], function(n) {
                function e(e, t, i) {
                    i.get("debug") && window.console && console.warn && console.warn("Select2: The `initSelection` option has been deprecated in favor of a custom data adapter that overrides the `current` method. This method is now called multiple times instead of a single time when the instance is initialized. Support will be removed for the `initSelection` option in future versions of Select2"),
                    this.initSelection = i.get("initSelection"),
                    this._isInitialized = !1,
                    e.call(this, t, i)
                }
                return e.prototype.current = function(e, t) {
                    var i = this;
                    this._isInitialized ? e.call(this, t) : this.initSelection.call(null, this.$element, function(e) {
                        i._isInitialized = !0,
                        n.isArray(e) || (e = [e]),
                        t(e)
                    })
                }
                ,
                e
            }),
            e.define("select2/compat/inputData", ["jquery", "../utils"], function(r, n) {
                function e(e, t, i) {
                    this._currentData = [],
                    this._valueSeparator = i.get("valueSeparator") || ",",
                    "hidden" === t.prop("type") && i.get("debug") && console && console.warn && console.warn("Select2: Using a hidden input with Select2 is no longer supported and may stop working in the future. It is recommended to use a `<select>` element instead."),
                    e.call(this, t, i)
                }
                return e.prototype.current = function(e, t) {
                    function n(e, t) {
                        var i = [];
                        return e.selected || -1 !== r.inArray(e.id, t) ? (e.selected = !0,
                        i.push(e)) : e.selected = !1,
                        e.children && i.push.apply(i, n(e.children, t)),
                        i
                    }
                    for (var i = [], o = 0; o < this._currentData.length; o++) {
                        var s = this._currentData[o];
                        i.push.apply(i, n(s, this.$element.val().split(this._valueSeparator)))
                    }
                    t(i)
                }
                ,
                e.prototype.select = function(e, t) {
                    if (this.options.get("multiple")) {
                        var i = this.$element.val();
                        i += this._valueSeparator + t.id,
                        this.$element.val(i),
                        this.$element.trigger("change")
                    } else
                        this.current(function(e) {
                            r.map(e, function(e) {
                                e.selected = !1
                            })
                        }),
                        this.$element.val(t.id),
                        this.$element.trigger("change")
                }
                ,
                e.prototype.unselect = function(e, o) {
                    var s = this;
                    o.selected = !1,
                    this.current(function(e) {
                        for (var t = [], i = 0; i < e.length; i++) {
                            var n = e[i];
                            o.id != n.id && t.push(n.id)
                        }
                        s.$element.val(t.join(s._valueSeparator)),
                        s.$element.trigger("change")
                    })
                }
                ,
                e.prototype.query = function(e, t, i) {
                    for (var n = [], o = 0; o < this._currentData.length; o++) {
                        var s = this._currentData[o]
                          , r = this.matches(t, s);
                        null !== r && n.push(r)
                    }
                    i({
                        results: n
                    })
                }
                ,
                e.prototype.addOptions = function(e, t) {
                    var i = r.map(t, function(e) {
                        return n.GetData(e[0], "data")
                    });
                    this._currentData.push.apply(this._currentData, i)
                }
                ,
                e
            }),
            e.define("select2/compat/matcher", ["jquery"], function(r) {
                return function(s) {
                    return function(e, t) {
                        var i = r.extend(!0, {}, t);
                        if (null == e.term || "" === r.trim(e.term))
                            return i;
                        if (t.children) {
                            for (var n = t.children.length - 1; 0 <= n; n--) {
                                var o = t.children[n];
                                s(e.term, o.text, o) || i.children.splice(n, 1)
                            }
                            if (0 < i.children.length)
                                return i
                        }
                        return s(e.term, t.text, t) ? i : null
                    }
                }
            }),
            e.define("select2/compat/query", [], function() {
                function e(e, t, i) {
                    i.get("debug") && window.console && console.warn && console.warn("Select2: The `query` option has been deprecated in favor of a custom data adapter that overrides the `query` method. Support will be removed for the `query` option in future versions of Select2."),
                    e.call(this, t, i)
                }
                return e.prototype.query = function(e, t, i) {
                    t.callback = i,
                    this.options.get("query").call(null, t)
                }
                ,
                e
            }),
            e.define("select2/dropdown/attachContainer", [], function() {
                function e(e, t, i) {
                    e.call(this, t, i)
                }
                return e.prototype.position = function(e, t, i) {
                    i.find(".dropdown-wrapper").append(t),
                    t.addClass("select2-dropdown--below"),
                    i.addClass("select2-container--below")
                }
                ,
                e
            }),
            e.define("select2/dropdown/stopPropagation", [], function() {
                function e() {}
                return e.prototype.bind = function(e, t, i) {
                    e.call(this, t, i),
                    this.$dropdown.on(["blur", "change", "click", "dblclick", "focus", "focusin", "focusout", "input", "keydown", "keyup", "keypress", "mousedown", "mouseenter", "mouseleave", "mousemove", "mouseover", "mouseup", "search", "touchend", "touchstart"].join(" "), function(e) {
                        e.stopPropagation()
                    })
                }
                ,
                e
            }),
            e.define("select2/selection/stopPropagation", [], function() {
                function e() {}
                return e.prototype.bind = function(e, t, i) {
                    e.call(this, t, i),
                    this.$selection.on(["blur", "change", "click", "dblclick", "focus", "focusin", "focusout", "input", "keydown", "keyup", "keypress", "mousedown", "mouseenter", "mouseleave", "mousemove", "mouseover", "mouseup", "search", "touchend", "touchstart"].join(" "), function(e) {
                        e.stopPropagation()
                    })
                }
                ,
                e
            }),
            l = function(p) {
                var h, f, e = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"], t = "onwheel"in document || 9 <= document.documentMode ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"], g = Array.prototype.slice;
                if (p.event.fixHooks)
                    for (var i = e.length; i; )
                        p.event.fixHooks[e[--i]] = p.event.mouseHooks;
                var m = p.event.special.mousewheel = {
                    version: "3.1.12",
                    setup: function() {
                        if (this.addEventListener)
                            for (var e = t.length; e; )
                                this.addEventListener(t[--e], n, !1);
                        else
                            this.onmousewheel = n;
                        p.data(this, "mousewheel-line-height", m.getLineHeight(this)),
                        p.data(this, "mousewheel-page-height", m.getPageHeight(this))
                    },
                    teardown: function() {
                        if (this.removeEventListener)
                            for (var e = t.length; e; )
                                this.removeEventListener(t[--e], n, !1);
                        else
                            this.onmousewheel = null;
                        p.removeData(this, "mousewheel-line-height"),
                        p.removeData(this, "mousewheel-page-height")
                    },
                    getLineHeight: function(e) {
                        var t = p(e)
                          , i = t["offsetParent"in p.fn ? "offsetParent" : "parent"]();
                        return i.length || (i = p("body")),
                        parseInt(i.css("fontSize"), 10) || parseInt(t.css("fontSize"), 10) || 16
                    },
                    getPageHeight: function(e) {
                        return p(e).height()
                    },
                    settings: {
                        adjustOldDeltas: !0,
                        normalizeOffset: !0
                    }
                };
                function n(e) {
                    var t, i = e || window.event, n = g.call(arguments, 1), o = 0, s = 0, r = 0, a = 0, l = 0;
                    if ((e = p.event.fix(i)).type = "mousewheel",
                    "detail"in i && (r = -1 * i.detail),
                    "wheelDelta"in i && (r = i.wheelDelta),
                    "wheelDeltaY"in i && (r = i.wheelDeltaY),
                    "wheelDeltaX"in i && (s = -1 * i.wheelDeltaX),
                    "axis"in i && i.axis === i.HORIZONTAL_AXIS && (s = -1 * r,
                    r = 0),
                    o = 0 === r ? s : r,
                    "deltaY"in i && (o = r = -1 * i.deltaY),
                    "deltaX"in i && (s = i.deltaX,
                    0 === r && (o = -1 * s)),
                    0 !== r || 0 !== s) {
                        if (1 === i.deltaMode) {
                            var c = p.data(this, "mousewheel-line-height");
                            o *= c,
                            r *= c,
                            s *= c
                        } else if (2 === i.deltaMode) {
                            var d = p.data(this, "mousewheel-page-height");
                            o *= d,
                            r *= d,
                            s *= d
                        }
                        if (t = Math.max(Math.abs(r), Math.abs(s)),
                        (!f || t < f) && y(i, f = t) && (f /= 40),
                        y(i, t) && (o /= 40,
                        s /= 40,
                        r /= 40),
                        o = Math[1 <= o ? "floor" : "ceil"](o / f),
                        s = Math[1 <= s ? "floor" : "ceil"](s / f),
                        r = Math[1 <= r ? "floor" : "ceil"](r / f),
                        m.settings.normalizeOffset && this.getBoundingClientRect) {
                            var u = this.getBoundingClientRect();
                            a = e.clientX - u.left,
                            l = e.clientY - u.top
                        }
                        return e.deltaX = s,
                        e.deltaY = r,
                        e.deltaFactor = f,
                        e.offsetX = a,
                        e.offsetY = l,
                        e.deltaMode = 0,
                        n.unshift(e, o, s, r),
                        h && clearTimeout(h),
                        h = setTimeout(v, 200),
                        (p.event.dispatch || p.event.handle).apply(this, n)
                    }
                }
                function v() {
                    f = null
                }
                function y(e, t) {
                    return m.settings.adjustOldDeltas && "mousewheel" === e.type && t % 120 == 0
                }
                p.fn.extend({
                    mousewheel: function(e) {
                        return e ? this.bind("mousewheel", e) : this.trigger("mousewheel")
                    },
                    unmousewheel: function(e) {
                        return this.unbind("mousewheel", e)
                    }
                })
            }
            ,
            "function" == typeof e.define && e.define.amd ? e.define("jquery-mousewheel", ["jquery"], l) : "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? module.exports = l : l(u),
            e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults", "./select2/utils"], function(o, e, s, t, r) {
                if (null == o.fn.select2) {
                    var a = ["open", "close", "destroy"];
                    o.fn.select2 = function(t) {
                        if ("object" == _typeof(t = t || {}))
                            return this.each(function() {
                                var e = o.extend(!0, {}, t);
                                new s(o(this),e)
                            }),
                            this;
                        if ("string" != typeof t)
                            throw new Error("Invalid arguments for Select2: " + t);
                        var i, n = Array.prototype.slice.call(arguments, 1);
                        return this.each(function() {
                            var e = r.GetData(this, "select2");
                            null == e && window.console && console.error && console.error("The select2('" + t + "') method was called on an element that is not using Select2."),
                            i = e[t].apply(e, n)
                        }),
                        -1 < o.inArray(t, a) ? this : i
                    }
                }
                return null == o.fn.select2.defaults && (o.fn.select2.defaults = t),
                s
            }),
            {
                define: e.define,
                require: e.require
            }
        }()
          , t = e.require("jquery.select2");
        return u.fn.select2.amd = e,
        t
    }
    ,
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? module.exports = function(e, t) {
        return void 0 === t && (t = "undefined" != typeof window ? require("jquery") : require("jquery")(e)),
        ye(t),
        t
    }
    : ye(jQuery),
    qe = window.Zepto || window.jQuery,
    He = window,
    Re = document,
    ft.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        checkVisibility: !0,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: He,
        fallbackEasing: "swing",
        slideTransition: "",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        refreshClass: "owl-refresh",
        loadedClass: "owl-loaded",
        loadingClass: "owl-loading",
        rtlClass: "owl-rtl",
        responsiveClass: "owl-responsive",
        dragClass: "owl-drag",
        itemClass: "owl-item",
        stageClass: "owl-stage",
        stageOuterClass: "owl-stage-outer",
        grabClass: "owl-grab"
    },
    ft.Width = {
        Default: "default",
        Inner: "inner",
        Outer: "outer"
    },
    ft.Type = {
        Event: "event",
        State: "state"
    },
    ft.Plugins = {},
    ft.Workers = [{
        filter: ["width", "settings"],
        run: function() {
            this._width = this.$element.width()
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            e.current = this._items && this._items[this.relative(this._current)]
        }
    }, {
        filter: ["items", "settings"],
        run: function() {
            this.$stage.children(".cloned").remove()
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            var t = this.settings.margin || ""
              , i = !this.settings.autoWidth
              , n = this.settings.rtl
              , o = {
                width: "auto",
                "margin-left": n ? t : "",
                "margin-right": n ? "" : t
            };
            i || this.$stage.children().css(o),
            e.css = o
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            var t = (this.width() / this.settings.items).toFixed(3) - this.settings.margin
              , i = null
              , n = this._items.length
              , o = !this.settings.autoWidth
              , s = [];
            for (e.items = {
                merge: !1,
                width: t
            }; n--; )
                i = this._mergers[n],
                i = this.settings.mergeFit && Math.min(i, this.settings.items) || i,
                e.items.merge = 1 < i || e.items.merge,
                s[n] = o ? t * i : this._items[n].width();
            this._widths = s
        }
    }, {
        filter: ["items", "settings"],
        run: function() {
            var e = []
              , t = this._items
              , i = this.settings
              , n = Math.max(2 * i.items, 4)
              , o = 2 * Math.ceil(t.length / 2)
              , s = i.loop && t.length ? i.rewind ? n : Math.max(n, o) : 0
              , r = ""
              , a = "";
            for (s /= 2; 0 < s; )
                e.push(this.normalize(e.length / 2, !0)),
                r += t[e[e.length - 1]][0].outerHTML,
                e.push(this.normalize(t.length - 1 - (e.length - 1) / 2, !0)),
                a = t[e[e.length - 1]][0].outerHTML + a,
                --s;
            this._clones = e,
            qe(r).addClass("cloned").appendTo(this.$stage),
            qe(a).addClass("cloned").prependTo(this.$stage)
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function() {
            for (var e = this.settings.rtl ? 1 : -1, t = this._clones.length + this._items.length, i = -1, n = 0, o = 0, s = []; ++i < t; )
                n = s[i - 1] || 0,
                o = this._widths[this.relative(i)] + this.settings.margin,
                s.push(n + o * e);
            this._coordinates = s
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function() {
            var e = this.settings.stagePadding
              , t = this._coordinates
              , i = {
                width: Math.ceil(Math.abs(t[t.length - 1])) + 2 * e,
                "padding-left": e || "",
                "padding-right": e || ""
            };
            this.$stage.css(i)
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            var t = this._coordinates.length
              , i = !this.settings.autoWidth
              , n = this.$stage.children();
            if (i && e.items.merge)
                for (; t--; )
                    e.css.width = this._widths[this.relative(t)],
                    n.eq(t).css(e.css);
            else
                i && (e.css.width = e.items.width,
                n.css(e.css))
        }
    }, {
        filter: ["items"],
        run: function() {
            this._coordinates.length < 1 && this.$stage.removeAttr("style")
        }
    }, {
        filter: ["width", "items", "settings"],
        run: function(e) {
            e.current = e.current ? this.$stage.children().index(e.current) : 0,
            e.current = Math.max(this.minimum(), Math.min(this.maximum(), e.current)),
            this.reset(e.current)
        }
    }, {
        filter: ["position"],
        run: function() {
            this.animate(this.coordinates(this._current))
        }
    }, {
        filter: ["width", "position", "items", "settings"],
        run: function() {
            var e, t, i, n, o = this.settings.rtl ? 1 : -1, s = 2 * this.settings.stagePadding, r = this.coordinates(this.current()) + s, a = r + this.width() * o, l = [];
            for (i = 0,
            n = this._coordinates.length; i < n; i++)
                e = this._coordinates[i - 1] || 0,
                t = Math.abs(this._coordinates[i]) + s * o,
                (this.op(e, "<=", r) && this.op(e, ">", a) || this.op(t, "<", r) && this.op(t, ">", a)) && l.push(i);
            this.$stage.children(".active").removeClass("active"),
            this.$stage.children(":eq(" + l.join("), :eq(") + ")").addClass("active"),
            this.$stage.children(".center").removeClass("center"),
            this.settings.center && this.$stage.children().eq(this.current()).addClass("center")
        }
    }],
    ft.prototype.initializeStage = function() {
        this.$stage = this.$element.find("." + this.settings.stageClass),
        this.$stage.length || (this.$element.addClass(this.options.loadingClass),
        this.$stage = qe("<" + this.settings.stageElement + ">", {
            class: this.settings.stageClass
        }).wrap(qe("<div/>", {
            class: this.settings.stageOuterClass
        })),
        this.$element.append(this.$stage.parent()))
    }
    ,
    ft.prototype.initializeItems = function() {
        var e = this.$element.find(".owl-item");
        if (e.length)
            return this._items = e.get().map(function(e) {
                return qe(e)
            }),
            this._mergers = this._items.map(function() {
                return 1
            }),
            void this.refresh();
        this.replace(this.$element.children().not(this.$stage.parent())),
        this.isVisible() ? this.refresh() : this.invalidate("width"),
        this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)
    }
    ,
    ft.prototype.initialize = function() {
        var e, t, i;
        this.enter("initializing"),
        this.trigger("initialize"),
        this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
        this.settings.autoWidth && !this.is("pre-loading") && (e = this.$element.find("img"),
        t = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : We,
        i = this.$element.children(t).width(),
        e.length && i <= 0 && this.preloadAutoWidthImages(e));
        this.initializeStage(),
        this.initializeItems(),
        this.registerEventHandlers(),
        this.leave("initializing"),
        this.trigger("initialized")
    }
    ,
    ft.prototype.isVisible = function() {
        return !this.settings.checkVisibility || this.$element.is(":visible")
    }
    ,
    ft.prototype.setup = function() {
        var t = this.viewport()
          , e = this.options.responsive
          , i = -1
          , n = null;
        e ? (qe.each(e, function(e) {
            e <= t && i < e && (i = Number(e))
        }),
        "function" == typeof (n = qe.extend({}, this.options, e[i])).stagePadding && (n.stagePadding = n.stagePadding()),
        delete n.responsive,
        n.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s","g"), "$1" + i))) : n = qe.extend({}, this.options),
        this.trigger("change", {
            property: {
                name: "settings",
                value: n
            }
        }),
        this._breakpoint = i,
        this.settings = n,
        this.invalidate("settings"),
        this.trigger("changed", {
            property: {
                name: "settings",
                value: this.settings
            }
        })
    }
    ,
    ft.prototype.optionsLogic = function() {
        this.settings.autoWidth && (this.settings.stagePadding = !1,
        this.settings.merge = !1)
    }
    ,
    ft.prototype.prepare = function(e) {
        var t = this.trigger("prepare", {
            content: e
        });
        return t.data || (t.data = qe("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(e)),
        this.trigger("prepared", {
            content: t.data
        }),
        t.data
    }
    ,
    ft.prototype.update = function() {
        for (var e = 0, t = this._pipe.length, i = qe.proxy(function(e) {
            return this[e]
        }, this._invalidated), n = {}; e < t; )
            (this._invalidated.all || 0 < qe.grep(this._pipe[e].filter, i).length) && this._pipe[e].run(n),
            e++;
        this._invalidated = {},
        this.is("valid") || this.enter("valid")
    }
    ,
    ft.prototype.width = function(e) {
        switch (e = e || ft.Width.Default) {
        case ft.Width.Inner:
        case ft.Width.Outer:
            return this._width;
        default:
            return this._width - 2 * this.settings.stagePadding + this.settings.margin
        }
    }
    ,
    ft.prototype.refresh = function() {
        this.enter("refreshing"),
        this.trigger("refresh"),
        this.setup(),
        this.optionsLogic(),
        this.$element.addClass(this.options.refreshClass),
        this.update(),
        this.$element.removeClass(this.options.refreshClass),
        this.leave("refreshing"),
        this.trigger("refreshed")
    }
    ,
    ft.prototype.onThrottledResize = function() {
        He.clearTimeout(this.resizeTimer),
        this.resizeTimer = He.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
    }
    ,
    ft.prototype.onResize = function() {
        return !!this._items.length && this._width !== this.$element.width() && !!this.isVisible() && (this.enter("resizing"),
        this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"),
        !1) : (this.invalidate("width"),
        this.refresh(),
        this.leave("resizing"),
        void this.trigger("resized")))
    }
    ,
    ft.prototype.registerEventHandlers = function() {
        qe.support.transition && this.$stage.on(qe.support.transition.end + ".owl.core", qe.proxy(this.onTransitionEnd, this)),
        !1 !== this.settings.responsive && this.on(He, "resize", this._handlers.onThrottledResize),
        this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass),
        this.$stage.on("mousedown.owl.core", qe.proxy(this.onDragStart, this)),
        this.$stage.on("dragstart.owl.core selectstart.owl.core", function() {
            return !1
        })),
        this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", qe.proxy(this.onDragStart, this)),
        this.$stage.on("touchcancel.owl.core", qe.proxy(this.onDragEnd, this)))
    }
    ,
    ft.prototype.onDragStart = function(e) {
        var t = null;
        3 !== e.which && (t = qe.support.transform ? {
            x: (t = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","))[16 === t.length ? 12 : 4],
            y: t[16 === t.length ? 13 : 5]
        } : (t = this.$stage.position(),
        {
            x: this.settings.rtl ? t.left + this.$stage.width() - this.width() + this.settings.margin : t.left,
            y: t.top
        }),
        this.is("animating") && (qe.support.transform ? this.animate(t.x) : this.$stage.stop(),
        this.invalidate("position")),
        this.$element.toggleClass(this.options.grabClass, "mousedown" === e.type),
        this.speed(0),
        this._drag.time = (new Date).getTime(),
        this._drag.target = qe(e.target),
        this._drag.stage.start = t,
        this._drag.stage.current = t,
        this._drag.pointer = this.pointer(e),
        qe(Re).on("mouseup.owl.core touchend.owl.core", qe.proxy(this.onDragEnd, this)),
        qe(Re).one("mousemove.owl.core touchmove.owl.core", qe.proxy(function(e) {
            var t = this.difference(this._drag.pointer, this.pointer(e));
            qe(Re).on("mousemove.owl.core touchmove.owl.core", qe.proxy(this.onDragMove, this)),
            Math.abs(t.x) < Math.abs(t.y) && this.is("valid") || (e.preventDefault(),
            this.enter("dragging"),
            this.trigger("drag"))
        }, this)))
    }
    ,
    ft.prototype.onDragMove = function(e) {
        var t = null
          , i = null
          , n = null
          , o = this.difference(this._drag.pointer, this.pointer(e))
          , s = this.difference(this._drag.stage.start, o);
        this.is("dragging") && (e.preventDefault(),
        this.settings.loop ? (t = this.coordinates(this.minimum()),
        i = this.coordinates(this.maximum() + 1) - t,
        s.x = ((s.x - t) % i + i) % i + t) : (t = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()),
        i = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()),
        n = this.settings.pullDrag ? -1 * o.x / 5 : 0,
        s.x = Math.max(Math.min(s.x, t + n), i + n)),
        this._drag.stage.current = s,
        this.animate(s.x))
    }
    ,
    ft.prototype.onDragEnd = function(e) {
        var t = this.difference(this._drag.pointer, this.pointer(e))
          , i = this._drag.stage.current
          , n = 0 < t.x ^ this.settings.rtl ? "left" : "right";
        qe(Re).off(".owl.core"),
        this.$element.removeClass(this.options.grabClass),
        (0 !== t.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
        this.current(this.closest(i.x, 0 !== t.x ? n : this._drag.direction)),
        this.invalidate("position"),
        this.update(),
        this._drag.direction = n,
        (3 < Math.abs(t.x) || 300 < (new Date).getTime() - this._drag.time) && this._drag.target.one("click.owl.core", function() {
            return !1
        })),
        this.is("dragging") && (this.leave("dragging"),
        this.trigger("dragged"))
    }
    ,
    ft.prototype.closest = function(i, n) {
        var o = -1
          , s = this.width()
          , r = this.coordinates();
        return this.settings.freeDrag || qe.each(r, qe.proxy(function(e, t) {
            return "left" === n && t - 30 < i && i < t + 30 ? o = e : "right" === n && t - s - 30 < i && i < t - s + 30 ? o = e + 1 : this.op(i, "<", t) && this.op(i, ">", r[e + 1] !== We ? r[e + 1] : t - s) && (o = "left" === n ? e + 1 : e),
            -1 === o
        }, this)),
        this.settings.loop || (this.op(i, ">", r[this.minimum()]) ? o = i = this.minimum() : this.op(i, "<", r[this.maximum()]) && (o = i = this.maximum())),
        o
    }
    ,
    ft.prototype.animate = function(e) {
        var t = 0 < this.speed();
        this.is("animating") && this.onTransitionEnd(),
        t && (this.enter("animating"),
        this.trigger("translate")),
        qe.support.transform3d && qe.support.transition ? this.$stage.css({
            transform: "translate3d(" + e + "px,0px,0px)",
            transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "")
        }) : t ? this.$stage.animate({
            left: e + "px"
        }, this.speed(), this.settings.fallbackEasing, qe.proxy(this.onTransitionEnd, this)) : this.$stage.css({
            left: e + "px"
        })
    }
    ,
    ft.prototype.is = function(e) {
        return this._states.current[e] && 0 < this._states.current[e]
    }
    ,
    ft.prototype.current = function(e) {
        if (e === We)
            return this._current;
        if (0 === this._items.length)
            return We;
        if (e = this.normalize(e),
        this._current !== e) {
            var t = this.trigger("change", {
                property: {
                    name: "position",
                    value: e
                }
            });
            t.data !== We && (e = this.normalize(t.data)),
            this._current = e,
            this.invalidate("position"),
            this.trigger("changed", {
                property: {
                    name: "position",
                    value: this._current
                }
            })
        }
        return this._current
    }
    ,
    ft.prototype.invalidate = function(e) {
        return "string" === qe.type(e) && (this._invalidated[e] = !0,
        this.is("valid") && this.leave("valid")),
        qe.map(this._invalidated, function(e, t) {
            return t
        })
    }
    ,
    ft.prototype.reset = function(e) {
        (e = this.normalize(e)) !== We && (this._speed = 0,
        this._current = e,
        this.suppress(["translate", "translated"]),
        this.animate(this.coordinates(e)),
        this.release(["translate", "translated"]))
    }
    ,
    ft.prototype.normalize = function(e, t) {
        var i = this._items.length
          , n = t ? 0 : this._clones.length;
        return !this.isNumeric(e) || i < 1 ? e = We : (e < 0 || i + n <= e) && (e = ((e - n / 2) % i + i) % i + n / 2),
        e
    }
    ,
    ft.prototype.relative = function(e) {
        return e -= this._clones.length / 2,
        this.normalize(e, !0)
    }
    ,
    ft.prototype.maximum = function(e) {
        var t, i, n, o = this.settings, s = this._coordinates.length;
        if (o.loop)
            s = this._clones.length / 2 + this._items.length - 1;
        else if (o.autoWidth || o.merge) {
            if (t = this._items.length)
                for (i = this._items[--t].width(),
                n = this.$element.width(); t-- && !((i += this._items[t].width() + this.settings.margin) > n); )
                    ;
            s = t + 1
        } else
            s = o.center ? this._items.length - 1 : this._items.length - o.items;
        return e && (s -= this._clones.length / 2),
        Math.max(s, 0)
    }
    ,
    ft.prototype.minimum = function(e) {
        return e ? 0 : this._clones.length / 2
    }
    ,
    ft.prototype.items = function(e) {
        return e === We ? this._items.slice() : (e = this.normalize(e, !0),
        this._items[e])
    }
    ,
    ft.prototype.mergers = function(e) {
        return e === We ? this._mergers.slice() : (e = this.normalize(e, !0),
        this._mergers[e])
    }
    ,
    ft.prototype.clones = function(i) {
        function n(e) {
            return e % 2 == 0 ? o + e / 2 : t - (e + 1) / 2
        }
        var t = this._clones.length / 2
          , o = t + this._items.length;
        return i === We ? qe.map(this._clones, function(e, t) {
            return n(t)
        }) : qe.map(this._clones, function(e, t) {
            return e === i ? n(t) : null
        })
    }
    ,
    ft.prototype.speed = function(e) {
        return e !== We && (this._speed = e),
        this._speed
    }
    ,
    ft.prototype.coordinates = function(e) {
        var t, i = 1, n = e - 1;
        return e === We ? qe.map(this._coordinates, qe.proxy(function(e, t) {
            return this.coordinates(t)
        }, this)) : (this.settings.center ? (this.settings.rtl && (i = -1,
        n = e + 1),
        t = this._coordinates[e],
        t += (this.width() - t + (this._coordinates[n] || 0)) / 2 * i) : t = this._coordinates[n] || 0,
        t = Math.ceil(t))
    }
    ,
    ft.prototype.duration = function(e, t, i) {
        return 0 === i ? 0 : Math.min(Math.max(Math.abs(t - e), 1), 6) * Math.abs(i || this.settings.smartSpeed)
    }
    ,
    ft.prototype.to = function(e, t) {
        var i = this.current()
          , n = null
          , o = e - this.relative(i)
          , s = (0 < o) - (o < 0)
          , r = this._items.length
          , a = this.minimum()
          , l = this.maximum();
        this.settings.loop ? (!this.settings.rewind && Math.abs(o) > r / 2 && (o += -1 * s * r),
        (n = (((e = i + o) - a) % r + r) % r + a) !== e && n - o <= l && 0 < n - o && (i = n - o,
        e = n,
        this.reset(i))) : e = this.settings.rewind ? (e % (l += 1) + l) % l : Math.max(a, Math.min(l, e)),
        this.speed(this.duration(i, e, t)),
        this.current(e),
        this.isVisible() && this.update()
    }
    ,
    ft.prototype.next = function(e) {
        e = e || !1,
        this.to(this.relative(this.current()) + 1, e)
    }
    ,
    ft.prototype.prev = function(e) {
        e = e || !1,
        this.to(this.relative(this.current()) - 1, e)
    }
    ,
    ft.prototype.onTransitionEnd = function(e) {
        if (e !== We && (e.stopPropagation(),
        (e.target || e.srcElement || e.originalTarget) !== this.$stage.get(0)))
            return !1;
        this.leave("animating"),
        this.trigger("translated")
    }
    ,
    ft.prototype.viewport = function() {
        var e;
        return this.options.responsiveBaseElement !== He ? e = qe(this.options.responsiveBaseElement).width() : He.innerWidth ? e = He.innerWidth : Re.documentElement && Re.documentElement.clientWidth ? e = Re.documentElement.clientWidth : console.warn("Can not detect viewport width."),
        e
    }
    ,
    ft.prototype.replace = function(e) {
        this.$stage.empty(),
        this._items = [],
        e = e && (e instanceof jQuery ? e : qe(e)),
        this.settings.nestedItemSelector && (e = e.find("." + this.settings.nestedItemSelector)),
        e.filter(function() {
            return 1 === this.nodeType
        }).each(qe.proxy(function(e, t) {
            t = this.prepare(t),
            this.$stage.append(t),
            this._items.push(t),
            this._mergers.push(+t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
        }, this)),
        this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
        this.invalidate("items")
    }
    ,
    ft.prototype.add = function(e, t) {
        var i = this.relative(this._current);
        t = t === We ? this._items.length : this.normalize(t, !0),
        e = e instanceof jQuery ? e : qe(e),
        this.trigger("add", {
            content: e,
            position: t
        }),
        e = this.prepare(e),
        0 === this._items.length || t === this._items.length ? (0 === this._items.length && this.$stage.append(e),
        0 !== this._items.length && this._items[t - 1].after(e),
        this._items.push(e),
        this._mergers.push(+e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[t].before(e),
        this._items.splice(t, 0, e),
        this._mergers.splice(t, 0, +e.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)),
        this._items[i] && this.reset(this._items[i].index()),
        this.invalidate("items"),
        this.trigger("added", {
            content: e,
            position: t
        })
    }
    ,
    ft.prototype.remove = function(e) {
        (e = this.normalize(e, !0)) !== We && (this.trigger("remove", {
            content: this._items[e],
            position: e
        }),
        this._items[e].remove(),
        this._items.splice(e, 1),
        this._mergers.splice(e, 1),
        this.invalidate("items"),
        this.trigger("removed", {
            content: null,
            position: e
        }))
    }
    ,
    ft.prototype.preloadAutoWidthImages = function(e) {
        e.each(qe.proxy(function(e, t) {
            this.enter("pre-loading"),
            t = qe(t),
            qe(new Image).one("load", qe.proxy(function(e) {
                t.attr("src", e.target.src),
                t.css("opacity", 1),
                this.leave("pre-loading"),
                this.is("pre-loading") || this.is("initializing") || this.refresh()
            }, this)).attr("src", t.attr("src") || t.attr("data-src") || t.attr("data-src-retina"))
        }, this))
    }
    ,
    ft.prototype.destroy = function() {
        for (var e in this.$element.off(".owl.core"),
        this.$stage.off(".owl.core"),
        qe(Re).off(".owl.core"),
        !1 !== this.settings.responsive && (He.clearTimeout(this.resizeTimer),
        this.off(He, "resize", this._handlers.onThrottledResize)),
        this._plugins)
            this._plugins[e].destroy();
        this.$stage.children(".cloned").remove(),
        this.$stage.unwrap(),
        this.$stage.children().contents().unwrap(),
        this.$stage.children().unwrap(),
        this.$stage.remove(),
        this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s","g"), "")).removeData("owl.carousel")
    }
    ,
    ft.prototype.op = function(e, t, i) {
        var n = this.settings.rtl;
        switch (t) {
        case "<":
            return n ? i < e : e < i;
        case ">":
            return n ? e < i : i < e;
        case ">=":
            return n ? e <= i : i <= e;
        case "<=":
            return n ? i <= e : e <= i
        }
    }
    ,
    ft.prototype.on = function(e, t, i, n) {
        e.addEventListener ? e.addEventListener(t, i, n) : e.attachEvent && e.attachEvent("on" + t, i)
    }
    ,
    ft.prototype.off = function(e, t, i, n) {
        e.removeEventListener ? e.removeEventListener(t, i, n) : e.detachEvent && e.detachEvent("on" + t, i)
    }
    ,
    ft.prototype.trigger = function(e, t, i, n, o) {
        var s = {
            item: {
                count: this._items.length,
                index: this.current()
            }
        }
          , r = qe.camelCase(qe.grep(["on", e, i], function(e) {
            return e
        }).join("-").toLowerCase())
          , a = qe.Event([e, "owl", i || "carousel"].join(".").toLowerCase(), qe.extend({
            relatedTarget: this
        }, s, t));
        return this._supress[e] || (qe.each(this._plugins, function(e, t) {
            t.onTrigger && t.onTrigger(a)
        }),
        this.register({
            type: ft.Type.Event,
            name: e
        }),
        this.$element.trigger(a),
        this.settings && "function" == typeof this.settings[r] && this.settings[r].call(this, a)),
        a
    }
    ,
    ft.prototype.enter = function(e) {
        qe.each([e].concat(this._states.tags[e] || []), qe.proxy(function(e, t) {
            this._states.current[t] === We && (this._states.current[t] = 0),
            this._states.current[t]++
        }, this))
    }
    ,
    ft.prototype.leave = function(e) {
        qe.each([e].concat(this._states.tags[e] || []), qe.proxy(function(e, t) {
            this._states.current[t]--
        }, this))
    }
    ,
    ft.prototype.register = function(i) {
        if (i.type === ft.Type.Event) {
            if (qe.event.special[i.name] || (qe.event.special[i.name] = {}),
            !qe.event.special[i.name].owl) {
                var t = qe.event.special[i.name]._default;
                qe.event.special[i.name]._default = function(e) {
                    return !t || !t.apply || e.namespace && -1 !== e.namespace.indexOf("owl") ? e.namespace && -1 < e.namespace.indexOf("owl") : t.apply(this, arguments)
                }
                ,
                qe.event.special[i.name].owl = !0
            }
        } else
            i.type === ft.Type.State && (this._states.tags[i.name] ? this._states.tags[i.name] = this._states.tags[i.name].concat(i.tags) : this._states.tags[i.name] = i.tags,
            this._states.tags[i.name] = qe.grep(this._states.tags[i.name], qe.proxy(function(e, t) {
                return qe.inArray(e, this._states.tags[i.name]) === t
            }, this)))
    }
    ,
    ft.prototype.suppress = function(e) {
        qe.each(e, qe.proxy(function(e, t) {
            this._supress[t] = !0
        }, this))
    }
    ,
    ft.prototype.release = function(e) {
        qe.each(e, qe.proxy(function(e, t) {
            delete this._supress[t]
        }, this))
    }
    ,
    ft.prototype.pointer = function(e) {
        var t = {
            x: null,
            y: null
        };
        return (e = (e = e.originalEvent || e || He.event).touches && e.touches.length ? e.touches[0] : e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e).pageX ? (t.x = e.pageX,
        t.y = e.pageY) : (t.x = e.clientX,
        t.y = e.clientY),
        t
    }
    ,
    ft.prototype.isNumeric = function(e) {
        return !isNaN(parseFloat(e))
    }
    ,
    ft.prototype.difference = function(e, t) {
        return {
            x: e.x - t.x,
            y: e.y - t.y
        }
    }
    ,
    qe.fn.owlCarousel = function(t) {
        var n = Array.prototype.slice.call(arguments, 1);
        return this.each(function() {
            var e = qe(this)
              , i = e.data("owl.carousel");
            i || (i = new ft(this,"object" == _typeof(t) && t),
            e.data("owl.carousel", i),
            qe.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function(e, t) {
                i.register({
                    type: ft.Type.Event,
                    name: t
                }),
                i.$element.on(t + ".owl.carousel.core", qe.proxy(function(e) {
                    e.namespace && e.relatedTarget !== this && (this.suppress([t]),
                    i[t].apply(this, [].slice.call(arguments, 1)),
                    this.release([t]))
                }, i))
            })),
            "string" == typeof t && "_" !== t.charAt(0) && i[t].apply(i, n)
        })
    }
    ,
    qe.fn.owlCarousel.Constructor = ft,
    Me = window.Zepto || window.jQuery,
    Ie = window,
    document,
    ht.Defaults = {
        autoRefresh: !0,
        autoRefreshInterval: 500
    },
    ht.prototype.watch = function() {
        this._interval || (this._visible = this._core.isVisible(),
        this._interval = Ie.setInterval(Me.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
    }
    ,
    ht.prototype.refresh = function() {
        this._core.isVisible() !== this._visible && (this._visible = !this._visible,
        this._core.$element.toggleClass("owl-hidden", !this._visible),
        this._visible && this._core.invalidate("width") && this._core.refresh())
    }
    ,
    ht.prototype.destroy = function() {
        var e, t;
        for (e in Ie.clearInterval(this._interval),
        this._handlers)
            this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
            "function" != typeof this[t] && (this[t] = null)
    }
    ,
    Me.fn.owlCarousel.Constructor.Plugins.AutoRefresh = ht,
    Pe = window.Zepto || window.jQuery,
    Ne = window,
    document,
    pt.Defaults = {
        lazyLoad: !1,
        lazyLoadEager: 0
    },
    pt.prototype.load = function(e) {
        var t = this._core.$stage.children().eq(e)
          , i = t && t.find(".owl-lazy");
        !i || -1 < Pe.inArray(t.get(0), this._loaded) || (i.each(Pe.proxy(function(e, t) {
            var i, n = Pe(t), o = 1 < Ne.devicePixelRatio && n.attr("data-src-retina") || n.attr("data-src") || n.attr("data-srcset");
            this._core.trigger("load", {
                element: n,
                url: o
            }, "lazy"),
            n.is("img") ? n.one("load.owl.lazy", Pe.proxy(function() {
                n.css("opacity", 1),
                this._core.trigger("loaded", {
                    element: n,
                    url: o
                }, "lazy")
            }, this)).attr("src", o) : n.is("source") ? n.one("load.owl.lazy", Pe.proxy(function() {
                this._core.trigger("loaded", {
                    element: n,
                    url: o
                }, "lazy")
            }, this)).attr("srcset", o) : ((i = new Image).onload = Pe.proxy(function() {
                n.css({
                    "background-image": 'url("' + o + '")',
                    opacity: "1"
                }),
                this._core.trigger("loaded", {
                    element: n,
                    url: o
                }, "lazy")
            }, this),
            i.src = o)
        }, this)),
        this._loaded.push(t.get(0)))
    }
    ,
    pt.prototype.destroy = function() {
        var e, t;
        for (e in this.handlers)
            this._core.$element.off(e, this.handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
            "function" != typeof this[t] && (this[t] = null)
    }
    ,
    Pe.fn.owlCarousel.Constructor.Plugins.Lazy = pt,
    je = window.Zepto || window.jQuery,
    Le = window,
    document,
    ut.Defaults = {
        autoHeight: !1,
        autoHeightClass: "owl-height"
    },
    ut.prototype.update = function() {
        var e = this._core._current
          , t = e + this._core.settings.items
          , i = this._core.settings.lazyLoad
          , n = this._core.$stage.children().toArray().slice(e, t)
          , o = []
          , s = 0;
        je.each(n, function(e, t) {
            o.push(je(t).height())
        }),
        (s = Math.max.apply(null, o)) <= 1 && i && this._previousHeight && (s = this._previousHeight),
        this._previousHeight = s,
        this._core.$stage.parent().height(s).addClass(this._core.settings.autoHeightClass)
    }
    ,
    ut.prototype.destroy = function() {
        var e, t;
        for (e in this._handlers)
            this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
            "function" != typeof this[t] && (this[t] = null)
    }
    ,
    je.fn.owlCarousel.Constructor.Plugins.AutoHeight = ut,
    De = window.Zepto || window.jQuery,
    window,
    Oe = document,
    dt.Defaults = {
        video: !1,
        videoHeight: !1,
        videoWidth: !1
    },
    dt.prototype.fetch = function(e, t) {
        var i = e.attr("data-vimeo-id") ? "vimeo" : e.attr("data-vzaar-id") ? "vzaar" : "youtube"
          , n = e.attr("data-vimeo-id") || e.attr("data-youtube-id") || e.attr("data-vzaar-id")
          , o = e.attr("data-width") || this._core.settings.videoWidth
          , s = e.attr("data-height") || this._core.settings.videoHeight
          , r = e.attr("href");
        if (!r)
            throw new Error("Missing video URL.");
        if (-1 < (n = r.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu"))
            i = "youtube";
        else if (-1 < n[3].indexOf("vimeo"))
            i = "vimeo";
        else {
            if (!(-1 < n[3].indexOf("vzaar")))
                throw new Error("Video URL not supported.");
            i = "vzaar"
        }
        n = n[6],
        this._videos[r] = {
            type: i,
            id: n,
            width: o,
            height: s
        },
        t.attr("data-video", r),
        this.thumbnail(e, this._videos[r])
    }
    ,
    dt.prototype.thumbnail = function(t, e) {
        function i(e) {
            n = c.lazyLoad ? De("<div/>", {
                class: "owl-video-tn " + l,
                srcType: e
            }) : De("<div/>", {
                class: "owl-video-tn",
                style: "opacity:1;background-image:url(" + e + ")"
            }),
            t.after(n),
            t.after('<div class="owl-video-play-icon"></div>')
        }
        var n, o, s = e.width && e.height ? "width:" + e.width + "px;height:" + e.height + "px;" : "", r = t.find("img"), a = "src", l = "", c = this._core.settings;
        if (t.wrap(De("<div/>", {
            class: "owl-video-wrapper",
            style: s
        })),
        this._core.settings.lazyLoad && (a = "data-src",
        l = "owl-lazy"),
        r.length)
            return i(r.attr(a)),
            r.remove(),
            !1;
        "youtube" === e.type ? (o = "//img.youtube.com/vi/" + e.id + "/hqdefault.jpg",
        i(o)) : "vimeo" === e.type ? De.ajax({
            type: "GET",
            url: "//vimeo.com/api/v2/video/" + e.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(e) {
                o = e[0].thumbnail_large,
                i(o)
            }
        }) : "vzaar" === e.type && De.ajax({
            type: "GET",
            url: "//vzaar.com/api/videos/" + e.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(e) {
                o = e.framegrab_url,
                i(o)
            }
        })
    }
    ,
    dt.prototype.stop = function() {
        this._core.trigger("stop", null, "video"),
        this._playing.find(".owl-video-frame").remove(),
        this._playing.removeClass("owl-video-playing"),
        this._playing = null,
        this._core.leave("playing"),
        this._core.trigger("stopped", null, "video")
    }
    ,
    dt.prototype.play = function(e) {
        var t, i = De(e.target).closest("." + this._core.settings.itemClass), n = this._videos[i.attr("data-video")], o = n.width || "100%", s = n.height || this._core.$stage.height();
        this._playing || (this._core.enter("playing"),
        this._core.trigger("play", null, "video"),
        i = this._core.items(this._core.relative(i.index())),
        this._core.reset(i.index()),
        (t = De('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')).attr("height", s),
        t.attr("width", o),
        "youtube" === n.type ? t.attr("src", "//www.youtube.com/embed/" + n.id + "?autoplay=1&rel=0&v=" + n.id) : "vimeo" === n.type ? t.attr("src", "//player.vimeo.com/video/" + n.id + "?autoplay=1") : "vzaar" === n.type && t.attr("src", "//view.vzaar.com/" + n.id + "/player?autoplay=true"),
        De(t).wrap('<div class="owl-video-frame" />').insertAfter(i.find(".owl-video")),
        this._playing = i.addClass("owl-video-playing"))
    }
    ,
    dt.prototype.isInFullScreen = function() {
        var e = Oe.fullscreenElement || Oe.mozFullScreenElement || Oe.webkitFullscreenElement;
        return e && De(e).parent().hasClass("owl-video-frame")
    }
    ,
    dt.prototype.destroy = function() {
        var e, t;
        for (e in this._core.$element.off("click.owl.video"),
        this._handlers)
            this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
            "function" != typeof this[t] && (this[t] = null)
    }
    ,
    De.fn.owlCarousel.Constructor.Plugins.Video = dt,
    ze = window.Zepto || window.jQuery,
    window,
    document,
    ct.Defaults = {
        animateOut: !1,
        animateIn: !1
    },
    ct.prototype.swap = function() {
        if (1 === this.core.settings.items && ze.support.animation && ze.support.transition) {
            this.core.speed(0);
            var e, t = ze.proxy(this.clear, this), i = this.core.$stage.children().eq(this.previous), n = this.core.$stage.children().eq(this.next), o = this.core.settings.animateIn, s = this.core.settings.animateOut;
            this.core.current() !== this.previous && (s && (e = this.core.coordinates(this.previous) - this.core.coordinates(this.next),
            i.one(ze.support.animation.end, t).css({
                left: e + "px"
            }).addClass("animated owl-animated-out").addClass(s)),
            o && n.one(ze.support.animation.end, t).addClass("animated owl-animated-in").addClass(o))
        }
    }
    ,
    ct.prototype.clear = function(e) {
        ze(e.target).css({
            left: ""
        }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),
        this.core.onTransitionEnd()
    }
    ,
    ct.prototype.destroy = function() {
        var e, t;
        for (e in this.handlers)
            this.core.$element.off(e, this.handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
            "function" != typeof this[t] && (this[t] = null)
    }
    ,
    ze.fn.owlCarousel.Constructor.Plugins.Animate = ct,
    ke = window.Zepto || window.jQuery,
    Ae = window,
    Ee = document,
    lt.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1
    },
    lt.prototype._next = function(e) {
        this._call = Ae.setTimeout(ke.proxy(this._next, this, e), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()),
        this._core.is("interacting") || Ee.hidden || this._core.next(e || this._core.settings.autoplaySpeed)
    }
    ,
    lt.prototype.read = function() {
        return (new Date).getTime() - this._time
    }
    ,
    lt.prototype.play = function(e, t) {
        var i;
        this._core.is("rotating") || this._core.enter("rotating"),
        e = e || this._core.settings.autoplayTimeout,
        i = Math.min(this._time % (this._timeout || e), e),
        this._paused ? (this._time = this.read(),
        this._paused = !1) : Ae.clearTimeout(this._call),
        this._time += this.read() % e - i,
        this._timeout = e,
        this._call = Ae.setTimeout(ke.proxy(this._next, this, t), e - i)
    }
    ,
    lt.prototype.stop = function() {
        this._core.is("rotating") && (this._time = 0,
        this._paused = !0,
        Ae.clearTimeout(this._call),
        this._core.leave("rotating"))
    }
    ,
    lt.prototype.pause = function() {
        this._core.is("rotating") && !this._paused && (this._time = this.read(),
        this._paused = !0,
        Ae.clearTimeout(this._call))
    }
    ,
    lt.prototype.destroy = function() {
        var e, t;
        for (e in this.stop(),
        this._handlers)
            this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this))
            "function" != typeof this[t] && (this[t] = null)
    }
    ,
    ke.fn.owlCarousel.Constructor.Plugins.autoplay = lt,
    function(s) {
        "use strict";
        function t(e) {
            this._core = e,
            this._initialized = !1,
            this._pages = [],
            this._controls = {},
            this._templates = [],
            this.$element = this._core.$element,
            this._overrides = {
                next: this._core.next,
                prev: this._core.prev,
                to: this._core.to
            },
            this._handlers = {
                "prepared.owl.carousel": s.proxy(function(e) {
                    e.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + s(e.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
                }, this),
                "added.owl.carousel": s.proxy(function(e) {
                    e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 0, this._templates.pop())
                }, this),
                "remove.owl.carousel": s.proxy(function(e) {
                    e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 1)
                }, this),
                "changed.owl.carousel": s.proxy(function(e) {
                    e.namespace && "position" == e.property.name && this.draw()
                }, this),
                "initialized.owl.carousel": s.proxy(function(e) {
                    e.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"),
                    this.initialize(),
                    this.update(),
                    this.draw(),
                    this._initialized = !0,
                    this._core.trigger("initialized", null, "navigation"))
                }, this),
                "refreshed.owl.carousel": s.proxy(function(e) {
                    e.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"),
                    this.update(),
                    this.draw(),
                    this._core.trigger("refreshed", null, "navigation"))
                }, this)
            },
            this._core.options = s.extend({}, t.Defaults, this._core.options),
            this.$element.on(this._handlers)
        }
        t.Defaults = {
            nav: !1,
            navText: ['<span aria-label="' + theme.strings.previous + '">&#x2039;</span>', '<span aria-label="' + theme.strings.next + '">&#x203a;</span>'],
            navSpeed: !1,
            navElement: 'button type="button" role="presentation"',
            navContainer: !1,
            navContainerClass: "owl-nav",
            navClass: ["owl-prev", "owl-next"],
            slideBy: 1,
            dotClass: "owl-dot",
            dotsClass: "owl-dots",
            dots: !0,
            dotsEach: !1,
            dotsData: !1,
            dotsSpeed: !1,
            dotsContainer: !1
        },
        t.prototype.initialize = function() {
            var e, i = this._core.settings;
            for (e in this._controls.$relative = (i.navContainer ? s(i.navContainer) : s("<div>").addClass(i.navContainerClass).appendTo(this.$element)).addClass("disabled"),
            this._controls.$previous = s("<" + i.navElement + ">").addClass(i.navClass[0]).html(i.navText[0]).prependTo(this._controls.$relative).on("click", s.proxy(function(e) {
                this.prev(i.navSpeed)
            }, this)),
            this._controls.$next = s("<" + i.navElement + ">").addClass(i.navClass[1]).html(i.navText[1]).appendTo(this._controls.$relative).on("click", s.proxy(function(e) {
                this.next(i.navSpeed)
            }, this)),
            i.dotsData || (this._templates = [s('<button role="button">').addClass(i.dotClass).append(s("<span>")).prop("outerHTML")]),
            this._controls.$absolute = (i.dotsContainer ? s(i.dotsContainer) : s("<div>").addClass(i.dotsClass).appendTo(this.$element)).addClass("disabled"),
            this._controls.$absolute.on("click", "button", s.proxy(function(e) {
                var t = s(e.target).parent().is(this._controls.$absolute) ? s(e.target).index() : s(e.target).parent().index();
                e.preventDefault(),
                this.to(t, i.dotsSpeed)
            }, this)),
            this._overrides)
                this._core[e] = s.proxy(this[e], this)
        }
        ,
        t.prototype.destroy = function() {
            var e, t, i, n, o;
            for (e in o = this._core.settings,
            this._handlers)
                this.$element.off(e, this._handlers[e]);
            for (t in this._controls)
                "$relative" === t && o.navContainer ? this._controls[t].html("") : this._controls[t].remove();
            for (n in this.overides)
                this._core[n] = this._overrides[n];
            for (i in Object.getOwnPropertyNames(this))
                "function" != typeof this[i] && (this[i] = null)
        }
        ,
        t.prototype.update = function() {
            var e, t, i = this._core.clones().length / 2, n = i + this._core.items().length, o = this._core.maximum(!0), s = this._core.settings, r = s.center || s.autoWidth || s.dotsData ? 1 : s.dotsEach || s.items;
            if ("page" !== s.slideBy && (s.slideBy = Math.min(s.slideBy, s.items)),
            s.dots || "page" == s.slideBy)
                for (this._pages = [],
                e = i,
                t = 0; e < n; e++) {
                    if (r <= t || 0 === t) {
                        if (this._pages.push({
                            start: Math.min(o, e - i),
                            end: e - i + r - 1
                        }),
                        Math.min(o, e - i) === o)
                            break;
                        t = 0,
                        0
                    }
                    t += this._core.mergers(this._core.relative(e))
                }
        }
        ,
        t.prototype.draw = function() {
            var e, t = this._core.settings, i = this._core.items().length <= t.items, n = this._core.relative(this._core.current()), o = t.loop || t.rewind;
            this._controls.$relative.toggleClass("disabled", !t.nav || i),
            t.nav && (this._controls.$previous.toggleClass("disabled", !o && n <= this._core.minimum(!0)),
            this._controls.$next.toggleClass("disabled", !o && n >= this._core.maximum(!0))),
            this._controls.$absolute.toggleClass("disabled", !t.dots || i),
            t.dots && (e = this._pages.length - this._controls.$absolute.children().length,
            t.dotsData && 0 != e ? this._controls.$absolute.html(this._templates.join("")) : 0 < e ? this._controls.$absolute.append(new Array(1 + e).join(this._templates[0])) : e < 0 && this._controls.$absolute.children().slice(e).remove(),
            this._controls.$absolute.find(".active").removeClass("active"),
            this._controls.$absolute.children().eq(s.inArray(this.current(), this._pages)).addClass("active"))
        }
        ,
        t.prototype.onTrigger = function(e) {
            var t = this._core.settings;
            e.page = {
                index: s.inArray(this.current(), this._pages),
                count: this._pages.length,
                size: t && (t.center || t.autoWidth || t.dotsData ? 1 : t.dotsEach || t.items)
            }
        }
        ,
        t.prototype.current = function() {
            var i = this._core.relative(this._core.current());
            return s.grep(this._pages, s.proxy(function(e, t) {
                return e.start <= i && e.end >= i
            }, this)).pop()
        }
        ,
        t.prototype.getPosition = function(e) {
            var t, i, n = this._core.settings;
            return "page" == n.slideBy ? (t = s.inArray(this.current(), this._pages),
            i = this._pages.length,
            e ? ++t : --t,
            t = this._pages[(t % i + i) % i].start) : (t = this._core.relative(this._core.current()),
            i = this._core.items().length,
            e ? t += n.slideBy : t -= n.slideBy),
            t
        }
        ,
        t.prototype.next = function(e) {
            s.proxy(this._overrides.to, this._core)(this.getPosition(!0), e)
        }
        ,
        t.prototype.prev = function(e) {
            s.proxy(this._overrides.to, this._core)(this.getPosition(!1), e)
        }
        ,
        t.prototype.to = function(e, t, i) {
            var n;
            !i && this._pages.length ? (n = this._pages.length,
            s.proxy(this._overrides.to, this._core)(this._pages[(e % n + n) % n].start, t)) : s.proxy(this._overrides.to, this._core)(e, t)
        }
        ,
        s.fn.owlCarousel.Constructor.Plugins.Navigation = t
    }(window.Zepto || window.jQuery, (window,
    document)),
    function(n, o) {
        "use strict";
        function t(e) {
            this._core = e,
            this._hashes = {},
            this.$element = this._core.$element,
            this._handlers = {
                "initialized.owl.carousel": n.proxy(function(e) {
                    e.namespace && "URLHash" === this._core.settings.startPosition && n(o).trigger("hashchange.owl.navigation")
                }, this),
                "prepared.owl.carousel": n.proxy(function(e) {
                    if (e.namespace) {
                        var t = n(e.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                        if (!t)
                            return;
                        this._hashes[t] = e.content
                    }
                }, this),
                "changed.owl.carousel": n.proxy(function(e) {
                    if (e.namespace && "position" === e.property.name) {
                        var i = this._core.items(this._core.relative(this._core.current()))
                          , t = n.map(this._hashes, function(e, t) {
                            return e === i ? t : null
                        }).join();
                        if (!t || o.location.hash.slice(1) === t)
                            return;
                        o.location.hash = t
                    }
                }, this)
            },
            this._core.options = n.extend({}, t.Defaults, this._core.options),
            this.$element.on(this._handlers),
            n(o).on("hashchange.owl.navigation", n.proxy(function(e) {
                var t = o.location.hash.substring(1)
                  , i = this._core.$stage.children()
                  , n = this._hashes[t] && i.index(this._hashes[t]);
                void 0 !== n && n !== this._core.current() && this._core.to(this._core.relative(n), !1, !0)
            }, this))
        }
        t.Defaults = {
            URLhashListener: !1
        },
        t.prototype.destroy = function() {
            var e, t;
            for (e in n(o).off("hashchange.owl.navigation"),
            this._handlers)
                this._core.$element.off(e, this._handlers[e]);
            for (t in Object.getOwnPropertyNames(this))
                "function" != typeof this[t] && (this[t] = null)
        }
        ,
        n.fn.owlCarousel.Constructor.Plugins.Hash = t
    }(window.Zepto || window.jQuery, window, document),
    we = window.Zepto || window.jQuery,
    window,
    be = void document,
    xe = we("<support>").get(0).style,
    _e = "Webkit Moz O ms".split(" "),
    Ce = {
        transition: {
            end: {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd",
                transition: "transitionend"
            }
        },
        animation: {
            end: {
                WebkitAnimation: "webkitAnimationEnd",
                MozAnimation: "animationend",
                OAnimation: "oAnimationEnd",
                animation: "animationend"
            }
        }
    },
    Te = function() {
        return !!rt("transform")
    }
    ,
    Se = function() {
        return !!rt("perspective")
    }
    ,
    $e = function() {
        return !!rt("animation")
    }
    ,
    function() {
        return !!rt("transition")
    }() && (we.support.transition = new String(at("transition")),
    we.support.transition.end = Ce.transition.end[we.support.transition]),
    $e() && (we.support.animation = new String(at("animation")),
    we.support.animation.end = Ce.animation.end[we.support.animation]),
    Te() && (we.support.transform = new String(at("transform")),
    we.support.transform3d = Se())
}(theme.jQuery);
